export interface IbgeState { id: number; uf: string; name: string }

export interface IbgeMunicipality { id: number; name: string; microregionId: number }

export const IBGE_STATES: IbgeState[] = [
  { id: 11, uf: 'RO', name: 'Rondônia' },
  { id: 12, uf: 'AC', name: 'Acre' },
  { id: 13, uf: 'AM', name: 'Amazonas' },
  { id: 14, uf: 'RR', name: 'Roraima' },
  { id: 15, uf: 'PA', name: 'Pará' },
  { id: 16, uf: 'AP', name: 'Amapá' },
  { id: 17, uf: 'TO', name: 'Tocantins' },
  { id: 21, uf: 'MA', name: 'Maranhão' },
  { id: 22, uf: 'PI', name: 'Piauí' },
  { id: 23, uf: 'CE', name: 'Ceará' },
  { id: 24, uf: 'RN', name: 'Rio Grande do Norte' },
  { id: 25, uf: 'PB', name: 'Paraíba' },
  { id: 26, uf: 'PE', name: 'Pernambuco' },
  { id: 27, uf: 'AL', name: 'Alagoas' },
  { id: 28, uf: 'SE', name: 'Sergipe' },
  { id: 29, uf: 'BA', name: 'Bahia' },
  { id: 31, uf: 'MG', name: 'Minas Gerais' },
  { id: 32, uf: 'ES', name: 'Espírito Santo' },
  { id: 33, uf: 'RJ', name: 'Rio de Janeiro' },
  { id: 35, uf: 'SP', name: 'São Paulo' },
  { id: 41, uf: 'PR', name: 'Paraná' },
  { id: 42, uf: 'SC', name: 'Santa Catarina' },
  { id: 43, uf: 'RS', name: 'Rio Grande do Sul' },
  { id: 50, uf: 'MS', name: 'Mato Grosso do Sul' },
  { id: 51, uf: 'MT', name: 'Mato Grosso' },
  { id: 52, uf: 'GO', name: 'Goiás' },
  { id: 53, uf: 'DF', name: 'Distrito Federal' },
]

export const IBGE_MUNICIPALITIES: Record<number, IbgeMunicipality[]> = {
  11: [
    { id: 1100015, name: 'Alta Floresta D\'Oeste', microregionId: 11006 },
    { id: 1100379, name: 'Alto Alegre dos Parecis', microregionId: 11006 },
    { id: 1100403, name: 'Alto Paraíso', microregionId: 11003 },
    { id: 1100346, name: 'Alvorada D\'Oeste', microregionId: 11005 },
    { id: 1100023, name: 'Ariquemes', microregionId: 11003 },
    { id: 1100452, name: 'Buritis', microregionId: 11001 },
    { id: 1100031, name: 'Cabixi', microregionId: 11008 },
    { id: 1100601, name: 'Cacaulândia', microregionId: 11003 },
    { id: 1100049, name: 'Cacoal', microregionId: 11006 },
    { id: 1100700, name: 'Campo Novo de Rondônia', microregionId: 11001 },
    { id: 1100809, name: 'Candeias do Jamari', microregionId: 11001 },
    { id: 1100908, name: 'Castanheiras', microregionId: 11006 },
    { id: 1100056, name: 'Cerejeiras', microregionId: 11008 },
    { id: 1100924, name: 'Chupinguaia', microregionId: 11007 },
    { id: 1100064, name: 'Colorado do Oeste', microregionId: 11008 },
    { id: 1100072, name: 'Corumbiara', microregionId: 11008 },
    { id: 1100080, name: 'Costa Marques', microregionId: 11002 },
    { id: 1100940, name: 'Cujubim', microregionId: 11001 },
    { id: 1100098, name: 'Espigão D\'Oeste', microregionId: 11006 },
    { id: 1101005, name: 'Governador Jorge Teixeira', microregionId: 11004 },
    { id: 1100106, name: 'Guajará-Mirim', microregionId: 11002 },
    { id: 1101104, name: 'Itapuã do Oeste', microregionId: 11001 },
    { id: 1100114, name: 'Jaru', microregionId: 11004 },
    { id: 1100122, name: 'Ji-Paraná', microregionId: 11004 },
    { id: 1100130, name: 'Machadinho D\'Oeste', microregionId: 11003 },
    { id: 1101203, name: 'Ministro Andreazza', microregionId: 11006 },
    { id: 1101302, name: 'Mirante da Serra', microregionId: 11004 },
    { id: 1101401, name: 'Monte Negro', microregionId: 11003 },
    { id: 1100148, name: 'Nova Brasilândia D\'Oeste', microregionId: 11005 },
    { id: 1100338, name: 'Nova Mamoré', microregionId: 11001 },
    { id: 1101435, name: 'Nova União', microregionId: 11004 },
    { id: 1100502, name: 'Novo Horizonte do Oeste', microregionId: 11006 },
    { id: 1100155, name: 'Ouro Preto do Oeste', microregionId: 11004 },
    { id: 1101450, name: 'Parecis', microregionId: 11007 },
    { id: 1100189, name: 'Pimenta Bueno', microregionId: 11007 },
    { id: 1101468, name: 'Pimenteiras do Oeste', microregionId: 11008 },
    { id: 1100205, name: 'Porto Velho', microregionId: 11001 },
    { id: 1100254, name: 'Presidente Médici', microregionId: 11004 },
    { id: 1101476, name: 'Primavera de Rondônia', microregionId: 11007 },
    { id: 1100262, name: 'Rio Crespo', microregionId: 11003 },
    { id: 1100288, name: 'Rolim de Moura', microregionId: 11006 },
    { id: 1100296, name: 'Santa Luzia D\'Oeste', microregionId: 11006 },
    { id: 1101484, name: 'São Felipe D\'Oeste', microregionId: 11007 },
    { id: 1101492, name: 'São Francisco do Guaporé', microregionId: 11002 },
    { id: 1100320, name: 'São Miguel do Guaporé', microregionId: 11005 },
    { id: 1101500, name: 'Seringueiras', microregionId: 11005 },
    { id: 1101559, name: 'Teixeirópolis', microregionId: 11004 },
    { id: 1101609, name: 'Theobroma', microregionId: 11004 },
    { id: 1101708, name: 'Urupá', microregionId: 11004 },
    { id: 1101757, name: 'Vale do Anari', microregionId: 11003 },
    { id: 1101807, name: 'Vale do Paraíso', microregionId: 11004 },
    { id: 1100304, name: 'Vilhena', microregionId: 11007 },
  ],
  12: [
    { id: 1200013, name: 'Acrelândia', microregionId: 12004 },
    { id: 1200054, name: 'Assis Brasil', microregionId: 12005 },
    { id: 1200104, name: 'Brasiléia', microregionId: 12005 },
    { id: 1200138, name: 'Bujari', microregionId: 12004 },
    { id: 1200179, name: 'Capixaba', microregionId: 12004 },
    { id: 1200203, name: 'Cruzeiro do Sul', microregionId: 12001 },
    { id: 1200252, name: 'Epitaciolândia', microregionId: 12005 },
    { id: 1200302, name: 'Feijó', microregionId: 12002 },
    { id: 1200328, name: 'Jordão', microregionId: 12002 },
    { id: 1200336, name: 'Mâncio Lima', microregionId: 12001 },
    { id: 1200344, name: 'Manoel Urbano', microregionId: 12003 },
    { id: 1200351, name: 'Marechal Thaumaturgo', microregionId: 12001 },
    { id: 1200385, name: 'Plácido de Castro', microregionId: 12004 },
    { id: 1200807, name: 'Porto Acre', microregionId: 12004 },
    { id: 1200393, name: 'Porto Walter', microregionId: 12001 },
    { id: 1200401, name: 'Rio Branco', microregionId: 12004 },
    { id: 1200427, name: 'Rodrigues Alves', microregionId: 12001 },
    { id: 1200435, name: 'Santa Rosa do Purus', microregionId: 12003 },
    { id: 1200500, name: 'Sena Madureira', microregionId: 12003 },
    { id: 1200450, name: 'Senador Guiomard', microregionId: 12004 },
    { id: 1200609, name: 'Tarauacá', microregionId: 12002 },
    { id: 1200708, name: 'Xapuri', microregionId: 12005 },
  ],
  13: [
    { id: 1300029, name: 'Alvarães', microregionId: 13005 },
    { id: 1300060, name: 'Amaturá', microregionId: 13003 },
    { id: 1300086, name: 'Anamã', microregionId: 13006 },
    { id: 1300102, name: 'Anori', microregionId: 13006 },
    { id: 1300144, name: 'Apuí', microregionId: 13013 },
    { id: 1300201, name: 'Atalaia do Norte', microregionId: 13003 },
    { id: 1300300, name: 'Autazes', microregionId: 13007 },
    { id: 1300409, name: 'Barcelos', microregionId: 13001 },
    { id: 1300508, name: 'Barreirinha', microregionId: 13010 },
    { id: 1300607, name: 'Benjamin Constant', microregionId: 13003 },
    { id: 1300631, name: 'Beruri', microregionId: 13006 },
    { id: 1300680, name: 'Boa Vista do Ramos', microregionId: 13010 },
    { id: 1300706, name: 'Boca do Acre', microregionId: 13011 },
    { id: 1300805, name: 'Borba', microregionId: 13013 },
    { id: 1300839, name: 'Caapiranga', microregionId: 13006 },
    { id: 1300904, name: 'Canutama', microregionId: 13012 },
    { id: 1301001, name: 'Carauari', microregionId: 13004 },
    { id: 1301100, name: 'Careiro', microregionId: 13007 },
    { id: 1301159, name: 'Careiro da Várzea', microregionId: 13007 },
    { id: 1301209, name: 'Coari', microregionId: 13006 },
    { id: 1301308, name: 'Codajás', microregionId: 13006 },
    { id: 1301407, name: 'Eirunepé', microregionId: 13004 },
    { id: 1301506, name: 'Envira', microregionId: 13004 },
    { id: 1301605, name: 'Fonte Boa', microregionId: 13003 },
    { id: 1301654, name: 'Guajará', microregionId: 13004 },
    { id: 1301704, name: 'Humaitá', microregionId: 13013 },
    { id: 1301803, name: 'Ipixuna', microregionId: 13004 },
    { id: 1301852, name: 'Iranduba', microregionId: 13007 },
    { id: 1301902, name: 'Itacoatiara', microregionId: 13009 },
    { id: 1301951, name: 'Itamarati', microregionId: 13004 },
    { id: 1302009, name: 'Itapiranga', microregionId: 13009 },
    { id: 1302108, name: 'Japurá', microregionId: 13002 },
    { id: 1302207, name: 'Juruá', microregionId: 13004 },
    { id: 1302306, name: 'Jutaí', microregionId: 13003 },
    { id: 1302405, name: 'Lábrea', microregionId: 13012 },
    { id: 1302504, name: 'Manacapuru', microregionId: 13007 },
    { id: 1302553, name: 'Manaquiri', microregionId: 13007 },
    { id: 1302603, name: 'Manaus', microregionId: 13007 },
    { id: 1302702, name: 'Manicoré', microregionId: 13013 },
    { id: 1302801, name: 'Maraã', microregionId: 13002 },
    { id: 1302900, name: 'Maués', microregionId: 13010 },
    { id: 1303007, name: 'Nhamundá', microregionId: 13010 },
    { id: 1303106, name: 'Nova Olinda do Norte', microregionId: 13009 },
    { id: 1303205, name: 'Novo Airão', microregionId: 13001 },
    { id: 1303304, name: 'Novo Aripuanã', microregionId: 13013 },
    { id: 1303403, name: 'Parintins', microregionId: 13010 },
    { id: 1303502, name: 'Pauini', microregionId: 13011 },
    { id: 1303536, name: 'Presidente Figueiredo', microregionId: 13008 },
    { id: 1303569, name: 'Rio Preto da Eva', microregionId: 13008 },
    { id: 1303601, name: 'Santa Isabel do Rio Negro', microregionId: 13001 },
    { id: 1303700, name: 'Santo Antônio do Içá', microregionId: 13003 },
    { id: 1303809, name: 'São Gabriel da Cachoeira', microregionId: 13001 },
    { id: 1303908, name: 'São Paulo de Olivença', microregionId: 13003 },
    { id: 1303957, name: 'São Sebastião do Uatumã', microregionId: 13010 },
    { id: 1304005, name: 'Silves', microregionId: 13009 },
    { id: 1304062, name: 'Tabatinga', microregionId: 13003 },
    { id: 1304104, name: 'Tapauá', microregionId: 13012 },
    { id: 1304203, name: 'Tefé', microregionId: 13005 },
    { id: 1304237, name: 'Tonantins', microregionId: 13003 },
    { id: 1304260, name: 'Uarini', microregionId: 13005 },
    { id: 1304302, name: 'Urucará', microregionId: 13010 },
    { id: 1304401, name: 'Urucurituba', microregionId: 13009 },
  ],
  14: [
    { id: 1400050, name: 'Alto Alegre', microregionId: 14001 },
    { id: 1400027, name: 'Amajari', microregionId: 14001 },
    { id: 1400100, name: 'Boa Vista', microregionId: 14001 },
    { id: 1400159, name: 'Bonfim', microregionId: 14002 },
    { id: 1400175, name: 'Cantá', microregionId: 14002 },
    { id: 1400209, name: 'Caracaraí', microregionId: 14003 },
    { id: 1400233, name: 'Caroebe', microregionId: 14004 },
    { id: 1400282, name: 'Iracema', microregionId: 14003 },
    { id: 1400308, name: 'Mucajaí', microregionId: 14003 },
    { id: 1400407, name: 'Normandia', microregionId: 14002 },
    { id: 1400456, name: 'Pacaraima', microregionId: 14001 },
    { id: 1400472, name: 'Rorainópolis', microregionId: 14004 },
    { id: 1400506, name: 'São João da Baliza', microregionId: 14004 },
    { id: 1400605, name: 'São Luiz do Anauá', microregionId: 14004 },
    { id: 1400704, name: 'Uiramutã', microregionId: 14002 },
  ],
  15: [
    { id: 1500107, name: 'Abaetetuba', microregionId: 15011 },
    { id: 1500131, name: 'Abel Figueiredo', microregionId: 15017 },
    { id: 1500206, name: 'Acará', microregionId: 15012 },
    { id: 1500305, name: 'Afuá', microregionId: 15005 },
    { id: 1500347, name: 'Água Azul do Norte', microregionId: 15019 },
    { id: 1500404, name: 'Alenquer', microregionId: 15002 },
    { id: 1500503, name: 'Almeirim', microregionId: 15003 },
    { id: 1500602, name: 'Altamira', microregionId: 15015 },
    { id: 1500701, name: 'Anajás', microregionId: 15005 },
    { id: 1500800, name: 'Ananindeua', microregionId: 15007 },
    { id: 1500859, name: 'Anapu', microregionId: 15015 },
    { id: 1500909, name: 'Augusto Corrêa', microregionId: 15010 },
    { id: 1500958, name: 'Aurora do Pará', microregionId: 15013 },
    { id: 1501006, name: 'Aveiro', microregionId: 15014 },
    { id: 1501105, name: 'Bagre', microregionId: 15004 },
    { id: 1501204, name: 'Baião', microregionId: 15011 },
    { id: 1501253, name: 'Bannach', microregionId: 15018 },
    { id: 1501303, name: 'Barcarena', microregionId: 15007 },
    { id: 1501402, name: 'Belém', microregionId: 15007 },
    { id: 1501451, name: 'Belterra', microregionId: 15002 },
    { id: 1501501, name: 'Benevides', microregionId: 15007 },
    { id: 1501576, name: 'Bom Jesus do Tocantins', microregionId: 15017 },
    { id: 1501600, name: 'Bonito', microregionId: 15010 },
    { id: 1501709, name: 'Bragança', microregionId: 15010 },
    { id: 1501725, name: 'Brasil Novo', microregionId: 15015 },
    { id: 1501758, name: 'Brejo Grande do Araguaia', microregionId: 15020 },
    { id: 1501782, name: 'Breu Branco', microregionId: 15016 },
    { id: 1501808, name: 'Breves', microregionId: 15005 },
    { id: 1501907, name: 'Bujaru', microregionId: 15008 },
    { id: 1502004, name: 'Cachoeira do Arari', microregionId: 15006 },
    { id: 1501956, name: 'Cachoeira do Piriá', microregionId: 15013 },
    { id: 1502103, name: 'Cametá', microregionId: 15011 },
    { id: 1502152, name: 'Canaã dos Carajás', microregionId: 15019 },
    { id: 1502202, name: 'Capanema', microregionId: 15010 },
    { id: 1502301, name: 'Capitão Poço', microregionId: 15013 },
    { id: 1502400, name: 'Castanhal', microregionId: 15008 },
    { id: 1502509, name: 'Chaves', microregionId: 15006 },
    { id: 1502608, name: 'Colares', microregionId: 15009 },
    { id: 1502707, name: 'Conceição do Araguaia', microregionId: 15022 },
    { id: 1502756, name: 'Concórdia do Pará', microregionId: 15012 },
    { id: 1502764, name: 'Cumaru do Norte', microregionId: 15018 },
    { id: 1502772, name: 'Curionópolis', microregionId: 15019 },
    { id: 1502806, name: 'Curralinho', microregionId: 15005 },
    { id: 1502855, name: 'Curuá', microregionId: 15002 },
    { id: 1502905, name: 'Curuçá', microregionId: 15009 },
    { id: 1502939, name: 'Dom Eliseu', microregionId: 15017 },
    { id: 1502954, name: 'Eldorado do Carajás', microregionId: 15019 },
    { id: 1503002, name: 'Faro', microregionId: 15001 },
    { id: 1503044, name: 'Floresta do Araguaia', microregionId: 15022 },
    { id: 1503077, name: 'Garrafão do Norte', microregionId: 15013 },
    { id: 1503093, name: 'Goianésia do Pará', microregionId: 15017 },
    { id: 1503101, name: 'Gurupá', microregionId: 15004 },
    { id: 1503200, name: 'Igarapé-Açu', microregionId: 15010 },
    { id: 1503309, name: 'Igarapé-Miri', microregionId: 15011 },
    { id: 1503408, name: 'Inhangapi', microregionId: 15008 },
    { id: 1503457, name: 'Ipixuna do Pará', microregionId: 15013 },
    { id: 1503507, name: 'Irituia', microregionId: 15013 },
    { id: 1503606, name: 'Itaituba', microregionId: 15014 },
    { id: 1503705, name: 'Itupiranga', microregionId: 15016 },
    { id: 1503754, name: 'Jacareacanga', microregionId: 15014 },
    { id: 1503804, name: 'Jacundá', microregionId: 15016 },
    { id: 1503903, name: 'Juruti', microregionId: 15001 },
    { id: 1504000, name: 'Limoeiro do Ajuru', microregionId: 15011 },
    { id: 1504059, name: 'Mãe do Rio', microregionId: 15013 },
    { id: 1504109, name: 'Magalhães Barata', microregionId: 15009 },
    { id: 1504208, name: 'Marabá', microregionId: 15020 },
    { id: 1504307, name: 'Maracanã', microregionId: 15009 },
    { id: 1504406, name: 'Marapanim', microregionId: 15009 },
    { id: 1504422, name: 'Marituba', microregionId: 15007 },
    { id: 1504455, name: 'Medicilândia', microregionId: 15015 },
    { id: 1504505, name: 'Melgaço', microregionId: 15004 },
    { id: 1504604, name: 'Mocajuba', microregionId: 15011 },
    { id: 1504703, name: 'Moju', microregionId: 15012 },
    { id: 1504752, name: 'Mojuí dos Campos', microregionId: 15002 },
    { id: 1504802, name: 'Monte Alegre', microregionId: 15002 },
    { id: 1504901, name: 'Muaná', microregionId: 15006 },
    { id: 1504950, name: 'Nova Esperança do Piriá', microregionId: 15013 },
    { id: 1504976, name: 'Nova Ipixuna', microregionId: 15016 },
    { id: 1505007, name: 'Nova Timboteua', microregionId: 15010 },
    { id: 1505031, name: 'Novo Progresso', microregionId: 15014 },
    { id: 1505064, name: 'Novo Repartimento', microregionId: 15016 },
    { id: 1505106, name: 'Óbidos', microregionId: 15001 },
    { id: 1505205, name: 'Oeiras do Pará', microregionId: 15011 },
    { id: 1505304, name: 'Oriximiná', microregionId: 15001 },
    { id: 1505403, name: 'Ourém', microregionId: 15013 },
    { id: 1505437, name: 'Ourilândia do Norte', microregionId: 15018 },
    { id: 1505486, name: 'Pacajá', microregionId: 15015 },
    { id: 1505494, name: 'Palestina do Pará', microregionId: 15020 },
    { id: 1505502, name: 'Paragominas', microregionId: 15017 },
    { id: 1505536, name: 'Parauapebas', microregionId: 15019 },
    { id: 1505551, name: 'Pau D\'Arco', microregionId: 15021 },
    { id: 1505601, name: 'Peixe-Boi', microregionId: 15010 },
    { id: 1505635, name: 'Piçarra', microregionId: 15021 },
    { id: 1505650, name: 'Placas', microregionId: 15002 },
    { id: 1505700, name: 'Ponta de Pedras', microregionId: 15006 },
    { id: 1505809, name: 'Portel', microregionId: 15004 },
    { id: 1505908, name: 'Porto de Moz', microregionId: 15003 },
    { id: 1506005, name: 'Prainha', microregionId: 15002 },
    { id: 1506104, name: 'Primavera', microregionId: 15010 },
    { id: 1506112, name: 'Quatipuru', microregionId: 15010 },
    { id: 1506138, name: 'Redenção', microregionId: 15021 },
    { id: 1506161, name: 'Rio Maria', microregionId: 15021 },
    { id: 1506187, name: 'Rondon do Pará', microregionId: 15017 },
    { id: 1506195, name: 'Rurópolis', microregionId: 15014 },
    { id: 1506203, name: 'Salinópolis', microregionId: 15009 },
    { id: 1506302, name: 'Salvaterra', microregionId: 15006 },
    { id: 1506351, name: 'Santa Bárbara do Pará', microregionId: 15007 },
    { id: 1506401, name: 'Santa Cruz do Arari', microregionId: 15006 },
    { id: 1506500, name: 'Santa Izabel do Pará', microregionId: 15008 },
    { id: 1506559, name: 'Santa Luzia do Pará', microregionId: 15013 },
    { id: 1506583, name: 'Santa Maria das Barreiras', microregionId: 15022 },
    { id: 1506609, name: 'Santa Maria do Pará', microregionId: 15010 },
    { id: 1506708, name: 'Santana do Araguaia', microregionId: 15022 },
    { id: 1506807, name: 'Santarém', microregionId: 15002 },
    { id: 1506906, name: 'Santarém Novo', microregionId: 15010 },
    { id: 1507003, name: 'Santo Antônio do Tauá', microregionId: 15008 },
    { id: 1507102, name: 'São Caetano de Odivelas', microregionId: 15009 },
    { id: 1507151, name: 'São Domingos do Araguaia', microregionId: 15020 },
    { id: 1507201, name: 'São Domingos do Capim', microregionId: 15013 },
    { id: 1507300, name: 'São Félix do Xingu', microregionId: 15018 },
    { id: 1507409, name: 'São Francisco do Pará', microregionId: 15010 },
    { id: 1507458, name: 'São Geraldo do Araguaia', microregionId: 15021 },
    { id: 1507466, name: 'São João da Ponta', microregionId: 15009 },
    { id: 1507474, name: 'São João de Pirabas', microregionId: 15009 },
    { id: 1507508, name: 'São João do Araguaia', microregionId: 15020 },
    { id: 1507607, name: 'São Miguel do Guamá', microregionId: 15013 },
    { id: 1507706, name: 'São Sebastião da Boa Vista', microregionId: 15005 },
    { id: 1507755, name: 'Sapucaia', microregionId: 15021 },
    { id: 1507805, name: 'Senador José Porfírio', microregionId: 15015 },
    { id: 1507904, name: 'Soure', microregionId: 15006 },
    { id: 1507953, name: 'Tailândia', microregionId: 15012 },
    { id: 1507961, name: 'Terra Alta', microregionId: 15009 },
    { id: 1507979, name: 'Terra Santa', microregionId: 15001 },
    { id: 1508001, name: 'Tomé-Açu', microregionId: 15012 },
    { id: 1508035, name: 'Tracuateua', microregionId: 15010 },
    { id: 1508050, name: 'Trairão', microregionId: 15014 },
    { id: 1508084, name: 'Tucumã', microregionId: 15018 },
    { id: 1508100, name: 'Tucuruí', microregionId: 15016 },
    { id: 1508126, name: 'Ulianópolis', microregionId: 15017 },
    { id: 1508159, name: 'Uruará', microregionId: 15015 },
    { id: 1508209, name: 'Vigia', microregionId: 15009 },
    { id: 1508308, name: 'Viseu', microregionId: 15013 },
    { id: 1508357, name: 'Vitória do Xingu', microregionId: 15015 },
    { id: 1508407, name: 'Xinguara', microregionId: 15021 },
  ],
  16: [
    { id: 1600105, name: 'Amapá', microregionId: 16002 },
    { id: 1600204, name: 'Calçoene', microregionId: 16001 },
    { id: 1600212, name: 'Cutias', microregionId: 16003 },
    { id: 1600238, name: 'Ferreira Gomes', microregionId: 16003 },
    { id: 1600253, name: 'Itaubal', microregionId: 16003 },
    { id: 1600279, name: 'Laranjal do Jari', microregionId: 16004 },
    { id: 1600303, name: 'Macapá', microregionId: 16003 },
    { id: 1600402, name: 'Mazagão', microregionId: 16004 },
    { id: 1600501, name: 'Oiapoque', microregionId: 16001 },
    { id: 1600154, name: 'Pedra Branca do Amapari', microregionId: 16003 },
    { id: 1600535, name: 'Porto Grande', microregionId: 16003 },
    { id: 1600550, name: 'Pracuúba', microregionId: 16002 },
    { id: 1600600, name: 'Santana', microregionId: 16003 },
    { id: 1600055, name: 'Serra do Navio', microregionId: 16003 },
    { id: 1600709, name: 'Tartarugalzinho', microregionId: 16002 },
    { id: 1600808, name: 'Vitória do Jari', microregionId: 16004 },
  ],
  17: [
    { id: 1700251, name: 'Abreulândia', microregionId: 17003 },
    { id: 1700301, name: 'Aguiarnópolis', microregionId: 17001 },
    { id: 1700350, name: 'Aliança do Tocantins', microregionId: 17005 },
    { id: 1700400, name: 'Almas', microregionId: 17008 },
    { id: 1700707, name: 'Alvorada', microregionId: 17005 },
    { id: 1701002, name: 'Ananás', microregionId: 17001 },
    { id: 1701051, name: 'Angico', microregionId: 17001 },
    { id: 1701101, name: 'Aparecida do Rio Negro', microregionId: 17006 },
    { id: 1701309, name: 'Aragominas', microregionId: 17002 },
    { id: 1701903, name: 'Araguacema', microregionId: 17003 },
    { id: 1702000, name: 'Araguaçu', microregionId: 17004 },
    { id: 1702109, name: 'Araguaína', microregionId: 17002 },
    { id: 1702158, name: 'Araguanã', microregionId: 17002 },
    { id: 1702208, name: 'Araguatins', microregionId: 17001 },
    { id: 1702307, name: 'Arapoema', microregionId: 17002 },
    { id: 1702406, name: 'Arraias', microregionId: 17008 },
    { id: 1702554, name: 'Augustinópolis', microregionId: 17001 },
    { id: 1702703, name: 'Aurora do Tocantins', microregionId: 17008 },
    { id: 1702901, name: 'Axixá do Tocantins', microregionId: 17001 },
    { id: 1703008, name: 'Babaçulândia', microregionId: 17002 },
    { id: 1703057, name: 'Bandeirantes do Tocantins', microregionId: 17002 },
    { id: 1703073, name: 'Barra do Ouro', microregionId: 17007 },
    { id: 1703107, name: 'Barrolândia', microregionId: 17003 },
    { id: 1703206, name: 'Bernardo Sayão', microregionId: 17003 },
    { id: 1703305, name: 'Bom Jesus do Tocantins', microregionId: 17006 },
    { id: 1703602, name: 'Brasilândia do Tocantins', microregionId: 17003 },
    { id: 1703701, name: 'Brejinho de Nazaré', microregionId: 17005 },
    { id: 1703800, name: 'Buriti do Tocantins', microregionId: 17001 },
    { id: 1703826, name: 'Cachoeirinha', microregionId: 17001 },
    { id: 1703842, name: 'Campos Lindos', microregionId: 17007 },
    { id: 1703867, name: 'Cariri do Tocantins', microregionId: 17005 },
    { id: 1703883, name: 'Carmolândia', microregionId: 17002 },
    { id: 1703891, name: 'Carrasco Bonito', microregionId: 17001 },
    { id: 1703909, name: 'Caseara', microregionId: 17003 },
    { id: 1704105, name: 'Centenário', microregionId: 17007 },
    { id: 1705102, name: 'Chapada da Natividade', microregionId: 17008 },
    { id: 1704600, name: 'Chapada de Areia', microregionId: 17004 },
    { id: 1705508, name: 'Colinas do Tocantins', microregionId: 17002 },
    { id: 1716703, name: 'Colméia', microregionId: 17003 },
    { id: 1705557, name: 'Combinado', microregionId: 17008 },
    { id: 1705607, name: 'Conceição do Tocantins', microregionId: 17008 },
    { id: 1706001, name: 'Couto Magalhães', microregionId: 17003 },
    { id: 1706100, name: 'Cristalândia', microregionId: 17004 },
    { id: 1706258, name: 'Crixás do Tocantins', microregionId: 17005 },
    { id: 1706506, name: 'Darcinópolis', microregionId: 17001 },
    { id: 1707009, name: 'Dianópolis', microregionId: 17008 },
    { id: 1707108, name: 'Divinópolis do Tocantins', microregionId: 17003 },
    { id: 1707207, name: 'Dois Irmãos do Tocantins', microregionId: 17003 },
    { id: 1707306, name: 'Dueré', microregionId: 17004 },
    { id: 1707405, name: 'Esperantina', microregionId: 17001 },
    { id: 1707553, name: 'Fátima', microregionId: 17004 },
    { id: 1707652, name: 'Figueirópolis', microregionId: 17005 },
    { id: 1707702, name: 'Filadélfia', microregionId: 17002 },
    { id: 1708205, name: 'Formoso do Araguaia', microregionId: 17004 },
    { id: 1708304, name: 'Goianorte', microregionId: 17003 },
    { id: 1709005, name: 'Goiatins', microregionId: 17007 },
    { id: 1709302, name: 'Guaraí', microregionId: 17003 },
    { id: 1709500, name: 'Gurupi', microregionId: 17005 },
    { id: 1709807, name: 'Ipueiras', microregionId: 17006 },
    { id: 1710508, name: 'Itacajá', microregionId: 17007 },
    { id: 1710706, name: 'Itaguatins', microregionId: 17001 },
    { id: 1710904, name: 'Itapiratins', microregionId: 17007 },
    { id: 1711100, name: 'Itaporã do Tocantins', microregionId: 17003 },
    { id: 1711506, name: 'Jaú do Tocantins', microregionId: 17005 },
    { id: 1711803, name: 'Juarina', microregionId: 17003 },
    { id: 1711902, name: 'Lagoa da Confusão', microregionId: 17004 },
    { id: 1711951, name: 'Lagoa do Tocantins', microregionId: 17007 },
    { id: 1712009, name: 'Lajeado', microregionId: 17006 },
    { id: 1712157, name: 'Lavandeira', microregionId: 17008 },
    { id: 1712405, name: 'Lizarda', microregionId: 17007 },
    { id: 1712454, name: 'Luzinópolis', microregionId: 17001 },
    { id: 1712504, name: 'Marianópolis do Tocantins', microregionId: 17003 },
    { id: 1712702, name: 'Mateiros', microregionId: 17007 },
    { id: 1712801, name: 'Maurilândia do Tocantins', microregionId: 17001 },
    { id: 1713205, name: 'Miracema do Tocantins', microregionId: 17003 },
    { id: 1713304, name: 'Miranorte', microregionId: 17003 },
    { id: 1713601, name: 'Monte do Carmo', microregionId: 17006 },
    { id: 1713700, name: 'Monte Santo do Tocantins', microregionId: 17003 },
    { id: 1713957, name: 'Muricilândia', microregionId: 17002 },
    { id: 1714203, name: 'Natividade', microregionId: 17008 },
    { id: 1714302, name: 'Nazaré', microregionId: 17001 },
    { id: 1714880, name: 'Nova Olinda', microregionId: 17002 },
    { id: 1715002, name: 'Nova Rosalândia', microregionId: 17004 },
    { id: 1715101, name: 'Novo Acordo', microregionId: 17007 },
    { id: 1715150, name: 'Novo Alegre', microregionId: 17008 },
    { id: 1715259, name: 'Novo Jardim', microregionId: 17008 },
    { id: 1715507, name: 'Oliveira de Fátima', microregionId: 17004 },
    { id: 1721000, name: 'Palmas', microregionId: 17006 },
    { id: 1715705, name: 'Palmeirante', microregionId: 17002 },
    { id: 1713809, name: 'Palmeiras do Tocantins', microregionId: 17001 },
    { id: 1715754, name: 'Palmeirópolis', microregionId: 17005 },
    { id: 1716109, name: 'Paraíso do Tocantins', microregionId: 17004 },
    { id: 1716208, name: 'Paranã', microregionId: 17008 },
    { id: 1716307, name: 'Pau D\'Arco', microregionId: 17002 },
    { id: 1716505, name: 'Pedro Afonso', microregionId: 17006 },
    { id: 1716604, name: 'Peixe', microregionId: 17005 },
    { id: 1716653, name: 'Pequizeiro', microregionId: 17003 },
    { id: 1717008, name: 'Pindorama do Tocantins', microregionId: 17008 },
    { id: 1717206, name: 'Piraquê', microregionId: 17002 },
    { id: 1717503, name: 'Pium', microregionId: 17004 },
    { id: 1717800, name: 'Ponte Alta do Bom Jesus', microregionId: 17008 },
    { id: 1717909, name: 'Ponte Alta do Tocantins', microregionId: 17007 },
    { id: 1718006, name: 'Porto Alegre do Tocantins', microregionId: 17008 },
    { id: 1718204, name: 'Porto Nacional', microregionId: 17006 },
    { id: 1718303, name: 'Praia Norte', microregionId: 17001 },
    { id: 1718402, name: 'Presidente Kennedy', microregionId: 17003 },
    { id: 1718451, name: 'Pugmil', microregionId: 17004 },
    { id: 1718501, name: 'Recursolândia', microregionId: 17007 },
    { id: 1718550, name: 'Riachinho', microregionId: 17001 },
    { id: 1718659, name: 'Rio da Conceição', microregionId: 17008 },
    { id: 1718709, name: 'Rio dos Bois', microregionId: 17003 },
    { id: 1718758, name: 'Rio Sono', microregionId: 17007 },
    { id: 1718808, name: 'Sampaio', microregionId: 17001 },
    { id: 1718840, name: 'Sandolândia', microregionId: 17004 },
    { id: 1718865, name: 'Santa Fé do Araguaia', microregionId: 17002 },
    { id: 1718881, name: 'Santa Maria do Tocantins', microregionId: 17006 },
    { id: 1718899, name: 'Santa Rita do Tocantins', microregionId: 17005 },
    { id: 1718907, name: 'Santa Rosa do Tocantins', microregionId: 17008 },
    { id: 1719004, name: 'Santa Tereza do Tocantins', microregionId: 17007 },
    { id: 1720002, name: 'Santa Terezinha do Tocantins', microregionId: 17001 },
    { id: 1720101, name: 'São Bento do Tocantins', microregionId: 17001 },
    { id: 1720150, name: 'São Félix do Tocantins', microregionId: 17007 },
    { id: 1720200, name: 'São Miguel do Tocantins', microregionId: 17001 },
    { id: 1720259, name: 'São Salvador do Tocantins', microregionId: 17005 },
    { id: 1720309, name: 'São Sebastião do Tocantins', microregionId: 17001 },
    { id: 1720499, name: 'São Valério', microregionId: 17008 },
    { id: 1720655, name: 'Silvanópolis', microregionId: 17006 },
    { id: 1720804, name: 'Sítio Novo do Tocantins', microregionId: 17001 },
    { id: 1720853, name: 'Sucupira', microregionId: 17005 },
    { id: 1708254, name: 'Tabocão', microregionId: 17003 },
    { id: 1720903, name: 'Taguatinga', microregionId: 17008 },
    { id: 1720937, name: 'Taipas do Tocantins', microregionId: 17008 },
    { id: 1720978, name: 'Talismã', microregionId: 17005 },
    { id: 1721109, name: 'Tocantínia', microregionId: 17006 },
    { id: 1721208, name: 'Tocantinópolis', microregionId: 17001 },
    { id: 1721257, name: 'Tupirama', microregionId: 17003 },
    { id: 1721307, name: 'Tupiratins', microregionId: 17003 },
    { id: 1722081, name: 'Wanderlândia', microregionId: 17002 },
    { id: 1722107, name: 'Xambioá', microregionId: 17002 },
  ],
  21: [
    { id: 2100055, name: 'Açailândia', microregionId: 21009 },
    { id: 2100105, name: 'Afonso Cunha', microregionId: 21016 },
    { id: 2100154, name: 'Água Doce do Maranhão', microregionId: 21013 },
    { id: 2100204, name: 'Alcântara', microregionId: 21001 },
    { id: 2100303, name: 'Aldeias Altas', microregionId: 21016 },
    { id: 2100402, name: 'Altamira do Maranhão', microregionId: 21008 },
    { id: 2100436, name: 'Alto Alegre do Maranhão', microregionId: 21015 },
    { id: 2100477, name: 'Alto Alegre do Pindaré', microregionId: 21008 },
    { id: 2100501, name: 'Alto Parnaíba', microregionId: 21020 },
    { id: 2100550, name: 'Amapá do Maranhão', microregionId: 21007 },
    { id: 2100600, name: 'Amarante do Maranhão', microregionId: 21009 },
    { id: 2100709, name: 'Anajatuba', microregionId: 21005 },
    { id: 2100808, name: 'Anapurus', microregionId: 21014 },
    { id: 2100832, name: 'Apicum-Açu', microregionId: 21001 },
    { id: 2100873, name: 'Araguanã', microregionId: 21008 },
    { id: 2100907, name: 'Araioses', microregionId: 21013 },
    { id: 2100956, name: 'Arame', microregionId: 21011 },
    { id: 2101004, name: 'Arari', microregionId: 21005 },
    { id: 2101103, name: 'Axixá', microregionId: 21003 },
    { id: 2101202, name: 'Bacabal', microregionId: 21010 },
    { id: 2101251, name: 'Bacabeira', microregionId: 21003 },
    { id: 2101301, name: 'Bacuri', microregionId: 21001 },
    { id: 2101350, name: 'Bacurituba', microregionId: 21001 },
    { id: 2101400, name: 'Balsas', microregionId: 21020 },
    { id: 2101509, name: 'Barão de Grajaú', microregionId: 21018 },
    { id: 2101608, name: 'Barra do Corda', microregionId: 21011 },
    { id: 2101707, name: 'Barreirinhas', microregionId: 21004 },
    { id: 2101772, name: 'Bela Vista do Maranhão', microregionId: 21005 },
    { id: 2101731, name: 'Belágua', microregionId: 21014 },
    { id: 2101806, name: 'Benedito Leite', microregionId: 21021 },
    { id: 2101905, name: 'Bequimão', microregionId: 21001 },
    { id: 2101939, name: 'Bernardo do Mearim', microregionId: 21010 },
    { id: 2101970, name: 'Boa Vista do Gurupi', microregionId: 21007 },
    { id: 2102002, name: 'Bom Jardim', microregionId: 21008 },
    { id: 2102036, name: 'Bom Jesus das Selvas', microregionId: 21008 },
    { id: 2102077, name: 'Bom Lugar', microregionId: 21010 },
    { id: 2102101, name: 'Brejo', microregionId: 21014 },
    { id: 2102150, name: 'Brejo de Areia', microregionId: 21008 },
    { id: 2102200, name: 'Buriti', microregionId: 21014 },
    { id: 2102309, name: 'Buriti Bravo', microregionId: 21017 },
    { id: 2102325, name: 'Buriticupu', microregionId: 21008 },
    { id: 2102358, name: 'Buritirana', microregionId: 21009 },
    { id: 2102374, name: 'Cachoeira Grande', microregionId: 21003 },
    { id: 2102408, name: 'Cajapió', microregionId: 21001 },
    { id: 2102507, name: 'Cajari', microregionId: 21005 },
    { id: 2102556, name: 'Campestre do Maranhão', microregionId: 21019 },
    { id: 2102606, name: 'Cândido Mendes', microregionId: 21007 },
    { id: 2102705, name: 'Cantanhede', microregionId: 21006 },
    { id: 2102754, name: 'Capinzal do Norte', microregionId: 21015 },
    { id: 2102804, name: 'Carolina', microregionId: 21019 },
    { id: 2102903, name: 'Carutapera', microregionId: 21007 },
    { id: 2103000, name: 'Caxias', microregionId: 21017 },
    { id: 2103109, name: 'Cedral', microregionId: 21001 },
    { id: 2103125, name: 'Central do Maranhão', microregionId: 21001 },
    { id: 2103158, name: 'Centro do Guilherme', microregionId: 21007 },
    { id: 2103174, name: 'Centro Novo do Maranhão', microregionId: 21007 },
    { id: 2103208, name: 'Chapadinha', microregionId: 21014 },
    { id: 2103257, name: 'Cidelândia', microregionId: 21009 },
    { id: 2103307, name: 'Codó', microregionId: 21015 },
    { id: 2103406, name: 'Coelho Neto', microregionId: 21016 },
    { id: 2103505, name: 'Colinas', microregionId: 21018 },
    { id: 2103554, name: 'Conceição do Lago-Açu', microregionId: 21005 },
    { id: 2103604, name: 'Coroatá', microregionId: 21015 },
    { id: 2103703, name: 'Cururupu', microregionId: 21001 },
    { id: 2103752, name: 'Davinópolis', microregionId: 21009 },
    { id: 2103802, name: 'Dom Pedro', microregionId: 21012 },
    { id: 2103901, name: 'Duque Bacelar', microregionId: 21016 },
    { id: 2104008, name: 'Esperantinópolis', microregionId: 21010 },
    { id: 2104057, name: 'Estreito', microregionId: 21019 },
    { id: 2104073, name: 'Feira Nova do Maranhão', microregionId: 21020 },
    { id: 2104081, name: 'Fernando Falcão', microregionId: 21011 },
    { id: 2104099, name: 'Formosa da Serra Negra', microregionId: 21011 },
    { id: 2104107, name: 'Fortaleza dos Nogueiras', microregionId: 21021 },
    { id: 2104206, name: 'Fortuna', microregionId: 21012 },
    { id: 2104305, name: 'Godofredo Viana', microregionId: 21007 },
    { id: 2104404, name: 'Gonçalves Dias', microregionId: 21012 },
    { id: 2104503, name: 'Governador Archer', microregionId: 21012 },
    { id: 2104552, name: 'Governador Edison Lobão', microregionId: 21009 },
    { id: 2104602, name: 'Governador Eugênio Barros', microregionId: 21012 },
    { id: 2104628, name: 'Governador Luiz Rocha', microregionId: 21012 },
    { id: 2104651, name: 'Governador Newton Bello', microregionId: 21008 },
    { id: 2104677, name: 'Governador Nunes Freire', microregionId: 21007 },
    { id: 2104701, name: 'Graça Aranha', microregionId: 21012 },
    { id: 2104800, name: 'Grajaú', microregionId: 21011 },
    { id: 2104909, name: 'Guimarães', microregionId: 21001 },
    { id: 2105005, name: 'Humberto de Campos', microregionId: 21004 },
    { id: 2105104, name: 'Icatu', microregionId: 21003 },
    { id: 2105153, name: 'Igarapé do Meio', microregionId: 21005 },
    { id: 2105203, name: 'Igarapé Grande', microregionId: 21010 },
    { id: 2105302, name: 'Imperatriz', microregionId: 21009 },
    { id: 2105351, name: 'Itaipava do Grajaú', microregionId: 21011 },
    { id: 2105401, name: 'Itapecuru Mirim', microregionId: 21006 },
    { id: 2105427, name: 'Itinga do Maranhão', microregionId: 21009 },
    { id: 2105450, name: 'Jatobá', microregionId: 21018 },
    { id: 2105476, name: 'Jenipapo dos Vieiras', microregionId: 21011 },
    { id: 2105500, name: 'João Lisboa', microregionId: 21009 },
    { id: 2105609, name: 'Joselândia', microregionId: 21011 },
    { id: 2105658, name: 'Junco do Maranhão', microregionId: 21007 },
    { id: 2105708, name: 'Lago da Pedra', microregionId: 21008 },
    { id: 2105807, name: 'Lago do Junco', microregionId: 21010 },
    { id: 2105948, name: 'Lago dos Rodrigues', microregionId: 21010 },
    { id: 2105906, name: 'Lago Verde', microregionId: 21010 },
    { id: 2105922, name: 'Lagoa do Mato', microregionId: 21018 },
    { id: 2105963, name: 'Lagoa Grande do Maranhão', microregionId: 21008 },
    { id: 2105989, name: 'Lajeado Novo', microregionId: 21009 },
    { id: 2106003, name: 'Lima Campos', microregionId: 21010 },
    { id: 2106102, name: 'Loreto', microregionId: 21021 },
    { id: 2106201, name: 'Luís Domingues', microregionId: 21007 },
    { id: 2106300, name: 'Magalhães de Almeida', microregionId: 21013 },
    { id: 2106326, name: 'Maracaçumé', microregionId: 21007 },
    { id: 2106359, name: 'Marajá do Sena', microregionId: 21008 },
    { id: 2106375, name: 'Maranhãozinho', microregionId: 21007 },
    { id: 2106409, name: 'Mata Roma', microregionId: 21014 },
    { id: 2106508, name: 'Matinha', microregionId: 21005 },
    { id: 2106607, name: 'Matões', microregionId: 21017 },
    { id: 2106631, name: 'Matões do Norte', microregionId: 21006 },
    { id: 2106672, name: 'Milagres do Maranhão', microregionId: 21014 },
    { id: 2106706, name: 'Mirador', microregionId: 21018 },
    { id: 2106755, name: 'Miranda do Norte', microregionId: 21006 },
    { id: 2106805, name: 'Mirinzal', microregionId: 21001 },
    { id: 2106904, name: 'Monção', microregionId: 21005 },
    { id: 2107001, name: 'Montes Altos', microregionId: 21009 },
    { id: 2107100, name: 'Morros', microregionId: 21003 },
    { id: 2107209, name: 'Nina Rodrigues', microregionId: 21006 },
    { id: 2107258, name: 'Nova Colinas', microregionId: 21021 },
    { id: 2107308, name: 'Nova Iorque', microregionId: 21018 },
    { id: 2107357, name: 'Nova Olinda do Maranhão', microregionId: 21008 },
    { id: 2107407, name: 'Olho d\'Água das Cunhãs', microregionId: 21010 },
    { id: 2107456, name: 'Olinda Nova do Maranhão', microregionId: 21005 },
    { id: 2107506, name: 'Paço do Lumiar', microregionId: 21002 },
    { id: 2107605, name: 'Palmeirândia', microregionId: 21005 },
    { id: 2107704, name: 'Paraibano', microregionId: 21018 },
    { id: 2107803, name: 'Parnarama', microregionId: 21017 },
    { id: 2107902, name: 'Passagem Franca', microregionId: 21018 },
    { id: 2108009, name: 'Pastos Bons', microregionId: 21018 },
    { id: 2108058, name: 'Paulino Neves', microregionId: 21004 },
    { id: 2108108, name: 'Paulo Ramos', microregionId: 21008 },
    { id: 2108207, name: 'Pedreiras', microregionId: 21010 },
    { id: 2108256, name: 'Pedro do Rosário', microregionId: 21005 },
    { id: 2108306, name: 'Penalva', microregionId: 21005 },
    { id: 2108405, name: 'Peri Mirim', microregionId: 21005 },
    { id: 2108454, name: 'Peritoró', microregionId: 21015 },
    { id: 2108504, name: 'Pindaré-Mirim', microregionId: 21008 },
    { id: 2108603, name: 'Pinheiro', microregionId: 21005 },
    { id: 2108702, name: 'Pio XII', microregionId: 21010 },
    { id: 2108801, name: 'Pirapemas', microregionId: 21006 },
    { id: 2108900, name: 'Poção de Pedras', microregionId: 21010 },
    { id: 2109007, name: 'Porto Franco', microregionId: 21019 },
    { id: 2109056, name: 'Porto Rico do Maranhão', microregionId: 21001 },
    { id: 2109106, name: 'Presidente Dutra', microregionId: 21012 },
    { id: 2109205, name: 'Presidente Juscelino', microregionId: 21003 },
    { id: 2109239, name: 'Presidente Médici', microregionId: 21008 },
    { id: 2109270, name: 'Presidente Sarney', microregionId: 21005 },
    { id: 2109304, name: 'Presidente Vargas', microregionId: 21006 },
    { id: 2109403, name: 'Primeira Cruz', microregionId: 21004 },
    { id: 2109452, name: 'Raposa', microregionId: 21002 },
    { id: 2109502, name: 'Riachão', microregionId: 21020 },
    { id: 2109551, name: 'Ribamar Fiquene', microregionId: 21009 },
    { id: 2109601, name: 'Rosário', microregionId: 21003 },
    { id: 2109700, name: 'Sambaíba', microregionId: 21021 },
    { id: 2109759, name: 'Santa Filomena do Maranhão', microregionId: 21011 },
    { id: 2109809, name: 'Santa Helena', microregionId: 21005 },
    { id: 2109908, name: 'Santa Inês', microregionId: 21008 },
    { id: 2110005, name: 'Santa Luzia', microregionId: 21008 },
    { id: 2110039, name: 'Santa Luzia do Paruá', microregionId: 21008 },
    { id: 2110104, name: 'Santa Quitéria do Maranhão', microregionId: 21013 },
    { id: 2110203, name: 'Santa Rita', microregionId: 21003 },
    { id: 2110237, name: 'Santana do Maranhão', microregionId: 21013 },
    { id: 2110278, name: 'Santo Amaro do Maranhão', microregionId: 21004 },
    { id: 2110302, name: 'Santo Antônio dos Lopes', microregionId: 21010 },
    { id: 2110401, name: 'São Benedito do Rio Preto', microregionId: 21014 },
    { id: 2110500, name: 'São Bento', microregionId: 21005 },
    { id: 2110609, name: 'São Bernardo', microregionId: 21013 },
    { id: 2110658, name: 'São Domingos do Azeitão', microregionId: 21021 },
    { id: 2110708, name: 'São Domingos do Maranhão', microregionId: 21012 },
    { id: 2110807, name: 'São Félix de Balsas', microregionId: 21021 },
    { id: 2110856, name: 'São Francisco do Brejão', microregionId: 21009 },
    { id: 2110906, name: 'São Francisco do Maranhão', microregionId: 21018 },
    { id: 2111003, name: 'São João Batista', microregionId: 21005 },
    { id: 2111029, name: 'São João do Carú', microregionId: 21008 },
    { id: 2111052, name: 'São João do Paraíso', microregionId: 21019 },
    { id: 2111078, name: 'São João do Soter', microregionId: 21017 },
    { id: 2111102, name: 'São João dos Patos', microregionId: 21018 },
    { id: 2111201, name: 'São José de Ribamar', microregionId: 21002 },
    { id: 2111250, name: 'São José dos Basílios', microregionId: 21012 },
    { id: 2111300, name: 'São Luís', microregionId: 21002 },
    { id: 2111409, name: 'São Luís Gonzaga do Maranhão', microregionId: 21010 },
    { id: 2111508, name: 'São Mateus do Maranhão', microregionId: 21010 },
    { id: 2111532, name: 'São Pedro da Água Branca', microregionId: 21009 },
    { id: 2111573, name: 'São Pedro dos Crentes', microregionId: 21019 },
    { id: 2111607, name: 'São Raimundo das Mangabeiras', microregionId: 21021 },
    { id: 2111631, name: 'São Raimundo do Doca Bezerra', microregionId: 21010 },
    { id: 2111672, name: 'São Roberto', microregionId: 21010 },
    { id: 2111706, name: 'São Vicente Ferrer', microregionId: 21005 },
    { id: 2111722, name: 'Satubinha', microregionId: 21010 },
    { id: 2111748, name: 'Senador Alexandre Costa', microregionId: 21012 },
    { id: 2111763, name: 'Senador La Rocque', microregionId: 21009 },
    { id: 2111789, name: 'Serrano do Maranhão', microregionId: 21001 },
    { id: 2111805, name: 'Sítio Novo', microregionId: 21011 },
    { id: 2111904, name: 'Sucupira do Norte', microregionId: 21018 },
    { id: 2111953, name: 'Sucupira do Riachão', microregionId: 21018 },
    { id: 2112001, name: 'Tasso Fragoso', microregionId: 21020 },
    { id: 2112100, name: 'Timbiras', microregionId: 21015 },
    { id: 2112209, name: 'Timon', microregionId: 21017 },
    { id: 2112233, name: 'Trizidela do Vale', microregionId: 21010 },
    { id: 2112274, name: 'Tufilândia', microregionId: 21008 },
    { id: 2112308, name: 'Tuntum', microregionId: 21011 },
    { id: 2112407, name: 'Turiaçu', microregionId: 21007 },
    { id: 2112456, name: 'Turilândia', microregionId: 21007 },
    { id: 2112506, name: 'Tutóia', microregionId: 21004 },
    { id: 2112605, name: 'Urbano Santos', microregionId: 21014 },
    { id: 2112704, name: 'Vargem Grande', microregionId: 21006 },
    { id: 2112803, name: 'Viana', microregionId: 21005 },
    { id: 2112852, name: 'Vila Nova dos Martírios', microregionId: 21009 },
    { id: 2112902, name: 'Vitória do Mearim', microregionId: 21005 },
    { id: 2113009, name: 'Vitorino Freire', microregionId: 21008 },
    { id: 2114007, name: 'Zé Doca', microregionId: 21008 },
  ],
  22: [
    { id: 2200053, name: 'Acauã', microregionId: 22015 },
    { id: 2200103, name: 'Agricolândia', microregionId: 22005 },
    { id: 2200202, name: 'Água Branca', microregionId: 22005 },
    { id: 2200251, name: 'Alagoinha do Piauí', microregionId: 22014 },
    { id: 2200277, name: 'Alegrete do Piauí', microregionId: 22014 },
    { id: 2200301, name: 'Alto Longá', microregionId: 22004 },
    { id: 2200400, name: 'Altos', microregionId: 22003 },
    { id: 2200459, name: 'Alvorada do Gurguéia', microregionId: 22010 },
    { id: 2200509, name: 'Amarante', microregionId: 22005 },
    { id: 2200608, name: 'Angical do Piauí', microregionId: 22005 },
    { id: 2200707, name: 'Anísio de Abreu', microregionId: 22011 },
    { id: 2200806, name: 'Antônio Almeida', microregionId: 22008 },
    { id: 2200905, name: 'Aroazes', microregionId: 22006 },
    { id: 2200954, name: 'Aroeiras do Itaim', microregionId: 22013 },
    { id: 2201002, name: 'Arraial', microregionId: 22005 },
    { id: 2201051, name: 'Assunção do Piauí', microregionId: 22004 },
    { id: 2201101, name: 'Avelino Lopes', microregionId: 22012 },
    { id: 2201150, name: 'Baixa Grande do Ribeiro', microregionId: 22007 },
    { id: 2201176, name: 'Barra D\'Alcântara', microregionId: 22006 },
    { id: 2201200, name: 'Barras', microregionId: 22001 },
    { id: 2201309, name: 'Barreiras do Piauí', microregionId: 22010 },
    { id: 2201408, name: 'Barro Duro', microregionId: 22005 },
    { id: 2201507, name: 'Batalha', microregionId: 22001 },
    { id: 2201556, name: 'Bela Vista do Piauí', microregionId: 22015 },
    { id: 2201572, name: 'Belém do Piauí', microregionId: 22015 },
    { id: 2201606, name: 'Beneditinos', microregionId: 22003 },
    { id: 2201705, name: 'Bertolínia', microregionId: 22008 },
    { id: 2201739, name: 'Betânia do Piauí', microregionId: 22015 },
    { id: 2201770, name: 'Boa Hora', microregionId: 22001 },
    { id: 2201804, name: 'Bocaina', microregionId: 22013 },
    { id: 2201903, name: 'Bom Jesus', microregionId: 22010 },
    { id: 2201919, name: 'Bom Princípio do Piauí', microregionId: 22002 },
    { id: 2201929, name: 'Bonfim do Piauí', microregionId: 22011 },
    { id: 2201945, name: 'Boqueirão do Piauí', microregionId: 22004 },
    { id: 2201960, name: 'Brasileira', microregionId: 22001 },
    { id: 2201988, name: 'Brejo do Piauí', microregionId: 22011 },
    { id: 2202000, name: 'Buriti dos Lopes', microregionId: 22002 },
    { id: 2202026, name: 'Buriti dos Montes', microregionId: 22004 },
    { id: 2202059, name: 'Cabeceiras do Piauí', microregionId: 22001 },
    { id: 2202075, name: 'Cajazeiras do Piauí', microregionId: 22013 },
    { id: 2202083, name: 'Cajueiro da Praia', microregionId: 22002 },
    { id: 2202091, name: 'Caldeirão Grande do Piauí', microregionId: 22015 },
    { id: 2202109, name: 'Campinas do Piauí', microregionId: 22015 },
    { id: 2202117, name: 'Campo Alegre do Fidalgo', microregionId: 22015 },
    { id: 2202133, name: 'Campo Grande do Piauí', microregionId: 22015 },
    { id: 2202174, name: 'Campo Largo do Piauí', microregionId: 22001 },
    { id: 2202208, name: 'Campo Maior', microregionId: 22004 },
    { id: 2202251, name: 'Canavieira', microregionId: 22009 },
    { id: 2202307, name: 'Canto do Buriti', microregionId: 22011 },
    { id: 2202406, name: 'Capitão de Campos', microregionId: 22004 },
    { id: 2202455, name: 'Capitão Gervásio Oliveira', microregionId: 22015 },
    { id: 2202505, name: 'Caracol', microregionId: 22011 },
    { id: 2202539, name: 'Caraúbas do Piauí', microregionId: 22002 },
    { id: 2202554, name: 'Caridade do Piauí', microregionId: 22015 },
    { id: 2202604, name: 'Castelo do Piauí', microregionId: 22004 },
    { id: 2202653, name: 'Caxingó', microregionId: 22002 },
    { id: 2202703, name: 'Cocal', microregionId: 22002 },
    { id: 2202711, name: 'Cocal de Telha', microregionId: 22004 },
    { id: 2202729, name: 'Cocal dos Alves', microregionId: 22002 },
    { id: 2202737, name: 'Coivaras', microregionId: 22003 },
    { id: 2202752, name: 'Colônia do Gurguéia', microregionId: 22008 },
    { id: 2202778, name: 'Colônia do Piauí', microregionId: 22013 },
    { id: 2202802, name: 'Conceição do Canindé', microregionId: 22015 },
    { id: 2202851, name: 'Coronel José Dias', microregionId: 22011 },
    { id: 2202901, name: 'Corrente', microregionId: 22012 },
    { id: 2203008, name: 'Cristalândia do Piauí', microregionId: 22012 },
    { id: 2203107, name: 'Cristino Castro', microregionId: 22010 },
    { id: 2203206, name: 'Curimatá', microregionId: 22012 },
    { id: 2203230, name: 'Currais', microregionId: 22010 },
    { id: 2203271, name: 'Curral Novo do Piauí', microregionId: 22015 },
    { id: 2203255, name: 'Curralinhos', microregionId: 22003 },
    { id: 2203305, name: 'Demerval Lobão', microregionId: 22003 },
    { id: 2203354, name: 'Dirceu Arcoverde', microregionId: 22011 },
    { id: 2203404, name: 'Dom Expedito Lopes', microregionId: 22013 },
    { id: 2203453, name: 'Dom Inocêncio', microregionId: 22011 },
    { id: 2203420, name: 'Domingos Mourão', microregionId: 22004 },
    { id: 2203503, name: 'Elesbão Veloso', microregionId: 22006 },
    { id: 2203602, name: 'Eliseu Martins', microregionId: 22008 },
    { id: 2203701, name: 'Esperantina', microregionId: 22001 },
    { id: 2203750, name: 'Fartura do Piauí', microregionId: 22011 },
    { id: 2203800, name: 'Flores do Piauí', microregionId: 22009 },
    { id: 2203859, name: 'Floresta do Piauí', microregionId: 22015 },
    { id: 2203909, name: 'Floriano', microregionId: 22009 },
    { id: 2204006, name: 'Francinópolis', microregionId: 22006 },
    { id: 2204105, name: 'Francisco Ayres', microregionId: 22005 },
    { id: 2204154, name: 'Francisco Macedo', microregionId: 22015 },
    { id: 2204204, name: 'Francisco Santos', microregionId: 22014 },
    { id: 2204303, name: 'Fronteiras', microregionId: 22015 },
    { id: 2204352, name: 'Geminiano', microregionId: 22013 },
    { id: 2204402, name: 'Gilbués', microregionId: 22010 },
    { id: 2204501, name: 'Guadalupe', microregionId: 22009 },
    { id: 2204550, name: 'Guaribas', microregionId: 22011 },
    { id: 2204600, name: 'Hugo Napoleão', microregionId: 22005 },
    { id: 2204659, name: 'Ilha Grande', microregionId: 22002 },
    { id: 2204709, name: 'Inhuma', microregionId: 22006 },
    { id: 2204808, name: 'Ipiranga do Piauí', microregionId: 22013 },
    { id: 2204907, name: 'Isaías Coelho', microregionId: 22015 },
    { id: 2205003, name: 'Itainópolis', microregionId: 22015 },
    { id: 2205102, name: 'Itaueira', microregionId: 22009 },
    { id: 2205151, name: 'Jacobina do Piauí', microregionId: 22015 },
    { id: 2205201, name: 'Jaicós', microregionId: 22015 },
    { id: 2205250, name: 'Jardim do Mulato', microregionId: 22005 },
    { id: 2205276, name: 'Jatobá do Piauí', microregionId: 22004 },
    { id: 2205300, name: 'Jerumenha', microregionId: 22009 },
    { id: 2205359, name: 'João Costa', microregionId: 22015 },
    { id: 2205409, name: 'Joaquim Pires', microregionId: 22001 },
    { id: 2205458, name: 'Joca Marques', microregionId: 22001 },
    { id: 2205508, name: 'José de Freitas', microregionId: 22003 },
    { id: 2205516, name: 'Juazeiro do Piauí', microregionId: 22004 },
    { id: 2205524, name: 'Júlio Borges', microregionId: 22012 },
    { id: 2205532, name: 'Jurema', microregionId: 22011 },
    { id: 2205557, name: 'Lagoa Alegre', microregionId: 22003 },
    { id: 2205573, name: 'Lagoa de São Francisco', microregionId: 22004 },
    { id: 2205565, name: 'Lagoa do Barro do Piauí', microregionId: 22015 },
    { id: 2205581, name: 'Lagoa do Piauí', microregionId: 22003 },
    { id: 2205599, name: 'Lagoa do Sítio', microregionId: 22006 },
    { id: 2205540, name: 'Lagoinha do Piauí', microregionId: 22005 },
    { id: 2205607, name: 'Landri Sales', microregionId: 22008 },
    { id: 2205706, name: 'Luís Correia', microregionId: 22002 },
    { id: 2205805, name: 'Luzilândia', microregionId: 22001 },
    { id: 2205854, name: 'Madeiro', microregionId: 22001 },
    { id: 2205904, name: 'Manoel Emídio', microregionId: 22008 },
    { id: 2205953, name: 'Marcolândia', microregionId: 22015 },
    { id: 2206001, name: 'Marcos Parente', microregionId: 22008 },
    { id: 2206050, name: 'Massapê do Piauí', microregionId: 22015 },
    { id: 2206100, name: 'Matias Olímpio', microregionId: 22001 },
    { id: 2206209, name: 'Miguel Alves', microregionId: 22001 },
    { id: 2206308, name: 'Miguel Leão', microregionId: 22003 },
    { id: 2206357, name: 'Milton Brandão', microregionId: 22004 },
    { id: 2206407, name: 'Monsenhor Gil', microregionId: 22003 },
    { id: 2206506, name: 'Monsenhor Hipólito', microregionId: 22014 },
    { id: 2206605, name: 'Monte Alegre do Piauí', microregionId: 22010 },
    { id: 2206654, name: 'Morro Cabeça no Tempo', microregionId: 22012 },
    { id: 2206670, name: 'Morro do Chapéu do Piauí', microregionId: 22001 },
    { id: 2206696, name: 'Murici dos Portelas', microregionId: 22002 },
    { id: 2206704, name: 'Nazaré do Piauí', microregionId: 22009 },
    { id: 2206720, name: 'Nazária', microregionId: 22003 },
    { id: 2206753, name: 'Nossa Senhora de Nazaré', microregionId: 22004 },
    { id: 2206803, name: 'Nossa Senhora dos Remédios', microregionId: 22001 },
    { id: 2207959, name: 'Nova Santa Rita', microregionId: 22015 },
    { id: 2206902, name: 'Novo Oriente do Piauí', microregionId: 22006 },
    { id: 2206951, name: 'Novo Santo Antônio', microregionId: 22004 },
    { id: 2207009, name: 'Oeiras', microregionId: 22013 },
    { id: 2207108, name: 'Olho D\'Água do Piauí', microregionId: 22005 },
    { id: 2207207, name: 'Padre Marcos', microregionId: 22015 },
    { id: 2207306, name: 'Paes Landim', microregionId: 22015 },
    { id: 2207355, name: 'Pajeú do Piauí', microregionId: 22011 },
    { id: 2207405, name: 'Palmeira do Piauí', microregionId: 22010 },
    { id: 2207504, name: 'Palmeirais', microregionId: 22005 },
    { id: 2207553, name: 'Paquetá', microregionId: 22013 },
    { id: 2207603, name: 'Parnaguá', microregionId: 22012 },
    { id: 2207702, name: 'Parnaíba', microregionId: 22002 },
    { id: 2207751, name: 'Passagem Franca do Piauí', microregionId: 22005 },
    { id: 2207777, name: 'Patos do Piauí', microregionId: 22015 },
    { id: 2207793, name: 'Pau D\'Arco do Piauí', microregionId: 22003 },
    { id: 2207801, name: 'Paulistana', microregionId: 22015 },
    { id: 2207850, name: 'Pavussu', microregionId: 22009 },
    { id: 2207900, name: 'Pedro II', microregionId: 22004 },
    { id: 2207934, name: 'Pedro Laurentino', microregionId: 22015 },
    { id: 2208007, name: 'Picos', microregionId: 22013 },
    { id: 2208106, name: 'Pimenteiras', microregionId: 22006 },
    { id: 2208205, name: 'Pio IX', microregionId: 22014 },
    { id: 2208304, name: 'Piracuruca', microregionId: 22002 },
    { id: 2208403, name: 'Piripiri', microregionId: 22001 },
    { id: 2208502, name: 'Porto', microregionId: 22001 },
    { id: 2208551, name: 'Porto Alegre do Piauí', microregionId: 22008 },
    { id: 2208601, name: 'Prata do Piauí', microregionId: 22006 },
    { id: 2208650, name: 'Queimada Nova', microregionId: 22015 },
    { id: 2208700, name: 'Redenção do Gurguéia', microregionId: 22010 },
    { id: 2208809, name: 'Regeneração', microregionId: 22005 },
    { id: 2208858, name: 'Riacho Frio', microregionId: 22012 },
    { id: 2208874, name: 'Ribeira do Piauí', microregionId: 22015 },
    { id: 2208908, name: 'Ribeiro Gonçalves', microregionId: 22007 },
    { id: 2209005, name: 'Rio Grande do Piauí', microregionId: 22009 },
    { id: 2209104, name: 'Santa Cruz do Piauí', microregionId: 22013 },
    { id: 2209153, name: 'Santa Cruz dos Milagres', microregionId: 22006 },
    { id: 2209203, name: 'Santa Filomena', microregionId: 22007 },
    { id: 2209302, name: 'Santa Luz', microregionId: 22010 },
    { id: 2209377, name: 'Santa Rosa do Piauí', microregionId: 22013 },
    { id: 2209351, name: 'Santana do Piauí', microregionId: 22013 },
    { id: 2209401, name: 'Santo Antônio de Lisboa', microregionId: 22014 },
    { id: 2209450, name: 'Santo Antônio dos Milagres', microregionId: 22005 },
    { id: 2209500, name: 'Santo Inácio do Piauí', microregionId: 22015 },
    { id: 2209559, name: 'São Braz do Piauí', microregionId: 22011 },
    { id: 2209609, name: 'São Félix do Piauí', microregionId: 22006 },
    { id: 2209658, name: 'São Francisco de Assis do Piauí', microregionId: 22015 },
    { id: 2209708, name: 'São Francisco do Piauí', microregionId: 22009 },
    { id: 2209757, name: 'São Gonçalo do Gurguéia', microregionId: 22010 },
    { id: 2209807, name: 'São Gonçalo do Piauí', microregionId: 22005 },
    { id: 2209856, name: 'São João da Canabrava', microregionId: 22013 },
    { id: 2209872, name: 'São João da Fronteira', microregionId: 22002 },
    { id: 2209906, name: 'São João da Serra', microregionId: 22004 },
    { id: 2209955, name: 'São João da Varjota', microregionId: 22013 },
    { id: 2209971, name: 'São João do Arraial', microregionId: 22001 },
    { id: 2210003, name: 'São João do Piauí', microregionId: 22015 },
    { id: 2210052, name: 'São José do Divino', microregionId: 22002 },
    { id: 2210102, name: 'São José do Peixe', microregionId: 22009 },
    { id: 2210201, name: 'São José do Piauí', microregionId: 22013 },
    { id: 2210300, name: 'São Julião', microregionId: 22014 },
    { id: 2210359, name: 'São Lourenço do Piauí', microregionId: 22011 },
    { id: 2210375, name: 'São Luis do Piauí', microregionId: 22013 },
    { id: 2210383, name: 'São Miguel da Baixa Grande', microregionId: 22006 },
    { id: 2210391, name: 'São Miguel do Fidalgo', microregionId: 22009 },
    { id: 2210409, name: 'São Miguel do Tapuio', microregionId: 22004 },
    { id: 2210508, name: 'São Pedro do Piauí', microregionId: 22005 },
    { id: 2210607, name: 'São Raimundo Nonato', microregionId: 22011 },
    { id: 2210623, name: 'Sebastião Barros', microregionId: 22012 },
    { id: 2210631, name: 'Sebastião Leal', microregionId: 22008 },
    { id: 2210656, name: 'Sigefredo Pacheco', microregionId: 22004 },
    { id: 2210706, name: 'Simões', microregionId: 22015 },
    { id: 2210805, name: 'Simplício Mendes', microregionId: 22015 },
    { id: 2210904, name: 'Socorro do Piauí', microregionId: 22015 },
    { id: 2210938, name: 'Sussuapara', microregionId: 22013 },
    { id: 2210953, name: 'Tamboril do Piauí', microregionId: 22011 },
    { id: 2210979, name: 'Tanque do Piauí', microregionId: 22013 },
    { id: 2211001, name: 'Teresina', microregionId: 22003 },
    { id: 2211100, name: 'União', microregionId: 22003 },
    { id: 2211209, name: 'Uruçuí', microregionId: 22007 },
    { id: 2211308, name: 'Valença do Piauí', microregionId: 22006 },
    { id: 2211357, name: 'Várzea Branca', microregionId: 22011 },
    { id: 2211407, name: 'Várzea Grande', microregionId: 22006 },
    { id: 2211506, name: 'Vera Mendes', microregionId: 22015 },
    { id: 2211605, name: 'Vila Nova do Piauí', microregionId: 22015 },
    { id: 2211704, name: 'Wall Ferraz', microregionId: 22013 },
  ],
  23: [
    { id: 2300101, name: 'Abaiara', microregionId: 23033 },
    { id: 2300150, name: 'Acarape', microregionId: 23013 },
    { id: 2300200, name: 'Acaraú', microregionId: 23001 },
    { id: 2300309, name: 'Acopiara', microregionId: 23021 },
    { id: 2300408, name: 'Aiuaba', microregionId: 23020 },
    { id: 2300507, name: 'Alcântaras', microregionId: 23004 },
    { id: 2300606, name: 'Altaneira', microregionId: 23030 },
    { id: 2300705, name: 'Alto Santo', microregionId: 23023 },
    { id: 2300754, name: 'Amontada', microregionId: 23008 },
    { id: 2300804, name: 'Antonina do Norte', microregionId: 23027 },
    { id: 2300903, name: 'Apuiarés', microregionId: 23011 },
    { id: 2301000, name: 'Aquiraz', microregionId: 23016 },
    { id: 2301109, name: 'Aracati', microregionId: 23022 },
    { id: 2301208, name: 'Aracoiaba', microregionId: 23013 },
    { id: 2301257, name: 'Ararendá', microregionId: 23018 },
    { id: 2301307, name: 'Araripe', microregionId: 23029 },
    { id: 2301406, name: 'Aratuba', microregionId: 23013 },
    { id: 2301505, name: 'Arneiroz', microregionId: 23020 },
    { id: 2301604, name: 'Assaré', microregionId: 23029 },
    { id: 2301703, name: 'Aurora', microregionId: 23031 },
    { id: 2301802, name: 'Baixio', microregionId: 23028 },
    { id: 2301851, name: 'Banabuiú', microregionId: 23019 },
    { id: 2301901, name: 'Barbalha', microregionId: 23032 },
    { id: 2301950, name: 'Barreira', microregionId: 23014 },
    { id: 2302008, name: 'Barro', microregionId: 23031 },
    { id: 2302057, name: 'Barroquinha', microregionId: 23001 },
    { id: 2302107, name: 'Baturité', microregionId: 23013 },
    { id: 2302206, name: 'Beberibe', microregionId: 23015 },
    { id: 2302305, name: 'Bela Cruz', microregionId: 23001 },
    { id: 2302404, name: 'Boa Viagem', microregionId: 23019 },
    { id: 2302503, name: 'Brejo Santo', microregionId: 23033 },
    { id: 2302602, name: 'Camocim', microregionId: 23001 },
    { id: 2302701, name: 'Campos Sales', microregionId: 23029 },
    { id: 2302800, name: 'Canindé', microregionId: 23012 },
    { id: 2302909, name: 'Capistrano', microregionId: 23013 },
    { id: 2303006, name: 'Caridade', microregionId: 23012 },
    { id: 2303105, name: 'Cariré', microregionId: 23005 },
    { id: 2303204, name: 'Caririaçu', microregionId: 23030 },
    { id: 2303303, name: 'Cariús', microregionId: 23027 },
    { id: 2303402, name: 'Carnaubal', microregionId: 23002 },
    { id: 2303501, name: 'Cascavel', microregionId: 23015 },
    { id: 2303600, name: 'Catarina', microregionId: 23020 },
    { id: 2303659, name: 'Catunda', microregionId: 23007 },
    { id: 2303709, name: 'Caucaia', microregionId: 23016 },
    { id: 2303808, name: 'Cedro', microregionId: 23026 },
    { id: 2303907, name: 'Chaval', microregionId: 23001 },
    { id: 2303931, name: 'Choró', microregionId: 23019 },
    { id: 2303956, name: 'Chorozinho', microregionId: 23014 },
    { id: 2304004, name: 'Coreaú', microregionId: 23003 },
    { id: 2304103, name: 'Crateús', microregionId: 23018 },
    { id: 2304202, name: 'Crato', microregionId: 23032 },
    { id: 2304236, name: 'Croatá', microregionId: 23002 },
    { id: 2304251, name: 'Cruz', microregionId: 23001 },
    { id: 2304269, name: 'Deputado Irapuan Pinheiro', microregionId: 23021 },
    { id: 2304277, name: 'Ereré', microregionId: 23025 },
    { id: 2304285, name: 'Eusébio', microregionId: 23016 },
    { id: 2304301, name: 'Farias Brito', microregionId: 23030 },
    { id: 2304350, name: 'Forquilha', microregionId: 23005 },
    { id: 2304400, name: 'Fortaleza', microregionId: 23016 },
    { id: 2304459, name: 'Fortim', microregionId: 23022 },
    { id: 2304509, name: 'Frecheirinha', microregionId: 23003 },
    { id: 2304608, name: 'General Sampaio', microregionId: 23011 },
    { id: 2304657, name: 'Graça', microregionId: 23005 },
    { id: 2304707, name: 'Granja', microregionId: 23001 },
    { id: 2304806, name: 'Granjeiro', microregionId: 23030 },
    { id: 2304905, name: 'Groaíras', microregionId: 23005 },
    { id: 2304954, name: 'Guaiúba', microregionId: 23016 },
    { id: 2305001, name: 'Guaraciaba do Norte', microregionId: 23002 },
    { id: 2305100, name: 'Guaramiranga', microregionId: 23013 },
    { id: 2305209, name: 'Hidrolândia', microregionId: 23007 },
    { id: 2305233, name: 'Horizonte', microregionId: 23017 },
    { id: 2305266, name: 'Ibaretama', microregionId: 23019 },
    { id: 2305308, name: 'Ibiapina', microregionId: 23002 },
    { id: 2305332, name: 'Ibicuitinga', microregionId: 23023 },
    { id: 2305357, name: 'Icapuí', microregionId: 23022 },
    { id: 2305407, name: 'Icó', microregionId: 23026 },
    { id: 2305506, name: 'Iguatu', microregionId: 23026 },
    { id: 2305605, name: 'Independência', microregionId: 23018 },
    { id: 2305654, name: 'Ipaporanga', microregionId: 23018 },
    { id: 2305704, name: 'Ipaumirim', microregionId: 23028 },
    { id: 2305803, name: 'Ipu', microregionId: 23006 },
    { id: 2305902, name: 'Ipueiras', microregionId: 23006 },
    { id: 2306009, name: 'Iracema', microregionId: 23025 },
    { id: 2306108, name: 'Irauçuba', microregionId: 23005 },
    { id: 2306207, name: 'Itaiçaba', microregionId: 23022 },
    { id: 2306256, name: 'Itaitinga', microregionId: 23016 },
    { id: 2306306, name: 'Itapajé', microregionId: 23010 },
    { id: 2306405, name: 'Itapipoca', microregionId: 23008 },
    { id: 2306504, name: 'Itapiúna', microregionId: 23013 },
    { id: 2306553, name: 'Itarema', microregionId: 23001 },
    { id: 2306603, name: 'Itatira', microregionId: 23012 },
    { id: 2306702, name: 'Jaguaretama', microregionId: 23024 },
    { id: 2306801, name: 'Jaguaribara', microregionId: 23024 },
    { id: 2306900, name: 'Jaguaribe', microregionId: 23024 },
    { id: 2307007, name: 'Jaguaruana', microregionId: 23023 },
    { id: 2307106, name: 'Jardim', microregionId: 23032 },
    { id: 2307205, name: 'Jati', microregionId: 23033 },
    { id: 2307254, name: 'Jijoca de Jericoacoara', microregionId: 23001 },
    { id: 2307304, name: 'Juazeiro do Norte', microregionId: 23032 },
    { id: 2307403, name: 'Jucás', microregionId: 23027 },
    { id: 2307502, name: 'Lavras da Mangabeira', microregionId: 23028 },
    { id: 2307601, name: 'Limoeiro do Norte', microregionId: 23023 },
    { id: 2307635, name: 'Madalena', microregionId: 23019 },
    { id: 2307650, name: 'Maracanaú', microregionId: 23016 },
    { id: 2307700, name: 'Maranguape', microregionId: 23016 },
    { id: 2307809, name: 'Marco', microregionId: 23001 },
    { id: 2307908, name: 'Martinópole', microregionId: 23001 },
    { id: 2308005, name: 'Massapê', microregionId: 23005 },
    { id: 2308104, name: 'Mauriti', microregionId: 23031 },
    { id: 2308203, name: 'Meruoca', microregionId: 23004 },
    { id: 2308302, name: 'Milagres', microregionId: 23033 },
    { id: 2308351, name: 'Milhã', microregionId: 23021 },
    { id: 2308377, name: 'Miraíma', microregionId: 23005 },
    { id: 2308401, name: 'Missão Velha', microregionId: 23032 },
    { id: 2308500, name: 'Mombaça', microregionId: 23021 },
    { id: 2308609, name: 'Monsenhor Tabosa', microregionId: 23018 },
    { id: 2308708, name: 'Morada Nova', microregionId: 23023 },
    { id: 2308807, name: 'Moraújo', microregionId: 23003 },
    { id: 2308906, name: 'Morrinhos', microregionId: 23001 },
    { id: 2309003, name: 'Mucambo', microregionId: 23005 },
    { id: 2309102, name: 'Mulungu', microregionId: 23013 },
    { id: 2309201, name: 'Nova Olinda', microregionId: 23032 },
    { id: 2309300, name: 'Nova Russas', microregionId: 23018 },
    { id: 2309409, name: 'Novo Oriente', microregionId: 23018 },
    { id: 2309458, name: 'Ocara', microregionId: 23014 },
    { id: 2309508, name: 'Orós', microregionId: 23026 },
    { id: 2309607, name: 'Pacajus', microregionId: 23017 },
    { id: 2309706, name: 'Pacatuba', microregionId: 23016 },
    { id: 2309805, name: 'Pacoti', microregionId: 23013 },
    { id: 2309904, name: 'Pacujá', microregionId: 23005 },
    { id: 2310001, name: 'Palhano', microregionId: 23023 },
    { id: 2310100, name: 'Palmácia', microregionId: 23013 },
    { id: 2310209, name: 'Paracuru', microregionId: 23009 },
    { id: 2310258, name: 'Paraipaba', microregionId: 23009 },
    { id: 2310308, name: 'Parambu', microregionId: 23020 },
    { id: 2310407, name: 'Paramoti', microregionId: 23012 },
    { id: 2310506, name: 'Pedra Branca', microregionId: 23021 },
    { id: 2310605, name: 'Penaforte', microregionId: 23033 },
    { id: 2310704, name: 'Pentecoste', microregionId: 23011 },
    { id: 2310803, name: 'Pereiro', microregionId: 23025 },
    { id: 2310852, name: 'Pindoretama', microregionId: 23015 },
    { id: 2310902, name: 'Piquet Carneiro', microregionId: 23021 },
    { id: 2310951, name: 'Pires Ferreira', microregionId: 23006 },
    { id: 2311009, name: 'Poranga', microregionId: 23006 },
    { id: 2311108, name: 'Porteiras', microregionId: 23032 },
    { id: 2311207, name: 'Potengi', microregionId: 23029 },
    { id: 2311231, name: 'Potiretama', microregionId: 23025 },
    { id: 2311264, name: 'Quiterianópolis', microregionId: 23018 },
    { id: 2311306, name: 'Quixadá', microregionId: 23019 },
    { id: 2311355, name: 'Quixelô', microregionId: 23026 },
    { id: 2311405, name: 'Quixeramobim', microregionId: 23019 },
    { id: 2311504, name: 'Quixeré', microregionId: 23023 },
    { id: 2311603, name: 'Redenção', microregionId: 23013 },
    { id: 2311702, name: 'Reriutaba', microregionId: 23006 },
    { id: 2311801, name: 'Russas', microregionId: 23023 },
    { id: 2311900, name: 'Saboeiro', microregionId: 23020 },
    { id: 2311959, name: 'Salitre', microregionId: 23029 },
    { id: 2312205, name: 'Santa Quitéria', microregionId: 23007 },
    { id: 2312007, name: 'Santana do Acaraú', microregionId: 23005 },
    { id: 2312106, name: 'Santana do Cariri', microregionId: 23032 },
    { id: 2312304, name: 'São Benedito', microregionId: 23002 },
    { id: 2312403, name: 'São Gonçalo do Amarante', microregionId: 23009 },
    { id: 2312502, name: 'São João do Jaguaribe', microregionId: 23023 },
    { id: 2312601, name: 'São Luís do Curu', microregionId: 23011 },
    { id: 2312700, name: 'Senador Pompeu', microregionId: 23021 },
    { id: 2312809, name: 'Senador Sá', microregionId: 23005 },
    { id: 2312908, name: 'Sobral', microregionId: 23005 },
    { id: 2313005, name: 'Solonópole', microregionId: 23021 },
    { id: 2313104, name: 'Tabuleiro do Norte', microregionId: 23023 },
    { id: 2313203, name: 'Tamboril', microregionId: 23018 },
    { id: 2313252, name: 'Tarrafas', microregionId: 23027 },
    { id: 2313302, name: 'Tauá', microregionId: 23020 },
    { id: 2313351, name: 'Tejuçuoca', microregionId: 23011 },
    { id: 2313401, name: 'Tianguá', microregionId: 23002 },
    { id: 2313500, name: 'Trairi', microregionId: 23008 },
    { id: 2313559, name: 'Tururu', microregionId: 23010 },
    { id: 2313609, name: 'Ubajara', microregionId: 23002 },
    { id: 2313708, name: 'Umari', microregionId: 23028 },
    { id: 2313757, name: 'Umirim', microregionId: 23010 },
    { id: 2313807, name: 'Uruburetama', microregionId: 23010 },
    { id: 2313906, name: 'Uruoca', microregionId: 23003 },
    { id: 2313955, name: 'Varjota', microregionId: 23006 },
    { id: 2314003, name: 'Várzea Alegre', microregionId: 23027 },
    { id: 2314102, name: 'Viçosa do Ceará', microregionId: 23002 },
  ],
  24: [
    { id: 2400109, name: 'Acari', microregionId: 24012 },
    { id: 2400307, name: 'Afonso Bezerra', microregionId: 24009 },
    { id: 2400406, name: 'Água Nova', microregionId: 24005 },
    { id: 2400505, name: 'Alexandria', microregionId: 24006 },
    { id: 2400604, name: 'Almino Afonso', microregionId: 24007 },
    { id: 2400703, name: 'Alto do Rodrigues', microregionId: 24004 },
    { id: 2400802, name: 'Angicos', microregionId: 24009 },
    { id: 2400901, name: 'Antônio Martins', microregionId: 24007 },
    { id: 2401008, name: 'Apodi', microregionId: 24002 },
    { id: 2401107, name: 'Areia Branca', microregionId: 24001 },
    { id: 2401206, name: 'Arez', microregionId: 24019 },
    { id: 2400208, name: 'Assú', microregionId: 24004 },
    { id: 2401404, name: 'Baía Formosa', microregionId: 24019 },
    { id: 2401453, name: 'Baraúna', microregionId: 24001 },
    { id: 2401503, name: 'Barcelona', microregionId: 24014 },
    { id: 2401602, name: 'Bento Fernandes', microregionId: 24013 },
    { id: 2401651, name: 'Bodó', microregionId: 24010 },
    { id: 2401701, name: 'Bom Jesus', microregionId: 24015 },
    { id: 2401800, name: 'Brejinho', microregionId: 24015 },
    { id: 2401859, name: 'Caiçara do Norte', microregionId: 24008 },
    { id: 2401909, name: 'Caiçara do Rio do Vento', microregionId: 24009 },
    { id: 2402006, name: 'Caicó', microregionId: 24011 },
    { id: 2401305, name: 'Campo Grande', microregionId: 24003 },
    { id: 2402105, name: 'Campo Redondo', microregionId: 24014 },
    { id: 2402204, name: 'Canguaretama', microregionId: 24019 },
    { id: 2402303, name: 'Caraúbas', microregionId: 24002 },
    { id: 2402402, name: 'Carnaúba dos Dantas', microregionId: 24012 },
    { id: 2402501, name: 'Carnaubais', microregionId: 24004 },
    { id: 2402600, name: 'Ceará-Mirim', microregionId: 24017 },
    { id: 2402709, name: 'Cerro Corá', microregionId: 24010 },
    { id: 2402808, name: 'Coronel Ezequiel', microregionId: 24014 },
    { id: 2402907, name: 'Coronel João Pessoa', microregionId: 24005 },
    { id: 2403004, name: 'Cruzeta', microregionId: 24012 },
    { id: 2403103, name: 'Currais Novos', microregionId: 24012 },
    { id: 2403202, name: 'Doutor Severiano', microregionId: 24005 },
    { id: 2403301, name: 'Encanto', microregionId: 24005 },
    { id: 2403400, name: 'Equador', microregionId: 24012 },
    { id: 2403509, name: 'Espírito Santo', microregionId: 24019 },
    { id: 2403608, name: 'Extremoz', microregionId: 24018 },
    { id: 2403707, name: 'Felipe Guerra', microregionId: 24002 },
    { id: 2403756, name: 'Fernando Pedroza', microregionId: 24009 },
    { id: 2403806, name: 'Florânia', microregionId: 24010 },
    { id: 2403905, name: 'Francisco Dantas', microregionId: 24006 },
    { id: 2404002, name: 'Frutuoso Gomes', microregionId: 24007 },
    { id: 2404101, name: 'Galinhos', microregionId: 24008 },
    { id: 2404200, name: 'Goianinha', microregionId: 24019 },
    { id: 2404309, name: 'Governador Dix-Sept Rosado', microregionId: 24002 },
    { id: 2404408, name: 'Grossos', microregionId: 24001 },
    { id: 2404507, name: 'Guamaré', microregionId: 24008 },
    { id: 2404606, name: 'Ielmo Marinho', microregionId: 24015 },
    { id: 2404705, name: 'Ipanguaçu', microregionId: 24004 },
    { id: 2404804, name: 'Ipueira', microregionId: 24011 },
    { id: 2404853, name: 'Itajá', microregionId: 24004 },
    { id: 2404903, name: 'Itaú', microregionId: 24006 },
    { id: 2405009, name: 'Jaçanã', microregionId: 24014 },
    { id: 2405108, name: 'Jandaíra', microregionId: 24013 },
    { id: 2405207, name: 'Janduís', microregionId: 24003 },
    { id: 2405306, name: 'Januário Cicco', microregionId: 24015 },
    { id: 2405405, name: 'Japi', microregionId: 24014 },
    { id: 2405504, name: 'Jardim de Angicos', microregionId: 24009 },
    { id: 2405603, name: 'Jardim de Piranhas', microregionId: 24011 },
    { id: 2405702, name: 'Jardim do Seridó', microregionId: 24012 },
    { id: 2405801, name: 'João Câmara', microregionId: 24013 },
    { id: 2405900, name: 'João Dias', microregionId: 24007 },
    { id: 2406007, name: 'José da Penha', microregionId: 24006 },
    { id: 2406106, name: 'Jucurutu', microregionId: 24004 },
    { id: 2406155, name: 'Jundiá', microregionId: 24015 },
    { id: 2406205, name: 'Lagoa d\'Anta', microregionId: 24015 },
    { id: 2406304, name: 'Lagoa de Pedras', microregionId: 24015 },
    { id: 2406403, name: 'Lagoa de Velhos', microregionId: 24014 },
    { id: 2406502, name: 'Lagoa Nova', microregionId: 24010 },
    { id: 2406601, name: 'Lagoa Salgada', microregionId: 24015 },
    { id: 2406700, name: 'Lajes', microregionId: 24009 },
    { id: 2406809, name: 'Lajes Pintadas', microregionId: 24014 },
    { id: 2406908, name: 'Lucrécia', microregionId: 24007 },
    { id: 2407005, name: 'Luís Gomes', microregionId: 24005 },
    { id: 2407104, name: 'Macaíba', microregionId: 24017 },
    { id: 2407203, name: 'Macau', microregionId: 24008 },
    { id: 2407252, name: 'Major Sales', microregionId: 24005 },
    { id: 2407302, name: 'Marcelino Vieira', microregionId: 24006 },
    { id: 2407401, name: 'Martins', microregionId: 24007 },
    { id: 2407500, name: 'Maxaranguape', microregionId: 24016 },
    { id: 2407609, name: 'Messias Targino', microregionId: 24003 },
    { id: 2407708, name: 'Montanhas', microregionId: 24019 },
    { id: 2407807, name: 'Monte Alegre', microregionId: 24015 },
    { id: 2407906, name: 'Monte das Gameleiras', microregionId: 24014 },
    { id: 2408003, name: 'Mossoró', microregionId: 24001 },
    { id: 2408102, name: 'Natal', microregionId: 24018 },
    { id: 2408201, name: 'Nísia Floresta', microregionId: 24017 },
    { id: 2408300, name: 'Nova Cruz', microregionId: 24015 },
    { id: 2408409, name: 'Olho d\'Água do Borges', microregionId: 24007 },
    { id: 2408508, name: 'Ouro Branco', microregionId: 24012 },
    { id: 2408607, name: 'Paraná', microregionId: 24006 },
    { id: 2408706, name: 'Paraú', microregionId: 24003 },
    { id: 2408805, name: 'Parazinho', microregionId: 24013 },
    { id: 2408904, name: 'Parelhas', microregionId: 24012 },
    { id: 2403251, name: 'Parnamirim', microregionId: 24018 },
    { id: 2409100, name: 'Passa e Fica', microregionId: 24015 },
    { id: 2409209, name: 'Passagem', microregionId: 24015 },
    { id: 2409308, name: 'Patu', microregionId: 24007 },
    { id: 2409407, name: 'Pau dos Ferros', microregionId: 24006 },
    { id: 2409506, name: 'Pedra Grande', microregionId: 24016 },
    { id: 2409605, name: 'Pedra Preta', microregionId: 24009 },
    { id: 2409704, name: 'Pedro Avelino', microregionId: 24009 },
    { id: 2409803, name: 'Pedro Velho', microregionId: 24019 },
    { id: 2409902, name: 'Pendências', microregionId: 24004 },
    { id: 2410009, name: 'Pilões', microregionId: 24006 },
    { id: 2410108, name: 'Poço Branco', microregionId: 24013 },
    { id: 2410207, name: 'Portalegre', microregionId: 24006 },
    { id: 2410256, name: 'Porto do Mangue', microregionId: 24004 },
    { id: 2410405, name: 'Pureza', microregionId: 24016 },
    { id: 2410504, name: 'Rafael Fernandes', microregionId: 24006 },
    { id: 2410603, name: 'Rafael Godeiro', microregionId: 24007 },
    { id: 2410702, name: 'Riacho da Cruz', microregionId: 24006 },
    { id: 2410801, name: 'Riacho de Santana', microregionId: 24005 },
    { id: 2410900, name: 'Riachuelo', microregionId: 24015 },
    { id: 2408953, name: 'Rio do Fogo', microregionId: 24016 },
    { id: 2411007, name: 'Rodolfo Fernandes', microregionId: 24006 },
    { id: 2411106, name: 'Ruy Barbosa', microregionId: 24014 },
    { id: 2411205, name: 'Santa Cruz', microregionId: 24014 },
    { id: 2409332, name: 'Santa Maria', microregionId: 24015 },
    { id: 2411403, name: 'Santana do Matos', microregionId: 24010 },
    { id: 2411429, name: 'Santana do Seridó', microregionId: 24012 },
    { id: 2411502, name: 'Santo Antônio', microregionId: 24015 },
    { id: 2411601, name: 'São Bento do Norte', microregionId: 24008 },
    { id: 2411700, name: 'São Bento do Trairí', microregionId: 24014 },
    { id: 2411809, name: 'São Fernando', microregionId: 24011 },
    { id: 2411908, name: 'São Francisco do Oeste', microregionId: 24006 },
    { id: 2412005, name: 'São Gonçalo do Amarante', microregionId: 24017 },
    { id: 2412104, name: 'São João do Sabugi', microregionId: 24011 },
    { id: 2412203, name: 'São José de Mipibu', microregionId: 24017 },
    { id: 2412302, name: 'São José do Campestre', microregionId: 24014 },
    { id: 2412401, name: 'São José do Seridó', microregionId: 24012 },
    { id: 2412500, name: 'São Miguel', microregionId: 24005 },
    { id: 2412559, name: 'São Miguel do Gostoso', microregionId: 24016 },
    { id: 2412609, name: 'São Paulo do Potengi', microregionId: 24015 },
    { id: 2412708, name: 'São Pedro', microregionId: 24015 },
    { id: 2412807, name: 'São Rafael', microregionId: 24004 },
    { id: 2412906, name: 'São Tomé', microregionId: 24014 },
    { id: 2413003, name: 'São Vicente', microregionId: 24010 },
    { id: 2413102, name: 'Senador Elói de Souza', microregionId: 24015 },
    { id: 2413201, name: 'Senador Georgino Avelino', microregionId: 24019 },
    { id: 2410306, name: 'Serra Caiada', microregionId: 24015 },
    { id: 2413300, name: 'Serra de São Bento', microregionId: 24014 },
    { id: 2413359, name: 'Serra do Mel', microregionId: 24001 },
    { id: 2413409, name: 'Serra Negra do Norte', microregionId: 24011 },
    { id: 2413508, name: 'Serrinha', microregionId: 24015 },
    { id: 2413557, name: 'Serrinha dos Pintos', microregionId: 24007 },
    { id: 2413607, name: 'Severiano Melo', microregionId: 24006 },
    { id: 2413706, name: 'Sítio Novo', microregionId: 24014 },
    { id: 2413805, name: 'Taboleiro Grande', microregionId: 24006 },
    { id: 2413904, name: 'Taipu', microregionId: 24016 },
    { id: 2414001, name: 'Tangará', microregionId: 24014 },
    { id: 2414100, name: 'Tenente Ananias', microregionId: 24006 },
    { id: 2414159, name: 'Tenente Laurentino Cruz', microregionId: 24010 },
    { id: 2411056, name: 'Tibau', microregionId: 24001 },
    { id: 2414209, name: 'Tibau do Sul', microregionId: 24019 },
    { id: 2414308, name: 'Timbaúba dos Batistas', microregionId: 24011 },
    { id: 2414407, name: 'Touros', microregionId: 24016 },
    { id: 2414456, name: 'Triunfo Potiguar', microregionId: 24003 },
    { id: 2414506, name: 'Umarizal', microregionId: 24007 },
    { id: 2414605, name: 'Upanema', microregionId: 24003 },
    { id: 2414704, name: 'Várzea', microregionId: 24015 },
    { id: 2414753, name: 'Venha-Ver', microregionId: 24005 },
    { id: 2414803, name: 'Vera Cruz', microregionId: 24015 },
    { id: 2414902, name: 'Viçosa', microregionId: 24006 },
    { id: 2415008, name: 'Vila Flor', microregionId: 24019 },
  ],
  25: [
    { id: 2500106, name: 'Água Branca', microregionId: 25007 },
    { id: 2500205, name: 'Aguiar', microregionId: 25005 },
    { id: 2500304, name: 'Alagoa Grande', microregionId: 25015 },
    { id: 2500403, name: 'Alagoa Nova', microregionId: 25015 },
    { id: 2500502, name: 'Alagoinha', microregionId: 25016 },
    { id: 2500536, name: 'Alcantil', microregionId: 25011 },
    { id: 2500577, name: 'Algodão de Jandaíra', microregionId: 25012 },
    { id: 2500601, name: 'Alhandra', microregionId: 25023 },
    { id: 2500734, name: 'Amparo', microregionId: 25010 },
    { id: 2500775, name: 'Aparecida', microregionId: 25003 },
    { id: 2500809, name: 'Araçagi', microregionId: 25016 },
    { id: 2500908, name: 'Arara', microregionId: 25012 },
    { id: 2501005, name: 'Araruna', microregionId: 25013 },
    { id: 2501104, name: 'Areia', microregionId: 25015 },
    { id: 2501153, name: 'Areia de Baraúnas', microregionId: 25004 },
    { id: 2501203, name: 'Areial', microregionId: 25014 },
    { id: 2501302, name: 'Aroeiras', microregionId: 25019 },
    { id: 2501351, name: 'Assunção', microregionId: 25010 },
    { id: 2501401, name: 'Baía da Traição', microregionId: 25020 },
    { id: 2501500, name: 'Bananeiras', microregionId: 25015 },
    { id: 2501534, name: 'Baraúna', microregionId: 25009 },
    { id: 2501609, name: 'Barra de Santa Rosa', microregionId: 25012 },
    { id: 2501575, name: 'Barra de Santana', microregionId: 25011 },
    { id: 2501708, name: 'Barra de São Miguel', microregionId: 25011 },
    { id: 2501807, name: 'Bayeux', microregionId: 25022 },
    { id: 2501906, name: 'Belém', microregionId: 25016 },
    { id: 2502003, name: 'Belém do Brejo do Cruz', microregionId: 25001 },
    { id: 2502052, name: 'Bernardino Batista', microregionId: 25002 },
    { id: 2502102, name: 'Boa Ventura', microregionId: 25006 },
    { id: 2502151, name: 'Boa Vista', microregionId: 25017 },
    { id: 2502201, name: 'Bom Jesus', microregionId: 25002 },
    { id: 2502300, name: 'Bom Sucesso', microregionId: 25001 },
    { id: 2502409, name: 'Bonito de Santa Fé', microregionId: 25002 },
    { id: 2502508, name: 'Boqueirão', microregionId: 25011 },
    { id: 2502706, name: 'Borborema', microregionId: 25015 },
    { id: 2502805, name: 'Brejo do Cruz', microregionId: 25001 },
    { id: 2502904, name: 'Brejo dos Santos', microregionId: 25001 },
    { id: 2503001, name: 'Caaporã', microregionId: 25023 },
    { id: 2503100, name: 'Cabaceiras', microregionId: 25011 },
    { id: 2503209, name: 'Cabedelo', microregionId: 25022 },
    { id: 2503308, name: 'Cachoeira dos Índios', microregionId: 25002 },
    { id: 2503407, name: 'Cacimba de Areia', microregionId: 25004 },
    { id: 2503506, name: 'Cacimba de Dentro', microregionId: 25013 },
    { id: 2503555, name: 'Cacimbas', microregionId: 25007 },
    { id: 2503605, name: 'Caiçara', microregionId: 25016 },
    { id: 2503704, name: 'Cajazeiras', microregionId: 25002 },
    { id: 2503753, name: 'Cajazeirinhas', microregionId: 25003 },
    { id: 2503803, name: 'Caldas Brandão', microregionId: 25018 },
    { id: 2503902, name: 'Camalaú', microregionId: 25010 },
    { id: 2504009, name: 'Campina Grande', microregionId: 25017 },
    { id: 2504033, name: 'Capim', microregionId: 25020 },
    { id: 2504074, name: 'Caraúbas', microregionId: 25011 },
    { id: 2504108, name: 'Carrapateira', microregionId: 25002 },
    { id: 2504157, name: 'Casserengue', microregionId: 25013 },
    { id: 2504207, name: 'Catingueira', microregionId: 25005 },
    { id: 2504306, name: 'Catolé do Rocha', microregionId: 25001 },
    { id: 2504355, name: 'Caturité', microregionId: 25011 },
    { id: 2504405, name: 'Conceição', microregionId: 25006 },
    { id: 2504504, name: 'Condado', microregionId: 25003 },
    { id: 2504603, name: 'Conde', microregionId: 25022 },
    { id: 2504702, name: 'Congo', microregionId: 25010 },
    { id: 2504801, name: 'Coremas', microregionId: 25005 },
    { id: 2504850, name: 'Coxixola', microregionId: 25010 },
    { id: 2504900, name: 'Cruz do Espírito Santo', microregionId: 25021 },
    { id: 2505006, name: 'Cubati', microregionId: 25009 },
    { id: 2505105, name: 'Cuité', microregionId: 25012 },
    { id: 2505238, name: 'Cuité de Mamanguape', microregionId: 25020 },
    { id: 2505204, name: 'Cuitegi', microregionId: 25016 },
    { id: 2505279, name: 'Curral de Cima', microregionId: 25020 },
    { id: 2505303, name: 'Curral Velho', microregionId: 25006 },
    { id: 2505352, name: 'Damião', microregionId: 25012 },
    { id: 2505402, name: 'Desterro', microregionId: 25007 },
    { id: 2505600, name: 'Diamante', microregionId: 25006 },
    { id: 2505709, name: 'Dona Inês', microregionId: 25013 },
    { id: 2505808, name: 'Duas Estradas', microregionId: 25016 },
    { id: 2505907, name: 'Emas', microregionId: 25005 },
    { id: 2506004, name: 'Esperança', microregionId: 25014 },
    { id: 2506103, name: 'Fagundes', microregionId: 25017 },
    { id: 2506202, name: 'Frei Martinho', microregionId: 25009 },
    { id: 2506251, name: 'Gado Bravo', microregionId: 25019 },
    { id: 2506301, name: 'Guarabira', microregionId: 25016 },
    { id: 2506400, name: 'Gurinhém', microregionId: 25018 },
    { id: 2506509, name: 'Gurjão', microregionId: 25011 },
    { id: 2506608, name: 'Ibiara', microregionId: 25006 },
    { id: 2502607, name: 'Igaracy', microregionId: 25005 },
    { id: 2506707, name: 'Imaculada', microregionId: 25007 },
    { id: 2506806, name: 'Ingá', microregionId: 25018 },
    { id: 2506905, name: 'Itabaiana', microregionId: 25018 },
    { id: 2507002, name: 'Itaporanga', microregionId: 25006 },
    { id: 2507101, name: 'Itapororoca', microregionId: 25020 },
    { id: 2507200, name: 'Itatuba', microregionId: 25018 },
    { id: 2507309, name: 'Jacaraú', microregionId: 25020 },
    { id: 2507408, name: 'Jericó', microregionId: 25001 },
    { id: 2507507, name: 'João Pessoa', microregionId: 25022 },
    { id: 2513653, name: 'Joca Claudino', microregionId: 25002 },
    { id: 2507606, name: 'Juarez Távora', microregionId: 25018 },
    { id: 2507705, name: 'Juazeirinho', microregionId: 25009 },
    { id: 2507804, name: 'Junco do Seridó', microregionId: 25008 },
    { id: 2507903, name: 'Juripiranga', microregionId: 25021 },
    { id: 2508000, name: 'Juru', microregionId: 25007 },
    { id: 2508109, name: 'Lagoa', microregionId: 25001 },
    { id: 2508208, name: 'Lagoa de Dentro', microregionId: 25016 },
    { id: 2508307, name: 'Lagoa Seca', microregionId: 25017 },
    { id: 2508406, name: 'Lastro', microregionId: 25003 },
    { id: 2508505, name: 'Livramento', microregionId: 25010 },
    { id: 2508554, name: 'Logradouro', microregionId: 25016 },
    { id: 2508604, name: 'Lucena', microregionId: 25022 },
    { id: 2508703, name: 'Mãe d\'Água', microregionId: 25004 },
    { id: 2508802, name: 'Malta', microregionId: 25003 },
    { id: 2508901, name: 'Mamanguape', microregionId: 25020 },
    { id: 2509008, name: 'Manaíra', microregionId: 25007 },
    { id: 2509057, name: 'Marcação', microregionId: 25020 },
    { id: 2509107, name: 'Mari', microregionId: 25021 },
    { id: 2509156, name: 'Marizópolis', microregionId: 25003 },
    { id: 2509206, name: 'Massaranduba', microregionId: 25017 },
    { id: 2509305, name: 'Mataraca', microregionId: 25020 },
    { id: 2509339, name: 'Matinhas', microregionId: 25015 },
    { id: 2509370, name: 'Mato Grosso', microregionId: 25001 },
    { id: 2509396, name: 'Maturéia', microregionId: 25007 },
    { id: 2509404, name: 'Mogeiro', microregionId: 25018 },
    { id: 2509503, name: 'Montadas', microregionId: 25014 },
    { id: 2509602, name: 'Monte Horebe', microregionId: 25002 },
    { id: 2509701, name: 'Monteiro', microregionId: 25010 },
    { id: 2509800, name: 'Mulungu', microregionId: 25016 },
    { id: 2509909, name: 'Natuba', microregionId: 25019 },
    { id: 2510006, name: 'Nazarezinho', microregionId: 25003 },
    { id: 2510105, name: 'Nova Floresta', microregionId: 25012 },
    { id: 2510204, name: 'Nova Olinda', microregionId: 25005 },
    { id: 2510303, name: 'Nova Palmeira', microregionId: 25009 },
    { id: 2510402, name: 'Olho d\'Água', microregionId: 25005 },
    { id: 2510501, name: 'Olivedos', microregionId: 25012 },
    { id: 2510600, name: 'Ouro Velho', microregionId: 25010 },
    { id: 2510659, name: 'Parari', microregionId: 25010 },
    { id: 2510709, name: 'Passagem', microregionId: 25004 },
    { id: 2510808, name: 'Patos', microregionId: 25004 },
    { id: 2510907, name: 'Paulista', microregionId: 25003 },
    { id: 2511004, name: 'Pedra Branca', microregionId: 25006 },
    { id: 2511103, name: 'Pedra Lavrada', microregionId: 25009 },
    { id: 2511202, name: 'Pedras de Fogo', microregionId: 25023 },
    { id: 2512721, name: 'Pedro Régis', microregionId: 25020 },
    { id: 2511301, name: 'Piancó', microregionId: 25005 },
    { id: 2511400, name: 'Picuí', microregionId: 25009 },
    { id: 2511509, name: 'Pilar', microregionId: 25021 },
    { id: 2511608, name: 'Pilões', microregionId: 25015 },
    { id: 2511707, name: 'Pilõezinhos', microregionId: 25016 },
    { id: 2511806, name: 'Pirpirituba', microregionId: 25016 },
    { id: 2511905, name: 'Pitimbu', microregionId: 25023 },
    { id: 2512002, name: 'Pocinhos', microregionId: 25012 },
    { id: 2512036, name: 'Poço Dantas', microregionId: 25002 },
    { id: 2512077, name: 'Poço de José de Moura', microregionId: 25002 },
    { id: 2512101, name: 'Pombal', microregionId: 25003 },
    { id: 2512200, name: 'Prata', microregionId: 25010 },
    { id: 2512309, name: 'Princesa Isabel', microregionId: 25007 },
    { id: 2512408, name: 'Puxinanã', microregionId: 25017 },
    { id: 2512507, name: 'Queimadas', microregionId: 25017 },
    { id: 2512606, name: 'Quixaba', microregionId: 25004 },
    { id: 2512705, name: 'Remígio', microregionId: 25012 },
    { id: 2512747, name: 'Riachão', microregionId: 25013 },
    { id: 2512754, name: 'Riachão do Bacamarte', microregionId: 25018 },
    { id: 2512762, name: 'Riachão do Poço', microregionId: 25021 },
    { id: 2512788, name: 'Riacho de Santo Antônio', microregionId: 25011 },
    { id: 2512804, name: 'Riacho dos Cavalos', microregionId: 25001 },
    { id: 2512903, name: 'Rio Tinto', microregionId: 25020 },
    { id: 2513000, name: 'Salgadinho', microregionId: 25008 },
    { id: 2513109, name: 'Salgado de São Félix', microregionId: 25018 },
    { id: 2513158, name: 'Santa Cecília', microregionId: 25019 },
    { id: 2513208, name: 'Santa Cruz', microregionId: 25003 },
    { id: 2513307, name: 'Santa Helena', microregionId: 25002 },
    { id: 2513356, name: 'Santa Inês', microregionId: 25006 },
    { id: 2513406, name: 'Santa Luzia', microregionId: 25008 },
    { id: 2513703, name: 'Santa Rita', microregionId: 25022 },
    { id: 2513802, name: 'Santa Teresinha', microregionId: 25004 },
    { id: 2513505, name: 'Santana de Mangueira', microregionId: 25006 },
    { id: 2513604, name: 'Santana dos Garrotes', microregionId: 25005 },
    { id: 2513851, name: 'Santo André', microregionId: 25011 },
    { id: 2513927, name: 'São Bentinho', microregionId: 25003 },
    { id: 2513901, name: 'São Bento', microregionId: 25001 },
    { id: 2513968, name: 'São Domingos', microregionId: 25003 },
    { id: 2513943, name: 'São Domingos do Cariri', microregionId: 25011 },
    { id: 2513984, name: 'São Francisco', microregionId: 25003 },
    { id: 2514008, name: 'São João do Cariri', microregionId: 25011 },
    { id: 2500700, name: 'São João do Rio do Peixe', microregionId: 25002 },
    { id: 2514107, name: 'São João do Tigre', microregionId: 25010 },
    { id: 2514206, name: 'São José da Lagoa Tapada', microregionId: 25003 },
    { id: 2514305, name: 'São José de Caiana', microregionId: 25006 },
    { id: 2514404, name: 'São José de Espinharas', microregionId: 25004 },
    { id: 2514503, name: 'São José de Piranhas', microregionId: 25002 },
    { id: 2514552, name: 'São José de Princesa', microregionId: 25007 },
    { id: 2514602, name: 'São José do Bonfim', microregionId: 25004 },
    { id: 2514651, name: 'São José do Brejo do Cruz', microregionId: 25001 },
    { id: 2514701, name: 'São José do Sabugi', microregionId: 25008 },
    { id: 2514800, name: 'São José dos Cordeiros', microregionId: 25010 },
    { id: 2514453, name: 'São José dos Ramos', microregionId: 25021 },
    { id: 2514909, name: 'São Mamede', microregionId: 25008 },
    { id: 2515005, name: 'São Miguel de Taipu', microregionId: 25021 },
    { id: 2515104, name: 'São Sebastião de Lagoa de Roça', microregionId: 25014 },
    { id: 2515203, name: 'São Sebastião do Umbuzeiro', microregionId: 25010 },
    { id: 2515401, name: 'São Vicente do Seridó', microregionId: 25009 },
    { id: 2515302, name: 'Sapé', microregionId: 25021 },
    { id: 2515500, name: 'Serra Branca', microregionId: 25010 },
    { id: 2515609, name: 'Serra da Raiz', microregionId: 25016 },
    { id: 2515708, name: 'Serra Grande', microregionId: 25006 },
    { id: 2515807, name: 'Serra Redonda', microregionId: 25017 },
    { id: 2515906, name: 'Serraria', microregionId: 25015 },
    { id: 2515930, name: 'Sertãozinho', microregionId: 25016 },
    { id: 2515971, name: 'Sobrado', microregionId: 25021 },
    { id: 2516003, name: 'Solânea', microregionId: 25013 },
    { id: 2516102, name: 'Soledade', microregionId: 25012 },
    { id: 2516151, name: 'Sossêgo', microregionId: 25012 },
    { id: 2516201, name: 'Sousa', microregionId: 25003 },
    { id: 2516300, name: 'Sumé', microregionId: 25010 },
    { id: 2516409, name: 'Tacima', microregionId: 25013 },
    { id: 2516508, name: 'Taperoá', microregionId: 25010 },
    { id: 2516607, name: 'Tavares', microregionId: 25007 },
    { id: 2516706, name: 'Teixeira', microregionId: 25007 },
    { id: 2516755, name: 'Tenório', microregionId: 25009 },
    { id: 2516805, name: 'Triunfo', microregionId: 25002 },
    { id: 2516904, name: 'Uiraúna', microregionId: 25002 },
    { id: 2517001, name: 'Umbuzeiro', microregionId: 25019 },
    { id: 2517100, name: 'Várzea', microregionId: 25008 },
    { id: 2517209, name: 'Vieirópolis', microregionId: 25003 },
    { id: 2505501, name: 'Vista Serrana', microregionId: 25003 },
    { id: 2517407, name: 'Zabelê', microregionId: 25010 },
  ],
  26: [
    { id: 2600054, name: 'Abreu e Lima', microregionId: 26017 },
    { id: 2600104, name: 'Afogados da Ingazeira', microregionId: 26003 },
    { id: 2600203, name: 'Afrânio', microregionId: 26005 },
    { id: 2600302, name: 'Agrestina', microregionId: 26012 },
    { id: 2600401, name: 'Água Preta', microregionId: 26015 },
    { id: 2600500, name: 'Águas Belas', microregionId: 26007 },
    { id: 2600609, name: 'Alagoinha', microregionId: 26008 },
    { id: 2600708, name: 'Aliança', microregionId: 26013 },
    { id: 2600807, name: 'Altinho', microregionId: 26012 },
    { id: 2600906, name: 'Amaraji', microregionId: 26015 },
    { id: 2601003, name: 'Angelim', microregionId: 26011 },
    { id: 2601052, name: 'Araçoiaba', microregionId: 26016 },
    { id: 2601102, name: 'Araripina', microregionId: 26001 },
    { id: 2601201, name: 'Arcoverde', microregionId: 26004 },
    { id: 2601300, name: 'Barra de Guabiraba', microregionId: 26012 },
    { id: 2601409, name: 'Barreiros', microregionId: 26015 },
    { id: 2601508, name: 'Belém de Maria', microregionId: 26015 },
    { id: 2601607, name: 'Belém do São Francisco', microregionId: 26006 },
    { id: 2601706, name: 'Belo Jardim', microregionId: 26008 },
    { id: 2601805, name: 'Betânia', microregionId: 26004 },
    { id: 2601904, name: 'Bezerros', microregionId: 26008 },
    { id: 2602001, name: 'Bodocó', microregionId: 26001 },
    { id: 2602100, name: 'Bom Conselho', microregionId: 26011 },
    { id: 2602209, name: 'Bom Jardim', microregionId: 26010 },
    { id: 2602308, name: 'Bonito', microregionId: 26012 },
    { id: 2602407, name: 'Brejão', microregionId: 26011 },
    { id: 2602506, name: 'Brejinho', microregionId: 26003 },
    { id: 2602605, name: 'Brejo da Madre de Deus', microregionId: 26008 },
    { id: 2602704, name: 'Buenos Aires', microregionId: 26013 },
    { id: 2602803, name: 'Buíque', microregionId: 26007 },
    { id: 2602902, name: 'Cabo de Santo Agostinho', microregionId: 26018 },
    { id: 2603009, name: 'Cabrobó', microregionId: 26005 },
    { id: 2603108, name: 'Cachoeirinha', microregionId: 26008 },
    { id: 2603207, name: 'Caetés', microregionId: 26011 },
    { id: 2603306, name: 'Calçado', microregionId: 26011 },
    { id: 2603405, name: 'Calumbi', microregionId: 26003 },
    { id: 2603454, name: 'Camaragibe', microregionId: 26017 },
    { id: 2603504, name: 'Camocim de São Félix', microregionId: 26012 },
    { id: 2603603, name: 'Camutanga', microregionId: 26013 },
    { id: 2603702, name: 'Canhotinho', microregionId: 26011 },
    { id: 2603801, name: 'Capoeiras', microregionId: 26008 },
    { id: 2603900, name: 'Carnaíba', microregionId: 26003 },
    { id: 2603926, name: 'Carnaubeira da Penha', microregionId: 26006 },
    { id: 2604007, name: 'Carpina', microregionId: 26013 },
    { id: 2604106, name: 'Caruaru', microregionId: 26008 },
    { id: 2604155, name: 'Casinhas', microregionId: 26009 },
    { id: 2604205, name: 'Catende', microregionId: 26015 },
    { id: 2604304, name: 'Cedro', microregionId: 26002 },
    { id: 2604403, name: 'Chã de Alegria', microregionId: 26014 },
    { id: 2604502, name: 'Chã Grande', microregionId: 26014 },
    { id: 2604601, name: 'Condado', microregionId: 26013 },
    { id: 2604700, name: 'Correntes', microregionId: 26011 },
    { id: 2604809, name: 'Cortês', microregionId: 26015 },
    { id: 2604908, name: 'Cumaru', microregionId: 26010 },
    { id: 2605004, name: 'Cupira', microregionId: 26012 },
    { id: 2605103, name: 'Custódia', microregionId: 26004 },
    { id: 2605152, name: 'Dormentes', microregionId: 26005 },
    { id: 2605202, name: 'Escada', microregionId: 26015 },
    { id: 2605301, name: 'Exu', microregionId: 26001 },
    { id: 2605400, name: 'Feira Nova', microregionId: 26010 },
    { id: 2605459, name: 'Fernando de Noronha', microregionId: 26019 },
    { id: 2605509, name: 'Ferreiros', microregionId: 26013 },
    { id: 2605608, name: 'Flores', microregionId: 26003 },
    { id: 2605707, name: 'Floresta', microregionId: 26006 },
    { id: 2605806, name: 'Frei Miguelinho', microregionId: 26009 },
    { id: 2605905, name: 'Gameleira', microregionId: 26015 },
    { id: 2606002, name: 'Garanhuns', microregionId: 26011 },
    { id: 2606101, name: 'Glória do Goitá', microregionId: 26014 },
    { id: 2606200, name: 'Goiana', microregionId: 26013 },
    { id: 2606309, name: 'Granito', microregionId: 26001 },
    { id: 2606408, name: 'Gravatá', microregionId: 26008 },
    { id: 2606507, name: 'Iati', microregionId: 26011 },
    { id: 2606606, name: 'Ibimirim', microregionId: 26004 },
    { id: 2606705, name: 'Ibirajuba', microregionId: 26012 },
    { id: 2606804, name: 'Igarassu', microregionId: 26016 },
    { id: 2606903, name: 'Iguaracy', microregionId: 26003 },
    { id: 2607604, name: 'Ilha de Itamaracá', microregionId: 26016 },
    { id: 2607000, name: 'Inajá', microregionId: 26004 },
    { id: 2607109, name: 'Ingazeira', microregionId: 26003 },
    { id: 2607208, name: 'Ipojuca', microregionId: 26018 },
    { id: 2607307, name: 'Ipubi', microregionId: 26001 },
    { id: 2607406, name: 'Itacuruba', microregionId: 26006 },
    { id: 2607505, name: 'Itaíba', microregionId: 26007 },
    { id: 2607653, name: 'Itambé', microregionId: 26013 },
    { id: 2607703, name: 'Itapetim', microregionId: 26003 },
    { id: 2607752, name: 'Itapissuma', microregionId: 26016 },
    { id: 2607802, name: 'Itaquitinga', microregionId: 26013 },
    { id: 2607901, name: 'Jaboatão dos Guararapes', microregionId: 26017 },
    { id: 2607950, name: 'Jaqueira', microregionId: 26015 },
    { id: 2608008, name: 'Jataúba', microregionId: 26008 },
    { id: 2608057, name: 'Jatobá', microregionId: 26006 },
    { id: 2608107, name: 'João Alfredo', microregionId: 26010 },
    { id: 2608206, name: 'Joaquim Nabuco', microregionId: 26015 },
    { id: 2608255, name: 'Jucati', microregionId: 26011 },
    { id: 2608305, name: 'Jupi', microregionId: 26011 },
    { id: 2608404, name: 'Jurema', microregionId: 26011 },
    { id: 2608503, name: 'Lagoa de Itaenga', microregionId: 26013 },
    { id: 2608453, name: 'Lagoa do Carro', microregionId: 26013 },
    { id: 2608602, name: 'Lagoa do Ouro', microregionId: 26011 },
    { id: 2608701, name: 'Lagoa dos Gatos', microregionId: 26012 },
    { id: 2608750, name: 'Lagoa Grande', microregionId: 26005 },
    { id: 2608800, name: 'Lajedo', microregionId: 26011 },
    { id: 2608909, name: 'Limoeiro', microregionId: 26010 },
    { id: 2609006, name: 'Macaparana', microregionId: 26013 },
    { id: 2609105, name: 'Machados', microregionId: 26010 },
    { id: 2609154, name: 'Manari', microregionId: 26004 },
    { id: 2609204, name: 'Maraial', microregionId: 26015 },
    { id: 2609303, name: 'Mirandiba', microregionId: 26002 },
    { id: 2614303, name: 'Moreilândia', microregionId: 26001 },
    { id: 2609402, name: 'Moreno', microregionId: 26017 },
    { id: 2609501, name: 'Nazaré da Mata', microregionId: 26013 },
    { id: 2609600, name: 'Olinda', microregionId: 26017 },
    { id: 2609709, name: 'Orobó', microregionId: 26010 },
    { id: 2609808, name: 'Orocó', microregionId: 26005 },
    { id: 2609907, name: 'Ouricuri', microregionId: 26001 },
    { id: 2610004, name: 'Palmares', microregionId: 26015 },
    { id: 2610103, name: 'Palmeirina', microregionId: 26011 },
    { id: 2610202, name: 'Panelas', microregionId: 26012 },
    { id: 2610301, name: 'Paranatama', microregionId: 26011 },
    { id: 2610400, name: 'Parnamirim', microregionId: 26002 },
    { id: 2610509, name: 'Passira', microregionId: 26010 },
    { id: 2610608, name: 'Paudalho', microregionId: 26013 },
    { id: 2610707, name: 'Paulista', microregionId: 26017 },
    { id: 2610806, name: 'Pedra', microregionId: 26007 },
    { id: 2610905, name: 'Pesqueira', microregionId: 26008 },
    { id: 2611002, name: 'Petrolândia', microregionId: 26006 },
    { id: 2611101, name: 'Petrolina', microregionId: 26005 },
    { id: 2611200, name: 'Poção', microregionId: 26008 },
    { id: 2611309, name: 'Pombos', microregionId: 26014 },
    { id: 2611408, name: 'Primavera', microregionId: 26015 },
    { id: 2611507, name: 'Quipapá', microregionId: 26015 },
    { id: 2611533, name: 'Quixaba', microregionId: 26003 },
    { id: 2611606, name: 'Recife', microregionId: 26017 },
    { id: 2611705, name: 'Riacho das Almas', microregionId: 26008 },
    { id: 2611804, name: 'Ribeirão', microregionId: 26015 },
    { id: 2611903, name: 'Rio Formoso', microregionId: 26015 },
    { id: 2612000, name: 'Sairé', microregionId: 26012 },
    { id: 2612109, name: 'Salgadinho', microregionId: 26010 },
    { id: 2612208, name: 'Salgueiro', microregionId: 26002 },
    { id: 2612307, name: 'Saloá', microregionId: 26011 },
    { id: 2612406, name: 'Sanharó', microregionId: 26008 },
    { id: 2612455, name: 'Santa Cruz', microregionId: 26001 },
    { id: 2612471, name: 'Santa Cruz da Baixa Verde', microregionId: 26003 },
    { id: 2612505, name: 'Santa Cruz do Capibaribe', microregionId: 26009 },
    { id: 2612554, name: 'Santa Filomena', microregionId: 26001 },
    { id: 2612604, name: 'Santa Maria da Boa Vista', microregionId: 26005 },
    { id: 2612703, name: 'Santa Maria do Cambucá', microregionId: 26009 },
    { id: 2612802, name: 'Santa Terezinha', microregionId: 26003 },
    { id: 2612901, name: 'São Benedito do Sul', microregionId: 26015 },
    { id: 2613008, name: 'São Bento do Una', microregionId: 26008 },
    { id: 2613107, name: 'São Caitano', microregionId: 26008 },
    { id: 2613206, name: 'São João', microregionId: 26011 },
    { id: 2613305, name: 'São Joaquim do Monte', microregionId: 26012 },
    { id: 2613404, name: 'São José da Coroa Grande', microregionId: 26015 },
    { id: 2613503, name: 'São José do Belmonte', microregionId: 26002 },
    { id: 2613602, name: 'São José do Egito', microregionId: 26003 },
    { id: 2613701, name: 'São Lourenço da Mata', microregionId: 26017 },
    { id: 2613800, name: 'São Vicente Férrer', microregionId: 26010 },
    { id: 2613909, name: 'Serra Talhada', microregionId: 26003 },
    { id: 2614006, name: 'Serrita', microregionId: 26002 },
    { id: 2614105, name: 'Sertânia', microregionId: 26004 },
    { id: 2614204, name: 'Sirinhaém', microregionId: 26015 },
    { id: 2614402, name: 'Solidão', microregionId: 26003 },
    { id: 2614501, name: 'Surubim', microregionId: 26009 },
    { id: 2614600, name: 'Tabira', microregionId: 26003 },
    { id: 2614709, name: 'Tacaimbó', microregionId: 26008 },
    { id: 2614808, name: 'Tacaratu', microregionId: 26006 },
    { id: 2614857, name: 'Tamandaré', microregionId: 26015 },
    { id: 2615003, name: 'Taquaritinga do Norte', microregionId: 26009 },
    { id: 2615102, name: 'Terezinha', microregionId: 26011 },
    { id: 2615201, name: 'Terra Nova', microregionId: 26005 },
    { id: 2615300, name: 'Timbaúba', microregionId: 26013 },
    { id: 2615409, name: 'Toritama', microregionId: 26009 },
    { id: 2615508, name: 'Tracunhaém', microregionId: 26013 },
    { id: 2615607, name: 'Trindade', microregionId: 26001 },
    { id: 2615706, name: 'Triunfo', microregionId: 26003 },
    { id: 2615805, name: 'Tupanatinga', microregionId: 26007 },
    { id: 2615904, name: 'Tuparetama', microregionId: 26003 },
    { id: 2616001, name: 'Venturosa', microregionId: 26007 },
    { id: 2616100, name: 'Verdejante', microregionId: 26002 },
    { id: 2616183, name: 'Vertente do Lério', microregionId: 26009 },
    { id: 2616209, name: 'Vertentes', microregionId: 26009 },
    { id: 2616308, name: 'Vicência', microregionId: 26013 },
    { id: 2616407, name: 'Vitória de Santo Antão', microregionId: 26014 },
    { id: 2616506, name: 'Xexéu', microregionId: 26015 },
  ],
  27: [
    { id: 2700102, name: 'Água Branca', microregionId: 27001 },
    { id: 2700201, name: 'Anadia', microregionId: 27012 },
    { id: 2700300, name: 'Arapiraca', microregionId: 27006 },
    { id: 2700409, name: 'Atalaia', microregionId: 27009 },
    { id: 2700508, name: 'Barra de Santo Antônio', microregionId: 27011 },
    { id: 2700607, name: 'Barra de São Miguel', microregionId: 27011 },
    { id: 2700706, name: 'Batalha', microregionId: 27004 },
    { id: 2700805, name: 'Belém', microregionId: 27005 },
    { id: 2700904, name: 'Belo Monte', microregionId: 27004 },
    { id: 2701001, name: 'Boca da Mata', microregionId: 27012 },
    { id: 2701100, name: 'Branquinha', microregionId: 27009 },
    { id: 2701209, name: 'Cacimbinhas', microregionId: 27005 },
    { id: 2701308, name: 'Cajueiro', microregionId: 27009 },
    { id: 2701357, name: 'Campestre', microregionId: 27009 },
    { id: 2701407, name: 'Campo Alegre', microregionId: 27012 },
    { id: 2701506, name: 'Campo Grande', microregionId: 27006 },
    { id: 2701605, name: 'Canapi', microregionId: 27001 },
    { id: 2701704, name: 'Capela', microregionId: 27009 },
    { id: 2701803, name: 'Carneiros', microregionId: 27003 },
    { id: 2701902, name: 'Chã Preta', microregionId: 27008 },
    { id: 2702009, name: 'Coité do Nóia', microregionId: 27006 },
    { id: 2702108, name: 'Colônia Leopoldina', microregionId: 27009 },
    { id: 2702207, name: 'Coqueiro Seco', microregionId: 27011 },
    { id: 2702306, name: 'Coruripe', microregionId: 27012 },
    { id: 2702355, name: 'Craíbas', microregionId: 27006 },
    { id: 2702405, name: 'Delmiro Gouveia', microregionId: 27002 },
    { id: 2702504, name: 'Dois Riachos', microregionId: 27003 },
    { id: 2702553, name: 'Estrela de Alagoas', microregionId: 27005 },
    { id: 2702603, name: 'Feira Grande', microregionId: 27006 },
    { id: 2702702, name: 'Feliz Deserto', microregionId: 27013 },
    { id: 2702801, name: 'Flexeiras', microregionId: 27009 },
    { id: 2702900, name: 'Girau do Ponciano', microregionId: 27006 },
    { id: 2703007, name: 'Ibateguara', microregionId: 27008 },
    { id: 2703106, name: 'Igaci', microregionId: 27005 },
    { id: 2703205, name: 'Igreja Nova', microregionId: 27013 },
    { id: 2703304, name: 'Inhapi', microregionId: 27001 },
    { id: 2703403, name: 'Jacaré dos Homens', microregionId: 27004 },
    { id: 2703502, name: 'Jacuípe', microregionId: 27009 },
    { id: 2703601, name: 'Japaratinga', microregionId: 27010 },
    { id: 2703700, name: 'Jaramataia', microregionId: 27004 },
    { id: 2703759, name: 'Jequiá da Praia', microregionId: 27012 },
    { id: 2703809, name: 'Joaquim Gomes', microregionId: 27009 },
    { id: 2703908, name: 'Jundiá', microregionId: 27009 },
    { id: 2704005, name: 'Junqueiro', microregionId: 27012 },
    { id: 2704104, name: 'Lagoa da Canoa', microregionId: 27006 },
    { id: 2704203, name: 'Limoeiro de Anadia', microregionId: 27006 },
    { id: 2704302, name: 'Maceió', microregionId: 27011 },
    { id: 2704401, name: 'Major Isidoro', microregionId: 27004 },
    { id: 2704906, name: 'Mar Vermelho', microregionId: 27005 },
    { id: 2704500, name: 'Maragogi', microregionId: 27010 },
    { id: 2704609, name: 'Maravilha', microregionId: 27003 },
    { id: 2704708, name: 'Marechal Deodoro', microregionId: 27011 },
    { id: 2704807, name: 'Maribondo', microregionId: 27005 },
    { id: 2705002, name: 'Mata Grande', microregionId: 27001 },
    { id: 2705101, name: 'Matriz de Camaragibe', microregionId: 27009 },
    { id: 2705200, name: 'Messias', microregionId: 27009 },
    { id: 2705309, name: 'Minador do Negrão', microregionId: 27005 },
    { id: 2705408, name: 'Monteirópolis', microregionId: 27004 },
    { id: 2705507, name: 'Murici', microregionId: 27009 },
    { id: 2705606, name: 'Novo Lino', microregionId: 27009 },
    { id: 2705705, name: 'Olho d\'Água das Flores', microregionId: 27004 },
    { id: 2705804, name: 'Olho d\'Água do Casado', microregionId: 27002 },
    { id: 2705903, name: 'Olho d\'Água Grande', microregionId: 27007 },
    { id: 2706000, name: 'Olivença', microregionId: 27004 },
    { id: 2706109, name: 'Ouro Branco', microregionId: 27003 },
    { id: 2706208, name: 'Palestina', microregionId: 27003 },
    { id: 2706307, name: 'Palmeira dos Índios', microregionId: 27005 },
    { id: 2706406, name: 'Pão de Açúcar', microregionId: 27003 },
    { id: 2706422, name: 'Pariconha', microregionId: 27001 },
    { id: 2706448, name: 'Paripueira', microregionId: 27011 },
    { id: 2706505, name: 'Passo de Camaragibe', microregionId: 27010 },
    { id: 2706604, name: 'Paulo Jacinto', microregionId: 27005 },
    { id: 2706703, name: 'Penedo', microregionId: 27013 },
    { id: 2706802, name: 'Piaçabuçu', microregionId: 27013 },
    { id: 2706901, name: 'Pilar', microregionId: 27011 },
    { id: 2707008, name: 'Pindoba', microregionId: 27008 },
    { id: 2707107, name: 'Piranhas', microregionId: 27002 },
    { id: 2707206, name: 'Poço das Trincheiras', microregionId: 27003 },
    { id: 2707305, name: 'Porto Calvo', microregionId: 27009 },
    { id: 2707404, name: 'Porto de Pedras', microregionId: 27010 },
    { id: 2707503, name: 'Porto Real do Colégio', microregionId: 27013 },
    { id: 2707602, name: 'Quebrangulo', microregionId: 27005 },
    { id: 2707701, name: 'Rio Largo', microregionId: 27011 },
    { id: 2707800, name: 'Roteiro', microregionId: 27012 },
    { id: 2707909, name: 'Santa Luzia do Norte', microregionId: 27011 },
    { id: 2708006, name: 'Santana do Ipanema', microregionId: 27003 },
    { id: 2708105, name: 'Santana do Mundaú', microregionId: 27008 },
    { id: 2708204, name: 'São Brás', microregionId: 27007 },
    { id: 2708303, name: 'São José da Laje', microregionId: 27008 },
    { id: 2708402, name: 'São José da Tapera', microregionId: 27003 },
    { id: 2708501, name: 'São Luís do Quitunde', microregionId: 27009 },
    { id: 2708600, name: 'São Miguel dos Campos', microregionId: 27012 },
    { id: 2708709, name: 'São Miguel dos Milagres', microregionId: 27010 },
    { id: 2708808, name: 'São Sebastião', microregionId: 27006 },
    { id: 2708907, name: 'Satuba', microregionId: 27011 },
    { id: 2708956, name: 'Senador Rui Palmeira', microregionId: 27003 },
    { id: 2709004, name: 'Tanque d\'Arca', microregionId: 27005 },
    { id: 2709103, name: 'Taquarana', microregionId: 27006 },
    { id: 2709152, name: 'Teotônio Vilela', microregionId: 27012 },
    { id: 2709202, name: 'Traipu', microregionId: 27007 },
    { id: 2709301, name: 'União dos Palmares', microregionId: 27008 },
    { id: 2709400, name: 'Viçosa', microregionId: 27008 },
  ],
  28: [
    { id: 2800100, name: 'Amparo do São Francisco', microregionId: 28007 },
    { id: 2800209, name: 'Aquidabã', microregionId: 28003 },
    { id: 2800308, name: 'Aracaju', microregionId: 28011 },
    { id: 2800407, name: 'Arauá', microregionId: 28012 },
    { id: 2800506, name: 'Areia Branca', microregionId: 28004 },
    { id: 2800605, name: 'Barra dos Coqueiros', microregionId: 28011 },
    { id: 2800670, name: 'Boquim', microregionId: 28012 },
    { id: 2800704, name: 'Brejo Grande', microregionId: 28007 },
    { id: 2801009, name: 'Campo do Brito', microregionId: 28004 },
    { id: 2801108, name: 'Canhoba', microregionId: 28007 },
    { id: 2801207, name: 'Canindé de São Francisco', microregionId: 28001 },
    { id: 2801306, name: 'Capela', microregionId: 28008 },
    { id: 2801405, name: 'Carira', microregionId: 28002 },
    { id: 2801504, name: 'Carmópolis', microregionId: 28010 },
    { id: 2801603, name: 'Cedro de São João', microregionId: 28007 },
    { id: 2801702, name: 'Cristinápolis', microregionId: 28012 },
    { id: 2801900, name: 'Cumbe', microregionId: 28003 },
    { id: 2802007, name: 'Divina Pastora', microregionId: 28008 },
    { id: 2802106, name: 'Estância', microregionId: 28013 },
    { id: 2802205, name: 'Feira Nova', microregionId: 28001 },
    { id: 2802304, name: 'Frei Paulo', microregionId: 28002 },
    { id: 2802403, name: 'Gararu', microregionId: 28001 },
    { id: 2802502, name: 'General Maynard', microregionId: 28010 },
    { id: 2802601, name: 'Graccho Cardoso', microregionId: 28001 },
    { id: 2802700, name: 'Ilha das Flores', microregionId: 28007 },
    { id: 2802809, name: 'Indiaroba', microregionId: 28013 },
    { id: 2802908, name: 'Itabaiana', microregionId: 28004 },
    { id: 2803005, name: 'Itabaianinha', microregionId: 28012 },
    { id: 2803104, name: 'Itabi', microregionId: 28001 },
    { id: 2803203, name: 'Itaporanga d\'Ajuda', microregionId: 28013 },
    { id: 2803302, name: 'Japaratuba', microregionId: 28009 },
    { id: 2803401, name: 'Japoatã', microregionId: 28009 },
    { id: 2803500, name: 'Lagarto', microregionId: 28006 },
    { id: 2803609, name: 'Laranjeiras', microregionId: 28010 },
    { id: 2803708, name: 'Macambira', microregionId: 28004 },
    { id: 2803807, name: 'Malhada dos Bois', microregionId: 28003 },
    { id: 2803906, name: 'Malhador', microregionId: 28004 },
    { id: 2804003, name: 'Maruim', microregionId: 28010 },
    { id: 2804102, name: 'Moita Bonita', microregionId: 28004 },
    { id: 2804201, name: 'Monte Alegre de Sergipe', microregionId: 28001 },
    { id: 2804300, name: 'Muribeca', microregionId: 28003 },
    { id: 2804409, name: 'Neópolis', microregionId: 28007 },
    { id: 2804458, name: 'Nossa Senhora Aparecida', microregionId: 28002 },
    { id: 2804508, name: 'Nossa Senhora da Glória', microregionId: 28001 },
    { id: 2804607, name: 'Nossa Senhora das Dores', microregionId: 28003 },
    { id: 2804706, name: 'Nossa Senhora de Lourdes', microregionId: 28007 },
    { id: 2804805, name: 'Nossa Senhora do Socorro', microregionId: 28011 },
    { id: 2804904, name: 'Pacatuba', microregionId: 28009 },
    { id: 2805000, name: 'Pedra Mole', microregionId: 28002 },
    { id: 2805109, name: 'Pedrinhas', microregionId: 28012 },
    { id: 2805208, name: 'Pinhão', microregionId: 28002 },
    { id: 2805307, name: 'Pirambu', microregionId: 28009 },
    { id: 2805406, name: 'Poço Redondo', microregionId: 28001 },
    { id: 2805505, name: 'Poço Verde', microregionId: 28005 },
    { id: 2805604, name: 'Porto da Folha', microregionId: 28001 },
    { id: 2805703, name: 'Propriá', microregionId: 28007 },
    { id: 2805802, name: 'Riachão do Dantas', microregionId: 28006 },
    { id: 2805901, name: 'Riachuelo', microregionId: 28010 },
    { id: 2806008, name: 'Ribeirópolis', microregionId: 28002 },
    { id: 2806107, name: 'Rosário do Catete', microregionId: 28010 },
    { id: 2806206, name: 'Salgado', microregionId: 28012 },
    { id: 2806305, name: 'Santa Luzia do Itanhy', microregionId: 28013 },
    { id: 2806503, name: 'Santa Rosa de Lima', microregionId: 28008 },
    { id: 2806404, name: 'Santana do São Francisco', microregionId: 28007 },
    { id: 2806602, name: 'Santo Amaro das Brotas', microregionId: 28010 },
    { id: 2806701, name: 'São Cristóvão', microregionId: 28011 },
    { id: 2806800, name: 'São Domingos', microregionId: 28004 },
    { id: 2806909, name: 'São Francisco', microregionId: 28009 },
    { id: 2807006, name: 'São Miguel do Aleixo', microregionId: 28003 },
    { id: 2807105, name: 'Simão Dias', microregionId: 28005 },
    { id: 2807204, name: 'Siriri', microregionId: 28008 },
    { id: 2807303, name: 'Telha', microregionId: 28007 },
    { id: 2807402, name: 'Tobias Barreto', microregionId: 28005 },
    { id: 2807501, name: 'Tomar do Geru', microregionId: 28012 },
    { id: 2807600, name: 'Umbaúba', microregionId: 28012 },
  ],
  29: [
    { id: 2900108, name: 'Abaíra', microregionId: 29023 },
    { id: 2900207, name: 'Abaré', microregionId: 29005 },
    { id: 2900306, name: 'Acajutiba', microregionId: 29017 },
    { id: 2900355, name: 'Adustina', microregionId: 29015 },
    { id: 2900405, name: 'Água Fria', microregionId: 29012 },
    { id: 2900603, name: 'Aiquara', microregionId: 29024 },
    { id: 2900702, name: 'Alagoinhas', microregionId: 29017 },
    { id: 2900801, name: 'Alcobaça', microregionId: 29032 },
    { id: 2900900, name: 'Almadina', microregionId: 29031 },
    { id: 2901007, name: 'Amargosa', microregionId: 29024 },
    { id: 2901106, name: 'Amélia Rodrigues', microregionId: 29019 },
    { id: 2901155, name: 'América Dourada', microregionId: 29009 },
    { id: 2901205, name: 'Anagé', microregionId: 29028 },
    { id: 2901304, name: 'Andaraí', microregionId: 29023 },
    { id: 2901353, name: 'Andorinha', microregionId: 29008 },
    { id: 2901403, name: 'Angical', microregionId: 29002 },
    { id: 2901502, name: 'Anguera', microregionId: 29012 },
    { id: 2901601, name: 'Antas', microregionId: 29015 },
    { id: 2901700, name: 'Antônio Cardoso', microregionId: 29012 },
    { id: 2901809, name: 'Antônio Gonçalves', microregionId: 29008 },
    { id: 2901908, name: 'Aporá', microregionId: 29017 },
    { id: 2901957, name: 'Apuarema', microregionId: 29024 },
    { id: 2902054, name: 'Araçás', microregionId: 29017 },
    { id: 2902005, name: 'Aracatu', microregionId: 29027 },
    { id: 2902104, name: 'Araci', microregionId: 29016 },
    { id: 2902203, name: 'Aramari', microregionId: 29017 },
    { id: 2902252, name: 'Arataca', microregionId: 29031 },
    { id: 2902302, name: 'Aratuípe', microregionId: 29020 },
    { id: 2902401, name: 'Aurelino Leal', microregionId: 29031 },
    { id: 2902500, name: 'Baianópolis', microregionId: 29001 },
    { id: 2902609, name: 'Baixa Grande', microregionId: 29011 },
    { id: 2902658, name: 'Banzaê', microregionId: 29015 },
    { id: 2902708, name: 'Barra', microregionId: 29006 },
    { id: 2902807, name: 'Barra da Estiva', microregionId: 29023 },
    { id: 2902906, name: 'Barra do Choça', microregionId: 29028 },
    { id: 2903003, name: 'Barra do Mendes', microregionId: 29009 },
    { id: 2903102, name: 'Barra do Rocha', microregionId: 29031 },
    { id: 2903201, name: 'Barreiras', microregionId: 29001 },
    { id: 2903235, name: 'Barro Alto', microregionId: 29009 },
    { id: 2903300, name: 'Barro Preto', microregionId: 29031 },
    { id: 2903276, name: 'Barrocas', microregionId: 29016 },
    { id: 2903409, name: 'Belmonte', microregionId: 29031 },
    { id: 2903508, name: 'Belo Campo', microregionId: 29028 },
    { id: 2903607, name: 'Biritinga', microregionId: 29016 },
    { id: 2903706, name: 'Boa Nova', microregionId: 29028 },
    { id: 2903805, name: 'Boa Vista do Tupim', microregionId: 29011 },
    { id: 2903904, name: 'Bom Jesus da Lapa', microregionId: 29007 },
    { id: 2903953, name: 'Bom Jesus da Serra', microregionId: 29028 },
    { id: 2904001, name: 'Boninal', microregionId: 29023 },
    { id: 2904050, name: 'Bonito', microregionId: 29023 },
    { id: 2904100, name: 'Boquira', microregionId: 29022 },
    { id: 2904209, name: 'Botuporã', microregionId: 29022 },
    { id: 2904308, name: 'Brejões', microregionId: 29024 },
    { id: 2904407, name: 'Brejolândia', microregionId: 29002 },
    { id: 2904506, name: 'Brotas de Macaúbas', microregionId: 29022 },
    { id: 2904605, name: 'Brumado', microregionId: 29027 },
    { id: 2904704, name: 'Buerarema', microregionId: 29031 },
    { id: 2904753, name: 'Buritirama', microregionId: 29006 },
    { id: 2904803, name: 'Caatiba', microregionId: 29028 },
    { id: 2904852, name: 'Cabaceiras do Paraguaçu', microregionId: 29020 },
    { id: 2904902, name: 'Cachoeira', microregionId: 29020 },
    { id: 2905008, name: 'Caculé', microregionId: 29026 },
    { id: 2905107, name: 'Caém', microregionId: 29010 },
    { id: 2905156, name: 'Caetanos', microregionId: 29028 },
    { id: 2905206, name: 'Caetité', microregionId: 29026 },
    { id: 2905305, name: 'Cafarnaum', microregionId: 29009 },
    { id: 2905404, name: 'Cairu', microregionId: 29030 },
    { id: 2905503, name: 'Caldeirão Grande', microregionId: 29010 },
    { id: 2905602, name: 'Camacan', microregionId: 29031 },
    { id: 2905701, name: 'Camaçari', microregionId: 29021 },
    { id: 2905800, name: 'Camamu', microregionId: 29030 },
    { id: 2905909, name: 'Campo Alegre de Lourdes', microregionId: 29004 },
    { id: 2906006, name: 'Campo Formoso', microregionId: 29008 },
    { id: 2906105, name: 'Canápolis', microregionId: 29003 },
    { id: 2906204, name: 'Canarana', microregionId: 29009 },
    { id: 2906303, name: 'Canavieiras', microregionId: 29031 },
    { id: 2906402, name: 'Candeal', microregionId: 29016 },
    { id: 2906501, name: 'Candeias', microregionId: 29021 },
    { id: 2906600, name: 'Candiba', microregionId: 29026 },
    { id: 2906709, name: 'Cândido Sales', microregionId: 29028 },
    { id: 2906808, name: 'Cansanção', microregionId: 29014 },
    { id: 2906824, name: 'Canudos', microregionId: 29014 },
    { id: 2906857, name: 'Capela do Alto Alegre', microregionId: 29016 },
    { id: 2906873, name: 'Capim Grosso', microregionId: 29010 },
    { id: 2906899, name: 'Caraíbas', microregionId: 29027 },
    { id: 2906907, name: 'Caravelas', microregionId: 29032 },
    { id: 2907004, name: 'Cardeal da Silva', microregionId: 29018 },
    { id: 2907103, name: 'Carinhanha', microregionId: 29007 },
    { id: 2907202, name: 'Casa Nova', microregionId: 29004 },
    { id: 2907301, name: 'Castro Alves', microregionId: 29020 },
    { id: 2907400, name: 'Catolândia', microregionId: 29001 },
    { id: 2907509, name: 'Catu', microregionId: 29019 },
    { id: 2907558, name: 'Caturama', microregionId: 29022 },
    { id: 2907608, name: 'Central', microregionId: 29009 },
    { id: 2907707, name: 'Chorrochó', microregionId: 29005 },
    { id: 2907806, name: 'Cícero Dantas', microregionId: 29015 },
    { id: 2907905, name: 'Cipó', microregionId: 29015 },
    { id: 2908002, name: 'Coaraci', microregionId: 29031 },
    { id: 2908101, name: 'Cocos', microregionId: 29003 },
    { id: 2908200, name: 'Conceição da Feira', microregionId: 29012 },
    { id: 2908309, name: 'Conceição do Almeida', microregionId: 29020 },
    { id: 2908408, name: 'Conceição do Coité', microregionId: 29016 },
    { id: 2908507, name: 'Conceição do Jacuípe', microregionId: 29012 },
    { id: 2908606, name: 'Conde', microregionId: 29018 },
    { id: 2908705, name: 'Condeúba', microregionId: 29027 },
    { id: 2908804, name: 'Contendas do Sincorá', microregionId: 29023 },
    { id: 2908903, name: 'Coração de Maria', microregionId: 29012 },
    { id: 2909000, name: 'Cordeiros', microregionId: 29027 },
    { id: 2909109, name: 'Coribe', microregionId: 29003 },
    { id: 2909208, name: 'Coronel João Sá', microregionId: 29013 },
    { id: 2909307, name: 'Correntina', microregionId: 29003 },
    { id: 2909406, name: 'Cotegipe', microregionId: 29002 },
    { id: 2909505, name: 'Cravolândia', microregionId: 29024 },
    { id: 2909604, name: 'Crisópolis', microregionId: 29017 },
    { id: 2909703, name: 'Cristópolis', microregionId: 29002 },
    { id: 2909802, name: 'Cruz das Almas', microregionId: 29020 },
    { id: 2909901, name: 'Curaçá', microregionId: 29004 },
    { id: 2910008, name: 'Dário Meira', microregionId: 29028 },
    { id: 2910057, name: 'Dias d\'Ávila', microregionId: 29021 },
    { id: 2910107, name: 'Dom Basílio', microregionId: 29025 },
    { id: 2910206, name: 'Dom Macedo Costa', microregionId: 29020 },
    { id: 2910305, name: 'Elísio Medrado', microregionId: 29012 },
    { id: 2910404, name: 'Encruzilhada', microregionId: 29029 },
    { id: 2910503, name: 'Entre Rios', microregionId: 29018 },
    { id: 2900504, name: 'Érico Cardoso', microregionId: 29025 },
    { id: 2910602, name: 'Esplanada', microregionId: 29018 },
    { id: 2910701, name: 'Euclides da Cunha', microregionId: 29014 },
    { id: 2910727, name: 'Eunápolis', microregionId: 29032 },
    { id: 2910750, name: 'Fátima', microregionId: 29015 },
    { id: 2910776, name: 'Feira da Mata', microregionId: 29007 },
    { id: 2910800, name: 'Feira de Santana', microregionId: 29012 },
    { id: 2910859, name: 'Filadélfia', microregionId: 29008 },
    { id: 2910909, name: 'Firmino Alves', microregionId: 29031 },
    { id: 2911006, name: 'Floresta Azul', microregionId: 29031 },
    { id: 2911105, name: 'Formosa do Rio Preto', microregionId: 29001 },
    { id: 2911204, name: 'Gandu', microregionId: 29031 },
    { id: 2911253, name: 'Gavião', microregionId: 29016 },
    { id: 2911303, name: 'Gentio do Ouro', microregionId: 29009 },
    { id: 2911402, name: 'Glória', microregionId: 29005 },
    { id: 2911501, name: 'Gongogi', microregionId: 29031 },
    { id: 2911600, name: 'Governador Mangabeira', microregionId: 29020 },
    { id: 2911659, name: 'Guajeru', microregionId: 29027 },
    { id: 2911709, name: 'Guanambi', microregionId: 29026 },
    { id: 2911808, name: 'Guaratinga', microregionId: 29032 },
    { id: 2911857, name: 'Heliópolis', microregionId: 29015 },
    { id: 2911907, name: 'Iaçu', microregionId: 29011 },
    { id: 2912004, name: 'Ibiassucê', microregionId: 29026 },
    { id: 2912103, name: 'Ibicaraí', microregionId: 29031 },
    { id: 2912202, name: 'Ibicoara', microregionId: 29023 },
    { id: 2912301, name: 'Ibicuí', microregionId: 29028 },
    { id: 2912400, name: 'Ibipeba', microregionId: 29009 },
    { id: 2912509, name: 'Ibipitanga', microregionId: 29022 },
    { id: 2912608, name: 'Ibiquera', microregionId: 29011 },
    { id: 2912707, name: 'Ibirapitanga', microregionId: 29031 },
    { id: 2912806, name: 'Ibirapuã', microregionId: 29032 },
    { id: 2912905, name: 'Ibirataia', microregionId: 29031 },
    { id: 2913002, name: 'Ibitiara', microregionId: 29022 },
    { id: 2913101, name: 'Ibititá', microregionId: 29009 },
    { id: 2913200, name: 'Ibotirama', microregionId: 29006 },
    { id: 2913309, name: 'Ichu', microregionId: 29016 },
    { id: 2913408, name: 'Igaporã', microregionId: 29026 },
    { id: 2913457, name: 'Igrapiúna', microregionId: 29030 },
    { id: 2913507, name: 'Iguaí', microregionId: 29028 },
    { id: 2913606, name: 'Ilhéus', microregionId: 29031 },
    { id: 2913705, name: 'Inhambupe', microregionId: 29017 },
    { id: 2913804, name: 'Ipecaetá', microregionId: 29012 },
    { id: 2913903, name: 'Ipiaú', microregionId: 29031 },
    { id: 2914000, name: 'Ipirá', microregionId: 29012 },
    { id: 2914109, name: 'Ipupiara', microregionId: 29022 },
    { id: 2914208, name: 'Irajuba', microregionId: 29024 },
    { id: 2914307, name: 'Iramaia', microregionId: 29024 },
    { id: 2914406, name: 'Iraquara', microregionId: 29009 },
    { id: 2914505, name: 'Irará', microregionId: 29012 },
    { id: 2914604, name: 'Irecê', microregionId: 29009 },
    { id: 2914653, name: 'Itabela', microregionId: 29032 },
    { id: 2914703, name: 'Itaberaba', microregionId: 29011 },
    { id: 2914802, name: 'Itabuna', microregionId: 29031 },
    { id: 2914901, name: 'Itacaré', microregionId: 29031 },
    { id: 2915007, name: 'Itaeté', microregionId: 29023 },
    { id: 2915106, name: 'Itagi', microregionId: 29024 },
    { id: 2915205, name: 'Itagibá', microregionId: 29031 },
    { id: 2915304, name: 'Itagimirim', microregionId: 29032 },
    { id: 2915353, name: 'Itaguaçu da Bahia', microregionId: 29006 },
    { id: 2915403, name: 'Itaju do Colônia', microregionId: 29031 },
    { id: 2915502, name: 'Itajuípe', microregionId: 29031 },
    { id: 2915601, name: 'Itamaraju', microregionId: 29032 },
    { id: 2915700, name: 'Itamari', microregionId: 29031 },
    { id: 2915809, name: 'Itambé', microregionId: 29029 },
    { id: 2915908, name: 'Itanagra', microregionId: 29019 },
    { id: 2916005, name: 'Itanhém', microregionId: 29032 },
    { id: 2916104, name: 'Itaparica', microregionId: 29021 },
    { id: 2916203, name: 'Itapé', microregionId: 29031 },
    { id: 2916302, name: 'Itapebi', microregionId: 29031 },
    { id: 2916401, name: 'Itapetinga', microregionId: 29029 },
    { id: 2916500, name: 'Itapicuru', microregionId: 29015 },
    { id: 2916609, name: 'Itapitanga', microregionId: 29031 },
    { id: 2916708, name: 'Itaquara', microregionId: 29024 },
    { id: 2916807, name: 'Itarantim', microregionId: 29029 },
    { id: 2916856, name: 'Itatim', microregionId: 29012 },
    { id: 2916906, name: 'Itiruçu', microregionId: 29024 },
    { id: 2917003, name: 'Itiúba', microregionId: 29008 },
    { id: 2917102, name: 'Itororó', microregionId: 29029 },
    { id: 2917201, name: 'Ituaçu', microregionId: 29027 },
    { id: 2917300, name: 'Ituberá', microregionId: 29030 },
    { id: 2917334, name: 'Iuiu', microregionId: 29026 },
    { id: 2917359, name: 'Jaborandi', microregionId: 29003 },
    { id: 2917409, name: 'Jacaraci', microregionId: 29026 },
    { id: 2917508, name: 'Jacobina', microregionId: 29010 },
    { id: 2917607, name: 'Jaguaquara', microregionId: 29024 },
    { id: 2917706, name: 'Jaguarari', microregionId: 29008 },
    { id: 2917805, name: 'Jaguaripe', microregionId: 29020 },
    { id: 2917904, name: 'Jandaíra', microregionId: 29018 },
    { id: 2918001, name: 'Jequié', microregionId: 29024 },
    { id: 2918100, name: 'Jeremoabo', microregionId: 29013 },
    { id: 2918209, name: 'Jiquiriçá', microregionId: 29024 },
    { id: 2918308, name: 'Jitaúna', microregionId: 29024 },
    { id: 2918357, name: 'João Dourado', microregionId: 29009 },
    { id: 2918407, name: 'Juazeiro', microregionId: 29004 },
    { id: 2918456, name: 'Jucuruçu', microregionId: 29032 },
    { id: 2918506, name: 'Jussara', microregionId: 29009 },
    { id: 2918555, name: 'Jussari', microregionId: 29031 },
    { id: 2918605, name: 'Jussiape', microregionId: 29023 },
    { id: 2918704, name: 'Lafaiete Coutinho', microregionId: 29024 },
    { id: 2918753, name: 'Lagoa Real', microregionId: 29026 },
    { id: 2918803, name: 'Laje', microregionId: 29024 },
    { id: 2918902, name: 'Lajedão', microregionId: 29032 },
    { id: 2919009, name: 'Lajedinho', microregionId: 29011 },
    { id: 2919058, name: 'Lajedo do Tabocal', microregionId: 29024 },
    { id: 2919108, name: 'Lamarão', microregionId: 29016 },
    { id: 2919157, name: 'Lapão', microregionId: 29009 },
    { id: 2919207, name: 'Lauro de Freitas', microregionId: 29021 },
    { id: 2919306, name: 'Lençóis', microregionId: 29023 },
    { id: 2919405, name: 'Licínio de Almeida', microregionId: 29026 },
    { id: 2919504, name: 'Livramento de Nossa Senhora', microregionId: 29025 },
    { id: 2919553, name: 'Luís Eduardo Magalhães', microregionId: 29001 },
    { id: 2919603, name: 'Macajuba', microregionId: 29011 },
    { id: 2919702, name: 'Macarani', microregionId: 29029 },
    { id: 2919801, name: 'Macaúbas', microregionId: 29022 },
    { id: 2919900, name: 'Macururé', microregionId: 29005 },
    { id: 2919926, name: 'Madre de Deus', microregionId: 29021 },
    { id: 2919959, name: 'Maetinga', microregionId: 29027 },
    { id: 2920007, name: 'Maiquinique', microregionId: 29029 },
    { id: 2920106, name: 'Mairi', microregionId: 29011 },
    { id: 2920205, name: 'Malhada', microregionId: 29026 },
    { id: 2920304, name: 'Malhada de Pedras', microregionId: 29027 },
    { id: 2920403, name: 'Manoel Vitorino', microregionId: 29028 },
    { id: 2920452, name: 'Mansidão', microregionId: 29002 },
    { id: 2920502, name: 'Maracás', microregionId: 29024 },
    { id: 2920601, name: 'Maragogipe', microregionId: 29020 },
    { id: 2920700, name: 'Maraú', microregionId: 29030 },
    { id: 2920809, name: 'Marcionílio Souza', microregionId: 29024 },
    { id: 2920908, name: 'Mascote', microregionId: 29031 },
    { id: 2921005, name: 'Mata de São João', microregionId: 29019 },
    { id: 2921054, name: 'Matina', microregionId: 29026 },
    { id: 2921104, name: 'Medeiros Neto', microregionId: 29032 },
    { id: 2921203, name: 'Miguel Calmon', microregionId: 29010 },
    { id: 2921302, name: 'Milagres', microregionId: 29024 },
    { id: 2921401, name: 'Mirangaba', microregionId: 29010 },
    { id: 2921450, name: 'Mirante', microregionId: 29028 },
    { id: 2921500, name: 'Monte Santo', microregionId: 29014 },
    { id: 2921609, name: 'Morpará', microregionId: 29006 },
    { id: 2921708, name: 'Morro do Chapéu', microregionId: 29010 },
    { id: 2921807, name: 'Mortugaba', microregionId: 29026 },
    { id: 2921906, name: 'Mucugê', microregionId: 29023 },
    { id: 2922003, name: 'Mucuri', microregionId: 29032 },
    { id: 2922052, name: 'Mulungu do Morro', microregionId: 29009 },
    { id: 2922102, name: 'Mundo Novo', microregionId: 29011 },
    { id: 2922201, name: 'Muniz Ferreira', microregionId: 29020 },
    { id: 2922250, name: 'Muquém do São Francisco', microregionId: 29006 },
    { id: 2922300, name: 'Muritiba', microregionId: 29020 },
    { id: 2922409, name: 'Mutuípe', microregionId: 29024 },
    { id: 2922508, name: 'Nazaré', microregionId: 29020 },
    { id: 2922607, name: 'Nilo Peçanha', microregionId: 29030 },
    { id: 2922656, name: 'Nordestina', microregionId: 29014 },
    { id: 2922706, name: 'Nova Canaã', microregionId: 29028 },
    { id: 2922730, name: 'Nova Fátima', microregionId: 29016 },
    { id: 2922755, name: 'Nova Ibiá', microregionId: 29031 },
    { id: 2922805, name: 'Nova Itarana', microregionId: 29024 },
    { id: 2922854, name: 'Nova Redenção', microregionId: 29023 },
    { id: 2922904, name: 'Nova Soure', microregionId: 29015 },
    { id: 2923001, name: 'Nova Viçosa', microregionId: 29032 },
    { id: 2923035, name: 'Novo Horizonte', microregionId: 29022 },
    { id: 2923050, name: 'Novo Triunfo', microregionId: 29015 },
    { id: 2923100, name: 'Olindina', microregionId: 29015 },
    { id: 2923209, name: 'Oliveira dos Brejinhos', microregionId: 29022 },
    { id: 2923308, name: 'Ouriçangas', microregionId: 29012 },
    { id: 2923357, name: 'Ourolândia', microregionId: 29010 },
    { id: 2923407, name: 'Palmas de Monte Alto', microregionId: 29026 },
    { id: 2923506, name: 'Palmeiras', microregionId: 29023 },
    { id: 2923605, name: 'Paramirim', microregionId: 29025 },
    { id: 2923704, name: 'Paratinga', microregionId: 29007 },
    { id: 2923803, name: 'Paripiranga', microregionId: 29015 },
    { id: 2923902, name: 'Pau Brasil', microregionId: 29031 },
    { id: 2924009, name: 'Paulo Afonso', microregionId: 29005 },
    { id: 2924058, name: 'Pé de Serra', microregionId: 29016 },
    { id: 2924108, name: 'Pedrão', microregionId: 29012 },
    { id: 2924207, name: 'Pedro Alexandre', microregionId: 29013 },
    { id: 2924306, name: 'Piatã', microregionId: 29023 },
    { id: 2924405, name: 'Pilão Arcado', microregionId: 29004 },
    { id: 2924504, name: 'Pindaí', microregionId: 29026 },
    { id: 2924603, name: 'Pindobaçu', microregionId: 29008 },
    { id: 2924652, name: 'Pintadas', microregionId: 29012 },
    { id: 2924678, name: 'Piraí do Norte', microregionId: 29030 },
    { id: 2924702, name: 'Piripá', microregionId: 29027 },
    { id: 2924801, name: 'Piritiba', microregionId: 29010 },
    { id: 2924900, name: 'Planaltino', microregionId: 29024 },
    { id: 2925006, name: 'Planalto', microregionId: 29028 },
    { id: 2925105, name: 'Poções', microregionId: 29028 },
    { id: 2925204, name: 'Pojuca', microregionId: 29019 },
    { id: 2925253, name: 'Ponto Novo', microregionId: 29010 },
    { id: 2925303, name: 'Porto Seguro', microregionId: 29032 },
    { id: 2925402, name: 'Potiraguá', microregionId: 29029 },
    { id: 2925501, name: 'Prado', microregionId: 29032 },
    { id: 2925600, name: 'Presidente Dutra', microregionId: 29009 },
    { id: 2925709, name: 'Presidente Jânio Quadros', microregionId: 29027 },
    { id: 2925758, name: 'Presidente Tancredo Neves', microregionId: 29030 },
    { id: 2925808, name: 'Queimadas', microregionId: 29014 },
    { id: 2925907, name: 'Quijingue', microregionId: 29014 },
    { id: 2925931, name: 'Quixabeira', microregionId: 29010 },
    { id: 2925956, name: 'Rafael Jambeiro', microregionId: 29012 },
    { id: 2926004, name: 'Remanso', microregionId: 29004 },
    { id: 2926103, name: 'Retirolândia', microregionId: 29016 },
    { id: 2926202, name: 'Riachão das Neves', microregionId: 29001 },
    { id: 2926301, name: 'Riachão do Jacuípe', microregionId: 29016 },
    { id: 2926400, name: 'Riacho de Santana', microregionId: 29026 },
    { id: 2926509, name: 'Ribeira do Amparo', microregionId: 29015 },
    { id: 2926608, name: 'Ribeira do Pombal', microregionId: 29015 },
    { id: 2926657, name: 'Ribeirão do Largo', microregionId: 29029 },
    { id: 2926707, name: 'Rio de Contas', microregionId: 29023 },
    { id: 2926806, name: 'Rio do Antônio', microregionId: 29027 },
    { id: 2926905, name: 'Rio do Pires', microregionId: 29025 },
    { id: 2927002, name: 'Rio Real', microregionId: 29017 },
    { id: 2927101, name: 'Rodelas', microregionId: 29005 },
    { id: 2927200, name: 'Ruy Barbosa', microregionId: 29011 },
    { id: 2927309, name: 'Salinas da Margarida', microregionId: 29020 },
    { id: 2927408, name: 'Salvador', microregionId: 29021 },
    { id: 2927507, name: 'Santa Bárbara', microregionId: 29012 },
    { id: 2927606, name: 'Santa Brígida', microregionId: 29013 },
    { id: 2927705, name: 'Santa Cruz Cabrália', microregionId: 29032 },
    { id: 2927804, name: 'Santa Cruz da Vitória', microregionId: 29031 },
    { id: 2927903, name: 'Santa Inês', microregionId: 29024 },
    { id: 2928059, name: 'Santa Luzia', microregionId: 29031 },
    { id: 2928109, name: 'Santa Maria da Vitória', microregionId: 29003 },
    { id: 2928406, name: 'Santa Rita de Cássia', microregionId: 29002 },
    { id: 2928505, name: 'Santa Terezinha', microregionId: 29012 },
    { id: 2928000, name: 'Santaluz', microregionId: 29016 },
    { id: 2928208, name: 'Santana', microregionId: 29003 },
    { id: 2928307, name: 'Santanópolis', microregionId: 29012 },
    { id: 2928604, name: 'Santo Amaro', microregionId: 29020 },
    { id: 2928703, name: 'Santo Antônio de Jesus', microregionId: 29020 },
    { id: 2928802, name: 'Santo Estêvão', microregionId: 29012 },
    { id: 2928901, name: 'São Desidério', microregionId: 29001 },
    { id: 2928950, name: 'São Domingos', microregionId: 29016 },
    { id: 2929107, name: 'São Felipe', microregionId: 29020 },
    { id: 2929008, name: 'São Félix', microregionId: 29020 },
    { id: 2929057, name: 'São Félix do Coribe', microregionId: 29003 },
    { id: 2929206, name: 'São Francisco do Conde', microregionId: 29021 },
    { id: 2929255, name: 'São Gabriel', microregionId: 29009 },
    { id: 2929305, name: 'São Gonçalo dos Campos', microregionId: 29012 },
    { id: 2929354, name: 'São José da Vitória', microregionId: 29031 },
    { id: 2929370, name: 'São José do Jacuípe', microregionId: 29010 },
    { id: 2929404, name: 'São Miguel das Matas', microregionId: 29024 },
    { id: 2929503, name: 'São Sebastião do Passé', microregionId: 29019 },
    { id: 2929602, name: 'Sapeaçu', microregionId: 29020 },
    { id: 2929701, name: 'Sátiro Dias', microregionId: 29017 },
    { id: 2929750, name: 'Saubara', microregionId: 29020 },
    { id: 2929800, name: 'Saúde', microregionId: 29010 },
    { id: 2929909, name: 'Seabra', microregionId: 29023 },
    { id: 2930006, name: 'Sebastião Laranjeiras', microregionId: 29026 },
    { id: 2930105, name: 'Senhor do Bonfim', microregionId: 29008 },
    { id: 2930204, name: 'Sento Sé', microregionId: 29004 },
    { id: 2930154, name: 'Serra do Ramalho', microregionId: 29007 },
    { id: 2930303, name: 'Serra Dourada', microregionId: 29003 },
    { id: 2930402, name: 'Serra Preta', microregionId: 29012 },
    { id: 2930501, name: 'Serrinha', microregionId: 29016 },
    { id: 2930600, name: 'Serrolândia', microregionId: 29010 },
    { id: 2930709, name: 'Simões Filho', microregionId: 29021 },
    { id: 2930758, name: 'Sítio do Mato', microregionId: 29007 },
    { id: 2930766, name: 'Sítio do Quinto', microregionId: 29013 },
    { id: 2930774, name: 'Sobradinho', microregionId: 29004 },
    { id: 2930808, name: 'Souto Soares', microregionId: 29009 },
    { id: 2930907, name: 'Tabocas do Brejo Velho', microregionId: 29002 },
    { id: 2931004, name: 'Tanhaçu', microregionId: 29027 },
    { id: 2931053, name: 'Tanque Novo', microregionId: 29022 },
    { id: 2931103, name: 'Tanquinho', microregionId: 29012 },
    { id: 2931202, name: 'Taperoá', microregionId: 29030 },
    { id: 2931301, name: 'Tapiramutá', microregionId: 29011 },
    { id: 2931350, name: 'Teixeira de Freitas', microregionId: 29032 },
    { id: 2931400, name: 'Teodoro Sampaio', microregionId: 29012 },
    { id: 2931509, name: 'Teofilândia', microregionId: 29016 },
    { id: 2931608, name: 'Teolândia', microregionId: 29031 },
    { id: 2931707, name: 'Terra Nova', microregionId: 29019 },
    { id: 2931806, name: 'Tremedal', microregionId: 29027 },
    { id: 2931905, name: 'Tucano', microregionId: 29014 },
    { id: 2932002, name: 'Uauá', microregionId: 29014 },
    { id: 2932101, name: 'Ubaíra', microregionId: 29024 },
    { id: 2932200, name: 'Ubaitaba', microregionId: 29031 },
    { id: 2932309, name: 'Ubatã', microregionId: 29031 },
    { id: 2932408, name: 'Uibaí', microregionId: 29009 },
    { id: 2932457, name: 'Umburanas', microregionId: 29008 },
    { id: 2932507, name: 'Una', microregionId: 29031 },
    { id: 2932606, name: 'Urandi', microregionId: 29026 },
    { id: 2932705, name: 'Uruçuca', microregionId: 29031 },
    { id: 2932804, name: 'Utinga', microregionId: 29023 },
    { id: 2932903, name: 'Valença', microregionId: 29030 },
    { id: 2933000, name: 'Valente', microregionId: 29016 },
    { id: 2933059, name: 'Várzea da Roça', microregionId: 29011 },
    { id: 2933109, name: 'Várzea do Poço', microregionId: 29010 },
    { id: 2933158, name: 'Várzea Nova', microregionId: 29010 },
    { id: 2933174, name: 'Varzedo', microregionId: 29020 },
    { id: 2933208, name: 'Vera Cruz', microregionId: 29021 },
    { id: 2933257, name: 'Vereda', microregionId: 29032 },
    { id: 2933307, name: 'Vitória da Conquista', microregionId: 29028 },
    { id: 2933406, name: 'Wagner', microregionId: 29023 },
    { id: 2933455, name: 'Wanderley', microregionId: 29002 },
    { id: 2933505, name: 'Wenceslau Guimarães', microregionId: 29031 },
    { id: 2933604, name: 'Xique-Xique', microregionId: 29006 },
  ],
  31: [
    { id: 3100104, name: 'Abadia dos Dourados', microregionId: 31019 },
    { id: 3100203, name: 'Abaeté', microregionId: 31024 },
    { id: 3100302, name: 'Abre Campo', microregionId: 31061 },
    { id: 3100401, name: 'Acaiaca', microregionId: 31060 },
    { id: 3100500, name: 'Açucena', microregionId: 31039 },
    { id: 3100609, name: 'Água Boa', microregionId: 31036 },
    { id: 3100708, name: 'Água Comprida', microregionId: 31022 },
    { id: 3100807, name: 'Aguanil', microregionId: 31045 },
    { id: 3100906, name: 'Águas Formosas', microregionId: 31016 },
    { id: 3101003, name: 'Águas Vermelhas', microregionId: 31005 },
    { id: 3101102, name: 'Aimorés', microregionId: 31041 },
    { id: 3101201, name: 'Aiuruoca', microregionId: 31055 },
    { id: 3101300, name: 'Alagoa', microregionId: 31054 },
    { id: 3101409, name: 'Albertina', microregionId: 31051 },
    { id: 3101508, name: 'Além Paraíba', microregionId: 31066 },
    { id: 3101607, name: 'Alfenas', microregionId: 31049 },
    { id: 3101631, name: 'Alfredo Vasconcelos', microregionId: 31059 },
    { id: 3101706, name: 'Almenara', microregionId: 31014 },
    { id: 3101805, name: 'Alpercata', microregionId: 31037 },
    { id: 3101904, name: 'Alpinópolis', microregionId: 31047 },
    { id: 3102001, name: 'Alterosa', microregionId: 31049 },
    { id: 3102050, name: 'Alto Caparaó', microregionId: 31061 },
    { id: 3153509, name: 'Alto Jequitibá', microregionId: 31061 },
    { id: 3102100, name: 'Alto Rio Doce', microregionId: 31062 },
    { id: 3102209, name: 'Alvarenga', microregionId: 31041 },
    { id: 3102308, name: 'Alvinópolis', microregionId: 31031 },
    { id: 3102407, name: 'Alvorada de Minas', microregionId: 31028 },
    { id: 3102506, name: 'Amparo do Serra', microregionId: 31062 },
    { id: 3102605, name: 'Andradas', microregionId: 31051 },
    { id: 3102803, name: 'Andrelândia', microregionId: 31055 },
    { id: 3102852, name: 'Angelândia', microregionId: 31011 },
    { id: 3102902, name: 'Antônio Carlos', microregionId: 31059 },
    { id: 3103009, name: 'Antônio Dias', microregionId: 31039 },
    { id: 3103108, name: 'Antônio Prado de Minas', microregionId: 31063 },
    { id: 3103207, name: 'Araçaí', microregionId: 31027 },
    { id: 3103306, name: 'Aracitaba', microregionId: 31065 },
    { id: 3103405, name: 'Araçuaí', microregionId: 31012 },
    { id: 3103504, name: 'Araguari', microregionId: 31018 },
    { id: 3103603, name: 'Arantina', microregionId: 31055 },
    { id: 3103702, name: 'Araponga', microregionId: 31062 },
    { id: 3103751, name: 'Araporã', microregionId: 31018 },
    { id: 3103801, name: 'Arapuá', microregionId: 31020 },
    { id: 3103900, name: 'Araújos', microregionId: 31026 },
    { id: 3104007, name: 'Araxá', microregionId: 31023 },
    { id: 3104106, name: 'Arceburgo', microregionId: 31048 },
    { id: 3104205, name: 'Arcos', microregionId: 31044 },
    { id: 3104304, name: 'Areado', microregionId: 31049 },
    { id: 3104403, name: 'Argirita', microregionId: 31066 },
    { id: 3104452, name: 'Aricanduva', microregionId: 31011 },
    { id: 3104502, name: 'Arinos', microregionId: 31001 },
    { id: 3104601, name: 'Astolfo Dutra', microregionId: 31064 },
    { id: 3104700, name: 'Ataléia', microregionId: 31015 },
    { id: 3104809, name: 'Augusto de Lima', microregionId: 31025 },
    { id: 3104908, name: 'Baependi', microregionId: 31054 },
    { id: 3105004, name: 'Baldim', microregionId: 31027 },
    { id: 3105103, name: 'Bambuí', microregionId: 31042 },
    { id: 3105202, name: 'Bandeira', microregionId: 31014 },
    { id: 3105301, name: 'Bandeira do Sul', microregionId: 31051 },
    { id: 3105400, name: 'Barão de Cocais', microregionId: 31031 },
    { id: 3105509, name: 'Barão do Monte Alto', microregionId: 31063 },
    { id: 3105608, name: 'Barbacena', microregionId: 31059 },
    { id: 3105707, name: 'Barra Longa', microregionId: 31060 },
    { id: 3105905, name: 'Barroso', microregionId: 31059 },
    { id: 3106002, name: 'Bela Vista de Minas', microregionId: 31031 },
    { id: 3106101, name: 'Belmiro Braga', microregionId: 31065 },
    { id: 3106200, name: 'Belo Horizonte', microregionId: 31030 },
    { id: 3106309, name: 'Belo Oriente', microregionId: 31039 },
    { id: 3106408, name: 'Belo Vale', microregionId: 31032 },
    { id: 3106507, name: 'Berilo', microregionId: 31011 },
    { id: 3106655, name: 'Berizal', microregionId: 31005 },
    { id: 3106606, name: 'Bertópolis', microregionId: 31016 },
    { id: 3106705, name: 'Betim', microregionId: 31030 },
    { id: 3106804, name: 'Bias Fortes', microregionId: 31065 },
    { id: 3106903, name: 'Bicas', microregionId: 31065 },
    { id: 3107000, name: 'Biquinhas', microregionId: 31024 },
    { id: 3107109, name: 'Boa Esperança', microregionId: 31050 },
    { id: 3107208, name: 'Bocaina de Minas', microregionId: 31055 },
    { id: 3107307, name: 'Bocaiúva', microregionId: 31009 },
    { id: 3107406, name: 'Bom Despacho', microregionId: 31026 },
    { id: 3107505, name: 'Bom Jardim de Minas', microregionId: 31055 },
    { id: 3107604, name: 'Bom Jesus da Penha', microregionId: 31047 },
    { id: 3107703, name: 'Bom Jesus do Amparo', microregionId: 31031 },
    { id: 3107802, name: 'Bom Jesus do Galho', microregionId: 31040 },
    { id: 3107901, name: 'Bom Repouso', microregionId: 31052 },
    { id: 3108008, name: 'Bom Sucesso', microregionId: 31046 },
    { id: 3108107, name: 'Bonfim', microregionId: 31032 },
    { id: 3108206, name: 'Bonfinópolis de Minas', microregionId: 31001 },
    { id: 3108255, name: 'Bonito de Minas', microregionId: 31003 },
    { id: 3108305, name: 'Borda da Mata', microregionId: 31052 },
    { id: 3108404, name: 'Botelhos', microregionId: 31051 },
    { id: 3108503, name: 'Botumirim', microregionId: 31008 },
    { id: 3108701, name: 'Brás Pires', microregionId: 31062 },
    { id: 3108552, name: 'Brasilândia de Minas', microregionId: 31002 },
    { id: 3108602, name: 'Brasília de Minas', microregionId: 31007 },
    { id: 3108800, name: 'Braúnas', microregionId: 31035 },
    { id: 3108909, name: 'Brazópolis', microregionId: 31056 },
    { id: 3109006, name: 'Brumadinho', microregionId: 31030 },
    { id: 3109105, name: 'Bueno Brandão', microregionId: 31052 },
    { id: 3109204, name: 'Buenópolis', microregionId: 31025 },
    { id: 3109253, name: 'Bugre', microregionId: 31040 },
    { id: 3109303, name: 'Buritis', microregionId: 31001 },
    { id: 3109402, name: 'Buritizeiro', microregionId: 31006 },
    { id: 3109451, name: 'Cabeceira Grande', microregionId: 31001 },
    { id: 3109501, name: 'Cabo Verde', microregionId: 31048 },
    { id: 3109600, name: 'Cachoeira da Prata', microregionId: 31027 },
    { id: 3109709, name: 'Cachoeira de Minas', microregionId: 31053 },
    { id: 3102704, name: 'Cachoeira de Pajeú', microregionId: 31013 },
    { id: 3109808, name: 'Cachoeira Dourada', microregionId: 31017 },
    { id: 3109907, name: 'Caetanópolis', microregionId: 31027 },
    { id: 3110004, name: 'Caeté', microregionId: 31030 },
    { id: 3110103, name: 'Caiana', microregionId: 31063 },
    { id: 3110202, name: 'Cajuri', microregionId: 31062 },
    { id: 3110301, name: 'Caldas', microregionId: 31051 },
    { id: 3110400, name: 'Camacho', microregionId: 31044 },
    { id: 3110509, name: 'Camanducaia', microregionId: 31052 },
    { id: 3110608, name: 'Cambuí', microregionId: 31052 },
    { id: 3110707, name: 'Cambuquira', microregionId: 31054 },
    { id: 3110806, name: 'Campanário', microregionId: 31037 },
    { id: 3110905, name: 'Campanha', microregionId: 31050 },
    { id: 3111002, name: 'Campestre', microregionId: 31051 },
    { id: 3111101, name: 'Campina Verde', microregionId: 31021 },
    { id: 3111150, name: 'Campo Azul', microregionId: 31007 },
    { id: 3111200, name: 'Campo Belo', microregionId: 31045 },
    { id: 3111309, name: 'Campo do Meio', microregionId: 31050 },
    { id: 3111408, name: 'Campo Florido', microregionId: 31022 },
    { id: 3111507, name: 'Campos Altos', microregionId: 31023 },
    { id: 3111606, name: 'Campos Gerais', microregionId: 31050 },
    { id: 3111903, name: 'Cana Verde', microregionId: 31045 },
    { id: 3111705, name: 'Canaã', microregionId: 31062 },
    { id: 3111804, name: 'Canápolis', microregionId: 31018 },
    { id: 3112000, name: 'Candeias', microregionId: 31045 },
    { id: 3112059, name: 'Cantagalo', microregionId: 31036 },
    { id: 3112109, name: 'Caparaó', microregionId: 31061 },
    { id: 3112208, name: 'Capela Nova', microregionId: 31059 },
    { id: 3112307, name: 'Capelinha', microregionId: 31011 },
    { id: 3112406, name: 'Capetinga', microregionId: 31047 },
    { id: 3112505, name: 'Capim Branco', microregionId: 31027 },
    { id: 3112604, name: 'Capinópolis', microregionId: 31017 },
    { id: 3112653, name: 'Capitão Andrade', microregionId: 31037 },
    { id: 3112703, name: 'Capitão Enéas', microregionId: 31007 },
    { id: 3112802, name: 'Capitólio', microregionId: 31047 },
    { id: 3112901, name: 'Caputira', microregionId: 31061 },
    { id: 3113008, name: 'Caraí', microregionId: 31012 },
    { id: 3113107, name: 'Caranaíba', microregionId: 31059 },
    { id: 3113206, name: 'Carandaí', microregionId: 31059 },
    { id: 3113305, name: 'Carangola', microregionId: 31063 },
    { id: 3113404, name: 'Caratinga', microregionId: 31040 },
    { id: 3113503, name: 'Carbonita', microregionId: 31011 },
    { id: 3113602, name: 'Careaçu', microregionId: 31053 },
    { id: 3113701, name: 'Carlos Chagas', microregionId: 31016 },
    { id: 3113800, name: 'Carmésia', microregionId: 31035 },
    { id: 3113909, name: 'Carmo da Cachoeira', microregionId: 31050 },
    { id: 3114006, name: 'Carmo da Mata', microregionId: 31046 },
    { id: 3114105, name: 'Carmo de Minas', microregionId: 31054 },
    { id: 3114204, name: 'Carmo do Cajuru', microregionId: 31043 },
    { id: 3114303, name: 'Carmo do Paranaíba', microregionId: 31020 },
    { id: 3114402, name: 'Carmo do Rio Claro', microregionId: 31049 },
    { id: 3114501, name: 'Carmópolis de Minas', microregionId: 31046 },
    { id: 3114550, name: 'Carneirinho', microregionId: 31021 },
    { id: 3114600, name: 'Carrancas', microregionId: 31057 },
    { id: 3114709, name: 'Carvalhópolis', microregionId: 31049 },
    { id: 3114808, name: 'Carvalhos', microregionId: 31055 },
    { id: 3114907, name: 'Casa Grande', microregionId: 31034 },
    { id: 3115003, name: 'Cascalho Rico', microregionId: 31018 },
    { id: 3115102, name: 'Cássia', microregionId: 31047 },
    { id: 3115300, name: 'Cataguases', microregionId: 31066 },
    { id: 3115359, name: 'Catas Altas', microregionId: 31031 },
    { id: 3115409, name: 'Catas Altas da Noruega', microregionId: 31034 },
    { id: 3115458, name: 'Catuji', microregionId: 31015 },
    { id: 3115474, name: 'Catuti', microregionId: 31004 },
    { id: 3115508, name: 'Caxambu', microregionId: 31054 },
    { id: 3115607, name: 'Cedro do Abaeté', microregionId: 31024 },
    { id: 3115706, name: 'Central de Minas', microregionId: 31038 },
    { id: 3115805, name: 'Centralina', microregionId: 31018 },
    { id: 3115904, name: 'Chácara', microregionId: 31065 },
    { id: 3116001, name: 'Chalé', microregionId: 31061 },
    { id: 3116100, name: 'Chapada do Norte', microregionId: 31011 },
    { id: 3116159, name: 'Chapada Gaúcha', microregionId: 31003 },
    { id: 3116209, name: 'Chiador', microregionId: 31065 },
    { id: 3116308, name: 'Cipotânea', microregionId: 31062 },
    { id: 3116407, name: 'Claraval', microregionId: 31047 },
    { id: 3116506, name: 'Claro dos Poções', microregionId: 31007 },
    { id: 3116605, name: 'Cláudio', microregionId: 31043 },
    { id: 3116704, name: 'Coimbra', microregionId: 31062 },
    { id: 3116803, name: 'Coluna', microregionId: 31035 },
    { id: 3116902, name: 'Comendador Gomes', microregionId: 31021 },
    { id: 3117009, name: 'Comercinho', microregionId: 31013 },
    { id: 3117108, name: 'Conceição da Aparecida', microregionId: 31049 },
    { id: 3115201, name: 'Conceição da Barra de Minas', microregionId: 31058 },
    { id: 3117306, name: 'Conceição das Alagoas', microregionId: 31022 },
    { id: 3117207, name: 'Conceição das Pedras', microregionId: 31053 },
    { id: 3117405, name: 'Conceição de Ipanema', microregionId: 31041 },
    { id: 3117504, name: 'Conceição do Mato Dentro', microregionId: 31028 },
    { id: 3117603, name: 'Conceição do Pará', microregionId: 31043 },
    { id: 3117702, name: 'Conceição do Rio Verde', microregionId: 31054 },
    { id: 3117801, name: 'Conceição dos Ouros', microregionId: 31053 },
    { id: 3117836, name: 'Cônego Marinho', microregionId: 31003 },
    { id: 3117876, name: 'Confins', microregionId: 31030 },
    { id: 3117900, name: 'Congonhal', microregionId: 31052 },
    { id: 3118007, name: 'Congonhas', microregionId: 31034 },
    { id: 3118106, name: 'Congonhas do Norte', microregionId: 31028 },
    { id: 3118205, name: 'Conquista', microregionId: 31022 },
    { id: 3118304, name: 'Conselheiro Lafaiete', microregionId: 31034 },
    { id: 3118403, name: 'Conselheiro Pena', microregionId: 31041 },
    { id: 3118502, name: 'Consolação', microregionId: 31056 },
    { id: 3118601, name: 'Contagem', microregionId: 31030 },
    { id: 3118700, name: 'Coqueiral', microregionId: 31050 },
    { id: 3118809, name: 'Coração de Jesus', microregionId: 31007 },
    { id: 3118908, name: 'Cordisburgo', microregionId: 31027 },
    { id: 3119005, name: 'Cordislândia', microregionId: 31053 },
    { id: 3119104, name: 'Corinto', microregionId: 31025 },
    { id: 3119203, name: 'Coroaci', microregionId: 31037 },
    { id: 3119302, name: 'Coromandel', microregionId: 31019 },
    { id: 3119401, name: 'Coronel Fabriciano', microregionId: 31039 },
    { id: 3119500, name: 'Coronel Murta', microregionId: 31012 },
    { id: 3119609, name: 'Coronel Pacheco', microregionId: 31065 },
    { id: 3119708, name: 'Coronel Xavier Chaves', microregionId: 31058 },
    { id: 3119807, name: 'Córrego Danta', microregionId: 31042 },
    { id: 3119906, name: 'Córrego do Bom Jesus', microregionId: 31052 },
    { id: 3119955, name: 'Córrego Fundo', microregionId: 31044 },
    { id: 3120003, name: 'Córrego Novo', microregionId: 31040 },
    { id: 3120102, name: 'Couto de Magalhães de Minas', microregionId: 31010 },
    { id: 3120151, name: 'Crisólita', microregionId: 31016 },
    { id: 3120201, name: 'Cristais', microregionId: 31045 },
    { id: 3120300, name: 'Cristália', microregionId: 31008 },
    { id: 3120409, name: 'Cristiano Otoni', microregionId: 31034 },
    { id: 3120508, name: 'Cristina', microregionId: 31056 },
    { id: 3120607, name: 'Crucilândia', microregionId: 31032 },
    { id: 3120706, name: 'Cruzeiro da Fortaleza', microregionId: 31019 },
    { id: 3120805, name: 'Cruzília', microregionId: 31055 },
    { id: 3120839, name: 'Cuparaque', microregionId: 31041 },
    { id: 3120870, name: 'Curral de Dentro', microregionId: 31005 },
    { id: 3120904, name: 'Curvelo', microregionId: 31025 },
    { id: 3121001, name: 'Datas', microregionId: 31010 },
    { id: 3121100, name: 'Delfim Moreira', microregionId: 31056 },
    { id: 3121209, name: 'Delfinópolis', microregionId: 31047 },
    { id: 3121258, name: 'Delta', microregionId: 31022 },
    { id: 3121308, name: 'Descoberto', microregionId: 31065 },
    { id: 3121407, name: 'Desterro de Entre Rios', microregionId: 31034 },
    { id: 3121506, name: 'Desterro do Melo', microregionId: 31059 },
    { id: 3121605, name: 'Diamantina', microregionId: 31010 },
    { id: 3121704, name: 'Diogo de Vasconcelos', microregionId: 31033 },
    { id: 3121803, name: 'Dionísio', microregionId: 31031 },
    { id: 3121902, name: 'Divinésia', microregionId: 31064 },
    { id: 3122009, name: 'Divino', microregionId: 31063 },
    { id: 3122108, name: 'Divino das Laranjeiras', microregionId: 31037 },
    { id: 3122207, name: 'Divinolândia de Minas', microregionId: 31035 },
    { id: 3122306, name: 'Divinópolis', microregionId: 31043 },
    { id: 3122355, name: 'Divisa Alegre', microregionId: 31005 },
    { id: 3122405, name: 'Divisa Nova', microregionId: 31049 },
    { id: 3122454, name: 'Divisópolis', microregionId: 31014 },
    { id: 3122470, name: 'Dom Bosco', microregionId: 31001 },
    { id: 3122504, name: 'Dom Cavati', microregionId: 31040 },
    { id: 3122603, name: 'Dom Joaquim', microregionId: 31028 },
    { id: 3122702, name: 'Dom Silvério', microregionId: 31060 },
    { id: 3122801, name: 'Dom Viçoso', microregionId: 31056 },
    { id: 3122900, name: 'Dona Euzébia', microregionId: 31066 },
    { id: 3123007, name: 'Dores de Campos', microregionId: 31058 },
    { id: 3123106, name: 'Dores de Guanhães', microregionId: 31035 },
    { id: 3123205, name: 'Dores do Indaiá', microregionId: 31026 },
    { id: 3123304, name: 'Dores do Turvo', microregionId: 31064 },
    { id: 3123403, name: 'Doresópolis', microregionId: 31042 },
    { id: 3123502, name: 'Douradoquara', microregionId: 31019 },
    { id: 3123528, name: 'Durandé', microregionId: 31061 },
    { id: 3123601, name: 'Elói Mendes', microregionId: 31050 },
    { id: 3123700, name: 'Engenheiro Caldas', microregionId: 31037 },
    { id: 3123809, name: 'Engenheiro Navarro', microregionId: 31009 },
    { id: 3123858, name: 'Entre Folhas', microregionId: 31040 },
    { id: 3123908, name: 'Entre Rios de Minas', microregionId: 31034 },
    { id: 3124005, name: 'Ervália', microregionId: 31062 },
    { id: 3124104, name: 'Esmeraldas', microregionId: 31030 },
    { id: 3124203, name: 'Espera Feliz', microregionId: 31063 },
    { id: 3124302, name: 'Espinosa', microregionId: 31004 },
    { id: 3124401, name: 'Espírito Santo do Dourado', microregionId: 31052 },
    { id: 3124500, name: 'Estiva', microregionId: 31052 },
    { id: 3124609, name: 'Estrela Dalva', microregionId: 31066 },
    { id: 3124708, name: 'Estrela do Indaiá', microregionId: 31026 },
    { id: 3124807, name: 'Estrela do Sul', microregionId: 31019 },
    { id: 3124906, name: 'Eugenópolis', microregionId: 31063 },
    { id: 3125002, name: 'Ewbank da Câmara', microregionId: 31065 },
    { id: 3125101, name: 'Extrema', microregionId: 31052 },
    { id: 3125200, name: 'Fama', microregionId: 31049 },
    { id: 3125309, name: 'Faria Lemos', microregionId: 31063 },
    { id: 3125408, name: 'Felício dos Santos', microregionId: 31010 },
    { id: 3125606, name: 'Felisburgo', microregionId: 31014 },
    { id: 3125705, name: 'Felixlândia', microregionId: 31025 },
    { id: 3125804, name: 'Fernandes Tourinho', microregionId: 31037 },
    { id: 3125903, name: 'Ferros', microregionId: 31031 },
    { id: 3125952, name: 'Fervedouro', microregionId: 31063 },
    { id: 3126000, name: 'Florestal', microregionId: 31029 },
    { id: 3126109, name: 'Formiga', microregionId: 31044 },
    { id: 3126208, name: 'Formoso', microregionId: 31001 },
    { id: 3126307, name: 'Fortaleza de Minas', microregionId: 31047 },
    { id: 3126406, name: 'Fortuna de Minas', microregionId: 31027 },
    { id: 3126505, name: 'Francisco Badaró', microregionId: 31011 },
    { id: 3126604, name: 'Francisco Dumont', microregionId: 31009 },
    { id: 3126703, name: 'Francisco Sá', microregionId: 31007 },
    { id: 3126752, name: 'Franciscópolis', microregionId: 31015 },
    { id: 3126802, name: 'Frei Gaspar', microregionId: 31015 },
    { id: 3126901, name: 'Frei Inocêncio', microregionId: 31037 },
    { id: 3126950, name: 'Frei Lagonegro', microregionId: 31036 },
    { id: 3127008, name: 'Fronteira', microregionId: 31021 },
    { id: 3127057, name: 'Fronteira dos Vales', microregionId: 31016 },
    { id: 3127073, name: 'Fruta de Leite', microregionId: 31005 },
    { id: 3127107, name: 'Frutal', microregionId: 31021 },
    { id: 3127206, name: 'Funilândia', microregionId: 31027 },
    { id: 3127305, name: 'Galiléia', microregionId: 31037 },
    { id: 3127339, name: 'Gameleiras', microregionId: 31004 },
    { id: 3127354, name: 'Glaucilândia', microregionId: 31007 },
    { id: 3127370, name: 'Goiabeira', microregionId: 31041 },
    { id: 3127388, name: 'Goianá', microregionId: 31065 },
    { id: 3127404, name: 'Gonçalves', microregionId: 31052 },
    { id: 3127503, name: 'Gonzaga', microregionId: 31035 },
    { id: 3127602, name: 'Gouveia', microregionId: 31010 },
    { id: 3127701, name: 'Governador Valadares', microregionId: 31037 },
    { id: 3127800, name: 'Grão Mogol', microregionId: 31008 },
    { id: 3127909, name: 'Grupiara', microregionId: 31019 },
    { id: 3128006, name: 'Guanhães', microregionId: 31035 },
    { id: 3128105, name: 'Guapé', microregionId: 31050 },
    { id: 3128204, name: 'Guaraciaba', microregionId: 31060 },
    { id: 3128253, name: 'Guaraciama', microregionId: 31009 },
    { id: 3128303, name: 'Guaranésia', microregionId: 31048 },
    { id: 3128402, name: 'Guarani', microregionId: 31064 },
    { id: 3128501, name: 'Guarará', microregionId: 31065 },
    { id: 3128600, name: 'Guarda-Mor', microregionId: 31002 },
    { id: 3128709, name: 'Guaxupé', microregionId: 31048 },
    { id: 3128808, name: 'Guidoval', microregionId: 31064 },
    { id: 3128907, name: 'Guimarânia', microregionId: 31020 },
    { id: 3129004, name: 'Guiricema', microregionId: 31064 },
    { id: 3129103, name: 'Gurinhatã', microregionId: 31017 },
    { id: 3129202, name: 'Heliodora', microregionId: 31053 },
    { id: 3129301, name: 'Iapu', microregionId: 31040 },
    { id: 3129400, name: 'Ibertioga', microregionId: 31059 },
    { id: 3129509, name: 'Ibiá', microregionId: 31023 },
    { id: 3129608, name: 'Ibiaí', microregionId: 31006 },
    { id: 3129657, name: 'Ibiracatu', microregionId: 31007 },
    { id: 3129707, name: 'Ibiraci', microregionId: 31047 },
    { id: 3129806, name: 'Ibirité', microregionId: 31030 },
    { id: 3129905, name: 'Ibitiúra de Minas', microregionId: 31051 },
    { id: 3130002, name: 'Ibituruna', microregionId: 31046 },
    { id: 3130051, name: 'Icaraí de Minas', microregionId: 31003 },
    { id: 3130101, name: 'Igarapé', microregionId: 31030 },
    { id: 3130200, name: 'Igaratinga', microregionId: 31043 },
    { id: 3130309, name: 'Iguatama', microregionId: 31042 },
    { id: 3130408, name: 'Ijaci', microregionId: 31057 },
    { id: 3130507, name: 'Ilicínea', microregionId: 31050 },
    { id: 3130556, name: 'Imbé de Minas', microregionId: 31040 },
    { id: 3130606, name: 'Inconfidentes', microregionId: 31051 },
    { id: 3130655, name: 'Indaiabira', microregionId: 31005 },
    { id: 3130705, name: 'Indianópolis', microregionId: 31018 },
    { id: 3130804, name: 'Ingaí', microregionId: 31057 },
    { id: 3130903, name: 'Inhapim', microregionId: 31040 },
    { id: 3131000, name: 'Inhaúma', microregionId: 31027 },
    { id: 3131109, name: 'Inimutaba', microregionId: 31025 },
    { id: 3131158, name: 'Ipaba', microregionId: 31040 },
    { id: 3131208, name: 'Ipanema', microregionId: 31041 },
    { id: 3131307, name: 'Ipatinga', microregionId: 31039 },
    { id: 3131406, name: 'Ipiaçu', microregionId: 31017 },
    { id: 3131505, name: 'Ipuiúna', microregionId: 31052 },
    { id: 3131604, name: 'Iraí de Minas', microregionId: 31019 },
    { id: 3131703, name: 'Itabira', microregionId: 31031 },
    { id: 3131802, name: 'Itabirinha', microregionId: 31038 },
    { id: 3131901, name: 'Itabirito', microregionId: 31033 },
    { id: 3132008, name: 'Itacambira', microregionId: 31008 },
    { id: 3132107, name: 'Itacarambi', microregionId: 31003 },
    { id: 3132206, name: 'Itaguara', microregionId: 31032 },
    { id: 3132305, name: 'Itaipé', microregionId: 31015 },
    { id: 3132404, name: 'Itajubá', microregionId: 31056 },
    { id: 3132503, name: 'Itamarandiba', microregionId: 31011 },
    { id: 3132602, name: 'Itamarati de Minas', microregionId: 31066 },
    { id: 3132701, name: 'Itambacuri', microregionId: 31037 },
    { id: 3132800, name: 'Itambé do Mato Dentro', microregionId: 31028 },
    { id: 3132909, name: 'Itamogi', microregionId: 31048 },
    { id: 3133006, name: 'Itamonte', microregionId: 31054 },
    { id: 3133105, name: 'Itanhandu', microregionId: 31054 },
    { id: 3133204, name: 'Itanhomi', microregionId: 31037 },
    { id: 3133303, name: 'Itaobim', microregionId: 31013 },
    { id: 3133402, name: 'Itapagipe', microregionId: 31021 },
    { id: 3133501, name: 'Itapecerica', microregionId: 31044 },
    { id: 3133600, name: 'Itapeva', microregionId: 31052 },
    { id: 3133709, name: 'Itatiaiuçu', microregionId: 31032 },
    { id: 3133758, name: 'Itaú de Minas', microregionId: 31047 },
    { id: 3133808, name: 'Itaúna', microregionId: 31043 },
    { id: 3133907, name: 'Itaverava', microregionId: 31034 },
    { id: 3134004, name: 'Itinga', microregionId: 31012 },
    { id: 3134103, name: 'Itueta', microregionId: 31041 },
    { id: 3134202, name: 'Ituiutaba', microregionId: 31017 },
    { id: 3134301, name: 'Itumirim', microregionId: 31057 },
    { id: 3134400, name: 'Iturama', microregionId: 31021 },
    { id: 3134509, name: 'Itutinga', microregionId: 31057 },
    { id: 3134608, name: 'Jaboticatubas', microregionId: 31027 },
    { id: 3134707, name: 'Jacinto', microregionId: 31014 },
    { id: 3134806, name: 'Jacuí', microregionId: 31048 },
    { id: 3134905, name: 'Jacutinga', microregionId: 31051 },
    { id: 3135001, name: 'Jaguaraçu', microregionId: 31039 },
    { id: 3135050, name: 'Jaíba', microregionId: 31004 },
    { id: 3135076, name: 'Jampruca', microregionId: 31037 },
    { id: 3135100, name: 'Janaúba', microregionId: 31004 },
    { id: 3135209, name: 'Januária', microregionId: 31003 },
    { id: 3135308, name: 'Japaraíba', microregionId: 31026 },
    { id: 3135357, name: 'Japonvar', microregionId: 31007 },
    { id: 3135407, name: 'Jeceaba', microregionId: 31032 },
    { id: 3135456, name: 'Jenipapo de Minas', microregionId: 31011 },
    { id: 3135506, name: 'Jequeri', microregionId: 31060 },
    { id: 3135605, name: 'Jequitaí', microregionId: 31006 },
    { id: 3135704, name: 'Jequitibá', microregionId: 31027 },
    { id: 3135803, name: 'Jequitinhonha', microregionId: 31014 },
    { id: 3135902, name: 'Jesuânia', microregionId: 31054 },
    { id: 3136009, name: 'Joaíma', microregionId: 31014 },
    { id: 3136108, name: 'Joanésia', microregionId: 31039 },
    { id: 3136207, name: 'João Monlevade', microregionId: 31031 },
    { id: 3136306, name: 'João Pinheiro', microregionId: 31002 },
    { id: 3136405, name: 'Joaquim Felício', microregionId: 31025 },
    { id: 3136504, name: 'Jordânia', microregionId: 31014 },
    { id: 3136520, name: 'José Gonçalves de Minas', microregionId: 31011 },
    { id: 3136553, name: 'José Raydan', microregionId: 31036 },
    { id: 3136579, name: 'Josenópolis', microregionId: 31008 },
    { id: 3136652, name: 'Juatuba', microregionId: 31030 },
    { id: 3136702, name: 'Juiz de Fora', microregionId: 31065 },
    { id: 3136801, name: 'Juramento', microregionId: 31007 },
    { id: 3136900, name: 'Juruaia', microregionId: 31048 },
    { id: 3136959, name: 'Juvenília', microregionId: 31003 },
    { id: 3137007, name: 'Ladainha', microregionId: 31015 },
    { id: 3137106, name: 'Lagamar', microregionId: 31002 },
    { id: 3137205, name: 'Lagoa da Prata', microregionId: 31026 },
    { id: 3137304, name: 'Lagoa dos Patos', microregionId: 31006 },
    { id: 3137403, name: 'Lagoa Dourada', microregionId: 31058 },
    { id: 3137502, name: 'Lagoa Formosa', microregionId: 31020 },
    { id: 3137536, name: 'Lagoa Grande', microregionId: 31002 },
    { id: 3137601, name: 'Lagoa Santa', microregionId: 31030 },
    { id: 3137700, name: 'Lajinha', microregionId: 31061 },
    { id: 3137809, name: 'Lambari', microregionId: 31054 },
    { id: 3137908, name: 'Lamim', microregionId: 31062 },
    { id: 3138005, name: 'Laranjal', microregionId: 31066 },
    { id: 3138104, name: 'Lassance', microregionId: 31006 },
    { id: 3138203, name: 'Lavras', microregionId: 31057 },
    { id: 3138302, name: 'Leandro Ferreira', microregionId: 31026 },
    { id: 3138351, name: 'Leme do Prado', microregionId: 31011 },
    { id: 3138401, name: 'Leopoldina', microregionId: 31066 },
    { id: 3138500, name: 'Liberdade', microregionId: 31055 },
    { id: 3138609, name: 'Lima Duarte', microregionId: 31065 },
    { id: 3138625, name: 'Limeira do Oeste', microregionId: 31021 },
    { id: 3138658, name: 'Lontra', microregionId: 31007 },
    { id: 3138674, name: 'Luisburgo', microregionId: 31061 },
    { id: 3138682, name: 'Luislândia', microregionId: 31007 },
    { id: 3138708, name: 'Luminárias', microregionId: 31057 },
    { id: 3138807, name: 'Luz', microregionId: 31026 },
    { id: 3138906, name: 'Machacalis', microregionId: 31016 },
    { id: 3139003, name: 'Machado', microregionId: 31049 },
    { id: 3139102, name: 'Madre de Deus de Minas', microregionId: 31058 },
    { id: 3139201, name: 'Malacacheta', microregionId: 31015 },
    { id: 3139250, name: 'Mamonas', microregionId: 31004 },
    { id: 3139300, name: 'Manga', microregionId: 31003 },
    { id: 3139409, name: 'Manhuaçu', microregionId: 31061 },
    { id: 3139508, name: 'Manhumirim', microregionId: 31061 },
    { id: 3139607, name: 'Mantena', microregionId: 31038 },
    { id: 3139805, name: 'Mar de Espanha', microregionId: 31065 },
    { id: 3139706, name: 'Maravilhas', microregionId: 31027 },
    { id: 3139904, name: 'Maria da Fé', microregionId: 31056 },
    { id: 3140001, name: 'Mariana', microregionId: 31033 },
    { id: 3140100, name: 'Marilac', microregionId: 31037 },
    { id: 3140159, name: 'Mário Campos', microregionId: 31030 },
    { id: 3140209, name: 'Maripá de Minas', microregionId: 31065 },
    { id: 3140308, name: 'Marliéria', microregionId: 31039 },
    { id: 3140407, name: 'Marmelópolis', microregionId: 31056 },
    { id: 3140506, name: 'Martinho Campos', microregionId: 31026 },
    { id: 3140530, name: 'Martins Soares', microregionId: 31061 },
    { id: 3140555, name: 'Mata Verde', microregionId: 31014 },
    { id: 3140605, name: 'Materlândia', microregionId: 31035 },
    { id: 3140704, name: 'Mateus Leme', microregionId: 31030 },
    { id: 3171501, name: 'Mathias Lobato', microregionId: 31037 },
    { id: 3140803, name: 'Matias Barbosa', microregionId: 31065 },
    { id: 3140852, name: 'Matias Cardoso', microregionId: 31003 },
    { id: 3140902, name: 'Matipó', microregionId: 31061 },
    { id: 3141009, name: 'Mato Verde', microregionId: 31004 },
    { id: 3141108, name: 'Matozinhos', microregionId: 31027 },
    { id: 3141207, name: 'Matutina', microregionId: 31020 },
    { id: 3141306, name: 'Medeiros', microregionId: 31042 },
    { id: 3141405, name: 'Medina', microregionId: 31013 },
    { id: 3141504, name: 'Mendes Pimentel', microregionId: 31038 },
    { id: 3141603, name: 'Mercês', microregionId: 31064 },
    { id: 3141702, name: 'Mesquita', microregionId: 31039 },
    { id: 3141801, name: 'Minas Novas', microregionId: 31011 },
    { id: 3141900, name: 'Minduri', microregionId: 31055 },
    { id: 3142007, name: 'Mirabela', microregionId: 31007 },
    { id: 3142106, name: 'Miradouro', microregionId: 31063 },
    { id: 3142205, name: 'Miraí', microregionId: 31063 },
    { id: 3142254, name: 'Miravânia', microregionId: 31003 },
    { id: 3142304, name: 'Moeda', microregionId: 31032 },
    { id: 3142403, name: 'Moema', microregionId: 31026 },
    { id: 3142502, name: 'Monjolos', microregionId: 31025 },
    { id: 3142601, name: 'Monsenhor Paulo', microregionId: 31050 },
    { id: 3142700, name: 'Montalvânia', microregionId: 31003 },
    { id: 3142809, name: 'Monte Alegre de Minas', microregionId: 31018 },
    { id: 3142908, name: 'Monte Azul', microregionId: 31004 },
    { id: 3143005, name: 'Monte Belo', microregionId: 31048 },
    { id: 3143104, name: 'Monte Carmelo', microregionId: 31019 },
    { id: 3143153, name: 'Monte Formoso', microregionId: 31014 },
    { id: 3143203, name: 'Monte Santo de Minas', microregionId: 31048 },
    { id: 3143401, name: 'Monte Sião', microregionId: 31051 },
    { id: 3143302, name: 'Montes Claros', microregionId: 31007 },
    { id: 3143450, name: 'Montezuma', microregionId: 31005 },
    { id: 3143500, name: 'Morada Nova de Minas', microregionId: 31024 },
    { id: 3143609, name: 'Morro da Garça', microregionId: 31025 },
    { id: 3143708, name: 'Morro do Pilar', microregionId: 31028 },
    { id: 3143807, name: 'Munhoz', microregionId: 31052 },
    { id: 3143906, name: 'Muriaé', microregionId: 31063 },
    { id: 3144003, name: 'Mutum', microregionId: 31041 },
    { id: 3144102, name: 'Muzambinho', microregionId: 31048 },
    { id: 3144201, name: 'Nacip Raydan', microregionId: 31037 },
    { id: 3144300, name: 'Nanuque', microregionId: 31016 },
    { id: 3144359, name: 'Naque', microregionId: 31039 },
    { id: 3144375, name: 'Natalândia', microregionId: 31001 },
    { id: 3144409, name: 'Natércia', microregionId: 31053 },
    { id: 3144508, name: 'Nazareno', microregionId: 31058 },
    { id: 3144607, name: 'Nepomuceno', microregionId: 31057 },
    { id: 3144656, name: 'Ninheira', microregionId: 31005 },
    { id: 3144672, name: 'Nova Belém', microregionId: 31038 },
    { id: 3144706, name: 'Nova Era', microregionId: 31031 },
    { id: 3144805, name: 'Nova Lima', microregionId: 31030 },
    { id: 3144904, name: 'Nova Módica', microregionId: 31037 },
    { id: 3145000, name: 'Nova Ponte', microregionId: 31023 },
    { id: 3145059, name: 'Nova Porteirinha', microregionId: 31004 },
    { id: 3145109, name: 'Nova Resende', microregionId: 31048 },
    { id: 3145208, name: 'Nova Serrana', microregionId: 31043 },
    { id: 3136603, name: 'Nova União', microregionId: 31031 },
    { id: 3145307, name: 'Novo Cruzeiro', microregionId: 31012 },
    { id: 3145356, name: 'Novo Oriente de Minas', microregionId: 31015 },
    { id: 3145372, name: 'Novorizonte', microregionId: 31005 },
    { id: 3145406, name: 'Olaria', microregionId: 31065 },
    { id: 3145455, name: 'Olhos-d\'Água', microregionId: 31009 },
    { id: 3145505, name: 'Olímpio Noronha', microregionId: 31054 },
    { id: 3145604, name: 'Oliveira', microregionId: 31046 },
    { id: 3145703, name: 'Oliveira Fortes', microregionId: 31065 },
    { id: 3145802, name: 'Onça de Pitangui', microregionId: 31029 },
    { id: 3145851, name: 'Oratórios', microregionId: 31060 },
    { id: 3145877, name: 'Orizânia', microregionId: 31063 },
    { id: 3145901, name: 'Ouro Branco', microregionId: 31034 },
    { id: 3146008, name: 'Ouro Fino', microregionId: 31051 },
    { id: 3146107, name: 'Ouro Preto', microregionId: 31033 },
    { id: 3146206, name: 'Ouro Verde de Minas', microregionId: 31015 },
    { id: 3146255, name: 'Padre Carvalho', microregionId: 31008 },
    { id: 3146305, name: 'Padre Paraíso', microregionId: 31012 },
    { id: 3146552, name: 'Pai Pedro', microregionId: 31004 },
    { id: 3146404, name: 'Paineiras', microregionId: 31024 },
    { id: 3146503, name: 'Pains', microregionId: 31044 },
    { id: 3146602, name: 'Paiva', microregionId: 31065 },
    { id: 3146701, name: 'Palma', microregionId: 31066 },
    { id: 3146750, name: 'Palmópolis', microregionId: 31014 },
    { id: 3146909, name: 'Papagaios', microregionId: 31027 },
    { id: 3147105, name: 'Pará de Minas', microregionId: 31029 },
    { id: 3147006, name: 'Paracatu', microregionId: 31002 },
    { id: 3147204, name: 'Paraguaçu', microregionId: 31049 },
    { id: 3147303, name: 'Paraisópolis', microregionId: 31056 },
    { id: 3147402, name: 'Paraopeba', microregionId: 31027 },
    { id: 3147600, name: 'Passa Quatro', microregionId: 31054 },
    { id: 3147709, name: 'Passa Tempo', microregionId: 31046 },
    { id: 3147808, name: 'Passa Vinte', microregionId: 31055 },
    { id: 3147501, name: 'Passabém', microregionId: 31028 },
    { id: 3147907, name: 'Passos', microregionId: 31047 },
    { id: 3147956, name: 'Patis', microregionId: 31007 },
    { id: 3148004, name: 'Patos de Minas', microregionId: 31020 },
    { id: 3148103, name: 'Patrocínio', microregionId: 31019 },
    { id: 3148202, name: 'Patrocínio do Muriaé', microregionId: 31063 },
    { id: 3148301, name: 'Paula Cândido', microregionId: 31062 },
    { id: 3148400, name: 'Paulistas', microregionId: 31035 },
    { id: 3148509, name: 'Pavão', microregionId: 31015 },
    { id: 3148608, name: 'Peçanha', microregionId: 31036 },
    { id: 3148707, name: 'Pedra Azul', microregionId: 31013 },
    { id: 3148756, name: 'Pedra Bonita', microregionId: 31061 },
    { id: 3148806, name: 'Pedra do Anta', microregionId: 31062 },
    { id: 3148905, name: 'Pedra do Indaiá', microregionId: 31044 },
    { id: 3149002, name: 'Pedra Dourada', microregionId: 31063 },
    { id: 3149101, name: 'Pedralva', microregionId: 31053 },
    { id: 3149150, name: 'Pedras de Maria da Cruz', microregionId: 31003 },
    { id: 3149200, name: 'Pedrinópolis', microregionId: 31023 },
    { id: 3149309, name: 'Pedro Leopoldo', microregionId: 31030 },
    { id: 3149408, name: 'Pedro Teixeira', microregionId: 31065 },
    { id: 3149507, name: 'Pequeri', microregionId: 31065 },
    { id: 3149606, name: 'Pequi', microregionId: 31027 },
    { id: 3149705, name: 'Perdigão', microregionId: 31043 },
    { id: 3149804, name: 'Perdizes', microregionId: 31023 },
    { id: 3149903, name: 'Perdões', microregionId: 31045 },
    { id: 3149952, name: 'Periquito', microregionId: 31039 },
    { id: 3150000, name: 'Pescador', microregionId: 31037 },
    { id: 3150109, name: 'Piau', microregionId: 31065 },
    { id: 3150158, name: 'Piedade de Caratinga', microregionId: 31040 },
    { id: 3150208, name: 'Piedade de Ponte Nova', microregionId: 31060 },
    { id: 3150307, name: 'Piedade do Rio Grande', microregionId: 31058 },
    { id: 3150406, name: 'Piedade dos Gerais', microregionId: 31032 },
    { id: 3150505, name: 'Pimenta', microregionId: 31044 },
    { id: 3150539, name: 'Pingo-d\'Água', microregionId: 31040 },
    { id: 3150570, name: 'Pintópolis', microregionId: 31003 },
    { id: 3150604, name: 'Piracema', microregionId: 31046 },
    { id: 3150703, name: 'Pirajuba', microregionId: 31021 },
    { id: 3150802, name: 'Piranga', microregionId: 31062 },
    { id: 3150901, name: 'Piranguçu', microregionId: 31056 },
    { id: 3151008, name: 'Piranguinho', microregionId: 31056 },
    { id: 3151107, name: 'Pirapetinga', microregionId: 31066 },
    { id: 3151206, name: 'Pirapora', microregionId: 31006 },
    { id: 3151305, name: 'Piraúba', microregionId: 31064 },
    { id: 3151404, name: 'Pitangui', microregionId: 31029 },
    { id: 3151503, name: 'Piumhi', microregionId: 31042 },
    { id: 3151602, name: 'Planura', microregionId: 31021 },
    { id: 3151701, name: 'Poço Fundo', microregionId: 31049 },
    { id: 3151800, name: 'Poços de Caldas', microregionId: 31051 },
    { id: 3151909, name: 'Pocrane', microregionId: 31041 },
    { id: 3152006, name: 'Pompéu', microregionId: 31024 },
    { id: 3152105, name: 'Ponte Nova', microregionId: 31060 },
    { id: 3152131, name: 'Ponto Chique', microregionId: 31007 },
    { id: 3152170, name: 'Ponto dos Volantes', microregionId: 31012 },
    { id: 3152204, name: 'Porteirinha', microregionId: 31004 },
    { id: 3152303, name: 'Porto Firme', microregionId: 31062 },
    { id: 3152402, name: 'Poté', microregionId: 31015 },
    { id: 3152501, name: 'Pouso Alegre', microregionId: 31052 },
    { id: 3152600, name: 'Pouso Alto', microregionId: 31054 },
    { id: 3152709, name: 'Prados', microregionId: 31058 },
    { id: 3152808, name: 'Prata', microregionId: 31018 },
    { id: 3152907, name: 'Pratápolis', microregionId: 31047 },
    { id: 3153004, name: 'Pratinha', microregionId: 31023 },
    { id: 3153103, name: 'Presidente Bernardes', microregionId: 31062 },
    { id: 3153202, name: 'Presidente Juscelino', microregionId: 31025 },
    { id: 3153301, name: 'Presidente Kubitschek', microregionId: 31010 },
    { id: 3153400, name: 'Presidente Olegário', microregionId: 31002 },
    { id: 3153608, name: 'Prudente de Morais', microregionId: 31027 },
    { id: 3153707, name: 'Quartel Geral', microregionId: 31026 },
    { id: 3153806, name: 'Queluzito', microregionId: 31034 },
    { id: 3153905, name: 'Raposos', microregionId: 31030 },
    { id: 3154002, name: 'Raul Soares', microregionId: 31060 },
    { id: 3154101, name: 'Recreio', microregionId: 31066 },
    { id: 3154150, name: 'Reduto', microregionId: 31061 },
    { id: 3154200, name: 'Resende Costa', microregionId: 31058 },
    { id: 3154309, name: 'Resplendor', microregionId: 31041 },
    { id: 3154408, name: 'Ressaquinha', microregionId: 31059 },
    { id: 3154457, name: 'Riachinho', microregionId: 31006 },
    { id: 3154507, name: 'Riacho dos Machados', microregionId: 31004 },
    { id: 3154606, name: 'Ribeirão das Neves', microregionId: 31030 },
    { id: 3154705, name: 'Ribeirão Vermelho', microregionId: 31057 },
    { id: 3154804, name: 'Rio Acima', microregionId: 31030 },
    { id: 3154903, name: 'Rio Casca', microregionId: 31060 },
    { id: 3155108, name: 'Rio do Prado', microregionId: 31014 },
    { id: 3155009, name: 'Rio Doce', microregionId: 31060 },
    { id: 3155207, name: 'Rio Espera', microregionId: 31062 },
    { id: 3155306, name: 'Rio Manso', microregionId: 31032 },
    { id: 3155405, name: 'Rio Novo', microregionId: 31065 },
    { id: 3155504, name: 'Rio Paranaíba', microregionId: 31020 },
    { id: 3155603, name: 'Rio Pardo de Minas', microregionId: 31005 },
    { id: 3155702, name: 'Rio Piracicaba', microregionId: 31031 },
    { id: 3155801, name: 'Rio Pomba', microregionId: 31064 },
    { id: 3155900, name: 'Rio Preto', microregionId: 31065 },
    { id: 3156007, name: 'Rio Vermelho', microregionId: 31028 },
    { id: 3156106, name: 'Ritápolis', microregionId: 31058 },
    { id: 3156205, name: 'Rochedo de Minas', microregionId: 31065 },
    { id: 3156304, name: 'Rodeiro', microregionId: 31064 },
    { id: 3156403, name: 'Romaria', microregionId: 31019 },
    { id: 3156452, name: 'Rosário da Limeira', microregionId: 31063 },
    { id: 3156502, name: 'Rubelita', microregionId: 31005 },
    { id: 3156601, name: 'Rubim', microregionId: 31014 },
    { id: 3156700, name: 'Sabará', microregionId: 31030 },
    { id: 3156809, name: 'Sabinópolis', microregionId: 31035 },
    { id: 3156908, name: 'Sacramento', microregionId: 31023 },
    { id: 3157005, name: 'Salinas', microregionId: 31005 },
    { id: 3157104, name: 'Salto da Divisa', microregionId: 31014 },
    { id: 3157203, name: 'Santa Bárbara', microregionId: 31031 },
    { id: 3157252, name: 'Santa Bárbara do Leste', microregionId: 31040 },
    { id: 3157278, name: 'Santa Bárbara do Monte Verde', microregionId: 31065 },
    { id: 3157302, name: 'Santa Bárbara do Tugúrio', microregionId: 31059 },
    { id: 3157336, name: 'Santa Cruz de Minas', microregionId: 31058 },
    { id: 3157377, name: 'Santa Cruz de Salinas', microregionId: 31005 },
    { id: 3157401, name: 'Santa Cruz do Escalvado', microregionId: 31060 },
    { id: 3157500, name: 'Santa Efigênia de Minas', microregionId: 31035 },
    { id: 3157609, name: 'Santa Fé de Minas', microregionId: 31006 },
    { id: 3157658, name: 'Santa Helena de Minas', microregionId: 31016 },
    { id: 3157708, name: 'Santa Juliana', microregionId: 31023 },
    { id: 3157807, name: 'Santa Luzia', microregionId: 31030 },
    { id: 3157906, name: 'Santa Margarida', microregionId: 31061 },
    { id: 3158003, name: 'Santa Maria de Itabira', microregionId: 31031 },
    { id: 3158102, name: 'Santa Maria do Salto', microregionId: 31014 },
    { id: 3158201, name: 'Santa Maria do Suaçuí', microregionId: 31036 },
    { id: 3159209, name: 'Santa Rita de Caldas', microregionId: 31051 },
    { id: 3159407, name: 'Santa Rita de Ibitipoca', microregionId: 31065 },
    { id: 3159308, name: 'Santa Rita de Jacutinga', microregionId: 31065 },
    { id: 3159357, name: 'Santa Rita de Minas', microregionId: 31040 },
    { id: 3159506, name: 'Santa Rita do Itueto', microregionId: 31041 },
    { id: 3159605, name: 'Santa Rita do Sapucaí', microregionId: 31053 },
    { id: 3159704, name: 'Santa Rosa da Serra', microregionId: 31020 },
    { id: 3159803, name: 'Santa Vitória', microregionId: 31017 },
    { id: 3158300, name: 'Santana da Vargem', microregionId: 31050 },
    { id: 3158409, name: 'Santana de Cataguases', microregionId: 31066 },
    { id: 3158508, name: 'Santana de Pirapama', microregionId: 31027 },
    { id: 3158607, name: 'Santana do Deserto', microregionId: 31065 },
    { id: 3158706, name: 'Santana do Garambéu', microregionId: 31058 },
    { id: 3158805, name: 'Santana do Jacaré', microregionId: 31045 },
    { id: 3158904, name: 'Santana do Manhuaçu', microregionId: 31061 },
    { id: 3158953, name: 'Santana do Paraíso', microregionId: 31039 },
    { id: 3159001, name: 'Santana do Riacho', microregionId: 31027 },
    { id: 3159100, name: 'Santana dos Montes', microregionId: 31034 },
    { id: 3159902, name: 'Santo Antônio do Amparo', microregionId: 31046 },
    { id: 3160009, name: 'Santo Antônio do Aventureiro', microregionId: 31066 },
    { id: 3160108, name: 'Santo Antônio do Grama', microregionId: 31060 },
    { id: 3160207, name: 'Santo Antônio do Itambé', microregionId: 31028 },
    { id: 3160306, name: 'Santo Antônio do Jacinto', microregionId: 31014 },
    { id: 3160405, name: 'Santo Antônio do Monte', microregionId: 31043 },
    { id: 3160454, name: 'Santo Antônio do Retiro', microregionId: 31005 },
    { id: 3160504, name: 'Santo Antônio do Rio Abaixo', microregionId: 31028 },
    { id: 3160603, name: 'Santo Hipólito', microregionId: 31025 },
    { id: 3160702, name: 'Santos Dumont', microregionId: 31065 },
    { id: 3160801, name: 'São Bento Abade', microregionId: 31050 },
    { id: 3160900, name: 'São Brás do Suaçuí', microregionId: 31034 },
    { id: 3160959, name: 'São Domingos das Dores', microregionId: 31040 },
    { id: 3161007, name: 'São Domingos do Prata', microregionId: 31031 },
    { id: 3161056, name: 'São Félix de Minas', microregionId: 31038 },
    { id: 3161106, name: 'São Francisco', microregionId: 31003 },
    { id: 3161205, name: 'São Francisco de Paula', microregionId: 31046 },
    { id: 3161304, name: 'São Francisco de Sales', microregionId: 31021 },
    { id: 3161403, name: 'São Francisco do Glória', microregionId: 31063 },
    { id: 3161502, name: 'São Geraldo', microregionId: 31064 },
    { id: 3161601, name: 'São Geraldo da Piedade', microregionId: 31037 },
    { id: 3161650, name: 'São Geraldo do Baixio', microregionId: 31037 },
    { id: 3161700, name: 'São Gonçalo do Abaeté', microregionId: 31002 },
    { id: 3161809, name: 'São Gonçalo do Pará', microregionId: 31043 },
    { id: 3161908, name: 'São Gonçalo do Rio Abaixo', microregionId: 31031 },
    { id: 3125507, name: 'São Gonçalo do Rio Preto', microregionId: 31010 },
    { id: 3162005, name: 'São Gonçalo do Sapucaí', microregionId: 31053 },
    { id: 3162104, name: 'São Gotardo', microregionId: 31020 },
    { id: 3162203, name: 'São João Batista do Glória', microregionId: 31047 },
    { id: 3162252, name: 'São João da Lagoa', microregionId: 31007 },
    { id: 3162302, name: 'São João da Mata', microregionId: 31053 },
    { id: 3162401, name: 'São João da Ponte', microregionId: 31007 },
    { id: 3162450, name: 'São João das Missões', microregionId: 31003 },
    { id: 3162500, name: 'São João del Rei', microregionId: 31058 },
    { id: 3162559, name: 'São João do Manhuaçu', microregionId: 31061 },
    { id: 3162575, name: 'São João do Manteninha', microregionId: 31038 },
    { id: 3162609, name: 'São João do Oriente', microregionId: 31040 },
    { id: 3162658, name: 'São João do Pacuí', microregionId: 31007 },
    { id: 3162708, name: 'São João do Paraíso', microregionId: 31005 },
    { id: 3162807, name: 'São João Evangelista', microregionId: 31035 },
    { id: 3162906, name: 'São João Nepomuceno', microregionId: 31065 },
    { id: 3162922, name: 'São Joaquim de Bicas', microregionId: 31030 },
    { id: 3162948, name: 'São José da Barra', microregionId: 31047 },
    { id: 3162955, name: 'São José da Lapa', microregionId: 31030 },
    { id: 3163003, name: 'São José da Safira', microregionId: 31037 },
    { id: 3163102, name: 'São José da Varginha', microregionId: 31029 },
    { id: 3163201, name: 'São José do Alegre', microregionId: 31053 },
    { id: 3163300, name: 'São José do Divino', microregionId: 31037 },
    { id: 3163409, name: 'São José do Goiabal', microregionId: 31031 },
    { id: 3163508, name: 'São José do Jacuri', microregionId: 31036 },
    { id: 3163607, name: 'São José do Mantimento', microregionId: 31061 },
    { id: 3163706, name: 'São Lourenço', microregionId: 31054 },
    { id: 3163805, name: 'São Miguel do Anta', microregionId: 31062 },
    { id: 3163904, name: 'São Pedro da União', microregionId: 31048 },
    { id: 3164100, name: 'São Pedro do Suaçuí', microregionId: 31036 },
    { id: 3164001, name: 'São Pedro dos Ferros', microregionId: 31060 },
    { id: 3164209, name: 'São Romão', microregionId: 31006 },
    { id: 3164308, name: 'São Roque de Minas', microregionId: 31042 },
    { id: 3164407, name: 'São Sebastião da Bela Vista', microregionId: 31053 },
    { id: 3164431, name: 'São Sebastião da Vargem Alegre', microregionId: 31063 },
    { id: 3164472, name: 'São Sebastião do Anta', microregionId: 31040 },
    { id: 3164506, name: 'São Sebastião do Maranhão', microregionId: 31036 },
    { id: 3164605, name: 'São Sebastião do Oeste', microregionId: 31043 },
    { id: 3164704, name: 'São Sebastião do Paraíso', microregionId: 31048 },
    { id: 3164803, name: 'São Sebastião do Rio Preto', microregionId: 31028 },
    { id: 3164902, name: 'São Sebastião do Rio Verde', microregionId: 31054 },
    { id: 3165008, name: 'São Tiago', microregionId: 31058 },
    { id: 3165107, name: 'São Tomás de Aquino', microregionId: 31048 },
    { id: 3165206, name: 'São Tomé das Letras', microregionId: 31050 },
    { id: 3165305, name: 'São Vicente de Minas', microregionId: 31055 },
    { id: 3165404, name: 'Sapucaí-Mirim', microregionId: 31052 },
    { id: 3165503, name: 'Sardoá', microregionId: 31035 },
    { id: 3165537, name: 'Sarzedo', microregionId: 31030 },
    { id: 3165560, name: 'Sem-Peixe', microregionId: 31060 },
    { id: 3165578, name: 'Senador Amaral', microregionId: 31052 },
    { id: 3165602, name: 'Senador Cortes', microregionId: 31065 },
    { id: 3165701, name: 'Senador Firmino', microregionId: 31064 },
    { id: 3165800, name: 'Senador José Bento', microregionId: 31052 },
    { id: 3165909, name: 'Senador Modestino Gonçalves', microregionId: 31010 },
    { id: 3166006, name: 'Senhora de Oliveira', microregionId: 31062 },
    { id: 3166105, name: 'Senhora do Porto', microregionId: 31035 },
    { id: 3166204, name: 'Senhora dos Remédios', microregionId: 31059 },
    { id: 3166303, name: 'Sericita', microregionId: 31060 },
    { id: 3166402, name: 'Seritinga', microregionId: 31055 },
    { id: 3166501, name: 'Serra Azul de Minas', microregionId: 31028 },
    { id: 3166600, name: 'Serra da Saudade', microregionId: 31026 },
    { id: 3166808, name: 'Serra do Salitre', microregionId: 31019 },
    { id: 3166709, name: 'Serra dos Aimorés', microregionId: 31016 },
    { id: 3166907, name: 'Serrania', microregionId: 31049 },
    { id: 3166956, name: 'Serranópolis de Minas', microregionId: 31004 },
    { id: 3167004, name: 'Serranos', microregionId: 31055 },
    { id: 3167103, name: 'Serro', microregionId: 31028 },
    { id: 3167202, name: 'Sete Lagoas', microregionId: 31027 },
    { id: 3165552, name: 'Setubinha', microregionId: 31015 },
    { id: 3167301, name: 'Silveirânia', microregionId: 31064 },
    { id: 3167400, name: 'Silvianópolis', microregionId: 31053 },
    { id: 3167509, name: 'Simão Pereira', microregionId: 31065 },
    { id: 3167608, name: 'Simonésia', microregionId: 31061 },
    { id: 3167707, name: 'Sobrália', microregionId: 31037 },
    { id: 3167806, name: 'Soledade de Minas', microregionId: 31054 },
    { id: 3167905, name: 'Tabuleiro', microregionId: 31064 },
    { id: 3168002, name: 'Taiobeiras', microregionId: 31005 },
    { id: 3168051, name: 'Taparuba', microregionId: 31041 },
    { id: 3168101, name: 'Tapira', microregionId: 31023 },
    { id: 3168200, name: 'Tapiraí', microregionId: 31042 },
    { id: 3168309, name: 'Taquaraçu de Minas', microregionId: 31031 },
    { id: 3168408, name: 'Tarumirim', microregionId: 31040 },
    { id: 3168507, name: 'Teixeiras', microregionId: 31062 },
    { id: 3168606, name: 'Teófilo Otoni', microregionId: 31015 },
    { id: 3168705, name: 'Timóteo', microregionId: 31039 },
    { id: 3168804, name: 'Tiradentes', microregionId: 31058 },
    { id: 3168903, name: 'Tiros', microregionId: 31020 },
    { id: 3169000, name: 'Tocantins', microregionId: 31064 },
    { id: 3169059, name: 'Tocos do Moji', microregionId: 31052 },
    { id: 3169109, name: 'Toledo', microregionId: 31052 },
    { id: 3169208, name: 'Tombos', microregionId: 31063 },
    { id: 3169307, name: 'Três Corações', microregionId: 31050 },
    { id: 3169356, name: 'Três Marias', microregionId: 31024 },
    { id: 3169406, name: 'Três Pontas', microregionId: 31050 },
    { id: 3169505, name: 'Tumiritinga', microregionId: 31037 },
    { id: 3169604, name: 'Tupaciguara', microregionId: 31018 },
    { id: 3169703, name: 'Turmalina', microregionId: 31011 },
    { id: 3169802, name: 'Turvolândia', microregionId: 31053 },
    { id: 3169901, name: 'Ubá', microregionId: 31064 },
    { id: 3170008, name: 'Ubaí', microregionId: 31007 },
    { id: 3170057, name: 'Ubaporanga', microregionId: 31040 },
    { id: 3170107, name: 'Uberaba', microregionId: 31022 },
    { id: 3170206, name: 'Uberlândia', microregionId: 31018 },
    { id: 3170305, name: 'Umburatiba', microregionId: 31016 },
    { id: 3170404, name: 'Unaí', microregionId: 31001 },
    { id: 3170438, name: 'União de Minas', microregionId: 31021 },
    { id: 3170479, name: 'Uruana de Minas', microregionId: 31001 },
    { id: 3170503, name: 'Urucânia', microregionId: 31060 },
    { id: 3170529, name: 'Urucuia', microregionId: 31003 },
    { id: 3170578, name: 'Vargem Alegre', microregionId: 31040 },
    { id: 3170602, name: 'Vargem Bonita', microregionId: 31042 },
    { id: 3170651, name: 'Vargem Grande do Rio Pardo', microregionId: 31005 },
    { id: 3170701, name: 'Varginha', microregionId: 31050 },
    { id: 3170750, name: 'Varjão de Minas', microregionId: 31002 },
    { id: 3170800, name: 'Várzea da Palma', microregionId: 31006 },
    { id: 3170909, name: 'Varzelândia', microregionId: 31007 },
    { id: 3171006, name: 'Vazante', microregionId: 31002 },
    { id: 3171030, name: 'Verdelândia', microregionId: 31007 },
    { id: 3171071, name: 'Veredinha', microregionId: 31011 },
    { id: 3171105, name: 'Veríssimo', microregionId: 31022 },
    { id: 3171154, name: 'Vermelho Novo', microregionId: 31060 },
    { id: 3171204, name: 'Vespasiano', microregionId: 31030 },
    { id: 3171303, name: 'Viçosa', microregionId: 31062 },
    { id: 3171402, name: 'Vieiras', microregionId: 31063 },
    { id: 3171600, name: 'Virgem da Lapa', microregionId: 31012 },
    { id: 3171709, name: 'Virgínia', microregionId: 31056 },
    { id: 3171808, name: 'Virginópolis', microregionId: 31035 },
    { id: 3171907, name: 'Virgolândia', microregionId: 31037 },
    { id: 3172004, name: 'Visconde do Rio Branco', microregionId: 31064 },
    { id: 3172103, name: 'Volta Grande', microregionId: 31066 },
    { id: 3172202, name: 'Wenceslau Braz', microregionId: 31056 },
  ],
  32: [
    { id: 3200102, name: 'Afonso Cláudio', microregionId: 32007 },
    { id: 3200169, name: 'Água Doce do Norte', microregionId: 32001 },
    { id: 3200136, name: 'Águia Branca', microregionId: 32002 },
    { id: 3200201, name: 'Alegre', microregionId: 32011 },
    { id: 3200300, name: 'Alfredo Chaves', microregionId: 32010 },
    { id: 3200359, name: 'Alto Rio Novo', microregionId: 32003 },
    { id: 3200409, name: 'Anchieta', microregionId: 32010 },
    { id: 3200508, name: 'Apiacá', microregionId: 32012 },
    { id: 3200607, name: 'Aracruz', microregionId: 32006 },
    { id: 3200706, name: 'Atílio Vivácqua', microregionId: 32012 },
    { id: 3200805, name: 'Baixo Guandu', microregionId: 32003 },
    { id: 3200904, name: 'Barra de São Francisco', microregionId: 32001 },
    { id: 3201001, name: 'Boa Esperança', microregionId: 32002 },
    { id: 3201100, name: 'Bom Jesus do Norte', microregionId: 32012 },
    { id: 3201159, name: 'Brejetuba', microregionId: 32007 },
    { id: 3201209, name: 'Cachoeiro de Itapemirim', microregionId: 32012 },
    { id: 3201308, name: 'Cariacica', microregionId: 32009 },
    { id: 3201407, name: 'Castelo', microregionId: 32012 },
    { id: 3201506, name: 'Colatina', microregionId: 32003 },
    { id: 3201605, name: 'Conceição da Barra', microregionId: 32005 },
    { id: 3201704, name: 'Conceição do Castelo', microregionId: 32007 },
    { id: 3201803, name: 'Divino de São Lourenço', microregionId: 32011 },
    { id: 3201902, name: 'Domingos Martins', microregionId: 32007 },
    { id: 3202009, name: 'Dores do Rio Preto', microregionId: 32011 },
    { id: 3202108, name: 'Ecoporanga', microregionId: 32001 },
    { id: 3202207, name: 'Fundão', microregionId: 32006 },
    { id: 3202256, name: 'Governador Lindenberg', microregionId: 32003 },
    { id: 3202306, name: 'Guaçuí', microregionId: 32011 },
    { id: 3202405, name: 'Guarapari', microregionId: 32010 },
    { id: 3202454, name: 'Ibatiba', microregionId: 32011 },
    { id: 3202504, name: 'Ibiraçu', microregionId: 32006 },
    { id: 3202553, name: 'Ibitirama', microregionId: 32011 },
    { id: 3202603, name: 'Iconha', microregionId: 32010 },
    { id: 3202652, name: 'Irupi', microregionId: 32011 },
    { id: 3202702, name: 'Itaguaçu', microregionId: 32008 },
    { id: 3202801, name: 'Itapemirim', microregionId: 32013 },
    { id: 3202900, name: 'Itarana', microregionId: 32008 },
    { id: 3203007, name: 'Iúna', microregionId: 32011 },
    { id: 3203056, name: 'Jaguaré', microregionId: 32005 },
    { id: 3203106, name: 'Jerônimo Monteiro', microregionId: 32012 },
    { id: 3203130, name: 'João Neiva', microregionId: 32006 },
    { id: 3203163, name: 'Laranja da Terra', microregionId: 32007 },
    { id: 3203205, name: 'Linhares', microregionId: 32006 },
    { id: 3203304, name: 'Mantenópolis', microregionId: 32001 },
    { id: 3203320, name: 'Marataízes', microregionId: 32013 },
    { id: 3203346, name: 'Marechal Floriano', microregionId: 32007 },
    { id: 3203353, name: 'Marilândia', microregionId: 32003 },
    { id: 3203403, name: 'Mimoso do Sul', microregionId: 32012 },
    { id: 3203502, name: 'Montanha', microregionId: 32004 },
    { id: 3203601, name: 'Mucurici', microregionId: 32004 },
    { id: 3203700, name: 'Muniz Freire', microregionId: 32011 },
    { id: 3203809, name: 'Muqui', microregionId: 32012 },
    { id: 3203908, name: 'Nova Venécia', microregionId: 32002 },
    { id: 3204005, name: 'Pancas', microregionId: 32003 },
    { id: 3204054, name: 'Pedro Canário', microregionId: 32005 },
    { id: 3204104, name: 'Pinheiros', microregionId: 32004 },
    { id: 3204203, name: 'Piúma', microregionId: 32010 },
    { id: 3204252, name: 'Ponto Belo', microregionId: 32004 },
    { id: 3204302, name: 'Presidente Kennedy', microregionId: 32013 },
    { id: 3204351, name: 'Rio Bananal', microregionId: 32006 },
    { id: 3204401, name: 'Rio Novo do Sul', microregionId: 32010 },
    { id: 3204500, name: 'Santa Leopoldina', microregionId: 32008 },
    { id: 3204559, name: 'Santa Maria de Jetibá', microregionId: 32008 },
    { id: 3204609, name: 'Santa Teresa', microregionId: 32008 },
    { id: 3204658, name: 'São Domingos do Norte', microregionId: 32003 },
    { id: 3204708, name: 'São Gabriel da Palha', microregionId: 32002 },
    { id: 3204807, name: 'São José do Calçado', microregionId: 32012 },
    { id: 3204906, name: 'São Mateus', microregionId: 32005 },
    { id: 3204955, name: 'São Roque do Canaã', microregionId: 32008 },
    { id: 3205002, name: 'Serra', microregionId: 32009 },
    { id: 3205010, name: 'Sooretama', microregionId: 32006 },
    { id: 3205036, name: 'Vargem Alta', microregionId: 32012 },
    { id: 3205069, name: 'Venda Nova do Imigrante', microregionId: 32007 },
    { id: 3205101, name: 'Viana', microregionId: 32009 },
    { id: 3205150, name: 'Vila Pavão', microregionId: 32002 },
    { id: 3205176, name: 'Vila Valério', microregionId: 32002 },
    { id: 3205200, name: 'Vila Velha', microregionId: 32009 },
    { id: 3205309, name: 'Vitória', microregionId: 32009 },
  ],
  33: [
    { id: 3300100, name: 'Angra dos Reis', microregionId: 33013 },
    { id: 3300159, name: 'Aperibé', microregionId: 33002 },
    { id: 3300209, name: 'Araruama', microregionId: 33010 },
    { id: 3300225, name: 'Areal', microregionId: 33005 },
    { id: 3300233, name: 'Armação dos Búzios', microregionId: 33010 },
    { id: 3300258, name: 'Arraial do Cabo', microregionId: 33010 },
    { id: 3300308, name: 'Barra do Piraí', microregionId: 33012 },
    { id: 3300407, name: 'Barra Mansa', microregionId: 33011 },
    { id: 3300456, name: 'Belford Roxo', microregionId: 33018 },
    { id: 3300506, name: 'Bom Jardim', microregionId: 33007 },
    { id: 3300605, name: 'Bom Jesus do Itabapoana', microregionId: 33001 },
    { id: 3300704, name: 'Cabo Frio', microregionId: 33010 },
    { id: 3300803, name: 'Cachoeiras de Macacu', microregionId: 33016 },
    { id: 3300902, name: 'Cambuci', microregionId: 33002 },
    { id: 3301009, name: 'Campos dos Goytacazes', microregionId: 33003 },
    { id: 3301108, name: 'Cantagalo', microregionId: 33006 },
    { id: 3300936, name: 'Carapebus', microregionId: 33004 },
    { id: 3301157, name: 'Cardoso Moreira', microregionId: 33003 },
    { id: 3301207, name: 'Carmo', microregionId: 33006 },
    { id: 3301306, name: 'Casimiro de Abreu', microregionId: 33009 },
    { id: 3300951, name: 'Comendador Levy Gasparian', microregionId: 33005 },
    { id: 3301405, name: 'Conceição de Macabu', microregionId: 33004 },
    { id: 3301504, name: 'Cordeiro', microregionId: 33006 },
    { id: 3301603, name: 'Duas Barras', microregionId: 33007 },
    { id: 3301702, name: 'Duque de Caxias', microregionId: 33018 },
    { id: 3301801, name: 'Engenheiro Paulo de Frontin', microregionId: 33014 },
    { id: 3301850, name: 'Guapimirim', microregionId: 33018 },
    { id: 3301876, name: 'Iguaba Grande', microregionId: 33010 },
    { id: 3301900, name: 'Itaboraí', microregionId: 33018 },
    { id: 3302007, name: 'Itaguaí', microregionId: 33017 },
    { id: 3302056, name: 'Italva', microregionId: 33001 },
    { id: 3302106, name: 'Itaocara', microregionId: 33002 },
    { id: 3302205, name: 'Itaperuna', microregionId: 33001 },
    { id: 3302254, name: 'Itatiaia', microregionId: 33011 },
    { id: 3302270, name: 'Japeri', microregionId: 33018 },
    { id: 3302304, name: 'Laje do Muriaé', microregionId: 33001 },
    { id: 3302403, name: 'Macaé', microregionId: 33004 },
    { id: 3302452, name: 'Macuco', microregionId: 33006 },
    { id: 3302502, name: 'Magé', microregionId: 33018 },
    { id: 3302601, name: 'Mangaratiba', microregionId: 33017 },
    { id: 3302700, name: 'Maricá', microregionId: 33018 },
    { id: 3302809, name: 'Mendes', microregionId: 33014 },
    { id: 3302858, name: 'Mesquita', microregionId: 33018 },
    { id: 3302908, name: 'Miguel Pereira', microregionId: 33014 },
    { id: 3303005, name: 'Miracema', microregionId: 33002 },
    { id: 3303104, name: 'Natividade', microregionId: 33001 },
    { id: 3303203, name: 'Nilópolis', microregionId: 33018 },
    { id: 3303302, name: 'Niterói', microregionId: 33018 },
    { id: 3303401, name: 'Nova Friburgo', microregionId: 33007 },
    { id: 3303500, name: 'Nova Iguaçu', microregionId: 33018 },
    { id: 3303609, name: 'Paracambi', microregionId: 33014 },
    { id: 3303708, name: 'Paraíba do Sul', microregionId: 33005 },
    { id: 3303807, name: 'Paraty', microregionId: 33013 },
    { id: 3303856, name: 'Paty do Alferes', microregionId: 33014 },
    { id: 3303906, name: 'Petrópolis', microregionId: 33015 },
    { id: 3303955, name: 'Pinheiral', microregionId: 33011 },
    { id: 3304003, name: 'Piraí', microregionId: 33011 },
    { id: 3304102, name: 'Porciúncula', microregionId: 33001 },
    { id: 3304110, name: 'Porto Real', microregionId: 33011 },
    { id: 3304128, name: 'Quatis', microregionId: 33011 },
    { id: 3304144, name: 'Queimados', microregionId: 33018 },
    { id: 3304151, name: 'Quissamã', microregionId: 33004 },
    { id: 3304201, name: 'Resende', microregionId: 33011 },
    { id: 3304300, name: 'Rio Bonito', microregionId: 33016 },
    { id: 3304409, name: 'Rio Claro', microregionId: 33011 },
    { id: 3304508, name: 'Rio das Flores', microregionId: 33012 },
    { id: 3304524, name: 'Rio das Ostras', microregionId: 33009 },
    { id: 3304557, name: 'Rio de Janeiro', microregionId: 33018 },
    { id: 3304607, name: 'Santa Maria Madalena', microregionId: 33008 },
    { id: 3304706, name: 'Santo Antônio de Pádua', microregionId: 33002 },
    { id: 3304805, name: 'São Fidélis', microregionId: 33003 },
    { id: 3304755, name: 'São Francisco de Itabapoana', microregionId: 33003 },
    { id: 3304904, name: 'São Gonçalo', microregionId: 33018 },
    { id: 3305000, name: 'São João da Barra', microregionId: 33003 },
    { id: 3305109, name: 'São João de Meriti', microregionId: 33018 },
    { id: 3305133, name: 'São José de Ubá', microregionId: 33002 },
    { id: 3305158, name: 'São José do Vale do Rio Preto', microregionId: 33015 },
    { id: 3305208, name: 'São Pedro da Aldeia', microregionId: 33010 },
    { id: 3305307, name: 'São Sebastião do Alto', microregionId: 33008 },
    { id: 3305406, name: 'Sapucaia', microregionId: 33005 },
    { id: 3305505, name: 'Saquarema', microregionId: 33010 },
    { id: 3305554, name: 'Seropédica', microregionId: 33017 },
    { id: 3305604, name: 'Silva Jardim', microregionId: 33009 },
    { id: 3305703, name: 'Sumidouro', microregionId: 33007 },
    { id: 3305752, name: 'Tanguá', microregionId: 33018 },
    { id: 3305802, name: 'Teresópolis', microregionId: 33015 },
    { id: 3305901, name: 'Trajano de Moraes', microregionId: 33008 },
    { id: 3306008, name: 'Três Rios', microregionId: 33005 },
    { id: 3306107, name: 'Valença', microregionId: 33012 },
    { id: 3306156, name: 'Varre-Sai', microregionId: 33001 },
    { id: 3306206, name: 'Vassouras', microregionId: 33014 },
    { id: 3306305, name: 'Volta Redonda', microregionId: 33011 },
  ],
  35: [
    { id: 3500105, name: 'Adamantina', microregionId: 35035 },
    { id: 3500204, name: 'Adolfo', microregionId: 35004 },
    { id: 3500303, name: 'Aguaí', microregionId: 35029 },
    { id: 3500402, name: 'Águas da Prata', microregionId: 35030 },
    { id: 3500501, name: 'Águas de Lindóia', microregionId: 35033 },
    { id: 3500550, name: 'Águas de Santa Bárbara', microregionId: 35022 },
    { id: 3500600, name: 'Águas de São Pedro', microregionId: 35028 },
    { id: 3500709, name: 'Agudos', microregionId: 35020 },
    { id: 3500758, name: 'Alambari', microregionId: 35042 },
    { id: 3500808, name: 'Alfredo Marcondes', microregionId: 35036 },
    { id: 3500907, name: 'Altair', microregionId: 35004 },
    { id: 3501004, name: 'Altinópolis', microregionId: 35015 },
    { id: 3501103, name: 'Alto Alegre', microregionId: 35018 },
    { id: 3501152, name: 'Alumínio', microregionId: 35046 },
    { id: 3501202, name: 'Álvares Florence', microregionId: 35003 },
    { id: 3501301, name: 'Álvares Machado', microregionId: 35036 },
    { id: 3501400, name: 'Álvaro de Carvalho', microregionId: 35038 },
    { id: 3501509, name: 'Alvinlândia', microregionId: 35038 },
    { id: 3501608, name: 'Americana', microregionId: 35032 },
    { id: 3501707, name: 'Américo Brasiliense', microregionId: 35024 },
    { id: 3501806, name: 'Américo de Campos', microregionId: 35003 },
    { id: 3501905, name: 'Amparo', microregionId: 35033 },
    { id: 3502002, name: 'Analândia', microregionId: 35025 },
    { id: 3502101, name: 'Andradina', microregionId: 35016 },
    { id: 3502200, name: 'Angatuba', microregionId: 35042 },
    { id: 3502309, name: 'Anhembi', microregionId: 35023 },
    { id: 3502408, name: 'Anhumas', microregionId: 35036 },
    { id: 3502507, name: 'Aparecida', microregionId: 35051 },
    { id: 3502606, name: 'Aparecida d\'Oeste', microregionId: 35001 },
    { id: 3502705, name: 'Apiaí', microregionId: 35044 },
    { id: 3502754, name: 'Araçariguama', microregionId: 35046 },
    { id: 3502804, name: 'Araçatuba', microregionId: 35017 },
    { id: 3502903, name: 'Araçoiaba da Serra', microregionId: 35046 },
    { id: 3503000, name: 'Aramina', microregionId: 35011 },
    { id: 3503109, name: 'Arandu', microregionId: 35022 },
    { id: 3503158, name: 'Arapeí', microregionId: 35052 },
    { id: 3503208, name: 'Araraquara', microregionId: 35024 },
    { id: 3503307, name: 'Araras', microregionId: 35027 },
    { id: 3503356, name: 'Arco-Íris', microregionId: 35037 },
    { id: 3503406, name: 'Arealva', microregionId: 35020 },
    { id: 3503505, name: 'Areias', microregionId: 35052 },
    { id: 3503604, name: 'Areiópolis', microregionId: 35020 },
    { id: 3503703, name: 'Ariranha', microregionId: 35005 },
    { id: 3503802, name: 'Artur Nogueira', microregionId: 35031 },
    { id: 3503901, name: 'Arujá', microregionId: 35059 },
    { id: 3503950, name: 'Aspásia', microregionId: 35001 },
    { id: 3504008, name: 'Assis', microregionId: 35039 },
    { id: 3504107, name: 'Atibaia', microregionId: 35048 },
    { id: 3504206, name: 'Auriflama', microregionId: 35006 },
    { id: 3504305, name: 'Avaí', microregionId: 35020 },
    { id: 3504404, name: 'Avanhandava', microregionId: 35018 },
    { id: 3504503, name: 'Avaré', microregionId: 35022 },
    { id: 3504602, name: 'Bady Bassitt', microregionId: 35004 },
    { id: 3504701, name: 'Balbinos', microregionId: 35020 },
    { id: 3504800, name: 'Bálsamo', microregionId: 35004 },
    { id: 3504909, name: 'Bananal', microregionId: 35052 },
    { id: 3505005, name: 'Barão de Antonina', microregionId: 35041 },
    { id: 3505104, name: 'Barbosa', microregionId: 35018 },
    { id: 3505203, name: 'Bariri', microregionId: 35021 },
    { id: 3505302, name: 'Barra Bonita', microregionId: 35021 },
    { id: 3505351, name: 'Barra do Chapéu', microregionId: 35044 },
    { id: 3505401, name: 'Barra do Turvo', microregionId: 35055 },
    { id: 3505500, name: 'Barretos', microregionId: 35009 },
    { id: 3505609, name: 'Barrinha', microregionId: 35014 },
    { id: 3505708, name: 'Barueri', microregionId: 35057 },
    { id: 3505807, name: 'Bastos', microregionId: 35037 },
    { id: 3505906, name: 'Batatais', microregionId: 35015 },
    { id: 3506003, name: 'Bauru', microregionId: 35020 },
    { id: 3506102, name: 'Bebedouro', microregionId: 35013 },
    { id: 3506201, name: 'Bento de Abreu', microregionId: 35017 },
    { id: 3506300, name: 'Bernardino de Campos', microregionId: 35040 },
    { id: 3506359, name: 'Bertioga', microregionId: 35063 },
    { id: 3506409, name: 'Bilac', microregionId: 35018 },
    { id: 3506508, name: 'Birigui', microregionId: 35018 },
    { id: 3506607, name: 'Biritiba Mirim', microregionId: 35062 },
    { id: 3506706, name: 'Boa Esperança do Sul', microregionId: 35024 },
    { id: 3506805, name: 'Bocaina', microregionId: 35021 },
    { id: 3506904, name: 'Bofete', microregionId: 35023 },
    { id: 3507001, name: 'Boituva', microregionId: 35043 },
    { id: 3507100, name: 'Bom Jesus dos Perdões', microregionId: 35048 },
    { id: 3507159, name: 'Bom Sucesso de Itararé', microregionId: 35041 },
    { id: 3507209, name: 'Borá', microregionId: 35039 },
    { id: 3507308, name: 'Boracéia', microregionId: 35021 },
    { id: 3507407, name: 'Borborema', microregionId: 35024 },
    { id: 3507456, name: 'Borebi', microregionId: 35020 },
    { id: 3507506, name: 'Botucatu', microregionId: 35023 },
    { id: 3507605, name: 'Bragança Paulista', microregionId: 35048 },
    { id: 3507704, name: 'Braúna', microregionId: 35018 },
    { id: 3507753, name: 'Brejo Alegre', microregionId: 35018 },
    { id: 3507803, name: 'Brodowski', microregionId: 35014 },
    { id: 3507902, name: 'Brotas', microregionId: 35026 },
    { id: 3508009, name: 'Buri', microregionId: 35041 },
    { id: 3508108, name: 'Buritama', microregionId: 35018 },
    { id: 3508207, name: 'Buritizal', microregionId: 35011 },
    { id: 3508306, name: 'Cabrália Paulista', microregionId: 35020 },
    { id: 3508405, name: 'Cabreúva', microregionId: 35046 },
    { id: 3508504, name: 'Caçapava', microregionId: 35050 },
    { id: 3508603, name: 'Cachoeira Paulista', microregionId: 35051 },
    { id: 3508702, name: 'Caconde', microregionId: 35030 },
    { id: 3508801, name: 'Cafelândia', microregionId: 35019 },
    { id: 3508900, name: 'Caiabu', microregionId: 35036 },
    { id: 3509007, name: 'Caieiras', microregionId: 35058 },
    { id: 3509106, name: 'Caiuá', microregionId: 35036 },
    { id: 3509205, name: 'Cajamar', microregionId: 35057 },
    { id: 3509254, name: 'Cajati', microregionId: 35055 },
    { id: 3509304, name: 'Cajobi', microregionId: 35005 },
    { id: 3509403, name: 'Cajuru', microregionId: 35015 },
    { id: 3509452, name: 'Campina do Monte Alegre', microregionId: 35042 },
    { id: 3509502, name: 'Campinas', microregionId: 35032 },
    { id: 3509601, name: 'Campo Limpo Paulista', microregionId: 35047 },
    { id: 3509700, name: 'Campos do Jordão', microregionId: 35049 },
    { id: 3509809, name: 'Campos Novos Paulista', microregionId: 35039 },
    { id: 3509908, name: 'Cananéia', microregionId: 35055 },
    { id: 3509957, name: 'Canas', microregionId: 35051 },
    { id: 3510005, name: 'Cândido Mota', microregionId: 35039 },
    { id: 3510104, name: 'Cândido Rodrigues', microregionId: 35013 },
    { id: 3510153, name: 'Canitar', microregionId: 35040 },
    { id: 3510203, name: 'Capão Bonito', microregionId: 35044 },
    { id: 3510302, name: 'Capela do Alto', microregionId: 35046 },
    { id: 3510401, name: 'Capivari', microregionId: 35028 },
    { id: 3510500, name: 'Caraguatatuba', microregionId: 35054 },
    { id: 3510609, name: 'Carapicuíba', microregionId: 35057 },
    { id: 3510708, name: 'Cardoso', microregionId: 35003 },
    { id: 3510807, name: 'Casa Branca', microregionId: 35030 },
    { id: 3510906, name: 'Cássia dos Coqueiros', microregionId: 35015 },
    { id: 3511003, name: 'Castilho', microregionId: 35016 },
    { id: 3511102, name: 'Catanduva', microregionId: 35005 },
    { id: 3511201, name: 'Catiguá', microregionId: 35005 },
    { id: 3511300, name: 'Cedral', microregionId: 35004 },
    { id: 3511409, name: 'Cerqueira César', microregionId: 35022 },
    { id: 3511508, name: 'Cerquilho', microregionId: 35043 },
    { id: 3511607, name: 'Cesário Lange', microregionId: 35043 },
    { id: 3511706, name: 'Charqueada', microregionId: 35028 },
    { id: 3557204, name: 'Chavantes', microregionId: 35040 },
    { id: 3511904, name: 'Clementina', microregionId: 35018 },
    { id: 3512001, name: 'Colina', microregionId: 35009 },
    { id: 3512100, name: 'Colômbia', microregionId: 35009 },
    { id: 3512209, name: 'Conchal', microregionId: 35027 },
    { id: 3512308, name: 'Conchas', microregionId: 35023 },
    { id: 3512407, name: 'Cordeirópolis', microregionId: 35027 },
    { id: 3512506, name: 'Coroados', microregionId: 35018 },
    { id: 3512605, name: 'Coronel Macedo', microregionId: 35041 },
    { id: 3512704, name: 'Corumbataí', microregionId: 35026 },
    { id: 3512803, name: 'Cosmópolis', microregionId: 35032 },
    { id: 3512902, name: 'Cosmorama', microregionId: 35003 },
    { id: 3513009, name: 'Cotia', microregionId: 35060 },
    { id: 3513108, name: 'Cravinhos', microregionId: 35014 },
    { id: 3513207, name: 'Cristais Paulista', microregionId: 35012 },
    { id: 3513306, name: 'Cruzália', microregionId: 35039 },
    { id: 3513405, name: 'Cruzeiro', microregionId: 35051 },
    { id: 3513504, name: 'Cubatão', microregionId: 35063 },
    { id: 3513603, name: 'Cunha', microregionId: 35053 },
    { id: 3513702, name: 'Descalvado', microregionId: 35025 },
    { id: 3513801, name: 'Diadema', microregionId: 35061 },
    { id: 3513850, name: 'Dirce Reis', microregionId: 35001 },
    { id: 3513900, name: 'Divinolândia', microregionId: 35030 },
    { id: 3514007, name: 'Dobrada', microregionId: 35024 },
    { id: 3514106, name: 'Dois Córregos', microregionId: 35021 },
    { id: 3514205, name: 'Dolcinópolis', microregionId: 35001 },
    { id: 3514304, name: 'Dourado', microregionId: 35025 },
    { id: 3514403, name: 'Dracena', microregionId: 35034 },
    { id: 3514502, name: 'Duartina', microregionId: 35020 },
    { id: 3514601, name: 'Dumont', microregionId: 35014 },
    { id: 3514700, name: 'Echaporã', microregionId: 35038 },
    { id: 3514809, name: 'Eldorado', microregionId: 35055 },
    { id: 3514908, name: 'Elias Fausto', microregionId: 35032 },
    { id: 3514924, name: 'Elisiário', microregionId: 35005 },
    { id: 3514957, name: 'Embaúba', microregionId: 35005 },
    { id: 3515004, name: 'Embu das Artes', microregionId: 35060 },
    { id: 3515103, name: 'Embu-Guaçu', microregionId: 35060 },
    { id: 3515129, name: 'Emilianópolis', microregionId: 35036 },
    { id: 3515152, name: 'Engenheiro Coelho', microregionId: 35031 },
    { id: 3515186, name: 'Espírito Santo do Pinhal', microregionId: 35030 },
    { id: 3515194, name: 'Espírito Santo do Turvo', microregionId: 35040 },
    { id: 3557303, name: 'Estiva Gerbi', microregionId: 35031 },
    { id: 3515202, name: 'Estrela d\'Oeste', microregionId: 35002 },
    { id: 3515301, name: 'Estrela do Norte', microregionId: 35036 },
    { id: 3515350, name: 'Euclides da Cunha Paulista', microregionId: 35036 },
    { id: 3515400, name: 'Fartura', microregionId: 35040 },
    { id: 3515608, name: 'Fernando Prestes', microregionId: 35013 },
    { id: 3515509, name: 'Fernandópolis', microregionId: 35002 },
    { id: 3515657, name: 'Fernão', microregionId: 35038 },
    { id: 3515707, name: 'Ferraz de Vasconcelos', microregionId: 35062 },
    { id: 3515806, name: 'Flora Rica', microregionId: 35035 },
    { id: 3515905, name: 'Floreal', microregionId: 35006 },
    { id: 3516002, name: 'Flórida Paulista', microregionId: 35035 },
    { id: 3516101, name: 'Florínea', microregionId: 35039 },
    { id: 3516200, name: 'Franca', microregionId: 35012 },
    { id: 3516309, name: 'Francisco Morato', microregionId: 35058 },
    { id: 3516408, name: 'Franco da Rocha', microregionId: 35058 },
    { id: 3516507, name: 'Gabriel Monteiro', microregionId: 35018 },
    { id: 3516606, name: 'Gália', microregionId: 35038 },
    { id: 3516705, name: 'Garça', microregionId: 35038 },
    { id: 3516804, name: 'Gastão Vidigal', microregionId: 35006 },
    { id: 3516853, name: 'Gavião Peixoto', microregionId: 35024 },
    { id: 3516903, name: 'General Salgado', microregionId: 35006 },
    { id: 3517000, name: 'Getulina', microregionId: 35019 },
    { id: 3517109, name: 'Glicério', microregionId: 35018 },
    { id: 3517208, name: 'Guaiçara', microregionId: 35019 },
    { id: 3517307, name: 'Guaimbê', microregionId: 35019 },
    { id: 3517406, name: 'Guaíra', microregionId: 35010 },
    { id: 3517505, name: 'Guapiaçu', microregionId: 35004 },
    { id: 3517604, name: 'Guapiara', microregionId: 35044 },
    { id: 3517703, name: 'Guará', microregionId: 35011 },
    { id: 3517802, name: 'Guaraçaí', microregionId: 35016 },
    { id: 3517901, name: 'Guaraci', microregionId: 35004 },
    { id: 3518008, name: 'Guarani d\'Oeste', microregionId: 35002 },
    { id: 3518107, name: 'Guarantã', microregionId: 35020 },
    { id: 3518206, name: 'Guararapes', microregionId: 35017 },
    { id: 3518305, name: 'Guararema', microregionId: 35062 },
    { id: 3518404, name: 'Guaratinguetá', microregionId: 35051 },
    { id: 3518503, name: 'Guareí', microregionId: 35042 },
    { id: 3518602, name: 'Guariba', microregionId: 35013 },
    { id: 3518701, name: 'Guarujá', microregionId: 35063 },
    { id: 3518800, name: 'Guarulhos', microregionId: 35059 },
    { id: 3518859, name: 'Guatapará', microregionId: 35014 },
    { id: 3518909, name: 'Guzolândia', microregionId: 35006 },
    { id: 3519006, name: 'Herculândia', microregionId: 35037 },
    { id: 3519055, name: 'Holambra', microregionId: 35032 },
    { id: 3519071, name: 'Hortolândia', microregionId: 35032 },
    { id: 3519105, name: 'Iacanga', microregionId: 35020 },
    { id: 3519204, name: 'Iacri', microregionId: 35037 },
    { id: 3519253, name: 'Iaras', microregionId: 35022 },
    { id: 3519303, name: 'Ibaté', microregionId: 35025 },
    { id: 3519402, name: 'Ibirá', microregionId: 35004 },
    { id: 3519501, name: 'Ibirarema', microregionId: 35039 },
    { id: 3519600, name: 'Ibitinga', microregionId: 35024 },
    { id: 3519709, name: 'Ibiúna', microregionId: 35045 },
    { id: 3519808, name: 'Icém', microregionId: 35004 },
    { id: 3519907, name: 'Iepê', microregionId: 35039 },
    { id: 3520004, name: 'Igaraçu do Tietê', microregionId: 35021 },
    { id: 3520103, name: 'Igarapava', microregionId: 35011 },
    { id: 3520202, name: 'Igaratá', microregionId: 35050 },
    { id: 3520301, name: 'Iguape', microregionId: 35055 },
    { id: 3520426, name: 'Ilha Comprida', microregionId: 35055 },
    { id: 3520442, name: 'Ilha Solteira', microregionId: 35016 },
    { id: 3520400, name: 'Ilhabela', microregionId: 35054 },
    { id: 3520509, name: 'Indaiatuba', microregionId: 35032 },
    { id: 3520608, name: 'Indiana', microregionId: 35036 },
    { id: 3520707, name: 'Indiaporã', microregionId: 35002 },
    { id: 3520806, name: 'Inúbia Paulista', microregionId: 35035 },
    { id: 3520905, name: 'Ipaussu', microregionId: 35040 },
    { id: 3521002, name: 'Iperó', microregionId: 35046 },
    { id: 3521101, name: 'Ipeúna', microregionId: 35026 },
    { id: 3521150, name: 'Ipiguá', microregionId: 35004 },
    { id: 3521200, name: 'Iporanga', microregionId: 35044 },
    { id: 3521309, name: 'Ipuã', microregionId: 35010 },
    { id: 3521408, name: 'Iracemápolis', microregionId: 35027 },
    { id: 3521507, name: 'Irapuã', microregionId: 35008 },
    { id: 3521606, name: 'Irapuru', microregionId: 35035 },
    { id: 3521705, name: 'Itaberá', microregionId: 35041 },
    { id: 3521804, name: 'Itaí', microregionId: 35022 },
    { id: 3521903, name: 'Itajobi', microregionId: 35008 },
    { id: 3522000, name: 'Itaju', microregionId: 35021 },
    { id: 3522109, name: 'Itanhaém', microregionId: 35056 },
    { id: 3522158, name: 'Itaoca', microregionId: 35044 },
    { id: 3522208, name: 'Itapecerica da Serra', microregionId: 35060 },
    { id: 3522307, name: 'Itapetininga', microregionId: 35042 },
    { id: 3522406, name: 'Itapeva', microregionId: 35041 },
    { id: 3522505, name: 'Itapevi', microregionId: 35057 },
    { id: 3522604, name: 'Itapira', microregionId: 35031 },
    { id: 3522653, name: 'Itapirapuã Paulista', microregionId: 35044 },
    { id: 3522703, name: 'Itápolis', microregionId: 35024 },
    { id: 3522802, name: 'Itaporanga', microregionId: 35041 },
    { id: 3522901, name: 'Itapuí', microregionId: 35021 },
    { id: 3523008, name: 'Itapura', microregionId: 35016 },
    { id: 3523107, name: 'Itaquaquecetuba', microregionId: 35062 },
    { id: 3523206, name: 'Itararé', microregionId: 35041 },
    { id: 3523305, name: 'Itariri', microregionId: 35056 },
    { id: 3523404, name: 'Itatiba', microregionId: 35048 },
    { id: 3523503, name: 'Itatinga', microregionId: 35022 },
    { id: 3523602, name: 'Itirapina', microregionId: 35026 },
    { id: 3523701, name: 'Itirapuã', microregionId: 35012 },
    { id: 3523800, name: 'Itobi', microregionId: 35030 },
    { id: 3523909, name: 'Itu', microregionId: 35046 },
    { id: 3524006, name: 'Itupeva', microregionId: 35047 },
    { id: 3524105, name: 'Ituverava', microregionId: 35011 },
    { id: 3524204, name: 'Jaborandi', microregionId: 35010 },
    { id: 3524303, name: 'Jaboticabal', microregionId: 35013 },
    { id: 3524402, name: 'Jacareí', microregionId: 35050 },
    { id: 3524501, name: 'Jaci', microregionId: 35004 },
    { id: 3524600, name: 'Jacupiranga', microregionId: 35055 },
    { id: 3524709, name: 'Jaguariúna', microregionId: 35032 },
    { id: 3524808, name: 'Jales', microregionId: 35001 },
    { id: 3524907, name: 'Jambeiro', microregionId: 35053 },
    { id: 3525003, name: 'Jandira', microregionId: 35057 },
    { id: 3525102, name: 'Jardinópolis', microregionId: 35014 },
    { id: 3525201, name: 'Jarinu', microregionId: 35048 },
    { id: 3525300, name: 'Jaú', microregionId: 35021 },
    { id: 3525409, name: 'Jeriquara', microregionId: 35012 },
    { id: 3525508, name: 'Joanópolis', microregionId: 35048 },
    { id: 3525607, name: 'João Ramalho', microregionId: 35036 },
    { id: 3525706, name: 'José Bonifácio', microregionId: 35004 },
    { id: 3525805, name: 'Júlio Mesquita', microregionId: 35019 },
    { id: 3525854, name: 'Jumirim', microregionId: 35028 },
    { id: 3525904, name: 'Jundiaí', microregionId: 35047 },
    { id: 3526001, name: 'Junqueirópolis', microregionId: 35034 },
    { id: 3526100, name: 'Juquiá', microregionId: 35055 },
    { id: 3526209, name: 'Juquitiba', microregionId: 35060 },
    { id: 3526308, name: 'Lagoinha', microregionId: 35053 },
    { id: 3526407, name: 'Laranjal Paulista', microregionId: 35043 },
    { id: 3526506, name: 'Lavínia', microregionId: 35017 },
    { id: 3526605, name: 'Lavrinhas', microregionId: 35051 },
    { id: 3526704, name: 'Leme', microregionId: 35027 },
    { id: 3526803, name: 'Lençóis Paulista', microregionId: 35020 },
    { id: 3526902, name: 'Limeira', microregionId: 35027 },
    { id: 3527009, name: 'Lindóia', microregionId: 35033 },
    { id: 3527108, name: 'Lins', microregionId: 35019 },
    { id: 3527207, name: 'Lorena', microregionId: 35051 },
    { id: 3527256, name: 'Lourdes', microregionId: 35018 },
    { id: 3527306, name: 'Louveira', microregionId: 35047 },
    { id: 3527405, name: 'Lucélia', microregionId: 35035 },
    { id: 3527504, name: 'Lucianópolis', microregionId: 35020 },
    { id: 3527603, name: 'Luís Antônio', microregionId: 35014 },
    { id: 3527702, name: 'Luiziânia', microregionId: 35018 },
    { id: 3527801, name: 'Lupércio', microregionId: 35038 },
    { id: 3527900, name: 'Lutécia', microregionId: 35039 },
    { id: 3528007, name: 'Macatuba', microregionId: 35021 },
    { id: 3528106, name: 'Macaubal', microregionId: 35007 },
    { id: 3528205, name: 'Macedônia', microregionId: 35002 },
    { id: 3528304, name: 'Magda', microregionId: 35006 },
    { id: 3528403, name: 'Mairinque', microregionId: 35046 },
    { id: 3528502, name: 'Mairiporã', microregionId: 35058 },
    { id: 3528601, name: 'Manduri', microregionId: 35040 },
    { id: 3528700, name: 'Marabá Paulista', microregionId: 35036 },
    { id: 3528809, name: 'Maracaí', microregionId: 35039 },
    { id: 3528858, name: 'Marapoama', microregionId: 35008 },
    { id: 3528908, name: 'Mariápolis', microregionId: 35035 },
    { id: 3529005, name: 'Marília', microregionId: 35038 },
    { id: 3529104, name: 'Marinópolis', microregionId: 35001 },
    { id: 3529203, name: 'Martinópolis', microregionId: 35036 },
    { id: 3529302, name: 'Matão', microregionId: 35024 },
    { id: 3529401, name: 'Mauá', microregionId: 35061 },
    { id: 3529500, name: 'Mendonça', microregionId: 35004 },
    { id: 3529609, name: 'Meridiano', microregionId: 35002 },
    { id: 3529658, name: 'Mesópolis', microregionId: 35001 },
    { id: 3529708, name: 'Miguelópolis', microregionId: 35010 },
    { id: 3529807, name: 'Mineiros do Tietê', microregionId: 35021 },
    { id: 3530003, name: 'Mira Estrela', microregionId: 35002 },
    { id: 3529906, name: 'Miracatu', microregionId: 35055 },
    { id: 3530102, name: 'Mirandópolis', microregionId: 35016 },
    { id: 3530201, name: 'Mirante do Paranapanema', microregionId: 35036 },
    { id: 3530300, name: 'Mirassol', microregionId: 35004 },
    { id: 3530409, name: 'Mirassolândia', microregionId: 35004 },
    { id: 3530508, name: 'Mococa', microregionId: 35030 },
    { id: 3530607, name: 'Mogi das Cruzes', microregionId: 35062 },
    { id: 3530706, name: 'Mogi Guaçu', microregionId: 35031 },
    { id: 3530805, name: 'Mogi Mirim', microregionId: 35031 },
    { id: 3530904, name: 'Mombuca', microregionId: 35028 },
    { id: 3531001, name: 'Monções', microregionId: 35007 },
    { id: 3531100, name: 'Mongaguá', microregionId: 35056 },
    { id: 3531209, name: 'Monte Alegre do Sul', microregionId: 35033 },
    { id: 3531308, name: 'Monte Alto', microregionId: 35013 },
    { id: 3531407, name: 'Monte Aprazível', microregionId: 35007 },
    { id: 3531506, name: 'Monte Azul Paulista', microregionId: 35013 },
    { id: 3531605, name: 'Monte Castelo', microregionId: 35034 },
    { id: 3531803, name: 'Monte Mor', microregionId: 35032 },
    { id: 3531704, name: 'Monteiro Lobato', microregionId: 35049 },
    { id: 3531902, name: 'Morro Agudo', microregionId: 35010 },
    { id: 3532009, name: 'Morungaba', microregionId: 35048 },
    { id: 3532058, name: 'Motuca', microregionId: 35024 },
    { id: 3532108, name: 'Murutinga do Sul', microregionId: 35016 },
    { id: 3532157, name: 'Nantes', microregionId: 35039 },
    { id: 3532207, name: 'Narandiba', microregionId: 35036 },
    { id: 3532306, name: 'Natividade da Serra', microregionId: 35053 },
    { id: 3532405, name: 'Nazaré Paulista', microregionId: 35048 },
    { id: 3532504, name: 'Neves Paulista', microregionId: 35007 },
    { id: 3532603, name: 'Nhandeara', microregionId: 35007 },
    { id: 3532702, name: 'Nipoã', microregionId: 35007 },
    { id: 3532801, name: 'Nova Aliança', microregionId: 35004 },
    { id: 3532827, name: 'Nova Campina', microregionId: 35041 },
    { id: 3532843, name: 'Nova Canaã Paulista', microregionId: 35001 },
    { id: 3532868, name: 'Nova Castilho', microregionId: 35006 },
    { id: 3532900, name: 'Nova Europa', microregionId: 35024 },
    { id: 3533007, name: 'Nova Granada', microregionId: 35004 },
    { id: 3533106, name: 'Nova Guataporanga', microregionId: 35034 },
    { id: 3533205, name: 'Nova Independência', microregionId: 35016 },
    { id: 3533304, name: 'Nova Luzitânia', microregionId: 35006 },
    { id: 3533403, name: 'Nova Odessa', microregionId: 35032 },
    { id: 3533254, name: 'Novais', microregionId: 35005 },
    { id: 3533502, name: 'Novo Horizonte', microregionId: 35008 },
    { id: 3533601, name: 'Nuporanga', microregionId: 35010 },
    { id: 3533700, name: 'Ocauçu', microregionId: 35038 },
    { id: 3533809, name: 'Óleo', microregionId: 35040 },
    { id: 3533908, name: 'Olímpia', microregionId: 35004 },
    { id: 3534005, name: 'Onda Verde', microregionId: 35004 },
    { id: 3534104, name: 'Oriente', microregionId: 35038 },
    { id: 3534203, name: 'Orindiúva', microregionId: 35004 },
    { id: 3534302, name: 'Orlândia', microregionId: 35010 },
    { id: 3534401, name: 'Osasco', microregionId: 35057 },
    { id: 3534500, name: 'Oscar Bressane', microregionId: 35038 },
    { id: 3534609, name: 'Osvaldo Cruz', microregionId: 35035 },
    { id: 3534708, name: 'Ourinhos', microregionId: 35040 },
    { id: 3534807, name: 'Ouro Verde', microregionId: 35034 },
    { id: 3534757, name: 'Ouroeste', microregionId: 35002 },
    { id: 3534906, name: 'Pacaembu', microregionId: 35035 },
    { id: 3535002, name: 'Palestina', microregionId: 35004 },
    { id: 3535101, name: 'Palmares Paulista', microregionId: 35005 },
    { id: 3535200, name: 'Palmeira d\'Oeste', microregionId: 35001 },
    { id: 3535309, name: 'Palmital', microregionId: 35039 },
    { id: 3535408, name: 'Panorama', microregionId: 35034 },
    { id: 3535507, name: 'Paraguaçu Paulista', microregionId: 35039 },
    { id: 3535606, name: 'Paraibuna', microregionId: 35053 },
    { id: 3535705, name: 'Paraíso', microregionId: 35005 },
    { id: 3535804, name: 'Paranapanema', microregionId: 35022 },
    { id: 3535903, name: 'Paranapuã', microregionId: 35001 },
    { id: 3536000, name: 'Parapuã', microregionId: 35035 },
    { id: 3536109, name: 'Pardinho', microregionId: 35023 },
    { id: 3536208, name: 'Pariquera-Açu', microregionId: 35055 },
    { id: 3536257, name: 'Parisi', microregionId: 35003 },
    { id: 3536307, name: 'Patrocínio Paulista', microregionId: 35012 },
    { id: 3536406, name: 'Paulicéia', microregionId: 35034 },
    { id: 3536505, name: 'Paulínia', microregionId: 35032 },
    { id: 3536570, name: 'Paulistânia', microregionId: 35020 },
    { id: 3536604, name: 'Paulo de Faria', microregionId: 35004 },
    { id: 3536703, name: 'Pederneiras', microregionId: 35021 },
    { id: 3536802, name: 'Pedra Bela', microregionId: 35033 },
    { id: 3536901, name: 'Pedranópolis', microregionId: 35002 },
    { id: 3537008, name: 'Pedregulho', microregionId: 35012 },
    { id: 3537107, name: 'Pedreira', microregionId: 35032 },
    { id: 3537156, name: 'Pedrinhas Paulista', microregionId: 35039 },
    { id: 3537206, name: 'Pedro de Toledo', microregionId: 35056 },
    { id: 3537305, name: 'Penápolis', microregionId: 35018 },
    { id: 3537404, name: 'Pereira Barreto', microregionId: 35016 },
    { id: 3537503, name: 'Pereiras', microregionId: 35043 },
    { id: 3537602, name: 'Peruíbe', microregionId: 35056 },
    { id: 3537701, name: 'Piacatu', microregionId: 35018 },
    { id: 3537800, name: 'Piedade', microregionId: 35045 },
    { id: 3537909, name: 'Pilar do Sul', microregionId: 35045 },
    { id: 3538006, name: 'Pindamonhangaba', microregionId: 35050 },
    { id: 3538105, name: 'Pindorama', microregionId: 35005 },
    { id: 3538204, name: 'Pinhalzinho', microregionId: 35033 },
    { id: 3538303, name: 'Piquerobi', microregionId: 35036 },
    { id: 3538501, name: 'Piquete', microregionId: 35051 },
    { id: 3538600, name: 'Piracaia', microregionId: 35048 },
    { id: 3538709, name: 'Piracicaba', microregionId: 35028 },
    { id: 3538808, name: 'Piraju', microregionId: 35040 },
    { id: 3538907, name: 'Pirajuí', microregionId: 35020 },
    { id: 3539004, name: 'Pirangi', microregionId: 35013 },
    { id: 3539103, name: 'Pirapora do Bom Jesus', microregionId: 35057 },
    { id: 3539202, name: 'Pirapozinho', microregionId: 35036 },
    { id: 3539301, name: 'Pirassununga', microregionId: 35029 },
    { id: 3539400, name: 'Piratininga', microregionId: 35020 },
    { id: 3539509, name: 'Pitangueiras', microregionId: 35013 },
    { id: 3539608, name: 'Planalto', microregionId: 35004 },
    { id: 3539707, name: 'Platina', microregionId: 35039 },
    { id: 3539806, name: 'Poá', microregionId: 35062 },
    { id: 3539905, name: 'Poloni', microregionId: 35007 },
    { id: 3540002, name: 'Pompéia', microregionId: 35038 },
    { id: 3540101, name: 'Pongaí', microregionId: 35020 },
    { id: 3540200, name: 'Pontal', microregionId: 35014 },
    { id: 3540259, name: 'Pontalinda', microregionId: 35001 },
    { id: 3540309, name: 'Pontes Gestal', microregionId: 35003 },
    { id: 3540408, name: 'Populina', microregionId: 35001 },
    { id: 3540507, name: 'Porangaba', microregionId: 35043 },
    { id: 3540606, name: 'Porto Feliz', microregionId: 35046 },
    { id: 3540705, name: 'Porto Ferreira', microregionId: 35029 },
    { id: 3540754, name: 'Potim', microregionId: 35051 },
    { id: 3540804, name: 'Potirendaba', microregionId: 35004 },
    { id: 3540853, name: 'Pracinha', microregionId: 35035 },
    { id: 3540903, name: 'Pradópolis', microregionId: 35014 },
    { id: 3541000, name: 'Praia Grande', microregionId: 35063 },
    { id: 3541059, name: 'Pratânia', microregionId: 35023 },
    { id: 3541109, name: 'Presidente Alves', microregionId: 35020 },
    { id: 3541208, name: 'Presidente Bernardes', microregionId: 35036 },
    { id: 3541307, name: 'Presidente Epitácio', microregionId: 35036 },
    { id: 3541406, name: 'Presidente Prudente', microregionId: 35036 },
    { id: 3541505, name: 'Presidente Venceslau', microregionId: 35036 },
    { id: 3541604, name: 'Promissão', microregionId: 35019 },
    { id: 3541653, name: 'Quadra', microregionId: 35043 },
    { id: 3541703, name: 'Quatá', microregionId: 35039 },
    { id: 3541802, name: 'Queiroz', microregionId: 35037 },
    { id: 3541901, name: 'Queluz', microregionId: 35051 },
    { id: 3542008, name: 'Quintana', microregionId: 35037 },
    { id: 3542107, name: 'Rafard', microregionId: 35028 },
    { id: 3542206, name: 'Rancharia', microregionId: 35036 },
    { id: 3542305, name: 'Redenção da Serra', microregionId: 35053 },
    { id: 3542404, name: 'Regente Feijó', microregionId: 35036 },
    { id: 3542503, name: 'Reginópolis', microregionId: 35020 },
    { id: 3542602, name: 'Registro', microregionId: 35055 },
    { id: 3542701, name: 'Restinga', microregionId: 35012 },
    { id: 3542800, name: 'Ribeira', microregionId: 35044 },
    { id: 3542909, name: 'Ribeirão Bonito', microregionId: 35025 },
    { id: 3543006, name: 'Ribeirão Branco', microregionId: 35044 },
    { id: 3543105, name: 'Ribeirão Corrente', microregionId: 35012 },
    { id: 3543204, name: 'Ribeirão do Sul', microregionId: 35040 },
    { id: 3543238, name: 'Ribeirão dos Índios', microregionId: 35036 },
    { id: 3543253, name: 'Ribeirão Grande', microregionId: 35044 },
    { id: 3543303, name: 'Ribeirão Pires', microregionId: 35061 },
    { id: 3543402, name: 'Ribeirão Preto', microregionId: 35014 },
    { id: 3543600, name: 'Rifaina', microregionId: 35012 },
    { id: 3543709, name: 'Rincão', microregionId: 35024 },
    { id: 3543808, name: 'Rinópolis', microregionId: 35035 },
    { id: 3543907, name: 'Rio Claro', microregionId: 35026 },
    { id: 3544004, name: 'Rio das Pedras', microregionId: 35028 },
    { id: 3544103, name: 'Rio Grande da Serra', microregionId: 35061 },
    { id: 3544202, name: 'Riolândia', microregionId: 35003 },
    { id: 3543501, name: 'Riversul', microregionId: 35041 },
    { id: 3544251, name: 'Rosana', microregionId: 35036 },
    { id: 3544301, name: 'Roseira', microregionId: 35051 },
    { id: 3544400, name: 'Rubiácea', microregionId: 35017 },
    { id: 3544509, name: 'Rubinéia', microregionId: 35001 },
    { id: 3544608, name: 'Sabino', microregionId: 35019 },
    { id: 3544707, name: 'Sagres', microregionId: 35035 },
    { id: 3544806, name: 'Sales', microregionId: 35008 },
    { id: 3544905, name: 'Sales Oliveira', microregionId: 35010 },
    { id: 3545001, name: 'Salesópolis', microregionId: 35062 },
    { id: 3545100, name: 'Salmourão', microregionId: 35035 },
    { id: 3545159, name: 'Saltinho', microregionId: 35028 },
    { id: 3545209, name: 'Salto', microregionId: 35046 },
    { id: 3545308, name: 'Salto de Pirapora', microregionId: 35046 },
    { id: 3545407, name: 'Salto Grande', microregionId: 35040 },
    { id: 3545506, name: 'Sandovalina', microregionId: 35036 },
    { id: 3545605, name: 'Santa Adélia', microregionId: 35005 },
    { id: 3545704, name: 'Santa Albertina', microregionId: 35001 },
    { id: 3545803, name: 'Santa Bárbara d\'Oeste', microregionId: 35032 },
    { id: 3546009, name: 'Santa Branca', microregionId: 35050 },
    { id: 3546108, name: 'Santa Clara d\'Oeste', microregionId: 35001 },
    { id: 3546207, name: 'Santa Cruz da Conceição', microregionId: 35027 },
    { id: 3546256, name: 'Santa Cruz da Esperança', microregionId: 35015 },
    { id: 3546306, name: 'Santa Cruz das Palmeiras', microregionId: 35029 },
    { id: 3546405, name: 'Santa Cruz do Rio Pardo', microregionId: 35040 },
    { id: 3546504, name: 'Santa Ernestina', microregionId: 35013 },
    { id: 3546603, name: 'Santa Fé do Sul', microregionId: 35001 },
    { id: 3546702, name: 'Santa Gertrudes', microregionId: 35027 },
    { id: 3546801, name: 'Santa Isabel', microregionId: 35059 },
    { id: 3546900, name: 'Santa Lúcia', microregionId: 35024 },
    { id: 3547007, name: 'Santa Maria da Serra', microregionId: 35028 },
    { id: 3547106, name: 'Santa Mercedes', microregionId: 35034 },
    { id: 3547403, name: 'Santa Rita d\'Oeste', microregionId: 35001 },
    { id: 3547502, name: 'Santa Rita do Passa Quatro', microregionId: 35014 },
    { id: 3547601, name: 'Santa Rosa de Viterbo', microregionId: 35014 },
    { id: 3547650, name: 'Santa Salete', microregionId: 35001 },
    { id: 3547205, name: 'Santana da Ponte Pensa', microregionId: 35001 },
    { id: 3547304, name: 'Santana de Parnaíba', microregionId: 35057 },
    { id: 3547700, name: 'Santo Anastácio', microregionId: 35036 },
    { id: 3547809, name: 'Santo André', microregionId: 35061 },
    { id: 3547908, name: 'Santo Antônio da Alegria', microregionId: 35015 },
    { id: 3548005, name: 'Santo Antônio de Posse', microregionId: 35031 },
    { id: 3548054, name: 'Santo Antônio do Aracanguá', microregionId: 35017 },
    { id: 3548104, name: 'Santo Antônio do Jardim', microregionId: 35030 },
    { id: 3548203, name: 'Santo Antônio do Pinhal', microregionId: 35049 },
    { id: 3548302, name: 'Santo Expedito', microregionId: 35036 },
    { id: 3548401, name: 'Santópolis do Aguapeí', microregionId: 35018 },
    { id: 3548500, name: 'Santos', microregionId: 35063 },
    { id: 3548609, name: 'São Bento do Sapucaí', microregionId: 35049 },
    { id: 3548708, name: 'São Bernardo do Campo', microregionId: 35061 },
    { id: 3548807, name: 'São Caetano do Sul', microregionId: 35061 },
    { id: 3548906, name: 'São Carlos', microregionId: 35025 },
    { id: 3549003, name: 'São Francisco', microregionId: 35001 },
    { id: 3549102, name: 'São João da Boa Vista', microregionId: 35030 },
    { id: 3549201, name: 'São João das Duas Pontes', microregionId: 35002 },
    { id: 3549250, name: 'São João de Iracema', microregionId: 35006 },
    { id: 3549300, name: 'São João do Pau d\'Alho', microregionId: 35034 },
    { id: 3549409, name: 'São Joaquim da Barra', microregionId: 35010 },
    { id: 3549508, name: 'São José da Bela Vista', microregionId: 35012 },
    { id: 3549607, name: 'São José do Barreiro', microregionId: 35052 },
    { id: 3549706, name: 'São José do Rio Pardo', microregionId: 35030 },
    { id: 3549805, name: 'São José do Rio Preto', microregionId: 35004 },
    { id: 3549904, name: 'São José dos Campos', microregionId: 35050 },
    { id: 3549953, name: 'São Lourenço da Serra', microregionId: 35060 },
    { id: 3550001, name: 'São Luiz do Paraitinga', microregionId: 35053 },
    { id: 3550100, name: 'São Manuel', microregionId: 35023 },
    { id: 3550209, name: 'São Miguel Arcanjo', microregionId: 35045 },
    { id: 3550308, name: 'São Paulo', microregionId: 35061 },
    { id: 3550407, name: 'São Pedro', microregionId: 35028 },
    { id: 3550506, name: 'São Pedro do Turvo', microregionId: 35040 },
    { id: 3550605, name: 'São Roque', microregionId: 35046 },
    { id: 3550704, name: 'São Sebastião', microregionId: 35054 },
    { id: 3550803, name: 'São Sebastião da Grama', microregionId: 35030 },
    { id: 3550902, name: 'São Simão', microregionId: 35014 },
    { id: 3551009, name: 'São Vicente', microregionId: 35063 },
    { id: 3551108, name: 'Sarapuí', microregionId: 35046 },
    { id: 3551207, name: 'Sarutaiá', microregionId: 35040 },
    { id: 3551306, name: 'Sebastianópolis do Sul', microregionId: 35007 },
    { id: 3551405, name: 'Serra Azul', microregionId: 35014 },
    { id: 3551603, name: 'Serra Negra', microregionId: 35033 },
    { id: 3551504, name: 'Serrana', microregionId: 35014 },
    { id: 3551702, name: 'Sertãozinho', microregionId: 35014 },
    { id: 3551801, name: 'Sete Barras', microregionId: 35055 },
    { id: 3551900, name: 'Severínia', microregionId: 35005 },
    { id: 3552007, name: 'Silveiras', microregionId: 35052 },
    { id: 3552106, name: 'Socorro', microregionId: 35033 },
    { id: 3552205, name: 'Sorocaba', microregionId: 35046 },
    { id: 3552304, name: 'Sud Mennucci', microregionId: 35016 },
    { id: 3552403, name: 'Sumaré', microregionId: 35032 },
    { id: 3552551, name: 'Suzanápolis', microregionId: 35016 },
    { id: 3552502, name: 'Suzano', microregionId: 35062 },
    { id: 3552601, name: 'Tabapuã', microregionId: 35005 },
    { id: 3552700, name: 'Tabatinga', microregionId: 35024 },
    { id: 3552809, name: 'Taboão da Serra', microregionId: 35060 },
    { id: 3552908, name: 'Taciba', microregionId: 35036 },
    { id: 3553005, name: 'Taguaí', microregionId: 35040 },
    { id: 3553104, name: 'Taiaçu', microregionId: 35013 },
    { id: 3553203, name: 'Taiúva', microregionId: 35013 },
    { id: 3553302, name: 'Tambaú', microregionId: 35030 },
    { id: 3553401, name: 'Tanabi', microregionId: 35004 },
    { id: 3553500, name: 'Tapiraí', microregionId: 35045 },
    { id: 3553609, name: 'Tapiratiba', microregionId: 35030 },
    { id: 3553658, name: 'Taquaral', microregionId: 35013 },
    { id: 3553708, name: 'Taquaritinga', microregionId: 35013 },
    { id: 3553807, name: 'Taquarituba', microregionId: 35041 },
    { id: 3553856, name: 'Taquarivaí', microregionId: 35041 },
    { id: 3553906, name: 'Tarabai', microregionId: 35036 },
    { id: 3553955, name: 'Tarumã', microregionId: 35039 },
    { id: 3554003, name: 'Tatuí', microregionId: 35043 },
    { id: 3554102, name: 'Taubaté', microregionId: 35050 },
    { id: 3554201, name: 'Tejupá', microregionId: 35040 },
    { id: 3554300, name: 'Teodoro Sampaio', microregionId: 35036 },
    { id: 3554409, name: 'Terra Roxa', microregionId: 35013 },
    { id: 3554508, name: 'Tietê', microregionId: 35028 },
    { id: 3554607, name: 'Timburi', microregionId: 35040 },
    { id: 3554656, name: 'Torre de Pedra', microregionId: 35043 },
    { id: 3554706, name: 'Torrinha', microregionId: 35026 },
    { id: 3554755, name: 'Trabiju', microregionId: 35024 },
    { id: 3554805, name: 'Tremembé', microregionId: 35050 },
    { id: 3554904, name: 'Três Fronteiras', microregionId: 35001 },
    { id: 3554953, name: 'Tuiuti', microregionId: 35048 },
    { id: 3555000, name: 'Tupã', microregionId: 35037 },
    { id: 3555109, name: 'Tupi Paulista', microregionId: 35034 },
    { id: 3555208, name: 'Turiúba', microregionId: 35018 },
    { id: 3555307, name: 'Turmalina', microregionId: 35002 },
    { id: 3555356, name: 'Ubarana', microregionId: 35004 },
    { id: 3555406, name: 'Ubatuba', microregionId: 35054 },
    { id: 3555505, name: 'Ubirajara', microregionId: 35020 },
    { id: 3555604, name: 'Uchoa', microregionId: 35004 },
    { id: 3555703, name: 'União Paulista', microregionId: 35007 },
    { id: 3555802, name: 'Urânia', microregionId: 35001 },
    { id: 3555901, name: 'Uru', microregionId: 35020 },
    { id: 3556008, name: 'Urupês', microregionId: 35008 },
    { id: 3556107, name: 'Valentim Gentil', microregionId: 35003 },
    { id: 3556206, name: 'Valinhos', microregionId: 35032 },
    { id: 3556305, name: 'Valparaíso', microregionId: 35017 },
    { id: 3556354, name: 'Vargem', microregionId: 35048 },
    { id: 3556404, name: 'Vargem Grande do Sul', microregionId: 35030 },
    { id: 3556453, name: 'Vargem Grande Paulista', microregionId: 35060 },
    { id: 3556503, name: 'Várzea Paulista', microregionId: 35047 },
    { id: 3556602, name: 'Vera Cruz', microregionId: 35038 },
    { id: 3556701, name: 'Vinhedo', microregionId: 35032 },
    { id: 3556800, name: 'Viradouro', microregionId: 35013 },
    { id: 3556909, name: 'Vista Alegre do Alto', microregionId: 35013 },
    { id: 3556958, name: 'Vitória Brasil', microregionId: 35001 },
    { id: 3557006, name: 'Votorantim', microregionId: 35046 },
    { id: 3557105, name: 'Votuporanga', microregionId: 35003 },
    { id: 3557154, name: 'Zacarias', microregionId: 35004 },
  ],
  41: [
    { id: 4100103, name: 'Abatiá', microregionId: 41015 },
    { id: 4100202, name: 'Adrianópolis', microregionId: 41035 },
    { id: 4100301, name: 'Agudos do Sul', microregionId: 41039 },
    { id: 4100400, name: 'Almirante Tamandaré', microregionId: 41037 },
    { id: 4100459, name: 'Altamira do Paraná', microregionId: 41004 },
    { id: 4128625, name: 'Alto Paraíso', microregionId: 41002 },
    { id: 4100608, name: 'Alto Paraná', microregionId: 41001 },
    { id: 4100707, name: 'Alto Piquiri', microregionId: 41002 },
    { id: 4100509, name: 'Altônia', microregionId: 41002 },
    { id: 4100806, name: 'Alvorada do Sul', microregionId: 41007 },
    { id: 4100905, name: 'Amaporã', microregionId: 41001 },
    { id: 4101002, name: 'Ampére', microregionId: 41025 },
    { id: 4101051, name: 'Anahy', microregionId: 41023 },
    { id: 4101101, name: 'Andirá', microregionId: 41015 },
    { id: 4101150, name: 'Ângulo', microregionId: 41006 },
    { id: 4101200, name: 'Antonina', microregionId: 41038 },
    { id: 4101309, name: 'Antônio Olinto', microregionId: 41034 },
    { id: 4101408, name: 'Apucarana', microregionId: 41010 },
    { id: 4101507, name: 'Arapongas', microregionId: 41010 },
    { id: 4101606, name: 'Arapoti', microregionId: 41020 },
    { id: 4101655, name: 'Arapuã', microregionId: 41013 },
    { id: 4101705, name: 'Araruna', microregionId: 41005 },
    { id: 4101804, name: 'Araucária', microregionId: 41037 },
    { id: 4101853, name: 'Ariranha do Ivaí', microregionId: 41013 },
    { id: 4101903, name: 'Assaí', microregionId: 41014 },
    { id: 4102000, name: 'Assis Chateaubriand', microregionId: 41022 },
    { id: 4102109, name: 'Astorga', microregionId: 41006 },
    { id: 4102208, name: 'Atalaia', microregionId: 41006 },
    { id: 4102307, name: 'Balsa Nova', microregionId: 41037 },
    { id: 4102406, name: 'Bandeirantes', microregionId: 41015 },
    { id: 4102505, name: 'Barbosa Ferraz', microregionId: 41005 },
    { id: 4102703, name: 'Barra do Jacaré', microregionId: 41016 },
    { id: 4102604, name: 'Barracão', microregionId: 41026 },
    { id: 4102752, name: 'Bela Vista da Caroba', microregionId: 41025 },
    { id: 4102802, name: 'Bela Vista do Paraíso', microregionId: 41007 },
    { id: 4102901, name: 'Bituruna', microregionId: 41033 },
    { id: 4103008, name: 'Boa Esperança', microregionId: 41004 },
    { id: 4103024, name: 'Boa Esperança do Iguaçu', microregionId: 41026 },
    { id: 4103040, name: 'Boa Ventura de São Roque', microregionId: 41028 },
    { id: 4103057, name: 'Boa Vista da Aparecida', microregionId: 41023 },
    { id: 4103107, name: 'Bocaiúva do Sul', microregionId: 41037 },
    { id: 4103156, name: 'Bom Jesus do Sul', microregionId: 41026 },
    { id: 4103206, name: 'Bom Sucesso', microregionId: 41012 },
    { id: 4103222, name: 'Bom Sucesso do Sul', microregionId: 41027 },
    { id: 4103305, name: 'Borrazópolis', microregionId: 41012 },
    { id: 4103354, name: 'Braganey', microregionId: 41023 },
    { id: 4103370, name: 'Brasilândia do Sul', microregionId: 41002 },
    { id: 4103404, name: 'Cafeara', microregionId: 41006 },
    { id: 4103453, name: 'Cafelândia', microregionId: 41023 },
    { id: 4103479, name: 'Cafezal do Sul', microregionId: 41002 },
    { id: 4103503, name: 'Califórnia', microregionId: 41010 },
    { id: 4103602, name: 'Cambará', microregionId: 41016 },
    { id: 4103701, name: 'Cambé', microregionId: 41011 },
    { id: 4103800, name: 'Cambira', microregionId: 41010 },
    { id: 4103909, name: 'Campina da Lagoa', microregionId: 41004 },
    { id: 4103958, name: 'Campina do Simão', microregionId: 41029 },
    { id: 4104006, name: 'Campina Grande do Sul', microregionId: 41037 },
    { id: 4104055, name: 'Campo Bonito', microregionId: 41023 },
    { id: 4104105, name: 'Campo do Tenente', microregionId: 41039 },
    { id: 4104204, name: 'Campo Largo', microregionId: 41037 },
    { id: 4104253, name: 'Campo Magro', microregionId: 41037 },
    { id: 4104303, name: 'Campo Mourão', microregionId: 41005 },
    { id: 4104402, name: 'Cândido de Abreu', microregionId: 41013 },
    { id: 4104428, name: 'Candói', microregionId: 41029 },
    { id: 4104451, name: 'Cantagalo', microregionId: 41029 },
    { id: 4104501, name: 'Capanema', microregionId: 41025 },
    { id: 4104600, name: 'Capitão Leônidas Marques', microregionId: 41023 },
    { id: 4104659, name: 'Carambeí', microregionId: 41021 },
    { id: 4104709, name: 'Carlópolis', microregionId: 41018 },
    { id: 4104808, name: 'Cascavel', microregionId: 41023 },
    { id: 4104907, name: 'Castro', microregionId: 41021 },
    { id: 4105003, name: 'Catanduvas', microregionId: 41023 },
    { id: 4105102, name: 'Centenário do Sul', microregionId: 41006 },
    { id: 4105201, name: 'Cerro Azul', microregionId: 41035 },
    { id: 4105300, name: 'Céu Azul', microregionId: 41024 },
    { id: 4105409, name: 'Chopinzinho', microregionId: 41027 },
    { id: 4105508, name: 'Cianorte', microregionId: 41003 },
    { id: 4105607, name: 'Cidade Gaúcha', microregionId: 41003 },
    { id: 4105706, name: 'Clevelândia', microregionId: 41030 },
    { id: 4105805, name: 'Colombo', microregionId: 41037 },
    { id: 4105904, name: 'Colorado', microregionId: 41006 },
    { id: 4106001, name: 'Congonhinhas', microregionId: 41015 },
    { id: 4106100, name: 'Conselheiro Mairinck', microregionId: 41017 },
    { id: 4106209, name: 'Contenda', microregionId: 41037 },
    { id: 4106308, name: 'Corbélia', microregionId: 41023 },
    { id: 4106407, name: 'Cornélio Procópio', microregionId: 41015 },
    { id: 4106456, name: 'Coronel Domingos Soares', microregionId: 41030 },
    { id: 4106506, name: 'Coronel Vivida', microregionId: 41027 },
    { id: 4106555, name: 'Corumbataí do Sul', microregionId: 41005 },
    { id: 4106803, name: 'Cruz Machado', microregionId: 41033 },
    { id: 4106571, name: 'Cruzeiro do Iguaçu', microregionId: 41026 },
    { id: 4106605, name: 'Cruzeiro do Oeste', microregionId: 41002 },
    { id: 4106704, name: 'Cruzeiro do Sul', microregionId: 41001 },
    { id: 4106852, name: 'Cruzmaltina', microregionId: 41012 },
    { id: 4106902, name: 'Curitiba', microregionId: 41037 },
    { id: 4107009, name: 'Curiúva', microregionId: 41017 },
    { id: 4107157, name: 'Diamante D\'Oeste', microregionId: 41022 },
    { id: 4107108, name: 'Diamante do Norte', microregionId: 41001 },
    { id: 4107124, name: 'Diamante do Sul', microregionId: 41023 },
    { id: 4107207, name: 'Dois Vizinhos', microregionId: 41026 },
    { id: 4107256, name: 'Douradina', microregionId: 41002 },
    { id: 4107306, name: 'Doutor Camargo', microregionId: 41008 },
    { id: 4128633, name: 'Doutor Ulysses', microregionId: 41035 },
    { id: 4107405, name: 'Enéas Marques', microregionId: 41026 },
    { id: 4107504, name: 'Engenheiro Beltrão', microregionId: 41005 },
    { id: 4107538, name: 'Entre Rios do Oeste', microregionId: 41022 },
    { id: 4107520, name: 'Esperança Nova', microregionId: 41002 },
    { id: 4107546, name: 'Espigão Alto do Iguaçu', microregionId: 41029 },
    { id: 4107553, name: 'Farol', microregionId: 41005 },
    { id: 4107603, name: 'Faxinal', microregionId: 41012 },
    { id: 4107652, name: 'Fazenda Rio Grande', microregionId: 41037 },
    { id: 4107702, name: 'Fênix', microregionId: 41005 },
    { id: 4107736, name: 'Fernandes Pinheiro', microregionId: 41031 },
    { id: 4107751, name: 'Figueira', microregionId: 41017 },
    { id: 4107850, name: 'Flor da Serra do Sul', microregionId: 41026 },
    { id: 4107801, name: 'Floraí', microregionId: 41008 },
    { id: 4107900, name: 'Floresta', microregionId: 41008 },
    { id: 4108007, name: 'Florestópolis', microregionId: 41007 },
    { id: 4108106, name: 'Flórida', microregionId: 41006 },
    { id: 4108205, name: 'Formosa do Oeste', microregionId: 41022 },
    { id: 4108304, name: 'Foz do Iguaçu', microregionId: 41024 },
    { id: 4108452, name: 'Foz do Jordão', microregionId: 41029 },
    { id: 4108320, name: 'Francisco Alves', microregionId: 41002 },
    { id: 4108403, name: 'Francisco Beltrão', microregionId: 41026 },
    { id: 4108502, name: 'General Carneiro', microregionId: 41033 },
    { id: 4108551, name: 'Godoy Moreira', microregionId: 41013 },
    { id: 4108601, name: 'Goioerê', microregionId: 41004 },
    { id: 4108650, name: 'Goioxim', microregionId: 41029 },
    { id: 4108700, name: 'Grandes Rios', microregionId: 41013 },
    { id: 4108809, name: 'Guaíra', microregionId: 41022 },
    { id: 4108908, name: 'Guairaçá', microregionId: 41001 },
    { id: 4108957, name: 'Guamiranga', microregionId: 41031 },
    { id: 4109005, name: 'Guapirama', microregionId: 41018 },
    { id: 4109104, name: 'Guaporema', microregionId: 41003 },
    { id: 4109203, name: 'Guaraci', microregionId: 41006 },
    { id: 4109302, name: 'Guaraniaçu', microregionId: 41023 },
    { id: 4109401, name: 'Guarapuava', microregionId: 41029 },
    { id: 4109500, name: 'Guaraqueçaba', microregionId: 41038 },
    { id: 4109609, name: 'Guaratuba', microregionId: 41038 },
    { id: 4109658, name: 'Honório Serpa', microregionId: 41030 },
    { id: 4109708, name: 'Ibaiti', microregionId: 41017 },
    { id: 4109757, name: 'Ibema', microregionId: 41023 },
    { id: 4109807, name: 'Ibiporã', microregionId: 41011 },
    { id: 4109906, name: 'Icaraíma', microregionId: 41002 },
    { id: 4110003, name: 'Iguaraçu', microregionId: 41006 },
    { id: 4110052, name: 'Iguatu', microregionId: 41023 },
    { id: 4110078, name: 'Imbaú', microregionId: 41019 },
    { id: 4110102, name: 'Imbituva', microregionId: 41031 },
    { id: 4110201, name: 'Inácio Martins', microregionId: 41029 },
    { id: 4110300, name: 'Inajá', microregionId: 41001 },
    { id: 4110409, name: 'Indianópolis', microregionId: 41003 },
    { id: 4110508, name: 'Ipiranga', microregionId: 41031 },
    { id: 4110607, name: 'Iporã', microregionId: 41002 },
    { id: 4110656, name: 'Iracema do Oeste', microregionId: 41022 },
    { id: 4110706, name: 'Irati', microregionId: 41032 },
    { id: 4110805, name: 'Iretama', microregionId: 41005 },
    { id: 4110904, name: 'Itaguajé', microregionId: 41006 },
    { id: 4110953, name: 'Itaipulândia', microregionId: 41024 },
    { id: 4111001, name: 'Itambaracá', microregionId: 41015 },
    { id: 4111100, name: 'Itambé', microregionId: 41008 },
    { id: 4111209, name: 'Itapejara d\'Oeste', microregionId: 41027 },
    { id: 4111258, name: 'Itaperuçu', microregionId: 41037 },
    { id: 4111308, name: 'Itaúna do Sul', microregionId: 41001 },
    { id: 4111407, name: 'Ivaí', microregionId: 41031 },
    { id: 4111506, name: 'Ivaiporã', microregionId: 41013 },
    { id: 4111555, name: 'Ivaté', microregionId: 41002 },
    { id: 4111605, name: 'Ivatuba', microregionId: 41008 },
    { id: 4111704, name: 'Jaboti', microregionId: 41017 },
    { id: 4111803, name: 'Jacarezinho', microregionId: 41016 },
    { id: 4111902, name: 'Jaguapitã', microregionId: 41006 },
    { id: 4112009, name: 'Jaguariaíva', microregionId: 41020 },
    { id: 4112108, name: 'Jandaia do Sul', microregionId: 41010 },
    { id: 4112207, name: 'Janiópolis', microregionId: 41004 },
    { id: 4112306, name: 'Japira', microregionId: 41017 },
    { id: 4112405, name: 'Japurá', microregionId: 41003 },
    { id: 4112504, name: 'Jardim Alegre', microregionId: 41013 },
    { id: 4112603, name: 'Jardim Olinda', microregionId: 41001 },
    { id: 4112702, name: 'Jataizinho', microregionId: 41014 },
    { id: 4112751, name: 'Jesuítas', microregionId: 41022 },
    { id: 4112801, name: 'Joaquim Távora', microregionId: 41018 },
    { id: 4112900, name: 'Jundiaí do Sul', microregionId: 41016 },
    { id: 4112959, name: 'Juranda', microregionId: 41004 },
    { id: 4113007, name: 'Jussara', microregionId: 41003 },
    { id: 4113106, name: 'Kaloré', microregionId: 41012 },
    { id: 4113205, name: 'Lapa', microregionId: 41036 },
    { id: 4113254, name: 'Laranjal', microregionId: 41028 },
    { id: 4113304, name: 'Laranjeiras do Sul', microregionId: 41029 },
    { id: 4113403, name: 'Leópolis', microregionId: 41015 },
    { id: 4113429, name: 'Lidianópolis', microregionId: 41013 },
    { id: 4113452, name: 'Lindoeste', microregionId: 41023 },
    { id: 4113502, name: 'Loanda', microregionId: 41001 },
    { id: 4113601, name: 'Lobato', microregionId: 41006 },
    { id: 4113700, name: 'Londrina', microregionId: 41011 },
    { id: 4113734, name: 'Luiziana', microregionId: 41005 },
    { id: 4113759, name: 'Lunardelli', microregionId: 41013 },
    { id: 4113809, name: 'Lupionópolis', microregionId: 41006 },
    { id: 4113908, name: 'Mallet', microregionId: 41032 },
    { id: 4114005, name: 'Mamborê', microregionId: 41005 },
    { id: 4114104, name: 'Mandaguaçu', microregionId: 41006 },
    { id: 4114203, name: 'Mandaguari', microregionId: 41009 },
    { id: 4114302, name: 'Mandirituba', microregionId: 41037 },
    { id: 4114351, name: 'Manfrinópolis', microregionId: 41026 },
    { id: 4114401, name: 'Mangueirinha', microregionId: 41030 },
    { id: 4114500, name: 'Manoel Ribas', microregionId: 41013 },
    { id: 4114609, name: 'Marechal Cândido Rondon', microregionId: 41022 },
    { id: 4114708, name: 'Maria Helena', microregionId: 41002 },
    { id: 4114807, name: 'Marialva', microregionId: 41009 },
    { id: 4114906, name: 'Marilândia do Sul', microregionId: 41010 },
    { id: 4115002, name: 'Marilena', microregionId: 41001 },
    { id: 4115101, name: 'Mariluz', microregionId: 41002 },
    { id: 4115200, name: 'Maringá', microregionId: 41009 },
    { id: 4115309, name: 'Mariópolis', microregionId: 41027 },
    { id: 4115358, name: 'Maripá', microregionId: 41022 },
    { id: 4115408, name: 'Marmeleiro', microregionId: 41026 },
    { id: 4115457, name: 'Marquinho', microregionId: 41029 },
    { id: 4115507, name: 'Marumbi', microregionId: 41012 },
    { id: 4115606, name: 'Matelândia', microregionId: 41024 },
    { id: 4115705, name: 'Matinhos', microregionId: 41038 },
    { id: 4115739, name: 'Mato Rico', microregionId: 41028 },
    { id: 4115754, name: 'Mauá da Serra', microregionId: 41010 },
    { id: 4115804, name: 'Medianeira', microregionId: 41024 },
    { id: 4115853, name: 'Mercedes', microregionId: 41022 },
    { id: 4115903, name: 'Mirador', microregionId: 41001 },
    { id: 4116000, name: 'Miraselva', microregionId: 41007 },
    { id: 4116059, name: 'Missal', microregionId: 41024 },
    { id: 4116109, name: 'Moreira Sales', microregionId: 41004 },
    { id: 4116208, name: 'Morretes', microregionId: 41038 },
    { id: 4116307, name: 'Munhoz de Melo', microregionId: 41006 },
    { id: 4116406, name: 'Nossa Senhora das Graças', microregionId: 41006 },
    { id: 4116505, name: 'Nova Aliança do Ivaí', microregionId: 41001 },
    { id: 4116604, name: 'Nova América da Colina', microregionId: 41015 },
    { id: 4116703, name: 'Nova Aurora', microregionId: 41023 },
    { id: 4116802, name: 'Nova Cantu', microregionId: 41004 },
    { id: 4116901, name: 'Nova Esperança', microregionId: 41006 },
    { id: 4116950, name: 'Nova Esperança do Sudoeste', microregionId: 41026 },
    { id: 4117008, name: 'Nova Fátima', microregionId: 41015 },
    { id: 4117057, name: 'Nova Laranjeiras', microregionId: 41029 },
    { id: 4117107, name: 'Nova Londrina', microregionId: 41001 },
    { id: 4117206, name: 'Nova Olímpia', microregionId: 41002 },
    { id: 4117255, name: 'Nova Prata do Iguaçu', microregionId: 41026 },
    { id: 4117214, name: 'Nova Santa Bárbara', microregionId: 41014 },
    { id: 4117222, name: 'Nova Santa Rosa', microregionId: 41022 },
    { id: 4117271, name: 'Nova Tebas', microregionId: 41013 },
    { id: 4117297, name: 'Novo Itacolomi', microregionId: 41010 },
    { id: 4117305, name: 'Ortigueira', microregionId: 41019 },
    { id: 4117404, name: 'Ourizona', microregionId: 41008 },
    { id: 4117453, name: 'Ouro Verde do Oeste', microregionId: 41022 },
    { id: 4117503, name: 'Paiçandu', microregionId: 41009 },
    { id: 4117602, name: 'Palmas', microregionId: 41030 },
    { id: 4117701, name: 'Palmeira', microregionId: 41021 },
    { id: 4117800, name: 'Palmital', microregionId: 41028 },
    { id: 4117909, name: 'Palotina', microregionId: 41022 },
    { id: 4118006, name: 'Paraíso do Norte', microregionId: 41001 },
    { id: 4118105, name: 'Paranacity', microregionId: 41001 },
    { id: 4118204, name: 'Paranaguá', microregionId: 41038 },
    { id: 4118303, name: 'Paranapoema', microregionId: 41001 },
    { id: 4118402, name: 'Paranavaí', microregionId: 41001 },
    { id: 4118451, name: 'Pato Bragado', microregionId: 41022 },
    { id: 4118501, name: 'Pato Branco', microregionId: 41027 },
    { id: 4118600, name: 'Paula Freitas', microregionId: 41033 },
    { id: 4118709, name: 'Paulo Frontin', microregionId: 41033 },
    { id: 4118808, name: 'Peabiru', microregionId: 41005 },
    { id: 4118857, name: 'Perobal', microregionId: 41002 },
    { id: 4118907, name: 'Pérola', microregionId: 41002 },
    { id: 4119004, name: 'Pérola d\'Oeste', microregionId: 41025 },
    { id: 4119103, name: 'Piên', microregionId: 41039 },
    { id: 4119152, name: 'Pinhais', microregionId: 41037 },
    { id: 4119251, name: 'Pinhal de São Bento', microregionId: 41026 },
    { id: 4119202, name: 'Pinhalão', microregionId: 41017 },
    { id: 4119301, name: 'Pinhão', microregionId: 41029 },
    { id: 4119400, name: 'Piraí do Sul', microregionId: 41020 },
    { id: 4119509, name: 'Piraquara', microregionId: 41037 },
    { id: 4119608, name: 'Pitanga', microregionId: 41028 },
    { id: 4119657, name: 'Pitangueiras', microregionId: 41011 },
    { id: 4119707, name: 'Planaltina do Paraná', microregionId: 41001 },
    { id: 4119806, name: 'Planalto', microregionId: 41025 },
    { id: 4119905, name: 'Ponta Grossa', microregionId: 41021 },
    { id: 4119954, name: 'Pontal do Paraná', microregionId: 41038 },
    { id: 4120002, name: 'Porecatu', microregionId: 41007 },
    { id: 4120101, name: 'Porto Amazonas', microregionId: 41036 },
    { id: 4120150, name: 'Porto Barreiro', microregionId: 41029 },
    { id: 4120200, name: 'Porto Rico', microregionId: 41001 },
    { id: 4120309, name: 'Porto Vitória', microregionId: 41033 },
    { id: 4120333, name: 'Prado Ferreira', microregionId: 41007 },
    { id: 4120358, name: 'Pranchita', microregionId: 41025 },
    { id: 4120408, name: 'Presidente Castelo Branco', microregionId: 41006 },
    { id: 4120507, name: 'Primeiro de Maio', microregionId: 41007 },
    { id: 4120606, name: 'Prudentópolis', microregionId: 41031 },
    { id: 4120655, name: 'Quarto Centenário', microregionId: 41004 },
    { id: 4120705, name: 'Quatiguá', microregionId: 41018 },
    { id: 4120804, name: 'Quatro Barras', microregionId: 41037 },
    { id: 4120853, name: 'Quatro Pontes', microregionId: 41022 },
    { id: 4120903, name: 'Quedas do Iguaçu', microregionId: 41029 },
    { id: 4121000, name: 'Querência do Norte', microregionId: 41001 },
    { id: 4121109, name: 'Quinta do Sol', microregionId: 41005 },
    { id: 4121208, name: 'Quitandinha', microregionId: 41039 },
    { id: 4121257, name: 'Ramilândia', microregionId: 41024 },
    { id: 4121307, name: 'Rancho Alegre', microregionId: 41014 },
    { id: 4121356, name: 'Rancho Alegre D\'Oeste', microregionId: 41004 },
    { id: 4121406, name: 'Realeza', microregionId: 41025 },
    { id: 4121505, name: 'Rebouças', microregionId: 41032 },
    { id: 4121604, name: 'Renascença', microregionId: 41026 },
    { id: 4121703, name: 'Reserva', microregionId: 41019 },
    { id: 4121752, name: 'Reserva do Iguaçu', microregionId: 41029 },
    { id: 4121802, name: 'Ribeirão Claro', microregionId: 41016 },
    { id: 4121901, name: 'Ribeirão do Pinhal', microregionId: 41015 },
    { id: 4122008, name: 'Rio Azul', microregionId: 41032 },
    { id: 4122107, name: 'Rio Bom', microregionId: 41012 },
    { id: 4122156, name: 'Rio Bonito do Iguaçu', microregionId: 41029 },
    { id: 4122172, name: 'Rio Branco do Ivaí', microregionId: 41013 },
    { id: 4122206, name: 'Rio Branco do Sul', microregionId: 41037 },
    { id: 4122305, name: 'Rio Negro', microregionId: 41039 },
    { id: 4122404, name: 'Rolândia', microregionId: 41011 },
    { id: 4122503, name: 'Roncador', microregionId: 41005 },
    { id: 4122602, name: 'Rondon', microregionId: 41003 },
    { id: 4122651, name: 'Rosário do Ivaí', microregionId: 41013 },
    { id: 4122701, name: 'Sabáudia', microregionId: 41010 },
    { id: 4122800, name: 'Salgado Filho', microregionId: 41026 },
    { id: 4122909, name: 'Salto do Itararé', microregionId: 41018 },
    { id: 4123006, name: 'Salto do Lontra', microregionId: 41026 },
    { id: 4123105, name: 'Santa Amélia', microregionId: 41015 },
    { id: 4123204, name: 'Santa Cecília do Pavão', microregionId: 41014 },
    { id: 4123303, name: 'Santa Cruz de Monte Castelo', microregionId: 41001 },
    { id: 4123402, name: 'Santa Fé', microregionId: 41006 },
    { id: 4123501, name: 'Santa Helena', microregionId: 41022 },
    { id: 4123600, name: 'Santa Inês', microregionId: 41006 },
    { id: 4123709, name: 'Santa Isabel do Ivaí', microregionId: 41001 },
    { id: 4123808, name: 'Santa Izabel do Oeste', microregionId: 41025 },
    { id: 4123824, name: 'Santa Lúcia', microregionId: 41023 },
    { id: 4123857, name: 'Santa Maria do Oeste', microregionId: 41028 },
    { id: 4123907, name: 'Santa Mariana', microregionId: 41015 },
    { id: 4123956, name: 'Santa Mônica', microregionId: 41001 },
    { id: 4124020, name: 'Santa Tereza do Oeste', microregionId: 41023 },
    { id: 4124053, name: 'Santa Terezinha de Itaipu', microregionId: 41024 },
    { id: 4124004, name: 'Santana do Itararé', microregionId: 41018 },
    { id: 4124103, name: 'Santo Antônio da Platina', microregionId: 41016 },
    { id: 4124202, name: 'Santo Antônio do Caiuá', microregionId: 41001 },
    { id: 4124301, name: 'Santo Antônio do Paraíso', microregionId: 41015 },
    { id: 4124400, name: 'Santo Antônio do Sudoeste', microregionId: 41026 },
    { id: 4124509, name: 'Santo Inácio', microregionId: 41006 },
    { id: 4124608, name: 'São Carlos do Ivaí', microregionId: 41001 },
    { id: 4124707, name: 'São Jerônimo da Serra', microregionId: 41014 },
    { id: 4124806, name: 'São João', microregionId: 41027 },
    { id: 4124905, name: 'São João do Caiuá', microregionId: 41001 },
    { id: 4125001, name: 'São João do Ivaí', microregionId: 41013 },
    { id: 4125100, name: 'São João do Triunfo', microregionId: 41034 },
    { id: 4125209, name: 'São Jorge d\'Oeste', microregionId: 41026 },
    { id: 4125308, name: 'São Jorge do Ivaí', microregionId: 41008 },
    { id: 4125357, name: 'São Jorge do Patrocínio', microregionId: 41002 },
    { id: 4125407, name: 'São José da Boa Vista', microregionId: 41018 },
    { id: 4125456, name: 'São José das Palmeiras', microregionId: 41022 },
    { id: 4125506, name: 'São José dos Pinhais', microregionId: 41037 },
    { id: 4125555, name: 'São Manoel do Paraná', microregionId: 41003 },
    { id: 4125605, name: 'São Mateus do Sul', microregionId: 41034 },
    { id: 4125704, name: 'São Miguel do Iguaçu', microregionId: 41024 },
    { id: 4125753, name: 'São Pedro do Iguaçu', microregionId: 41022 },
    { id: 4125803, name: 'São Pedro do Ivaí', microregionId: 41013 },
    { id: 4125902, name: 'São Pedro do Paraná', microregionId: 41001 },
    { id: 4126009, name: 'São Sebastião da Amoreira', microregionId: 41014 },
    { id: 4126108, name: 'São Tomé', microregionId: 41003 },
    { id: 4126207, name: 'Sapopema', microregionId: 41017 },
    { id: 4126256, name: 'Sarandi', microregionId: 41009 },
    { id: 4126272, name: 'Saudade do Iguaçu', microregionId: 41027 },
    { id: 4126306, name: 'Sengés', microregionId: 41020 },
    { id: 4126355, name: 'Serranópolis do Iguaçu', microregionId: 41024 },
    { id: 4126405, name: 'Sertaneja', microregionId: 41015 },
    { id: 4126504, name: 'Sertanópolis', microregionId: 41007 },
    { id: 4126603, name: 'Siqueira Campos', microregionId: 41018 },
    { id: 4126652, name: 'Sulina', microregionId: 41027 },
    { id: 4126678, name: 'Tamarana', microregionId: 41011 },
    { id: 4126702, name: 'Tamboara', microregionId: 41001 },
    { id: 4126801, name: 'Tapejara', microregionId: 41003 },
    { id: 4126900, name: 'Tapira', microregionId: 41002 },
    { id: 4127007, name: 'Teixeira Soares', microregionId: 41031 },
    { id: 4127106, name: 'Telêmaco Borba', microregionId: 41019 },
    { id: 4127205, name: 'Terra Boa', microregionId: 41005 },
    { id: 4127304, name: 'Terra Rica', microregionId: 41001 },
    { id: 4127403, name: 'Terra Roxa', microregionId: 41022 },
    { id: 4127502, name: 'Tibagi', microregionId: 41019 },
    { id: 4127601, name: 'Tijucas do Sul', microregionId: 41039 },
    { id: 4127700, name: 'Toledo', microregionId: 41022 },
    { id: 4127809, name: 'Tomazina', microregionId: 41018 },
    { id: 4127858, name: 'Três Barras do Paraná', microregionId: 41023 },
    { id: 4127882, name: 'Tunas do Paraná', microregionId: 41037 },
    { id: 4127908, name: 'Tuneiras do Oeste', microregionId: 41003 },
    { id: 4127957, name: 'Tupãssi', microregionId: 41022 },
    { id: 4127965, name: 'Turvo', microregionId: 41029 },
    { id: 4128005, name: 'Ubiratã', microregionId: 41004 },
    { id: 4128104, name: 'Umuarama', microregionId: 41002 },
    { id: 4128203, name: 'União da Vitória', microregionId: 41033 },
    { id: 4128302, name: 'Uniflor', microregionId: 41006 },
    { id: 4128401, name: 'Uraí', microregionId: 41014 },
    { id: 4128534, name: 'Ventania', microregionId: 41019 },
    { id: 4128559, name: 'Vera Cruz do Oeste', microregionId: 41024 },
    { id: 4128609, name: 'Verê', microregionId: 41026 },
    { id: 4128658, name: 'Virmond', microregionId: 41029 },
    { id: 4128708, name: 'Vitorino', microregionId: 41027 },
    { id: 4128500, name: 'Wenceslau Braz', microregionId: 41018 },
    { id: 4128807, name: 'Xambrê', microregionId: 41002 },
  ],
  42: [
    { id: 4200051, name: 'Abdon Batista', microregionId: 42009 },
    { id: 4200101, name: 'Abelardo Luz', microregionId: 42003 },
    { id: 4200200, name: 'Agrolândia', microregionId: 42014 },
    { id: 4200309, name: 'Agronômica', microregionId: 42011 },
    { id: 4200408, name: 'Água Doce', microregionId: 42004 },
    { id: 4200507, name: 'Águas de Chapecó', microregionId: 42002 },
    { id: 4200556, name: 'Águas Frias', microregionId: 42002 },
    { id: 4200606, name: 'Águas Mornas', microregionId: 42017 },
    { id: 4200705, name: 'Alfredo Wagner', microregionId: 42017 },
    { id: 4200754, name: 'Alto Bela Vista', microregionId: 42005 },
    { id: 4200804, name: 'Anchieta', microregionId: 42001 },
    { id: 4200903, name: 'Angelina', microregionId: 42015 },
    { id: 4201000, name: 'Anita Garibaldi', microregionId: 42010 },
    { id: 4201109, name: 'Anitápolis', microregionId: 42017 },
    { id: 4201208, name: 'Antônio Carlos', microregionId: 42016 },
    { id: 4201257, name: 'Apiúna', microregionId: 42012 },
    { id: 4201273, name: 'Arabutã', microregionId: 42005 },
    { id: 4201307, name: 'Araquari', microregionId: 42008 },
    { id: 4201406, name: 'Araranguá', microregionId: 42020 },
    { id: 4201505, name: 'Armazém', microregionId: 42018 },
    { id: 4201604, name: 'Arroio Trinta', microregionId: 42004 },
    { id: 4201653, name: 'Arvoredo', microregionId: 42005 },
    { id: 4201703, name: 'Ascurra', microregionId: 42012 },
    { id: 4201802, name: 'Atalanta', microregionId: 42014 },
    { id: 4201901, name: 'Aurora', microregionId: 42011 },
    { id: 4201950, name: 'Balneário Arroio do Silva', microregionId: 42020 },
    { id: 4202057, name: 'Balneário Barra do Sul', microregionId: 42008 },
    { id: 4202008, name: 'Balneário Camboriú', microregionId: 42013 },
    { id: 4202073, name: 'Balneário Gaivota', microregionId: 42020 },
    { id: 4212809, name: 'Balneário Piçarras', microregionId: 42013 },
    { id: 4220000, name: 'Balneário Rincão', microregionId: 42019 },
    { id: 4202081, name: 'Bandeirante', microregionId: 42001 },
    { id: 4202099, name: 'Barra Bonita', microregionId: 42001 },
    { id: 4202107, name: 'Barra Velha', microregionId: 42013 },
    { id: 4202131, name: 'Bela Vista do Toldo', microregionId: 42006 },
    { id: 4202156, name: 'Belmonte', microregionId: 42001 },
    { id: 4202206, name: 'Benedito Novo', microregionId: 42012 },
    { id: 4202305, name: 'Biguaçu', microregionId: 42016 },
    { id: 4202404, name: 'Blumenau', microregionId: 42012 },
    { id: 4202438, name: 'Bocaina do Sul', microregionId: 42010 },
    { id: 4202503, name: 'Bom Jardim da Serra', microregionId: 42010 },
    { id: 4202537, name: 'Bom Jesus', microregionId: 42003 },
    { id: 4202578, name: 'Bom Jesus do Oeste', microregionId: 42002 },
    { id: 4202602, name: 'Bom Retiro', microregionId: 42010 },
    { id: 4202453, name: 'Bombinhas', microregionId: 42013 },
    { id: 4202701, name: 'Botuverá', microregionId: 42012 },
    { id: 4202800, name: 'Braço do Norte', microregionId: 42018 },
    { id: 4202859, name: 'Braço do Trombudo', microregionId: 42011 },
    { id: 4202875, name: 'Brunópolis', microregionId: 42009 },
    { id: 4202909, name: 'Brusque', microregionId: 42012 },
    { id: 4203006, name: 'Caçador', microregionId: 42004 },
    { id: 4203105, name: 'Caibi', microregionId: 42002 },
    { id: 4203154, name: 'Calmon', microregionId: 42004 },
    { id: 4203204, name: 'Camboriú', microregionId: 42013 },
    { id: 4203303, name: 'Campo Alegre', microregionId: 42007 },
    { id: 4203402, name: 'Campo Belo do Sul', microregionId: 42010 },
    { id: 4203501, name: 'Campo Erê', microregionId: 42002 },
    { id: 4203600, name: 'Campos Novos', microregionId: 42009 },
    { id: 4203709, name: 'Canelinha', microregionId: 42015 },
    { id: 4203808, name: 'Canoinhas', microregionId: 42006 },
    { id: 4203253, name: 'Capão Alto', microregionId: 42010 },
    { id: 4203907, name: 'Capinzal', microregionId: 42004 },
    { id: 4203956, name: 'Capivari de Baixo', microregionId: 42018 },
    { id: 4204004, name: 'Catanduvas', microregionId: 42004 },
    { id: 4204103, name: 'Caxambu do Sul', microregionId: 42002 },
    { id: 4204152, name: 'Celso Ramos', microregionId: 42010 },
    { id: 4204178, name: 'Cerro Negro', microregionId: 42010 },
    { id: 4204194, name: 'Chapadão do Lageado', microregionId: 42014 },
    { id: 4204202, name: 'Chapecó', microregionId: 42002 },
    { id: 4204251, name: 'Cocal do Sul', microregionId: 42019 },
    { id: 4204301, name: 'Concórdia', microregionId: 42005 },
    { id: 4204350, name: 'Cordilheira Alta', microregionId: 42002 },
    { id: 4204400, name: 'Coronel Freitas', microregionId: 42002 },
    { id: 4204459, name: 'Coronel Martins', microregionId: 42003 },
    { id: 4204558, name: 'Correia Pinto', microregionId: 42010 },
    { id: 4204509, name: 'Corupá', microregionId: 42008 },
    { id: 4204608, name: 'Criciúma', microregionId: 42019 },
    { id: 4204707, name: 'Cunha Porã', microregionId: 42002 },
    { id: 4204756, name: 'Cunhataí', microregionId: 42002 },
    { id: 4204806, name: 'Curitibanos', microregionId: 42009 },
    { id: 4204905, name: 'Descanso', microregionId: 42001 },
    { id: 4205001, name: 'Dionísio Cerqueira', microregionId: 42001 },
    { id: 4205100, name: 'Dona Emma', microregionId: 42011 },
    { id: 4205159, name: 'Doutor Pedrinho', microregionId: 42012 },
    { id: 4205175, name: 'Entre Rios', microregionId: 42003 },
    { id: 4205191, name: 'Ermo', microregionId: 42020 },
    { id: 4205209, name: 'Erval Velho', microregionId: 42004 },
    { id: 4205308, name: 'Faxinal dos Guedes', microregionId: 42003 },
    { id: 4205357, name: 'Flor do Sertão', microregionId: 42002 },
    { id: 4205407, name: 'Florianópolis', microregionId: 42016 },
    { id: 4205431, name: 'Formosa do Sul', microregionId: 42002 },
    { id: 4205456, name: 'Forquilhinha', microregionId: 42019 },
    { id: 4205506, name: 'Fraiburgo', microregionId: 42004 },
    { id: 4205555, name: 'Frei Rogério', microregionId: 42009 },
    { id: 4205605, name: 'Galvão', microregionId: 42003 },
    { id: 4205704, name: 'Garopaba', microregionId: 42018 },
    { id: 4205803, name: 'Garuva', microregionId: 42008 },
    { id: 4205902, name: 'Gaspar', microregionId: 42012 },
    { id: 4206009, name: 'Governador Celso Ramos', microregionId: 42016 },
    { id: 4206108, name: 'Grão-Pará', microregionId: 42018 },
    { id: 4206207, name: 'Gravatal', microregionId: 42018 },
    { id: 4206306, name: 'Guabiruba', microregionId: 42012 },
    { id: 4206405, name: 'Guaraciaba', microregionId: 42001 },
    { id: 4206504, name: 'Guaramirim', microregionId: 42008 },
    { id: 4206603, name: 'Guarujá do Sul', microregionId: 42001 },
    { id: 4206652, name: 'Guatambú', microregionId: 42002 },
    { id: 4206702, name: 'Herval d\'Oeste', microregionId: 42004 },
    { id: 4206751, name: 'Ibiam', microregionId: 42004 },
    { id: 4206801, name: 'Ibicaré', microregionId: 42004 },
    { id: 4206900, name: 'Ibirama', microregionId: 42011 },
    { id: 4207007, name: 'Içara', microregionId: 42019 },
    { id: 4207106, name: 'Ilhota', microregionId: 42013 },
    { id: 4207205, name: 'Imaruí', microregionId: 42018 },
    { id: 4207304, name: 'Imbituba', microregionId: 42018 },
    { id: 4207403, name: 'Imbuia', microregionId: 42014 },
    { id: 4207502, name: 'Indaial', microregionId: 42012 },
    { id: 4207577, name: 'Iomerê', microregionId: 42004 },
    { id: 4207601, name: 'Ipira', microregionId: 42005 },
    { id: 4207650, name: 'Iporã do Oeste', microregionId: 42001 },
    { id: 4207684, name: 'Ipuaçu', microregionId: 42003 },
    { id: 4207700, name: 'Ipumirim', microregionId: 42005 },
    { id: 4207759, name: 'Iraceminha', microregionId: 42002 },
    { id: 4207809, name: 'Irani', microregionId: 42005 },
    { id: 4207858, name: 'Irati', microregionId: 42002 },
    { id: 4207908, name: 'Irineópolis', microregionId: 42006 },
    { id: 4208005, name: 'Itá', microregionId: 42005 },
    { id: 4208104, name: 'Itaiópolis', microregionId: 42006 },
    { id: 4208203, name: 'Itajaí', microregionId: 42013 },
    { id: 4208302, name: 'Itapema', microregionId: 42013 },
    { id: 4208401, name: 'Itapiranga', microregionId: 42001 },
    { id: 4208450, name: 'Itapoá', microregionId: 42008 },
    { id: 4208500, name: 'Ituporanga', microregionId: 42014 },
    { id: 4208609, name: 'Jaborá', microregionId: 42004 },
    { id: 4208708, name: 'Jacinto Machado', microregionId: 42020 },
    { id: 4208807, name: 'Jaguaruna', microregionId: 42018 },
    { id: 4208906, name: 'Jaraguá do Sul', microregionId: 42008 },
    { id: 4208955, name: 'Jardinópolis', microregionId: 42002 },
    { id: 4209003, name: 'Joaçaba', microregionId: 42004 },
    { id: 4209102, name: 'Joinville', microregionId: 42008 },
    { id: 4209151, name: 'José Boiteux', microregionId: 42011 },
    { id: 4209177, name: 'Jupiá', microregionId: 42003 },
    { id: 4209201, name: 'Lacerdópolis', microregionId: 42004 },
    { id: 4209300, name: 'Lages', microregionId: 42010 },
    { id: 4209409, name: 'Laguna', microregionId: 42018 },
    { id: 4209458, name: 'Lajeado Grande', microregionId: 42003 },
    { id: 4209508, name: 'Laurentino', microregionId: 42011 },
    { id: 4209607, name: 'Lauro Müller', microregionId: 42019 },
    { id: 4209706, name: 'Lebon Régis', microregionId: 42004 },
    { id: 4209805, name: 'Leoberto Leal', microregionId: 42015 },
    { id: 4209854, name: 'Lindóia do Sul', microregionId: 42005 },
    { id: 4209904, name: 'Lontras', microregionId: 42011 },
    { id: 4210001, name: 'Luiz Alves', microregionId: 42012 },
    { id: 4210035, name: 'Luzerna', microregionId: 42004 },
    { id: 4210050, name: 'Macieira', microregionId: 42004 },
    { id: 4210100, name: 'Mafra', microregionId: 42006 },
    { id: 4210209, name: 'Major Gercino', microregionId: 42015 },
    { id: 4210308, name: 'Major Vieira', microregionId: 42006 },
    { id: 4210407, name: 'Maracajá', microregionId: 42020 },
    { id: 4210506, name: 'Maravilha', microregionId: 42002 },
    { id: 4210555, name: 'Marema', microregionId: 42003 },
    { id: 4210605, name: 'Massaranduba', microregionId: 42008 },
    { id: 4210704, name: 'Matos Costa', microregionId: 42004 },
    { id: 4210803, name: 'Meleiro', microregionId: 42020 },
    { id: 4210852, name: 'Mirim Doce', microregionId: 42011 },
    { id: 4210902, name: 'Modelo', microregionId: 42002 },
    { id: 4211009, name: 'Mondaí', microregionId: 42001 },
    { id: 4211058, name: 'Monte Carlo', microregionId: 42009 },
    { id: 4211108, name: 'Monte Castelo', microregionId: 42006 },
    { id: 4211207, name: 'Morro da Fumaça', microregionId: 42019 },
    { id: 4211256, name: 'Morro Grande', microregionId: 42020 },
    { id: 4211306, name: 'Navegantes', microregionId: 42013 },
    { id: 4211405, name: 'Nova Erechim', microregionId: 42002 },
    { id: 4211454, name: 'Nova Itaberaba', microregionId: 42002 },
    { id: 4211504, name: 'Nova Trento', microregionId: 42015 },
    { id: 4211603, name: 'Nova Veneza', microregionId: 42019 },
    { id: 4211652, name: 'Novo Horizonte', microregionId: 42002 },
    { id: 4211702, name: 'Orleans', microregionId: 42018 },
    { id: 4211751, name: 'Otacílio Costa', microregionId: 42010 },
    { id: 4211801, name: 'Ouro', microregionId: 42004 },
    { id: 4211850, name: 'Ouro Verde', microregionId: 42003 },
    { id: 4211876, name: 'Paial', microregionId: 42005 },
    { id: 4211892, name: 'Painel', microregionId: 42010 },
    { id: 4211900, name: 'Palhoça', microregionId: 42016 },
    { id: 4212007, name: 'Palma Sola', microregionId: 42001 },
    { id: 4212056, name: 'Palmeira', microregionId: 42010 },
    { id: 4212106, name: 'Palmitos', microregionId: 42002 },
    { id: 4212205, name: 'Papanduva', microregionId: 42006 },
    { id: 4212239, name: 'Paraíso', microregionId: 42001 },
    { id: 4212254, name: 'Passo de Torres', microregionId: 42020 },
    { id: 4212270, name: 'Passos Maia', microregionId: 42003 },
    { id: 4212304, name: 'Paulo Lopes', microregionId: 42016 },
    { id: 4212403, name: 'Pedras Grandes', microregionId: 42018 },
    { id: 4212502, name: 'Penha', microregionId: 42013 },
    { id: 4212601, name: 'Peritiba', microregionId: 42005 },
    { id: 4212650, name: 'Pescaria Brava', microregionId: 42018 },
    { id: 4212700, name: 'Petrolândia', microregionId: 42014 },
    { id: 4212908, name: 'Pinhalzinho', microregionId: 42002 },
    { id: 4213005, name: 'Pinheiro Preto', microregionId: 42004 },
    { id: 4213104, name: 'Piratuba', microregionId: 42005 },
    { id: 4213153, name: 'Planalto Alegre', microregionId: 42002 },
    { id: 4213203, name: 'Pomerode', microregionId: 42012 },
    { id: 4213302, name: 'Ponte Alta', microregionId: 42009 },
    { id: 4213351, name: 'Ponte Alta do Norte', microregionId: 42009 },
    { id: 4213401, name: 'Ponte Serrada', microregionId: 42003 },
    { id: 4213500, name: 'Porto Belo', microregionId: 42013 },
    { id: 4213609, name: 'Porto União', microregionId: 42006 },
    { id: 4213708, name: 'Pouso Redondo', microregionId: 42011 },
    { id: 4213807, name: 'Praia Grande', microregionId: 42020 },
    { id: 4213906, name: 'Presidente Castello Branco', microregionId: 42005 },
    { id: 4214003, name: 'Presidente Getúlio', microregionId: 42011 },
    { id: 4214102, name: 'Presidente Nereu', microregionId: 42011 },
    { id: 4214151, name: 'Princesa', microregionId: 42001 },
    { id: 4214201, name: 'Quilombo', microregionId: 42002 },
    { id: 4214300, name: 'Rancho Queimado', microregionId: 42017 },
    { id: 4214409, name: 'Rio das Antas', microregionId: 42004 },
    { id: 4214508, name: 'Rio do Campo', microregionId: 42011 },
    { id: 4214607, name: 'Rio do Oeste', microregionId: 42011 },
    { id: 4214805, name: 'Rio do Sul', microregionId: 42011 },
    { id: 4214706, name: 'Rio dos Cedros', microregionId: 42012 },
    { id: 4214904, name: 'Rio Fortuna', microregionId: 42018 },
    { id: 4215000, name: 'Rio Negrinho', microregionId: 42007 },
    { id: 4215059, name: 'Rio Rufino', microregionId: 42010 },
    { id: 4215075, name: 'Riqueza', microregionId: 42001 },
    { id: 4215109, name: 'Rodeio', microregionId: 42012 },
    { id: 4215208, name: 'Romelândia', microregionId: 42001 },
    { id: 4215307, name: 'Salete', microregionId: 42011 },
    { id: 4215356, name: 'Saltinho', microregionId: 42002 },
    { id: 4215406, name: 'Salto Veloso', microregionId: 42004 },
    { id: 4215455, name: 'Sangão', microregionId: 42018 },
    { id: 4215505, name: 'Santa Cecília', microregionId: 42009 },
    { id: 4215554, name: 'Santa Helena', microregionId: 42001 },
    { id: 4215604, name: 'Santa Rosa de Lima', microregionId: 42018 },
    { id: 4215653, name: 'Santa Rosa do Sul', microregionId: 42020 },
    { id: 4215679, name: 'Santa Terezinha', microregionId: 42006 },
    { id: 4215687, name: 'Santa Terezinha do Progresso', microregionId: 42002 },
    { id: 4215695, name: 'Santiago do Sul', microregionId: 42002 },
    { id: 4215703, name: 'Santo Amaro da Imperatriz', microregionId: 42016 },
    { id: 4215802, name: 'São Bento do Sul', microregionId: 42007 },
    { id: 4215752, name: 'São Bernardino', microregionId: 42002 },
    { id: 4215901, name: 'São Bonifácio', microregionId: 42017 },
    { id: 4216008, name: 'São Carlos', microregionId: 42002 },
    { id: 4216057, name: 'São Cristóvão do Sul', microregionId: 42009 },
    { id: 4216107, name: 'São Domingos', microregionId: 42003 },
    { id: 4216206, name: 'São Francisco do Sul', microregionId: 42008 },
    { id: 4216305, name: 'São João Batista', microregionId: 42015 },
    { id: 4216354, name: 'São João do Itaperiú', microregionId: 42013 },
    { id: 4216255, name: 'São João do Oeste', microregionId: 42001 },
    { id: 4216404, name: 'São João do Sul', microregionId: 42020 },
    { id: 4216503, name: 'São Joaquim', microregionId: 42010 },
    { id: 4216602, name: 'São José', microregionId: 42016 },
    { id: 4216701, name: 'São José do Cedro', microregionId: 42001 },
    { id: 4216800, name: 'São José do Cerrito', microregionId: 42010 },
    { id: 4216909, name: 'São Lourenço do Oeste', microregionId: 42002 },
    { id: 4217006, name: 'São Ludgero', microregionId: 42018 },
    { id: 4217105, name: 'São Martinho', microregionId: 42018 },
    { id: 4217154, name: 'São Miguel da Boa Vista', microregionId: 42002 },
    { id: 4217204, name: 'São Miguel do Oeste', microregionId: 42001 },
    { id: 4217253, name: 'São Pedro de Alcântara', microregionId: 42016 },
    { id: 4217303, name: 'Saudades', microregionId: 42002 },
    { id: 4217402, name: 'Schroeder', microregionId: 42008 },
    { id: 4217501, name: 'Seara', microregionId: 42005 },
    { id: 4217550, name: 'Serra Alta', microregionId: 42002 },
    { id: 4217600, name: 'Siderópolis', microregionId: 42019 },
    { id: 4217709, name: 'Sombrio', microregionId: 42020 },
    { id: 4217758, name: 'Sul Brasil', microregionId: 42002 },
    { id: 4217808, name: 'Taió', microregionId: 42011 },
    { id: 4217907, name: 'Tangará', microregionId: 42004 },
    { id: 4217956, name: 'Tigrinhos', microregionId: 42002 },
    { id: 4218004, name: 'Tijucas', microregionId: 42015 },
    { id: 4218103, name: 'Timbé do Sul', microregionId: 42020 },
    { id: 4218202, name: 'Timbó', microregionId: 42012 },
    { id: 4218251, name: 'Timbó Grande', microregionId: 42006 },
    { id: 4218301, name: 'Três Barras', microregionId: 42006 },
    { id: 4218350, name: 'Treviso', microregionId: 42019 },
    { id: 4218400, name: 'Treze de Maio', microregionId: 42018 },
    { id: 4218509, name: 'Treze Tílias', microregionId: 42004 },
    { id: 4218608, name: 'Trombudo Central', microregionId: 42011 },
    { id: 4218707, name: 'Tubarão', microregionId: 42018 },
    { id: 4218756, name: 'Tunápolis', microregionId: 42001 },
    { id: 4218806, name: 'Turvo', microregionId: 42020 },
    { id: 4218855, name: 'União do Oeste', microregionId: 42002 },
    { id: 4218905, name: 'Urubici', microregionId: 42010 },
    { id: 4218954, name: 'Urupema', microregionId: 42010 },
    { id: 4219002, name: 'Urussanga', microregionId: 42019 },
    { id: 4219101, name: 'Vargeão', microregionId: 42003 },
    { id: 4219150, name: 'Vargem', microregionId: 42009 },
    { id: 4219176, name: 'Vargem Bonita', microregionId: 42004 },
    { id: 4219200, name: 'Vidal Ramos', microregionId: 42014 },
    { id: 4219309, name: 'Videira', microregionId: 42004 },
    { id: 4219358, name: 'Vitor Meireles', microregionId: 42011 },
    { id: 4219408, name: 'Witmarsum', microregionId: 42011 },
    { id: 4219507, name: 'Xanxerê', microregionId: 42003 },
    { id: 4219606, name: 'Xavantina', microregionId: 42005 },
    { id: 4219705, name: 'Xaxim', microregionId: 42003 },
    { id: 4219853, name: 'Zortéa', microregionId: 42009 },
  ],
  43: [
    { id: 4300034, name: 'Aceguá', microregionId: 43031 },
    { id: 4300059, name: 'Água Santa', microregionId: 43010 },
    { id: 4300109, name: 'Agudo', microregionId: 43019 },
    { id: 4300208, name: 'Ajuricaba', microregionId: 43008 },
    { id: 4300307, name: 'Alecrim', microregionId: 43001 },
    { id: 4300406, name: 'Alegrete', microregionId: 43029 },
    { id: 4300455, name: 'Alegria', microregionId: 43008 },
    { id: 4300471, name: 'Almirante Tamandaré do Sul', microregionId: 43009 },
    { id: 4300505, name: 'Alpestre', microregionId: 43003 },
    { id: 4300554, name: 'Alto Alegre', microregionId: 43011 },
    { id: 4300570, name: 'Alto Feliz', microregionId: 43023 },
    { id: 4300604, name: 'Alvorada', microregionId: 43026 },
    { id: 4300638, name: 'Amaral Ferrador', microregionId: 43032 },
    { id: 4300646, name: 'Ametista do Sul', microregionId: 43003 },
    { id: 4300661, name: 'André da Rocha', microregionId: 43014 },
    { id: 4300703, name: 'Anta Gorda', microregionId: 43014 },
    { id: 4300802, name: 'Antônio Prado', microregionId: 43016 },
    { id: 4300851, name: 'Arambaré', microregionId: 43028 },
    { id: 4300877, name: 'Araricá', microregionId: 43026 },
    { id: 4300901, name: 'Aratiba', microregionId: 43004 },
    { id: 4301008, name: 'Arroio do Meio', microregionId: 43021 },
    { id: 4301073, name: 'Arroio do Padre', microregionId: 43033 },
    { id: 4301057, name: 'Arroio do Sal', microregionId: 43027 },
    { id: 4301206, name: 'Arroio do Tigre', microregionId: 43020 },
    { id: 4301107, name: 'Arroio dos Ratos', microregionId: 43025 },
    { id: 4301305, name: 'Arroio Grande', microregionId: 43034 },
    { id: 4301404, name: 'Arvorezinha', microregionId: 43014 },
    { id: 4301503, name: 'Augusto Pestana', microregionId: 43008 },
    { id: 4301552, name: 'Áurea', microregionId: 43004 },
    { id: 4301602, name: 'Bagé', microregionId: 43031 },
    { id: 4301636, name: 'Balneário Pinhal', microregionId: 43027 },
    { id: 4301651, name: 'Barão', microregionId: 43023 },
    { id: 4301701, name: 'Barão de Cotegipe', microregionId: 43004 },
    { id: 4301750, name: 'Barão do Triunfo', microregionId: 43025 },
    { id: 4301859, name: 'Barra do Guarita', microregionId: 43002 },
    { id: 4301875, name: 'Barra do Quaraí', microregionId: 43029 },
    { id: 4301909, name: 'Barra do Ribeiro', microregionId: 43028 },
    { id: 4301925, name: 'Barra do Rio Azul', microregionId: 43004 },
    { id: 4301958, name: 'Barra Funda', microregionId: 43009 },
    { id: 4301800, name: 'Barracão', microregionId: 43005 },
    { id: 4302006, name: 'Barros Cassal', microregionId: 43013 },
    { id: 4302055, name: 'Benjamin Constant do Sul', microregionId: 43004 },
    { id: 4302105, name: 'Bento Gonçalves', microregionId: 43016 },
    { id: 4302154, name: 'Boa Vista das Missões', microregionId: 43009 },
    { id: 4302204, name: 'Boa Vista do Buricá', microregionId: 43002 },
    { id: 4302220, name: 'Boa Vista do Cadeado', microregionId: 43011 },
    { id: 4302238, name: 'Boa Vista do Incra', microregionId: 43011 },
    { id: 4302253, name: 'Boa Vista do Sul', microregionId: 43016 },
    { id: 4302303, name: 'Bom Jesus', microregionId: 43015 },
    { id: 4302352, name: 'Bom Princípio', microregionId: 43023 },
    { id: 4302378, name: 'Bom Progresso', microregionId: 43002 },
    { id: 4302402, name: 'Bom Retiro do Sul', microregionId: 43021 },
    { id: 4302451, name: 'Boqueirão do Leão', microregionId: 43021 },
    { id: 4302501, name: 'Bossoroca', microregionId: 43007 },
    { id: 4302584, name: 'Bozano', microregionId: 43008 },
    { id: 4302600, name: 'Braga', microregionId: 43002 },
    { id: 4302659, name: 'Brochier', microregionId: 43023 },
    { id: 4302709, name: 'Butiá', microregionId: 43025 },
    { id: 4302808, name: 'Caçapava do Sul', microregionId: 43032 },
    { id: 4302907, name: 'Cacequi', microregionId: 43018 },
    { id: 4303004, name: 'Cachoeira do Sul', microregionId: 43022 },
    { id: 4303103, name: 'Cachoeirinha', microregionId: 43026 },
    { id: 4303202, name: 'Cacique Doble', microregionId: 43005 },
    { id: 4303301, name: 'Caibaté', microregionId: 43006 },
    { id: 4303400, name: 'Caiçara', microregionId: 43003 },
    { id: 4303509, name: 'Camaquã', microregionId: 43028 },
    { id: 4303558, name: 'Camargo', microregionId: 43010 },
    { id: 4303608, name: 'Cambará do Sul', microregionId: 43015 },
    { id: 4303673, name: 'Campestre da Serra', microregionId: 43015 },
    { id: 4303707, name: 'Campina das Missões', microregionId: 43006 },
    { id: 4303806, name: 'Campinas do Sul', microregionId: 43004 },
    { id: 4303905, name: 'Campo Bom', microregionId: 43026 },
    { id: 4304002, name: 'Campo Novo', microregionId: 43002 },
    { id: 4304101, name: 'Campos Borges', microregionId: 43011 },
    { id: 4304200, name: 'Candelária', microregionId: 43020 },
    { id: 4304309, name: 'Cândido Godói', microregionId: 43001 },
    { id: 4304358, name: 'Candiota', microregionId: 43032 },
    { id: 4304408, name: 'Canela', microregionId: 43024 },
    { id: 4304507, name: 'Canguçu', microregionId: 43033 },
    { id: 4304606, name: 'Canoas', microregionId: 43026 },
    { id: 4304614, name: 'Canudos do Vale', microregionId: 43021 },
    { id: 4304622, name: 'Capão Bonito do Sul', microregionId: 43015 },
    { id: 4304630, name: 'Capão da Canoa', microregionId: 43027 },
    { id: 4304655, name: 'Capão do Cipó', microregionId: 43017 },
    { id: 4304663, name: 'Capão do Leão', microregionId: 43033 },
    { id: 4304689, name: 'Capela de Santana', microregionId: 43023 },
    { id: 4304697, name: 'Capitão', microregionId: 43021 },
    { id: 4304671, name: 'Capivari do Sul', microregionId: 43027 },
    { id: 4304713, name: 'Caraá', microregionId: 43027 },
    { id: 4304705, name: 'Carazinho', microregionId: 43009 },
    { id: 4304804, name: 'Carlos Barbosa', microregionId: 43016 },
    { id: 4304853, name: 'Carlos Gomes', microregionId: 43004 },
    { id: 4304903, name: 'Casca', microregionId: 43010 },
    { id: 4304952, name: 'Caseiros', microregionId: 43010 },
    { id: 4305009, name: 'Catuípe', microregionId: 43007 },
    { id: 4305108, name: 'Caxias do Sul', microregionId: 43016 },
    { id: 4305116, name: 'Centenário', microregionId: 43004 },
    { id: 4305124, name: 'Cerrito', microregionId: 43033 },
    { id: 4305132, name: 'Cerro Branco', microregionId: 43022 },
    { id: 4305157, name: 'Cerro Grande', microregionId: 43009 },
    { id: 4305173, name: 'Cerro Grande do Sul', microregionId: 43028 },
    { id: 4305207, name: 'Cerro Largo', microregionId: 43006 },
    { id: 4305306, name: 'Chapada', microregionId: 43009 },
    { id: 4305355, name: 'Charqueadas', microregionId: 43025 },
    { id: 4305371, name: 'Charrua', microregionId: 43010 },
    { id: 4305405, name: 'Chiapetta', microregionId: 43008 },
    { id: 4305439, name: 'Chuí', microregionId: 43035 },
    { id: 4305447, name: 'Chuvisca', microregionId: 43028 },
    { id: 4305454, name: 'Cidreira', microregionId: 43027 },
    { id: 4305504, name: 'Ciríaco', microregionId: 43010 },
    { id: 4305587, name: 'Colinas', microregionId: 43021 },
    { id: 4305603, name: 'Colorado', microregionId: 43012 },
    { id: 4305702, name: 'Condor', microregionId: 43008 },
    { id: 4305801, name: 'Constantina', microregionId: 43003 },
    { id: 4305835, name: 'Coqueiro Baixo', microregionId: 43021 },
    { id: 4305850, name: 'Coqueiros do Sul', microregionId: 43009 },
    { id: 4305871, name: 'Coronel Barros', microregionId: 43008 },
    { id: 4305900, name: 'Coronel Bicaco', microregionId: 43008 },
    { id: 4305934, name: 'Coronel Pilar', microregionId: 43016 },
    { id: 4305959, name: 'Cotiporã', microregionId: 43016 },
    { id: 4305975, name: 'Coxilha', microregionId: 43010 },
    { id: 4306007, name: 'Crissiumal', microregionId: 43002 },
    { id: 4306056, name: 'Cristal', microregionId: 43033 },
    { id: 4306072, name: 'Cristal do Sul', microregionId: 43003 },
    { id: 4306106, name: 'Cruz Alta', microregionId: 43011 },
    { id: 4306130, name: 'Cruzaltense', microregionId: 43004 },
    { id: 4306205, name: 'Cruzeiro do Sul', microregionId: 43021 },
    { id: 4306304, name: 'David Canabarro', microregionId: 43010 },
    { id: 4306320, name: 'Derrubadas', microregionId: 43002 },
    { id: 4306353, name: 'Dezesseis de Novembro', microregionId: 43007 },
    { id: 4306379, name: 'Dilermando de Aguiar', microregionId: 43018 },
    { id: 4306403, name: 'Dois Irmãos', microregionId: 43024 },
    { id: 4306429, name: 'Dois Irmãos das Missões', microregionId: 43003 },
    { id: 4306452, name: 'Dois Lajeados', microregionId: 43014 },
    { id: 4306502, name: 'Dom Feliciano', microregionId: 43028 },
    { id: 4306601, name: 'Dom Pedrito', microregionId: 43031 },
    { id: 4306551, name: 'Dom Pedro de Alcântara', microregionId: 43027 },
    { id: 4306700, name: 'Dona Francisca', microregionId: 43019 },
    { id: 4306734, name: 'Doutor Maurício Cardoso', microregionId: 43002 },
    { id: 4306759, name: 'Doutor Ricardo', microregionId: 43021 },
    { id: 4306767, name: 'Eldorado do Sul', microregionId: 43026 },
    { id: 4306809, name: 'Encantado', microregionId: 43021 },
    { id: 4306908, name: 'Encruzilhada do Sul', microregionId: 43032 },
    { id: 4306924, name: 'Engenho Velho', microregionId: 43003 },
    { id: 4306957, name: 'Entre Rios do Sul', microregionId: 43004 },
    { id: 4306932, name: 'Entre-Ijuís', microregionId: 43007 },
    { id: 4306973, name: 'Erebango', microregionId: 43004 },
    { id: 4307005, name: 'Erechim', microregionId: 43004 },
    { id: 4307054, name: 'Ernestina', microregionId: 43010 },
    { id: 4307203, name: 'Erval Grande', microregionId: 43004 },
    { id: 4307302, name: 'Erval Seco', microregionId: 43003 },
    { id: 4307401, name: 'Esmeralda', microregionId: 43015 },
    { id: 4307450, name: 'Esperança do Sul', microregionId: 43002 },
    { id: 4307500, name: 'Espumoso', microregionId: 43011 },
    { id: 4307559, name: 'Estação', microregionId: 43004 },
    { id: 4307609, name: 'Estância Velha', microregionId: 43026 },
    { id: 4307708, name: 'Esteio', microregionId: 43026 },
    { id: 4307807, name: 'Estrela', microregionId: 43021 },
    { id: 4307815, name: 'Estrela Velha', microregionId: 43020 },
    { id: 4307831, name: 'Eugênio de Castro', microregionId: 43007 },
    { id: 4307864, name: 'Fagundes Varela', microregionId: 43016 },
    { id: 4307906, name: 'Farroupilha', microregionId: 43016 },
    { id: 4308003, name: 'Faxinal do Soturno', microregionId: 43019 },
    { id: 4308052, name: 'Faxinalzinho', microregionId: 43004 },
    { id: 4308078, name: 'Fazenda Vilanova', microregionId: 43021 },
    { id: 4308102, name: 'Feliz', microregionId: 43023 },
    { id: 4308201, name: 'Flores da Cunha', microregionId: 43016 },
    { id: 4308250, name: 'Floriano Peixoto', microregionId: 43004 },
    { id: 4308300, name: 'Fontoura Xavier', microregionId: 43013 },
    { id: 4308409, name: 'Formigueiro', microregionId: 43019 },
    { id: 4308433, name: 'Forquetinha', microregionId: 43021 },
    { id: 4308458, name: 'Fortaleza dos Valos', microregionId: 43011 },
    { id: 4308508, name: 'Frederico Westphalen', microregionId: 43003 },
    { id: 4308607, name: 'Garibaldi', microregionId: 43016 },
    { id: 4308656, name: 'Garruchos', microregionId: 43029 },
    { id: 4308706, name: 'Gaurama', microregionId: 43004 },
    { id: 4308805, name: 'General Câmara', microregionId: 43025 },
    { id: 4308854, name: 'Gentil', microregionId: 43010 },
    { id: 4308904, name: 'Getúlio Vargas', microregionId: 43004 },
    { id: 4309001, name: 'Giruá', microregionId: 43007 },
    { id: 4309050, name: 'Glorinha', microregionId: 43026 },
    { id: 4309100, name: 'Gramado', microregionId: 43024 },
    { id: 4309126, name: 'Gramado dos Loureiros', microregionId: 43003 },
    { id: 4309159, name: 'Gramado Xavier', microregionId: 43020 },
    { id: 4309209, name: 'Gravataí', microregionId: 43026 },
    { id: 4309258, name: 'Guabiju', microregionId: 43014 },
    { id: 4309308, name: 'Guaíba', microregionId: 43026 },
    { id: 4309407, name: 'Guaporé', microregionId: 43014 },
    { id: 4309506, name: 'Guarani das Missões', microregionId: 43006 },
    { id: 4309555, name: 'Harmonia', microregionId: 43023 },
    { id: 4307104, name: 'Herval', microregionId: 43034 },
    { id: 4309571, name: 'Herveiras', microregionId: 43020 },
    { id: 4309605, name: 'Horizontina', microregionId: 43002 },
    { id: 4309654, name: 'Hulha Negra', microregionId: 43031 },
    { id: 4309704, name: 'Humaitá', microregionId: 43002 },
    { id: 4309753, name: 'Ibarama', microregionId: 43020 },
    { id: 4309803, name: 'Ibiaçá', microregionId: 43005 },
    { id: 4309902, name: 'Ibiraiaras', microregionId: 43010 },
    { id: 4309951, name: 'Ibirapuitã', microregionId: 43013 },
    { id: 4310009, name: 'Ibirubá', microregionId: 43011 },
    { id: 4310108, name: 'Igrejinha', microregionId: 43024 },
    { id: 4310207, name: 'Ijuí', microregionId: 43008 },
    { id: 4310306, name: 'Ilópolis', microregionId: 43014 },
    { id: 4310330, name: 'Imbé', microregionId: 43027 },
    { id: 4310363, name: 'Imigrante', microregionId: 43021 },
    { id: 4310405, name: 'Independência', microregionId: 43001 },
    { id: 4310413, name: 'Inhacorá', microregionId: 43008 },
    { id: 4310439, name: 'Ipê', microregionId: 43015 },
    { id: 4310462, name: 'Ipiranga do Sul', microregionId: 43004 },
    { id: 4310504, name: 'Iraí', microregionId: 43003 },
    { id: 4310538, name: 'Itaara', microregionId: 43018 },
    { id: 4310553, name: 'Itacurubi', microregionId: 43017 },
    { id: 4310579, name: 'Itapuca', microregionId: 43014 },
    { id: 4310603, name: 'Itaqui', microregionId: 43029 },
    { id: 4310652, name: 'Itati', microregionId: 43027 },
    { id: 4310702, name: 'Itatiba do Sul', microregionId: 43004 },
    { id: 4310751, name: 'Ivorá', microregionId: 43019 },
    { id: 4310801, name: 'Ivoti', microregionId: 43024 },
    { id: 4310850, name: 'Jaboticaba', microregionId: 43009 },
    { id: 4310876, name: 'Jacuizinho', microregionId: 43011 },
    { id: 4310900, name: 'Jacutinga', microregionId: 43004 },
    { id: 4311007, name: 'Jaguarão', microregionId: 43034 },
    { id: 4311106, name: 'Jaguari', microregionId: 43018 },
    { id: 4311122, name: 'Jaquirana', microregionId: 43015 },
    { id: 4311130, name: 'Jari', microregionId: 43017 },
    { id: 4311155, name: 'Jóia', microregionId: 43011 },
    { id: 4311205, name: 'Júlio de Castilhos', microregionId: 43017 },
    { id: 4311239, name: 'Lagoa Bonita do Sul', microregionId: 43020 },
    { id: 4311270, name: 'Lagoa dos Três Cantos', microregionId: 43012 },
    { id: 4311304, name: 'Lagoa Vermelha', microregionId: 43015 },
    { id: 4311254, name: 'Lagoão', microregionId: 43013 },
    { id: 4311403, name: 'Lajeado', microregionId: 43021 },
    { id: 4311429, name: 'Lajeado do Bugre', microregionId: 43009 },
    { id: 4311502, name: 'Lavras do Sul', microregionId: 43031 },
    { id: 4311601, name: 'Liberato Salzano', microregionId: 43003 },
    { id: 4311627, name: 'Lindolfo Collor', microregionId: 43024 },
    { id: 4311643, name: 'Linha Nova', microregionId: 43023 },
    { id: 4311718, name: 'Maçambará', microregionId: 43029 },
    { id: 4311700, name: 'Machadinho', microregionId: 43005 },
    { id: 4311734, name: 'Mampituba', microregionId: 43027 },
    { id: 4311759, name: 'Manoel Viana', microregionId: 43029 },
    { id: 4311775, name: 'Maquiné', microregionId: 43027 },
    { id: 4311791, name: 'Maratá', microregionId: 43023 },
    { id: 4311809, name: 'Marau', microregionId: 43010 },
    { id: 4311908, name: 'Marcelino Ramos', microregionId: 43004 },
    { id: 4311981, name: 'Mariana Pimentel', microregionId: 43026 },
    { id: 4312005, name: 'Mariano Moro', microregionId: 43004 },
    { id: 4312054, name: 'Marques de Souza', microregionId: 43021 },
    { id: 4312104, name: 'Mata', microregionId: 43018 },
    { id: 4312138, name: 'Mato Castelhano', microregionId: 43010 },
    { id: 4312153, name: 'Mato Leitão', microregionId: 43020 },
    { id: 4312179, name: 'Mato Queimado', microregionId: 43006 },
    { id: 4312203, name: 'Maximiliano de Almeida', microregionId: 43005 },
    { id: 4312252, name: 'Minas do Leão', microregionId: 43025 },
    { id: 4312302, name: 'Miraguaí', microregionId: 43002 },
    { id: 4312351, name: 'Montauri', microregionId: 43014 },
    { id: 4312377, name: 'Monte Alegre dos Campos', microregionId: 43015 },
    { id: 4312385, name: 'Monte Belo do Sul', microregionId: 43016 },
    { id: 4312401, name: 'Montenegro', microregionId: 43023 },
    { id: 4312427, name: 'Mormaço', microregionId: 43013 },
    { id: 4312443, name: 'Morrinhos do Sul', microregionId: 43027 },
    { id: 4312450, name: 'Morro Redondo', microregionId: 43033 },
    { id: 4312476, name: 'Morro Reuter', microregionId: 43024 },
    { id: 4312500, name: 'Mostardas', microregionId: 43027 },
    { id: 4312609, name: 'Muçum', microregionId: 43021 },
    { id: 4312617, name: 'Muitos Capões', microregionId: 43015 },
    { id: 4312625, name: 'Muliterno', microregionId: 43010 },
    { id: 4312658, name: 'Não-Me-Toque', microregionId: 43012 },
    { id: 4312674, name: 'Nicolau Vergueiro', microregionId: 43010 },
    { id: 4312708, name: 'Nonoai', microregionId: 43003 },
    { id: 4312757, name: 'Nova Alvorada', microregionId: 43014 },
    { id: 4312807, name: 'Nova Araçá', microregionId: 43014 },
    { id: 4312906, name: 'Nova Bassano', microregionId: 43014 },
    { id: 4312955, name: 'Nova Boa Vista', microregionId: 43009 },
    { id: 4313003, name: 'Nova Bréscia', microregionId: 43021 },
    { id: 4313011, name: 'Nova Candelária', microregionId: 43002 },
    { id: 4313037, name: 'Nova Esperança do Sul', microregionId: 43018 },
    { id: 4313060, name: 'Nova Hartz', microregionId: 43026 },
    { id: 4313086, name: 'Nova Pádua', microregionId: 43016 },
    { id: 4313102, name: 'Nova Palma', microregionId: 43019 },
    { id: 4313201, name: 'Nova Petrópolis', microregionId: 43024 },
    { id: 4313300, name: 'Nova Prata', microregionId: 43014 },
    { id: 4313334, name: 'Nova Ramada', microregionId: 43008 },
    { id: 4313359, name: 'Nova Roma do Sul', microregionId: 43016 },
    { id: 4313375, name: 'Nova Santa Rita', microregionId: 43026 },
    { id: 4313490, name: 'Novo Barreiro', microregionId: 43009 },
    { id: 4313391, name: 'Novo Cabrais', microregionId: 43022 },
    { id: 4313409, name: 'Novo Hamburgo', microregionId: 43026 },
    { id: 4313425, name: 'Novo Machado', microregionId: 43001 },
    { id: 4313441, name: 'Novo Tiradentes', microregionId: 43003 },
    { id: 4313466, name: 'Novo Xingu', microregionId: 43003 },
    { id: 4313508, name: 'Osório', microregionId: 43027 },
    { id: 4313607, name: 'Paim Filho', microregionId: 43005 },
    { id: 4313656, name: 'Palmares do Sul', microregionId: 43027 },
    { id: 4313706, name: 'Palmeira das Missões', microregionId: 43009 },
    { id: 4313805, name: 'Palmitinho', microregionId: 43003 },
    { id: 4313904, name: 'Panambi', microregionId: 43008 },
    { id: 4313953, name: 'Pantano Grande', microregionId: 43022 },
    { id: 4314001, name: 'Paraí', microregionId: 43014 },
    { id: 4314027, name: 'Paraíso do Sul', microregionId: 43022 },
    { id: 4314035, name: 'Pareci Novo', microregionId: 43023 },
    { id: 4314050, name: 'Parobé', microregionId: 43026 },
    { id: 4314068, name: 'Passa Sete', microregionId: 43020 },
    { id: 4314076, name: 'Passo do Sobrado', microregionId: 43022 },
    { id: 4314100, name: 'Passo Fundo', microregionId: 43010 },
    { id: 4314134, name: 'Paulo Bento', microregionId: 43004 },
    { id: 4314159, name: 'Paverama', microregionId: 43021 },
    { id: 4314175, name: 'Pedras Altas', microregionId: 43032 },
    { id: 4314209, name: 'Pedro Osório', microregionId: 43033 },
    { id: 4314308, name: 'Pejuçara', microregionId: 43008 },
    { id: 4314407, name: 'Pelotas', microregionId: 43033 },
    { id: 4314423, name: 'Picada Café', microregionId: 43024 },
    { id: 4314456, name: 'Pinhal', microregionId: 43009 },
    { id: 4314464, name: 'Pinhal da Serra', microregionId: 43015 },
    { id: 4314472, name: 'Pinhal Grande', microregionId: 43017 },
    { id: 4314498, name: 'Pinheirinho do Vale', microregionId: 43003 },
    { id: 4314506, name: 'Pinheiro Machado', microregionId: 43032 },
    { id: 4314548, name: 'Pinto Bandeira', microregionId: 43016 },
    { id: 4314555, name: 'Pirapó', microregionId: 43007 },
    { id: 4314605, name: 'Piratini', microregionId: 43032 },
    { id: 4314704, name: 'Planalto', microregionId: 43003 },
    { id: 4314753, name: 'Poço das Antas', microregionId: 43023 },
    { id: 4314779, name: 'Pontão', microregionId: 43010 },
    { id: 4314787, name: 'Ponte Preta', microregionId: 43004 },
    { id: 4314803, name: 'Portão', microregionId: 43023 },
    { id: 4314902, name: 'Porto Alegre', microregionId: 43026 },
    { id: 4315008, name: 'Porto Lucena', microregionId: 43001 },
    { id: 4315057, name: 'Porto Mauá', microregionId: 43001 },
    { id: 4315073, name: 'Porto Vera Cruz', microregionId: 43001 },
    { id: 4315107, name: 'Porto Xavier', microregionId: 43006 },
    { id: 4315131, name: 'Pouso Novo', microregionId: 43021 },
    { id: 4315149, name: 'Presidente Lucena', microregionId: 43024 },
    { id: 4315156, name: 'Progresso', microregionId: 43021 },
    { id: 4315172, name: 'Protásio Alves', microregionId: 43014 },
    { id: 4315206, name: 'Putinga', microregionId: 43014 },
    { id: 4315305, name: 'Quaraí', microregionId: 43029 },
    { id: 4315313, name: 'Quatro Irmãos', microregionId: 43004 },
    { id: 4315321, name: 'Quevedos', microregionId: 43017 },
    { id: 4315354, name: 'Quinze de Novembro', microregionId: 43011 },
    { id: 4315404, name: 'Redentora', microregionId: 43002 },
    { id: 4315453, name: 'Relvado', microregionId: 43021 },
    { id: 4315503, name: 'Restinga Sêca', microregionId: 43019 },
    { id: 4315552, name: 'Rio dos Índios', microregionId: 43003 },
    { id: 4315602, name: 'Rio Grande', microregionId: 43035 },
    { id: 4315701, name: 'Rio Pardo', microregionId: 43022 },
    { id: 4315750, name: 'Riozinho', microregionId: 43024 },
    { id: 4315800, name: 'Roca Sales', microregionId: 43021 },
    { id: 4315909, name: 'Rodeio Bonito', microregionId: 43003 },
    { id: 4315958, name: 'Rolador', microregionId: 43007 },
    { id: 4316006, name: 'Rolante', microregionId: 43024 },
    { id: 4316105, name: 'Ronda Alta', microregionId: 43010 },
    { id: 4316204, name: 'Rondinha', microregionId: 43003 },
    { id: 4316303, name: 'Roque Gonzales', microregionId: 43006 },
    { id: 4316402, name: 'Rosário do Sul', microregionId: 43030 },
    { id: 4316428, name: 'Sagrada Família', microregionId: 43009 },
    { id: 4316436, name: 'Saldanha Marinho', microregionId: 43011 },
    { id: 4316451, name: 'Salto do Jacuí', microregionId: 43011 },
    { id: 4316477, name: 'Salvador das Missões', microregionId: 43006 },
    { id: 4316501, name: 'Salvador do Sul', microregionId: 43023 },
    { id: 4316600, name: 'Sananduva', microregionId: 43005 },
    { id: 4317103, name: 'Sant\'Ana do Livramento', microregionId: 43030 },
    { id: 4316709, name: 'Santa Bárbara do Sul', microregionId: 43011 },
    { id: 4316733, name: 'Santa Cecília do Sul', microregionId: 43010 },
    { id: 4316758, name: 'Santa Clara do Sul', microregionId: 43021 },
    { id: 4316808, name: 'Santa Cruz do Sul', microregionId: 43020 },
    { id: 4316972, name: 'Santa Margarida do Sul', microregionId: 43030 },
    { id: 4316907, name: 'Santa Maria', microregionId: 43018 },
    { id: 4316956, name: 'Santa Maria do Herval', microregionId: 43024 },
    { id: 4317202, name: 'Santa Rosa', microregionId: 43001 },
    { id: 4317251, name: 'Santa Tereza', microregionId: 43016 },
    { id: 4317301, name: 'Santa Vitória do Palmar', microregionId: 43035 },
    { id: 4317004, name: 'Santana da Boa Vista', microregionId: 43032 },
    { id: 4317400, name: 'Santiago', microregionId: 43017 },
    { id: 4317509, name: 'Santo Ângelo', microregionId: 43007 },
    { id: 4317608, name: 'Santo Antônio da Patrulha', microregionId: 43027 },
    { id: 4317707, name: 'Santo Antônio das Missões', microregionId: 43007 },
    { id: 4317558, name: 'Santo Antônio do Palma', microregionId: 43010 },
    { id: 4317756, name: 'Santo Antônio do Planalto', microregionId: 43009 },
    { id: 4317806, name: 'Santo Augusto', microregionId: 43008 },
    { id: 4317905, name: 'Santo Cristo', microregionId: 43001 },
    { id: 4317954, name: 'Santo Expedito do Sul', microregionId: 43005 },
    { id: 4318002, name: 'São Borja', microregionId: 43029 },
    { id: 4318051, name: 'São Domingos do Sul', microregionId: 43010 },
    { id: 4318101, name: 'São Francisco de Assis', microregionId: 43029 },
    { id: 4318200, name: 'São Francisco de Paula', microregionId: 43015 },
    { id: 4318309, name: 'São Gabriel', microregionId: 43030 },
    { id: 4318408, name: 'São Jerônimo', microregionId: 43025 },
    { id: 4318424, name: 'São João da Urtiga', microregionId: 43005 },
    { id: 4318432, name: 'São João do Polêsine', microregionId: 43019 },
    { id: 4318440, name: 'São Jorge', microregionId: 43014 },
    { id: 4318457, name: 'São José das Missões', microregionId: 43009 },
    { id: 4318465, name: 'São José do Herval', microregionId: 43013 },
    { id: 4318481, name: 'São José do Hortêncio', microregionId: 43023 },
    { id: 4318499, name: 'São José do Inhacorá', microregionId: 43001 },
    { id: 4318507, name: 'São José do Norte', microregionId: 43035 },
    { id: 4318606, name: 'São José do Ouro', microregionId: 43005 },
    { id: 4318614, name: 'São José do Sul', microregionId: 43023 },
    { id: 4318622, name: 'São José dos Ausentes', microregionId: 43015 },
    { id: 4318705, name: 'São Leopoldo', microregionId: 43026 },
    { id: 4318804, name: 'São Lourenço do Sul', microregionId: 43033 },
    { id: 4318903, name: 'São Luiz Gonzaga', microregionId: 43007 },
    { id: 4319000, name: 'São Marcos', microregionId: 43016 },
    { id: 4319109, name: 'São Martinho', microregionId: 43002 },
    { id: 4319125, name: 'São Martinho da Serra', microregionId: 43018 },
    { id: 4319158, name: 'São Miguel das Missões', microregionId: 43007 },
    { id: 4319208, name: 'São Nicolau', microregionId: 43007 },
    { id: 4319307, name: 'São Paulo das Missões', microregionId: 43006 },
    { id: 4319356, name: 'São Pedro da Serra', microregionId: 43023 },
    { id: 4319364, name: 'São Pedro das Missões', microregionId: 43009 },
    { id: 4319372, name: 'São Pedro do Butiá', microregionId: 43006 },
    { id: 4319406, name: 'São Pedro do Sul', microregionId: 43018 },
    { id: 4319505, name: 'São Sebastião do Caí', microregionId: 43023 },
    { id: 4319604, name: 'São Sepé', microregionId: 43018 },
    { id: 4319703, name: 'São Valentim', microregionId: 43004 },
    { id: 4319711, name: 'São Valentim do Sul', microregionId: 43014 },
    { id: 4319737, name: 'São Valério do Sul', microregionId: 43008 },
    { id: 4319752, name: 'São Vendelino', microregionId: 43023 },
    { id: 4319802, name: 'São Vicente do Sul', microregionId: 43018 },
    { id: 4319901, name: 'Sapiranga', microregionId: 43026 },
    { id: 4320008, name: 'Sapucaia do Sul', microregionId: 43026 },
    { id: 4320107, name: 'Sarandi', microregionId: 43009 },
    { id: 4320206, name: 'Seberi', microregionId: 43003 },
    { id: 4320230, name: 'Sede Nova', microregionId: 43002 },
    { id: 4320263, name: 'Segredo', microregionId: 43020 },
    { id: 4320305, name: 'Selbach', microregionId: 43012 },
    { id: 4320321, name: 'Senador Salgado Filho', microregionId: 43007 },
    { id: 4320354, name: 'Sentinela do Sul', microregionId: 43028 },
    { id: 4320404, name: 'Serafina Corrêa', microregionId: 43014 },
    { id: 4320453, name: 'Sério', microregionId: 43021 },
    { id: 4320503, name: 'Sertão', microregionId: 43010 },
    { id: 4320552, name: 'Sertão Santana', microregionId: 43026 },
    { id: 4320578, name: 'Sete de Setembro', microregionId: 43006 },
    { id: 4320602, name: 'Severiano de Almeida', microregionId: 43004 },
    { id: 4320651, name: 'Silveira Martins', microregionId: 43019 },
    { id: 4320677, name: 'Sinimbu', microregionId: 43020 },
    { id: 4320701, name: 'Sobradinho', microregionId: 43020 },
    { id: 4320800, name: 'Soledade', microregionId: 43013 },
    { id: 4320859, name: 'Tabaí', microregionId: 43021 },
    { id: 4320909, name: 'Tapejara', microregionId: 43010 },
    { id: 4321006, name: 'Tapera', microregionId: 43012 },
    { id: 4321105, name: 'Tapes', microregionId: 43028 },
    { id: 4321204, name: 'Taquara', microregionId: 43024 },
    { id: 4321303, name: 'Taquari', microregionId: 43021 },
    { id: 4321329, name: 'Taquaruçu do Sul', microregionId: 43003 },
    { id: 4321352, name: 'Tavares', microregionId: 43027 },
    { id: 4321402, name: 'Tenente Portela', microregionId: 43002 },
    { id: 4321436, name: 'Terra de Areia', microregionId: 43027 },
    { id: 4321451, name: 'Teutônia', microregionId: 43021 },
    { id: 4321469, name: 'Tio Hugo', microregionId: 43012 },
    { id: 4321477, name: 'Tiradentes do Sul', microregionId: 43002 },
    { id: 4321493, name: 'Toropi', microregionId: 43018 },
    { id: 4321501, name: 'Torres', microregionId: 43027 },
    { id: 4321600, name: 'Tramandaí', microregionId: 43027 },
    { id: 4321626, name: 'Travesseiro', microregionId: 43021 },
    { id: 4321634, name: 'Três Arroios', microregionId: 43004 },
    { id: 4321667, name: 'Três Cachoeiras', microregionId: 43027 },
    { id: 4321709, name: 'Três Coroas', microregionId: 43024 },
    { id: 4321808, name: 'Três de Maio', microregionId: 43001 },
    { id: 4321832, name: 'Três Forquilhas', microregionId: 43027 },
    { id: 4321857, name: 'Três Palmeiras', microregionId: 43003 },
    { id: 4321907, name: 'Três Passos', microregionId: 43002 },
    { id: 4321956, name: 'Trindade do Sul', microregionId: 43003 },
    { id: 4322004, name: 'Triunfo', microregionId: 43025 },
    { id: 4322103, name: 'Tucunduva', microregionId: 43001 },
    { id: 4322152, name: 'Tunas', microregionId: 43013 },
    { id: 4322186, name: 'Tupanci do Sul', microregionId: 43005 },
    { id: 4322202, name: 'Tupanciretã', microregionId: 43017 },
    { id: 4322251, name: 'Tupandi', microregionId: 43023 },
    { id: 4322301, name: 'Tuparendi', microregionId: 43001 },
    { id: 4322327, name: 'Turuçu', microregionId: 43033 },
    { id: 4322343, name: 'Ubiretama', microregionId: 43007 },
    { id: 4322350, name: 'União da Serra', microregionId: 43014 },
    { id: 4322376, name: 'Unistalda', microregionId: 43017 },
    { id: 4322400, name: 'Uruguaiana', microregionId: 43029 },
    { id: 4322509, name: 'Vacaria', microregionId: 43015 },
    { id: 4322533, name: 'Vale do Sol', microregionId: 43020 },
    { id: 4322541, name: 'Vale Real', microregionId: 43023 },
    { id: 4322525, name: 'Vale Verde', microregionId: 43025 },
    { id: 4322558, name: 'Vanini', microregionId: 43010 },
    { id: 4322608, name: 'Venâncio Aires', microregionId: 43020 },
    { id: 4322707, name: 'Vera Cruz', microregionId: 43020 },
    { id: 4322806, name: 'Veranópolis', microregionId: 43016 },
    { id: 4322855, name: 'Vespasiano Corrêa', microregionId: 43021 },
    { id: 4322905, name: 'Viadutos', microregionId: 43004 },
    { id: 4323002, name: 'Viamão', microregionId: 43026 },
    { id: 4323101, name: 'Vicente Dutra', microregionId: 43003 },
    { id: 4323200, name: 'Victor Graeff', microregionId: 43012 },
    { id: 4323309, name: 'Vila Flores', microregionId: 43016 },
    { id: 4323358, name: 'Vila Lângaro', microregionId: 43010 },
    { id: 4323408, name: 'Vila Maria', microregionId: 43010 },
    { id: 4323457, name: 'Vila Nova do Sul', microregionId: 43018 },
    { id: 4323507, name: 'Vista Alegre', microregionId: 43003 },
    { id: 4323606, name: 'Vista Alegre do Prata', microregionId: 43014 },
    { id: 4323705, name: 'Vista Gaúcha', microregionId: 43002 },
    { id: 4323754, name: 'Vitória das Missões', microregionId: 43007 },
    { id: 4323770, name: 'Westfália', microregionId: 43021 },
    { id: 4323804, name: 'Xangri-lá', microregionId: 43027 },
  ],
  50: [
    { id: 5000203, name: 'Água Clara', microregionId: 50007 },
    { id: 5000252, name: 'Alcinópolis', microregionId: 50003 },
    { id: 5000609, name: 'Amambai', microregionId: 50010 },
    { id: 5000708, name: 'Anastácio', microregionId: 50002 },
    { id: 5000807, name: 'Anaurilândia', microregionId: 50008 },
    { id: 5000856, name: 'Angélica', microregionId: 50011 },
    { id: 5000906, name: 'Antônio João', microregionId: 50010 },
    { id: 5001003, name: 'Aparecida do Taboado', microregionId: 50006 },
    { id: 5001102, name: 'Aquidauana', microregionId: 50002 },
    { id: 5001243, name: 'Aral Moreira', microregionId: 50010 },
    { id: 5001508, name: 'Bandeirantes', microregionId: 50004 },
    { id: 5001904, name: 'Bataguassu', microregionId: 50008 },
    { id: 5002001, name: 'Batayporã', microregionId: 50008 },
    { id: 5002100, name: 'Bela Vista', microregionId: 50009 },
    { id: 5002159, name: 'Bodoquena', microregionId: 50009 },
    { id: 5002209, name: 'Bonito', microregionId: 50009 },
    { id: 5002308, name: 'Brasilândia', microregionId: 50007 },
    { id: 5002407, name: 'Caarapó', microregionId: 50010 },
    { id: 5002605, name: 'Camapuã', microregionId: 50003 },
    { id: 5002704, name: 'Campo Grande', microregionId: 50004 },
    { id: 5002803, name: 'Caracol', microregionId: 50009 },
    { id: 5002902, name: 'Cassilândia', microregionId: 50005 },
    { id: 5002951, name: 'Chapadão do Sul', microregionId: 50005 },
    { id: 5003108, name: 'Corguinho', microregionId: 50004 },
    { id: 5003157, name: 'Coronel Sapucaia', microregionId: 50011 },
    { id: 5003207, name: 'Corumbá', microregionId: 50001 },
    { id: 5003256, name: 'Costa Rica', microregionId: 50005 },
    { id: 5003306, name: 'Coxim', microregionId: 50003 },
    { id: 5003454, name: 'Deodápolis', microregionId: 50011 },
    { id: 5003488, name: 'Dois Irmãos do Buriti', microregionId: 50002 },
    { id: 5003504, name: 'Douradina', microregionId: 50010 },
    { id: 5003702, name: 'Dourados', microregionId: 50010 },
    { id: 5003751, name: 'Eldorado', microregionId: 50011 },
    { id: 5003801, name: 'Fátima do Sul', microregionId: 50010 },
    { id: 5003900, name: 'Figueirão', microregionId: 50003 },
    { id: 5004007, name: 'Glória de Dourados', microregionId: 50011 },
    { id: 5004106, name: 'Guia Lopes da Laguna', microregionId: 50009 },
    { id: 5004304, name: 'Iguatemi', microregionId: 50011 },
    { id: 5004403, name: 'Inocência', microregionId: 50006 },
    { id: 5004502, name: 'Itaporã', microregionId: 50010 },
    { id: 5004601, name: 'Itaquiraí', microregionId: 50011 },
    { id: 5004700, name: 'Ivinhema', microregionId: 50011 },
    { id: 5004809, name: 'Japorã', microregionId: 50011 },
    { id: 5004908, name: 'Jaraguari', microregionId: 50004 },
    { id: 5005004, name: 'Jardim', microregionId: 50009 },
    { id: 5005103, name: 'Jateí', microregionId: 50011 },
    { id: 5005152, name: 'Juti', microregionId: 50010 },
    { id: 5005202, name: 'Ladário', microregionId: 50001 },
    { id: 5005251, name: 'Laguna Carapã', microregionId: 50010 },
    { id: 5005400, name: 'Maracaju', microregionId: 50010 },
    { id: 5005608, name: 'Miranda', microregionId: 50002 },
    { id: 5005681, name: 'Mundo Novo', microregionId: 50011 },
    { id: 5005707, name: 'Naviraí', microregionId: 50011 },
    { id: 5005806, name: 'Nioaque', microregionId: 50009 },
    { id: 5006002, name: 'Nova Alvorada do Sul', microregionId: 50010 },
    { id: 5006200, name: 'Nova Andradina', microregionId: 50008 },
    { id: 5006259, name: 'Novo Horizonte do Sul', microregionId: 50011 },
    { id: 5006275, name: 'Paraíso das Águas', microregionId: 50005 },
    { id: 5006309, name: 'Paranaíba', microregionId: 50006 },
    { id: 5006358, name: 'Paranhos', microregionId: 50011 },
    { id: 5006408, name: 'Pedro Gomes', microregionId: 50003 },
    { id: 5006606, name: 'Ponta Porã', microregionId: 50010 },
    { id: 5006903, name: 'Porto Murtinho', microregionId: 50001 },
    { id: 5007109, name: 'Ribas do Rio Pardo', microregionId: 50007 },
    { id: 5007208, name: 'Rio Brilhante', microregionId: 50010 },
    { id: 5007307, name: 'Rio Negro', microregionId: 50004 },
    { id: 5007406, name: 'Rio Verde de Mato Grosso', microregionId: 50003 },
    { id: 5007505, name: 'Rochedo', microregionId: 50004 },
    { id: 5007554, name: 'Santa Rita do Pardo', microregionId: 50007 },
    { id: 5007695, name: 'São Gabriel do Oeste', microregionId: 50003 },
    { id: 5007802, name: 'Selvíria', microregionId: 50006 },
    { id: 5007703, name: 'Sete Quedas', microregionId: 50011 },
    { id: 5007901, name: 'Sidrolândia', microregionId: 50004 },
    { id: 5007935, name: 'Sonora', microregionId: 50003 },
    { id: 5007950, name: 'Tacuru', microregionId: 50011 },
    { id: 5007976, name: 'Taquarussu', microregionId: 50008 },
    { id: 5008008, name: 'Terenos', microregionId: 50004 },
    { id: 5008305, name: 'Três Lagoas', microregionId: 50007 },
    { id: 5008404, name: 'Vicentina', microregionId: 50010 },
  ],
  51: [
    { id: 5100102, name: 'Acorizal', microregionId: 51016 },
    { id: 5100201, name: 'Água Boa', microregionId: 51010 },
    { id: 5100250, name: 'Alta Floresta', microregionId: 51002 },
    { id: 5100300, name: 'Alto Araguaia', microregionId: 51022 },
    { id: 5100359, name: 'Alto Boa Vista', microregionId: 51009 },
    { id: 5100409, name: 'Alto Garças', microregionId: 51022 },
    { id: 5100508, name: 'Alto Paraguai', microregionId: 51015 },
    { id: 5100607, name: 'Alto Taquari', microregionId: 51022 },
    { id: 5100805, name: 'Apiacás', microregionId: 51002 },
    { id: 5101001, name: 'Araguaiana', microregionId: 51011 },
    { id: 5101209, name: 'Araguainha', microregionId: 51020 },
    { id: 5101258, name: 'Araputanga', microregionId: 51014 },
    { id: 5101308, name: 'Arenápolis', microregionId: 51015 },
    { id: 5101407, name: 'Aripuanã', microregionId: 51001 },
    { id: 5101605, name: 'Barão de Melgaço', microregionId: 51018 },
    { id: 5101704, name: 'Barra do Bugres', microregionId: 51013 },
    { id: 5101803, name: 'Barra do Garças', microregionId: 51011 },
    { id: 5101837, name: 'Boa Esperança do Norte', microregionId: 0 },
    { id: 5101852, name: 'Bom Jesus do Araguaia', microregionId: 51009 },
    { id: 5101902, name: 'Brasnorte', microregionId: 51001 },
    { id: 5102504, name: 'Cáceres', microregionId: 51018 },
    { id: 5102603, name: 'Campinápolis', microregionId: 51010 },
    { id: 5102637, name: 'Campo Novo do Parecis', microregionId: 51004 },
    { id: 5102678, name: 'Campo Verde', microregionId: 51019 },
    { id: 5102686, name: 'Campos de Júlio', microregionId: 51004 },
    { id: 5102694, name: 'Canabrava do Norte', microregionId: 51009 },
    { id: 5102702, name: 'Canarana', microregionId: 51010 },
    { id: 5102793, name: 'Carlinda', microregionId: 51002 },
    { id: 5102850, name: 'Castanheira', microregionId: 51001 },
    { id: 5103007, name: 'Chapada dos Guimarães', microregionId: 51017 },
    { id: 5103056, name: 'Cláudia', microregionId: 51007 },
    { id: 5103106, name: 'Cocalinho', microregionId: 51011 },
    { id: 5103205, name: 'Colíder', microregionId: 51003 },
    { id: 5103254, name: 'Colniza', microregionId: 51001 },
    { id: 5103304, name: 'Comodoro', microregionId: 51004 },
    { id: 5103353, name: 'Confresa', microregionId: 51009 },
    { id: 5103361, name: 'Conquista D\'Oeste', microregionId: 51012 },
    { id: 5103379, name: 'Cotriguaçu', microregionId: 51001 },
    { id: 5103403, name: 'Cuiabá', microregionId: 51017 },
    { id: 5103437, name: 'Curvelândia', microregionId: 51018 },
    { id: 5103452, name: 'Denise', microregionId: 51013 },
    { id: 5103502, name: 'Diamantino', microregionId: 51004 },
    { id: 5103601, name: 'Dom Aquino', microregionId: 51021 },
    { id: 5103700, name: 'Feliz Natal', microregionId: 51007 },
    { id: 5103809, name: 'Figueirópolis D\'Oeste', microregionId: 51014 },
    { id: 5103858, name: 'Gaúcha do Norte', microregionId: 51008 },
    { id: 5103908, name: 'General Carneiro', microregionId: 51020 },
    { id: 5103957, name: 'Glória D\'Oeste', microregionId: 51014 },
    { id: 5104104, name: 'Guarantã do Norte', microregionId: 51003 },
    { id: 5104203, name: 'Guiratinga', microregionId: 51020 },
    { id: 5104500, name: 'Indiavaí', microregionId: 51014 },
    { id: 5104526, name: 'Ipiranga do Norte', microregionId: 51006 },
    { id: 5104542, name: 'Itanhangá', microregionId: 51006 },
    { id: 5104559, name: 'Itaúba', microregionId: 51007 },
    { id: 5104609, name: 'Itiquira', microregionId: 51021 },
    { id: 5104807, name: 'Jaciara', microregionId: 51021 },
    { id: 5104906, name: 'Jangada', microregionId: 51016 },
    { id: 5105002, name: 'Jauru', microregionId: 51014 },
    { id: 5105101, name: 'Juara', microregionId: 51005 },
    { id: 5105150, name: 'Juína', microregionId: 51001 },
    { id: 5105176, name: 'Juruena', microregionId: 51001 },
    { id: 5105200, name: 'Juscimeira', microregionId: 51021 },
    { id: 5105234, name: 'Lambari D\'Oeste', microregionId: 51014 },
    { id: 5105259, name: 'Lucas do Rio Verde', microregionId: 51006 },
    { id: 5105309, name: 'Luciara', microregionId: 51009 },
    { id: 5105580, name: 'Marcelândia', microregionId: 51007 },
    { id: 5105606, name: 'Matupá', microregionId: 51003 },
    { id: 5105622, name: 'Mirassol d\'Oeste', microregionId: 51014 },
    { id: 5105903, name: 'Nobres', microregionId: 51006 },
    { id: 5106000, name: 'Nortelândia', microregionId: 51015 },
    { id: 5106109, name: 'Nossa Senhora do Livramento', microregionId: 51017 },
    { id: 5106158, name: 'Nova Bandeirantes', microregionId: 51002 },
    { id: 5106208, name: 'Nova Brasilândia', microregionId: 51008 },
    { id: 5106216, name: 'Nova Canaã do Norte', microregionId: 51003 },
    { id: 5108808, name: 'Nova Guarita', microregionId: 51003 },
    { id: 5106182, name: 'Nova Lacerda', microregionId: 51012 },
    { id: 5108857, name: 'Nova Marilândia', microregionId: 51015 },
    { id: 5108907, name: 'Nova Maringá', microregionId: 51005 },
    { id: 5108956, name: 'Nova Monte Verde', microregionId: 51002 },
    { id: 5106224, name: 'Nova Mutum', microregionId: 51006 },
    { id: 5106174, name: 'Nova Nazaré', microregionId: 51010 },
    { id: 5106232, name: 'Nova Olímpia', microregionId: 51013 },
    { id: 5106190, name: 'Nova Santa Helena', microregionId: 51007 },
    { id: 5106240, name: 'Nova Ubiratã', microregionId: 51006 },
    { id: 5106257, name: 'Nova Xavantina', microregionId: 51010 },
    { id: 5106273, name: 'Novo Horizonte do Norte', microregionId: 51005 },
    { id: 5106265, name: 'Novo Mundo', microregionId: 51003 },
    { id: 5106315, name: 'Novo Santo Antônio', microregionId: 51009 },
    { id: 5106281, name: 'Novo São Joaquim', microregionId: 51010 },
    { id: 5106299, name: 'Paranaíta', microregionId: 51002 },
    { id: 5106307, name: 'Paranatinga', microregionId: 51008 },
    { id: 5106372, name: 'Pedra Preta', microregionId: 51021 },
    { id: 5106422, name: 'Peixoto de Azevedo', microregionId: 51003 },
    { id: 5106455, name: 'Planalto da Serra', microregionId: 51008 },
    { id: 5106505, name: 'Poconé', microregionId: 51018 },
    { id: 5106653, name: 'Pontal do Araguaia', microregionId: 51020 },
    { id: 5106703, name: 'Ponte Branca', microregionId: 51020 },
    { id: 5106752, name: 'Pontes e Lacerda', microregionId: 51012 },
    { id: 5106778, name: 'Porto Alegre do Norte', microregionId: 51009 },
    { id: 5106802, name: 'Porto dos Gaúchos', microregionId: 51005 },
    { id: 5106828, name: 'Porto Esperidião', microregionId: 51014 },
    { id: 5106851, name: 'Porto Estrela', microregionId: 51013 },
    { id: 5107008, name: 'Poxoréu', microregionId: 51020 },
    { id: 5107040, name: 'Primavera do Leste', microregionId: 51019 },
    { id: 5107065, name: 'Querência', microregionId: 51010 },
    { id: 5107156, name: 'Reserva do Cabaçal', microregionId: 51014 },
    { id: 5107180, name: 'Ribeirão Cascalheira', microregionId: 51009 },
    { id: 5107198, name: 'Ribeirãozinho', microregionId: 51020 },
    { id: 5107206, name: 'Rio Branco', microregionId: 51014 },
    { id: 5107578, name: 'Rondolândia', microregionId: 51001 },
    { id: 5107602, name: 'Rondonópolis', microregionId: 51021 },
    { id: 5107701, name: 'Rosário Oeste', microregionId: 51016 },
    { id: 5107750, name: 'Salto do Céu', microregionId: 51014 },
    { id: 5107248, name: 'Santa Carmem', microregionId: 51007 },
    { id: 5107743, name: 'Santa Cruz do Xingu', microregionId: 51009 },
    { id: 5107768, name: 'Santa Rita do Trivelato', microregionId: 51006 },
    { id: 5107776, name: 'Santa Terezinha', microregionId: 51009 },
    { id: 5107263, name: 'Santo Afonso', microregionId: 51015 },
    { id: 5107800, name: 'Santo Antônio de Leverger', microregionId: 51017 },
    { id: 5107792, name: 'Santo Antônio do Leste', microregionId: 51010 },
    { id: 5107859, name: 'São Félix do Araguaia', microregionId: 51009 },
    { id: 5107297, name: 'São José do Povo', microregionId: 51021 },
    { id: 5107305, name: 'São José do Rio Claro', microregionId: 51005 },
    { id: 5107354, name: 'São José do Xingu', microregionId: 51009 },
    { id: 5107107, name: 'São José dos Quatro Marcos', microregionId: 51014 },
    { id: 5107404, name: 'São Pedro da Cipa', microregionId: 51021 },
    { id: 5107875, name: 'Sapezal', microregionId: 51004 },
    { id: 5107883, name: 'Serra Nova Dourada', microregionId: 51009 },
    { id: 5107909, name: 'Sinop', microregionId: 51007 },
    { id: 5107925, name: 'Sorriso', microregionId: 51006 },
    { id: 5107941, name: 'Tabaporã', microregionId: 51005 },
    { id: 5107958, name: 'Tangará da Serra', microregionId: 51013 },
    { id: 5108006, name: 'Tapurah', microregionId: 51006 },
    { id: 5108055, name: 'Terra Nova do Norte', microregionId: 51003 },
    { id: 5108105, name: 'Tesouro', microregionId: 51020 },
    { id: 5108204, name: 'Torixoréu', microregionId: 51020 },
    { id: 5108303, name: 'União do Sul', microregionId: 51007 },
    { id: 5108352, name: 'Vale de São Domingos', microregionId: 51012 },
    { id: 5108402, name: 'Várzea Grande', microregionId: 51017 },
    { id: 5108501, name: 'Vera', microregionId: 51007 },
    { id: 5105507, name: 'Vila Bela da Santíssima Trindade', microregionId: 51012 },
    { id: 5108600, name: 'Vila Rica', microregionId: 51009 },
  ],
  52: [
    { id: 5200050, name: 'Abadia de Goiás', microregionId: 52010 },
    { id: 5200100, name: 'Abadiânia', microregionId: 52012 },
    { id: 5200134, name: 'Acreúna', microregionId: 52014 },
    { id: 5200159, name: 'Adelândia', microregionId: 52009 },
    { id: 5200175, name: 'Água Fria de Goiás', microregionId: 52012 },
    { id: 5200209, name: 'Água Limpa', microregionId: 52015 },
    { id: 5200258, name: 'Águas Lindas de Goiás', microregionId: 52012 },
    { id: 5200308, name: 'Alexânia', microregionId: 52012 },
    { id: 5200506, name: 'Aloândia', microregionId: 52015 },
    { id: 5200555, name: 'Alto Horizonte', microregionId: 52004 },
    { id: 5200605, name: 'Alto Paraíso de Goiás', microregionId: 52005 },
    { id: 5200803, name: 'Alvorada do Norte', microregionId: 52011 },
    { id: 5200829, name: 'Amaralina', microregionId: 52004 },
    { id: 5200852, name: 'Americano do Brasil', microregionId: 52009 },
    { id: 5200902, name: 'Amorinópolis', microregionId: 52008 },
    { id: 5201108, name: 'Anápolis', microregionId: 52007 },
    { id: 5201207, name: 'Anhanguera', microregionId: 52017 },
    { id: 5201306, name: 'Anicuns', microregionId: 52009 },
    { id: 5201405, name: 'Aparecida de Goiânia', microregionId: 52010 },
    { id: 5201454, name: 'Aparecida do Rio Doce', microregionId: 52013 },
    { id: 5201504, name: 'Aporé', microregionId: 52013 },
    { id: 5201603, name: 'Araçu', microregionId: 52007 },
    { id: 5201702, name: 'Aragarças', microregionId: 52003 },
    { id: 5201801, name: 'Aragoiânia', microregionId: 52010 },
    { id: 5202155, name: 'Araguapaz', microregionId: 52002 },
    { id: 5202353, name: 'Arenópolis', microregionId: 52003 },
    { id: 5202502, name: 'Aruanã', microregionId: 52002 },
    { id: 5202601, name: 'Aurilândia', microregionId: 52009 },
    { id: 5202809, name: 'Avelinópolis', microregionId: 52009 },
    { id: 5203104, name: 'Baliza', microregionId: 52003 },
    { id: 5203203, name: 'Barro Alto', microregionId: 52006 },
    { id: 5203302, name: 'Bela Vista de Goiás', microregionId: 52010 },
    { id: 5203401, name: 'Bom Jardim de Goiás', microregionId: 52003 },
    { id: 5203500, name: 'Bom Jesus de Goiás', microregionId: 52015 },
    { id: 5203559, name: 'Bonfinópolis', microregionId: 52010 },
    { id: 5203575, name: 'Bonópolis', microregionId: 52004 },
    { id: 5203609, name: 'Brazabrantes', microregionId: 52007 },
    { id: 5203807, name: 'Britânia', microregionId: 52002 },
    { id: 5203906, name: 'Buriti Alegre', microregionId: 52015 },
    { id: 5203939, name: 'Buriti de Goiás', microregionId: 52009 },
    { id: 5203962, name: 'Buritinópolis', microregionId: 52011 },
    { id: 5204003, name: 'Cabeceiras', microregionId: 52012 },
    { id: 5204102, name: 'Cachoeira Alta', microregionId: 52018 },
    { id: 5204201, name: 'Cachoeira de Goiás', microregionId: 52008 },
    { id: 5204250, name: 'Cachoeira Dourada', microregionId: 52015 },
    { id: 5204300, name: 'Caçu', microregionId: 52018 },
    { id: 5204409, name: 'Caiapônia', microregionId: 52013 },
    { id: 5204508, name: 'Caldas Novas', microregionId: 52015 },
    { id: 5204557, name: 'Caldazinha', microregionId: 52010 },
    { id: 5204607, name: 'Campestre de Goiás', microregionId: 52014 },
    { id: 5204656, name: 'Campinaçu', microregionId: 52004 },
    { id: 5204706, name: 'Campinorte', microregionId: 52004 },
    { id: 5204805, name: 'Campo Alegre de Goiás', microregionId: 52017 },
    { id: 5204854, name: 'Campo Limpo de Goiás', microregionId: 52007 },
    { id: 5204904, name: 'Campos Belos', microregionId: 52005 },
    { id: 5204953, name: 'Campos Verdes', microregionId: 52004 },
    { id: 5205000, name: 'Carmo do Rio Verde', microregionId: 52006 },
    { id: 5205059, name: 'Castelândia', microregionId: 52013 },
    { id: 5205109, name: 'Catalão', microregionId: 52017 },
    { id: 5205208, name: 'Caturaí', microregionId: 52007 },
    { id: 5205307, name: 'Cavalcante', microregionId: 52005 },
    { id: 5205406, name: 'Ceres', microregionId: 52006 },
    { id: 5205455, name: 'Cezarina', microregionId: 52014 },
    { id: 5205471, name: 'Chapadão do Céu', microregionId: 52013 },
    { id: 5205497, name: 'Cidade Ocidental', microregionId: 52012 },
    { id: 5205513, name: 'Cocalzinho de Goiás', microregionId: 52012 },
    { id: 5205521, name: 'Colinas do Sul', microregionId: 52005 },
    { id: 5205703, name: 'Córrego do Ouro', microregionId: 52008 },
    { id: 5205802, name: 'Corumbá de Goiás', microregionId: 52012 },
    { id: 5205901, name: 'Corumbaíba', microregionId: 52017 },
    { id: 5206206, name: 'Cristalina', microregionId: 52012 },
    { id: 5206305, name: 'Cristianópolis', microregionId: 52016 },
    { id: 5206404, name: 'Crixás', microregionId: 52001 },
    { id: 5206503, name: 'Cromínia', microregionId: 52015 },
    { id: 5206602, name: 'Cumari', microregionId: 52017 },
    { id: 5206701, name: 'Damianópolis', microregionId: 52011 },
    { id: 5206800, name: 'Damolândia', microregionId: 52007 },
    { id: 5206909, name: 'Davinópolis', microregionId: 52017 },
    { id: 5207105, name: 'Diorama', microregionId: 52003 },
    { id: 5208301, name: 'Divinópolis de Goiás', microregionId: 52011 },
    { id: 5207253, name: 'Doverlândia', microregionId: 52013 },
    { id: 5207352, name: 'Edealina', microregionId: 52014 },
    { id: 5207402, name: 'Edéia', microregionId: 52014 },
    { id: 5207501, name: 'Estrela do Norte', microregionId: 52004 },
    { id: 5207535, name: 'Faina', microregionId: 52002 },
    { id: 5207600, name: 'Fazenda Nova', microregionId: 52008 },
    { id: 5207808, name: 'Firminópolis', microregionId: 52009 },
    { id: 5207907, name: 'Flores de Goiás', microregionId: 52011 },
    { id: 5208004, name: 'Formosa', microregionId: 52012 },
    { id: 5208103, name: 'Formoso', microregionId: 52004 },
    { id: 5208152, name: 'Gameleira de Goiás', microregionId: 52016 },
    { id: 5208400, name: 'Goianápolis', microregionId: 52010 },
    { id: 5208509, name: 'Goiandira', microregionId: 52017 },
    { id: 5208608, name: 'Goianésia', microregionId: 52006 },
    { id: 5208707, name: 'Goiânia', microregionId: 52010 },
    { id: 5208806, name: 'Goianira', microregionId: 52010 },
    { id: 5208905, name: 'Goiás', microregionId: 52002 },
    { id: 5209101, name: 'Goiatuba', microregionId: 52015 },
    { id: 5209150, name: 'Gouvelândia', microregionId: 52018 },
    { id: 5209200, name: 'Guapó', microregionId: 52010 },
    { id: 5209291, name: 'Guaraíta', microregionId: 52006 },
    { id: 5209408, name: 'Guarani de Goiás', microregionId: 52011 },
    { id: 5209457, name: 'Guarinos', microregionId: 52006 },
    { id: 5209606, name: 'Heitoraí', microregionId: 52007 },
    { id: 5209705, name: 'Hidrolândia', microregionId: 52010 },
    { id: 5209804, name: 'Hidrolina', microregionId: 52006 },
    { id: 5209903, name: 'Iaciara', microregionId: 52011 },
    { id: 5209937, name: 'Inaciolândia', microregionId: 52015 },
    { id: 5209952, name: 'Indiara', microregionId: 52014 },
    { id: 5210000, name: 'Inhumas', microregionId: 52007 },
    { id: 5210109, name: 'Ipameri', microregionId: 52017 },
    { id: 5210158, name: 'Ipiranga de Goiás', microregionId: 52006 },
    { id: 5210208, name: 'Iporá', microregionId: 52008 },
    { id: 5210307, name: 'Israelândia', microregionId: 52008 },
    { id: 5210406, name: 'Itaberaí', microregionId: 52007 },
    { id: 5210562, name: 'Itaguari', microregionId: 52007 },
    { id: 5210604, name: 'Itaguaru', microregionId: 52007 },
    { id: 5210802, name: 'Itajá', microregionId: 52018 },
    { id: 5210901, name: 'Itapaci', microregionId: 52006 },
    { id: 5211008, name: 'Itapirapuã', microregionId: 52002 },
    { id: 5211206, name: 'Itapuranga', microregionId: 52006 },
    { id: 5211305, name: 'Itarumã', microregionId: 52018 },
    { id: 5211404, name: 'Itauçu', microregionId: 52007 },
    { id: 5211503, name: 'Itumbiara', microregionId: 52015 },
    { id: 5211602, name: 'Ivolândia', microregionId: 52008 },
    { id: 5211701, name: 'Jandaia', microregionId: 52014 },
    { id: 5211800, name: 'Jaraguá', microregionId: 52007 },
    { id: 5211909, name: 'Jataí', microregionId: 52013 },
    { id: 5212006, name: 'Jaupaci', microregionId: 52008 },
    { id: 5212055, name: 'Jesúpolis', microregionId: 52007 },
    { id: 5212105, name: 'Joviânia', microregionId: 52015 },
    { id: 5212204, name: 'Jussara', microregionId: 52002 },
    { id: 5212253, name: 'Lagoa Santa', microregionId: 52018 },
    { id: 5212303, name: 'Leopoldo de Bulhões', microregionId: 52010 },
    { id: 5212501, name: 'Luziânia', microregionId: 52012 },
    { id: 5212600, name: 'Mairipotaba', microregionId: 52015 },
    { id: 5212709, name: 'Mambaí', microregionId: 52011 },
    { id: 5212808, name: 'Mara Rosa', microregionId: 52004 },
    { id: 5212907, name: 'Marzagão', microregionId: 52015 },
    { id: 5212956, name: 'Matrinchã', microregionId: 52002 },
    { id: 5213004, name: 'Maurilândia', microregionId: 52013 },
    { id: 5213053, name: 'Mimoso de Goiás', microregionId: 52012 },
    { id: 5213087, name: 'Minaçu', microregionId: 52004 },
    { id: 5213103, name: 'Mineiros', microregionId: 52013 },
    { id: 5213400, name: 'Moiporá', microregionId: 52008 },
    { id: 5213509, name: 'Monte Alegre de Goiás', microregionId: 52005 },
    { id: 5213707, name: 'Montes Claros de Goiás', microregionId: 52003 },
    { id: 5213756, name: 'Montividiu', microregionId: 52013 },
    { id: 5213772, name: 'Montividiu do Norte', microregionId: 52004 },
    { id: 5213806, name: 'Morrinhos', microregionId: 52015 },
    { id: 5213855, name: 'Morro Agudo de Goiás', microregionId: 52006 },
    { id: 5213905, name: 'Mossâmedes', microregionId: 52009 },
    { id: 5214002, name: 'Mozarlândia', microregionId: 52001 },
    { id: 5214051, name: 'Mundo Novo', microregionId: 52001 },
    { id: 5214101, name: 'Mutunópolis', microregionId: 52004 },
    { id: 5214408, name: 'Nazário', microregionId: 52009 },
    { id: 5214507, name: 'Nerópolis', microregionId: 52010 },
    { id: 5214606, name: 'Niquelândia', microregionId: 52004 },
    { id: 5214705, name: 'Nova América', microregionId: 52006 },
    { id: 5214804, name: 'Nova Aurora', microregionId: 52017 },
    { id: 5214838, name: 'Nova Crixás', microregionId: 52001 },
    { id: 5214861, name: 'Nova Glória', microregionId: 52006 },
    { id: 5214879, name: 'Nova Iguaçu de Goiás', microregionId: 52004 },
    { id: 5214903, name: 'Nova Roma', microregionId: 52005 },
    { id: 5215009, name: 'Nova Veneza', microregionId: 52007 },
    { id: 5215207, name: 'Novo Brasil', microregionId: 52008 },
    { id: 5215231, name: 'Novo Gama', microregionId: 52012 },
    { id: 5215256, name: 'Novo Planalto', microregionId: 52001 },
    { id: 5215306, name: 'Orizona', microregionId: 52016 },
    { id: 5215405, name: 'Ouro Verde de Goiás', microregionId: 52007 },
    { id: 5215504, name: 'Ouvidor', microregionId: 52017 },
    { id: 5215603, name: 'Padre Bernardo', microregionId: 52012 },
    { id: 5215652, name: 'Palestina de Goiás', microregionId: 52013 },
    { id: 5215702, name: 'Palmeiras de Goiás', microregionId: 52014 },
    { id: 5215801, name: 'Palmelo', microregionId: 52016 },
    { id: 5215900, name: 'Palminópolis', microregionId: 52014 },
    { id: 5216007, name: 'Panamá', microregionId: 52015 },
    { id: 5216304, name: 'Paranaiguara', microregionId: 52018 },
    { id: 5216403, name: 'Paraúna', microregionId: 52014 },
    { id: 5216452, name: 'Perolândia', microregionId: 52013 },
    { id: 5216809, name: 'Petrolina de Goiás', microregionId: 52007 },
    { id: 5216908, name: 'Pilar de Goiás', microregionId: 52006 },
    { id: 5217104, name: 'Piracanjuba', microregionId: 52015 },
    { id: 5217203, name: 'Piranhas', microregionId: 52003 },
    { id: 5217302, name: 'Pirenópolis', microregionId: 52012 },
    { id: 5217401, name: 'Pires do Rio', microregionId: 52016 },
    { id: 5217609, name: 'Planaltina', microregionId: 52012 },
    { id: 5217708, name: 'Pontalina', microregionId: 52015 },
    { id: 5218003, name: 'Porangatu', microregionId: 52004 },
    { id: 5218052, name: 'Porteirão', microregionId: 52015 },
    { id: 5218102, name: 'Portelândia', microregionId: 52013 },
    { id: 5218300, name: 'Posse', microregionId: 52011 },
    { id: 5218391, name: 'Professor Jamil', microregionId: 52015 },
    { id: 5218508, name: 'Quirinópolis', microregionId: 52018 },
    { id: 5218607, name: 'Rialma', microregionId: 52006 },
    { id: 5218706, name: 'Rianápolis', microregionId: 52006 },
    { id: 5218789, name: 'Rio Quente', microregionId: 52015 },
    { id: 5218805, name: 'Rio Verde', microregionId: 52013 },
    { id: 5218904, name: 'Rubiataba', microregionId: 52006 },
    { id: 5219001, name: 'Sanclerlândia', microregionId: 52009 },
    { id: 5219100, name: 'Santa Bárbara de Goiás', microregionId: 52009 },
    { id: 5219209, name: 'Santa Cruz de Goiás', microregionId: 52016 },
    { id: 5219258, name: 'Santa Fé de Goiás', microregionId: 52002 },
    { id: 5219308, name: 'Santa Helena de Goiás', microregionId: 52013 },
    { id: 5219357, name: 'Santa Isabel', microregionId: 52006 },
    { id: 5219407, name: 'Santa Rita do Araguaia', microregionId: 52013 },
    { id: 5219456, name: 'Santa Rita do Novo Destino', microregionId: 52006 },
    { id: 5219506, name: 'Santa Rosa de Goiás', microregionId: 52007 },
    { id: 5219605, name: 'Santa Tereza de Goiás', microregionId: 52004 },
    { id: 5219704, name: 'Santa Terezinha de Goiás', microregionId: 52004 },
    { id: 5219712, name: 'Santo Antônio da Barra', microregionId: 52013 },
    { id: 5219738, name: 'Santo Antônio de Goiás', microregionId: 52010 },
    { id: 5219753, name: 'Santo Antônio do Descoberto', microregionId: 52012 },
    { id: 5219803, name: 'São Domingos', microregionId: 52011 },
    { id: 5219902, name: 'São Francisco de Goiás', microregionId: 52007 },
    { id: 5220009, name: 'São João d\'Aliança', microregionId: 52005 },
    { id: 5220058, name: 'São João da Paraúna', microregionId: 52014 },
    { id: 5220108, name: 'São Luís de Montes Belos', microregionId: 52009 },
    { id: 5220157, name: 'São Luiz do Norte', microregionId: 52006 },
    { id: 5220207, name: 'São Miguel do Araguaia', microregionId: 52001 },
    { id: 5220264, name: 'São Miguel do Passa Quatro', microregionId: 52016 },
    { id: 5220280, name: 'São Patrício', microregionId: 52006 },
    { id: 5220405, name: 'São Simão', microregionId: 52018 },
    { id: 5220454, name: 'Senador Canedo', microregionId: 52010 },
    { id: 5220504, name: 'Serranópolis', microregionId: 52013 },
    { id: 5220603, name: 'Silvânia', microregionId: 52016 },
    { id: 5220686, name: 'Simolândia', microregionId: 52011 },
    { id: 5220702, name: 'Sítio d\'Abadia', microregionId: 52011 },
    { id: 5221007, name: 'Taquaral de Goiás', microregionId: 52007 },
    { id: 5221080, name: 'Teresina de Goiás', microregionId: 52005 },
    { id: 5221197, name: 'Terezópolis de Goiás', microregionId: 52010 },
    { id: 5221304, name: 'Três Ranchos', microregionId: 52017 },
    { id: 5221403, name: 'Trindade', microregionId: 52010 },
    { id: 5221452, name: 'Trombas', microregionId: 52004 },
    { id: 5221502, name: 'Turvânia', microregionId: 52009 },
    { id: 5221551, name: 'Turvelândia', microregionId: 52014 },
    { id: 5221577, name: 'Uirapuru', microregionId: 52001 },
    { id: 5221601, name: 'Uruaçu', microregionId: 52004 },
    { id: 5221700, name: 'Uruana', microregionId: 52006 },
    { id: 5221809, name: 'Urutaí', microregionId: 52016 },
    { id: 5221858, name: 'Valparaíso de Goiás', microregionId: 52012 },
    { id: 5221908, name: 'Varjão', microregionId: 52014 },
    { id: 5222005, name: 'Vianópolis', microregionId: 52016 },
    { id: 5222054, name: 'Vicentinópolis', microregionId: 52015 },
    { id: 5222203, name: 'Vila Boa', microregionId: 52012 },
    { id: 5222302, name: 'Vila Propício', microregionId: 52012 },
  ],
  53: [
    { id: 5300108, name: 'Brasília', microregionId: 53001 },
  ],
}
